/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';
export const HOST = "http://127.0.0.1:3000/graphql"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
export const apiSubscriptionSSE = (options: chainOptions) => (query: string) => {
  const url = options[0];
  const fetchOptions = options[1] || {};

  let abortController: AbortController | null = null;
  let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
  let onCallback: ((args: unknown) => void) | null = null;
  let errorCallback: ((args: unknown) => void) | null = null;
  let openCallback: (() => void) | null = null;
  let offCallback: ((args: unknown) => void) | null = null;

  const startStream = async () => {
    try {
      abortController = new AbortController();

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'text/event-stream',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          ...fetchOptions.headers,
        },
        body: JSON.stringify({ query }),
        signal: abortController.signal,
        ...fetchOptions,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (openCallback) {
        openCallback();
      }

      reader = response.body?.getReader() || null;
      if (!reader) {
        throw new Error('No response body');
      }

      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          if (offCallback) {
            offCallback({ data: null, code: 1000, reason: 'Stream completed' });
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = line.slice(6);
              const parsed = JSON.parse(data);

              if (parsed.errors) {
                if (errorCallback) {
                  errorCallback({ data: parsed.data, errors: parsed.errors });
                }
              } else if (onCallback && parsed.data) {
                onCallback(parsed.data);
              }
            } catch {
              if (errorCallback) {
                errorCallback({ errors: ['Failed to parse SSE data'] });
              }
            }
          }
        }
      }
    } catch (err: unknown) {
      const error = err as Error;
      if (error.name !== 'AbortError' && errorCallback) {
        errorCallback({ errors: [error.message || 'Unknown error'] });
      }
    }
  };

  return {
    on: (e: (args: unknown) => void) => {
      onCallback = e;
    },
    off: (e: (args: unknown) => void) => {
      offCallback = e;
    },
    error: (e: (args: unknown) => void) => {
      errorCallback = e;
    },
    open: (e?: () => void) => {
      if (e) {
        openCallback = e;
      }
      startStream();
    },
    close: () => {
      if (abortController) {
        abortController.abort();
      }
      if (reader) {
        reader.cancel();
      }
    },
  };
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export type SubscriptionToGraphQLSSE<Z, T, SCLR extends ScalarDefinition> = {
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: (fn?: () => void) => void;
  close: () => void;
};
export const SubscriptionThunderSSE =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQLSSE<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };
export const SubscriptionSSE = (...options: chainOptions) => SubscriptionThunderSSE(apiSubscriptionSSE(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type BaseSymbol = number | string | undefined | boolean | null;

type ScalarsSelector<T, V> = {
  [X in Required<{
    [P in keyof T]: P extends keyof V
      ? V[P] extends Array<any> | undefined
        ? never
        : T[P] extends BaseSymbol | Array<BaseSymbol>
        ? P
        : never
      : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const fnType = k in AllTypesProps ? AllTypesProps[k as keyof typeof AllTypesProps] : undefined;
  const hasFnTypes = typeof fnType === 'object' ? fnType : undefined;
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([k, value]) => {
        const isFunctionType = hasFnTypes && k in hasFnTypes && !!hasFnTypes[k as keyof typeof hasFnTypes];
        if (isFunctionType) return false;
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType) return true;
        if (typeof isReturnType !== 'string') return false;
        if (isReturnType.startsWith('scalar.')) {
          return true;
        }
        return false;
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T], T extends keyof ValueTypes ? ValueTypes[T] : never>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  _type: T,
  _field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S extends Array<infer R>
  ? Array<IsScalar<R, SCLR>>
  : S;

type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer _R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type ComposableSelector<T extends keyof ValueTypes> = ReturnType<SelectionFunction<ValueTypes[T]>>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = GraphQLTypes["Node"]
export type ScalarCoders = {
	BigInt?: ScalarResolver;
	Date?: ScalarResolver;
	DateTime?: ScalarResolver;
	JSON?: ScalarResolver;
	ID?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["MutationAddScanToDealerJacketResult"] | GraphQLTypes["MutationAddScanToGloveCompartmentsResult"] | GraphQLTypes["MutationAssignStaffToTransactionResult"] | GraphQLTypes["MutationCancelFormCollectionResult"] | GraphQLTypes["MutationCancelPreviousAndRequestSignaturesResult"] | GraphQLTypes["MutationChangeDocumentAccessResult"] | GraphQLTypes["MutationChangeFormSubmissionAccessResult"] | GraphQLTypes["MutationCreateAndSubmitCreditAndPrequalApplicationResult"] | GraphQLTypes["MutationCreateChatResult"] | GraphQLTypes["MutationCreateCoBuyerResult"] | GraphQLTypes["MutationCreateCreditApplicationAndCreateUserResult"] | GraphQLTypes["MutationCreateEmploymentResult"] | GraphQLTypes["MutationCreateGroupuserResult"] | GraphQLTypes["MutationCreateMessageResult"] | GraphQLTypes["MutationCreateStaffResult"] | GraphQLTypes["MutationCreateStaffScheduleEventsResult"] | GraphQLTypes["MutationCreateTransactionAndSubmitTestDriveResult"] | GraphQLTypes["MutationCreateUserFeedbackResult"] | GraphQLTypes["MutationCustomerCreatePrefilledTransactionResult"] | GraphQLTypes["MutationCustomerCreatePurchaseVehicleResult"] | GraphQLTypes["MutationCustomerCreateTradeVehicleResult"] | GraphQLTypes["MutationCustomerCreateTransactionResult"] | GraphQLTypes["MutationCustomerCreateUnauthenticatedTransactionResult"] | GraphQLTypes["MutationCustomerReferralPaidResult"] | GraphQLTypes["MutationCustomerReferralResult"] | GraphQLTypes["MutationCustomerSignupWithCognitoResult"] | GraphQLTypes["MutationCustomerUpdatePhoneNumberResult"] | GraphQLTypes["MutationCustomerUpdatePurchaseVehicleResult"] | GraphQLTypes["MutationCustomerUpdateTradeVehicleResult"] | GraphQLTypes["MutationDealershipCreatePurchaseVehicleResult"] | GraphQLTypes["MutationDealershipCreateTradeVehicleResult"] | GraphQLTypes["MutationDealershipCreateTransactionResult"] | GraphQLTypes["MutationDealershipRemoveTradeVehicleResult"] | GraphQLTypes["MutationDealershipUpdatePurchaseVehicleResult"] | GraphQLTypes["MutationDealershipUpdateTradeVehicleResult"] | GraphQLTypes["MutationDeleteStaffScheduleEventResult"] | GraphQLTypes["MutationDismissNotificationsResult"] | GraphQLTypes["MutationExtractVehicleFromRegistrationResult"] | GraphQLTypes["MutationFinalizeLivenessAnalysisResult"] | GraphQLTypes["MutationLoginResult"] | GraphQLTypes["MutationLogoutResult"] | GraphQLTypes["MutationMakeSubmissionTokenResult"] | GraphQLTypes["MutationMakeUploadForScannerResult"] | GraphQLTypes["MutationMakeUploadResult"] | GraphQLTypes["MutationMakeUploadToTransactionResult"] | GraphQLTypes["MutationMarkTransactionAsDeliveredResult"] | GraphQLTypes["MutationModifyHardCreditApplicationResult"] | GraphQLTypes["MutationOnboardingSubmitStep1Result"] | GraphQLTypes["MutationOnboardingSubmitStep2Result"] | GraphQLTypes["MutationOverrideTodoResult"] | GraphQLTypes["MutationPreLoginCheckResult"] | GraphQLTypes["MutationPrefillLicensePlateOrVinResult"] | GraphQLTypes["MutationPushDataToCrmsResult"] | GraphQLTypes["MutationPushDocumentToCdkDealJacketResult"] | GraphQLTypes["MutationPushDocumentsToCdkResult"] | GraphQLTypes["MutationPushFormSubmissionsToCdkResult"] | GraphQLTypes["MutationPushHardCreditApplicationResult"] | GraphQLTypes["MutationRecordConsentResult"] | GraphQLTypes["MutationRemoveCoBuyerResult"] | GraphQLTypes["MutationRemovePrimaryBuyerResult"] | GraphQLTypes["MutationRequestAgilityCreditPrequalResult"] | GraphQLTypes["MutationRequestIdentityVerificationResult"] | GraphQLTypes["MutationRequestOtpExistingUserDEVResult"] | GraphQLTypes["MutationRequestPrequalReportsResult"] | GraphQLTypes["MutationRequestPrescreenResult"] | GraphQLTypes["MutationResendStaffPasswordResult"] | GraphQLTypes["MutationSaveLendingPortalCustomerDataResult"] | GraphQLTypes["MutationSaveLendingPortalPurchaseVehicleDataResult"] | GraphQLTypes["MutationSaveLendingPortalTradeVehicleDataResult"] | GraphQLTypes["MutationSendFormReadyNotificationsResult"] | GraphQLTypes["MutationSetDeliveryMethodForUserResult"] | GraphQLTypes["MutationSetDocumentLabelsResult"] | GraphQLTypes["MutationSetDocumentTitleResult"] | GraphQLTypes["MutationSetStaffInformationResult"] | GraphQLTypes["MutationSetStaffPlanningEnabledResult"] | GraphQLTypes["MutationStageAdditionalFormsResult"] | GraphQLTypes["MutationStartLivenessAnalysisResult"] | GraphQLTypes["MutationSubmitFormValuesResult"] | GraphQLTypes["MutationSubmitPrequalApplicationAndCreateUserResult"] | GraphQLTypes["MutationSubmitPrequalApplicationOnTransactionResult"] | GraphQLTypes["MutationSubmitStaffAcknowledgementResult"] | GraphQLTypes["MutationSubmitStandardFormResult"] | GraphQLTypes["MutationSuspendGroupUserResult"] | GraphQLTypes["MutationSuspendStaffResult"] | GraphQLTypes["MutationSwitchCustomerRolesResult"] | GraphQLTypes["MutationTestDriveEnsureCustomerForDealershipResult"] | GraphQLTypes["MutationTrackUserEventResult"] | GraphQLTypes["MutationUnlockTransactionResult"] | GraphQLTypes["MutationUpdateCustomerResult"] | GraphQLTypes["MutationUpdateEmploymentResult"] | GraphQLTypes["MutationUpdateGroupUserResult"] | GraphQLTypes["MutationUpdateIdCardRotationResult"] | GraphQLTypes["MutationUpdateMyUserResult"] | GraphQLTypes["MutationUpdateReceivesAuthenticomReportResult"] | GraphQLTypes["MutationUpdateStaffAttributesResult"] | GraphQLTypes["MutationUpdateStaffExtraPermissionsResult"] | GraphQLTypes["MutationUpdateStaffScheduleEventResult"] | GraphQLTypes["MutationUpdateTransactionResult"] | GraphQLTypes["MutationUploadAdditionalDocumentsResult"] | GraphQLTypes["MutationUploadAdditionalDocumentsToTransactionResult"] | GraphQLTypes["MutationUploadIdCardResult"] | GraphQLTypes["MutationUploadIdCardWithTokenResult"] | GraphQLTypes["MutationUserExistsResult"] | GraphQLTypes["MutationVerifyOtpForExistingUserResult"]

export type ValueTypes = {
    ["Acknowledgement"]:Acknowledgement;
	["AcknowledgementFilter"]: {
	equals?: ValueTypes["Acknowledgement"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["Acknowledgement"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["AcknowledgementFilter"] | undefined | null | Variable<any, string>
};
	["AcknowledgementTemplate"]: AliasType<{
	code?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	language?:boolean | `@${string}`,
	revision?:boolean | `@${string}`,
	textMarkdown?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AcknowledgementTemplate']?: Omit<ValueTypes["AcknowledgementTemplate"], "...on AcknowledgementTemplate">
}>;
	["AcknowledgementTemplateFilter"]: {
	code?: ValueTypes["AcknowledgementFilter"] | undefined | null | Variable<any, string>,
	language?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>
};
	["AcknowledgementTemplateOrderBy"]: {
	revision?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["Address"]: AliasType<{
	apartmentDetails?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	customer?:ValueTypes["Customer"],
	durationMonths?:boolean | `@${string}`,
	durationYears?:boolean | `@${string}`,
	fullAddress?:boolean | `@${string}`,
	housingStatus?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	monthlyPayment?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	timelinePosition?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	zipCode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Address']?: Omit<ValueTypes["Address"], "...on Address">
}>;
	["AddressInput"]: {
	apartmentDetails?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	housingStatus?: string | undefined | null | Variable<any, string>,
	monthlyPayment?: number | undefined | null | Variable<any, string>,
	state?: string | undefined | null | Variable<any, string>,
	street?: string | undefined | null | Variable<any, string>,
	timelinePosition: number | Variable<any, string>,
	zipCode?: string | undefined | null | Variable<any, string>
};
	["AgilityCreditAccount"]: AliasType<{
	accountNumber?:boolean | `@${string}`,
	acctType?:boolean | `@${string}`,
	balance?:boolean | `@${string}`,
	bureau?:boolean | `@${string}`,
	closedDate?:boolean | `@${string}`,
	creditLimit?:boolean | `@${string}`,
	creditor?:boolean | `@${string}`,
	currentStatus?:boolean | `@${string}`,
	days30?:boolean | `@${string}`,
	days60?:boolean | `@${string}`,
	days90?:boolean | `@${string}`,
	highCredit?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	indJoint?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	monthlyPayment?:boolean | `@${string}`,
	notes?:boolean | `@${string}`,
	openClosed?:boolean | `@${string}`,
	openDate?:boolean | `@${string}`,
	originalAmount?:boolean | `@${string}`,
	pastDue?:boolean | `@${string}`,
	paymentHistory?:boolean | `@${string}`,
	reportedDate?:boolean | `@${string}`,
	timesLate?:boolean | `@${string}`,
	tradeType?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditAccount']?: Omit<ValueTypes["AgilityCreditAccount"], "...on AgilityCreditAccount">
}>;
	["AgilityCreditAccountKind"]:AgilityCreditAccountKind;
	["AgilityCreditAddress"]: AliasType<{
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	addressVarianceCode?:boolean | `@${string}`,
	addressVarianceDescription?:boolean | `@${string}`,
	dateLastReported?:boolean | `@${string}`,
	dateReported?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditAddress']?: Omit<ValueTypes["AgilityCreditAddress"], "...on AgilityCreditAddress">
}>;
	["AgilityCreditAka"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditAka']?: Omit<ValueTypes["AgilityCreditAka"], "...on AgilityCreditAka">
}>;
	["AgilityCreditAlert"]: AliasType<{
	date?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditAlert']?: Omit<ValueTypes["AgilityCreditAlert"], "...on AgilityCreditAlert">
}>;
	["AgilityCreditApplicantInformation"]: AliasType<{
	address?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	infiledDate?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	ssn?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditApplicantInformation']?: Omit<ValueTypes["AgilityCreditApplicantInformation"], "...on AgilityCreditApplicantInformation">
}>;
	["AgilityCreditEmployment"]: AliasType<{
	dateHired?:boolean | `@${string}`,
	dateTerminated?:boolean | `@${string}`,
	employer?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	income?:boolean | `@${string}`,
	infiledDate?:boolean | `@${string}`,
	lastReportedDate?:boolean | `@${string}`,
	occupation?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditEmployment']?: Omit<ValueTypes["AgilityCreditEmployment"], "...on AgilityCreditEmployment">
}>;
	["AgilityCreditIdVerification"]: AliasType<{
	id?:boolean | `@${string}`,
	idCard?:ValueTypes["IdCard"],
	response?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditIdVerification']?: Omit<ValueTypes["AgilityCreditIdVerification"], "...on AgilityCreditIdVerification">
}>;
	["AgilityCreditIdVerificationFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["AgilityCreditInquiry"]: AliasType<{
	date?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	industry?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	subscriberCode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditInquiry']?: Omit<ValueTypes["AgilityCreditInquiry"], "...on AgilityCreditInquiry">
}>;
	["AgilityCreditPrequalReport"]: AliasType<{
	accounts?:ValueTypes["AgilityCreditAccount"],
	addresses?:ValueTypes["AgilityCreditAddress"],
	akas?:ValueTypes["AgilityCreditAka"],
	alerts?:ValueTypes["AgilityCreditAlert"],
	applicantInformation?:ValueTypes["AgilityCreditApplicantInformation"],
	bureau?:boolean | `@${string}`,
	bureauAbbrev?:boolean | `@${string}`,
	collectionsCount?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	creditScores?:ValueTypes["AgilityCreditScore"],
	disputedAccountsCount?:boolean | `@${string}`,
	employments?:ValueTypes["AgilityCreditEmployment"],
	errorMessage?:boolean | `@${string}`,
	foreclosuresCount?:boolean | `@${string}`,
	hitIndicator?:boolean | `@${string}`,
	inquiries?:ValueTypes["AgilityCreditInquiry"],
	inquiriesCount?:boolean | `@${string}`,
	noScoreIndicator?:boolean | `@${string}`,
	openCollectionsCount?:boolean | `@${string}`,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "ap_...") */
	pId?:boolean | `@${string}`,
	publicRecords?:ValueTypes["AgilityCreditPublicRecord"],
	publicRecordsCount?:boolean | `@${string}`,
	pullType?:boolean | `@${string}`,
	repossessionsCount?:boolean | `@${string}`,
	revolvingCreditUsage?:boolean | `@${string}`,
	stage?:boolean | `@${string}`,
	summaryCategories?:ValueTypes["AgilityCreditSummaryCategory"],
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditPrequalReport']?: Omit<ValueTypes["AgilityCreditPrequalReport"], "...on AgilityCreditPrequalReport">
}>;
	["AgilityCreditPrequalReportFilter"]: {
	bureau?: ValueTypes["PrequalBureauFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	pId?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>
};
	["AgilityCreditPublicRecord"]: AliasType<{
	courtName?:boolean | `@${string}`,
	dischargeDate?:boolean | `@${string}`,
	docket?:boolean | `@${string}`,
	ecoa?:boolean | `@${string}`,
	filedDate?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	publicRecordType?:boolean | `@${string}`,
	reportedDate?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditPublicRecord']?: Omit<ValueTypes["AgilityCreditPublicRecord"], "...on AgilityCreditPublicRecord">
}>;
	["AgilityCreditPullType"]:AgilityCreditPullType;
	["AgilityCreditScore"]: AliasType<{
	factors?:ValueTypes["AgilityCreditScoreFactor"],
	id?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditScore']?: Omit<ValueTypes["AgilityCreditScore"], "...on AgilityCreditScore">
}>;
	["AgilityCreditScoreFactor"]: AliasType<{
	factorScore?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditScoreFactor']?: Omit<ValueTypes["AgilityCreditScoreFactor"], "...on AgilityCreditScoreFactor">
}>;
	["AgilityCreditSummaryCategory"]: AliasType<{
	balance?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	closed?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
	current?:boolean | `@${string}`,
	days30?:boolean | `@${string}`,
	days60?:boolean | `@${string}`,
	days90?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	open?:boolean | `@${string}`,
	pastDue?:boolean | `@${string}`,
	payments?:boolean | `@${string}`,
	unrated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on AgilityCreditSummaryCategory']?: Omit<ValueTypes["AgilityCreditSummaryCategory"], "...on AgilityCreditSummaryCategory">
}>;
	["Announcement"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	markdownText?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Announcement']?: Omit<ValueTypes["Announcement"], "...on Announcement">
}>;
	["AnnouncementOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["AssignedStaffOrFilter"]: {
	bdcId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	fniManagerId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	salesManagerId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	salesPersonId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	/** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
["BigInt"]:unknown;
	["BooleanFilter"]: {
	equals?: boolean | undefined | null | Variable<any, string>,
	not?: ValueTypes["BooleanFilter"] | undefined | null | Variable<any, string>
};
	["CdkDealJacketStatus"]:CdkDealJacketStatus;
	["Chat"]: AliasType<{
chatMessages?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["ChatChatMessagesConnection"]],
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Chat']?: Omit<ValueTypes["Chat"], "...on Chat">
}>;
	["ChatChatMessagesConnection"]: AliasType<{
	edges?:ValueTypes["ChatChatMessagesConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ChatChatMessagesConnection']?: Omit<ValueTypes["ChatChatMessagesConnection"], "...on ChatChatMessagesConnection">
}>;
	["ChatChatMessagesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["ChatMessage"],
		__typename?: boolean | `@${string}`,
	['...on ChatChatMessagesConnectionEdge']?: Omit<ValueTypes["ChatChatMessagesConnectionEdge"], "...on ChatChatMessagesConnectionEdge">
}>;
	["ChatMessage"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ChatMessage']?: Omit<ValueTypes["ChatMessage"], "...on ChatMessage">
}>;
	["CheckBoxGroup"]: AliasType<{
	id?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	n?:boolean | `@${string}`,
	rule?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CheckBoxGroup']?: Omit<ValueTypes["CheckBoxGroup"], "...on CheckBoxGroup">
}>;
	["CheckBoxGroupRules"]:CheckBoxGroupRules;
	["ComplianceData"]: AliasType<{
	/** ID Verification status, Not enabled for all dealerships */
	hasRequestedIdv?:ValueTypes["ComplianceIdvField"],
	id?:ValueTypes["ComplianceField"],
	idQuizSummary?:ValueTypes["ComplianceField"],
	ofacStatus?:ValueTypes["ComplianceField"],
	recalls?:ValueTypes["ComplianceField"],
	redFlagStatus?:ValueTypes["ComplianceField"],
		__typename?: boolean | `@${string}`,
	['...on ComplianceData']?: Omit<ValueTypes["ComplianceData"], "...on ComplianceData">
}>;
	["ComplianceField"]: AliasType<{
	description?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ComplianceField']?: Omit<ValueTypes["ComplianceField"], "...on ComplianceField">
}>;
	["ComplianceFormsData"]: AliasType<{
	/** Whether or not the lending portal can be accessed */
	lendingPortalPreCondition?:ValueTypes["ComplianceFormsPreCondition"],
	/** Returns the post-purchase forms that will be requested signed */
	postPurchaseForms?:ValueTypes["Form"],
	/** Whether or not the post-purchase forms can be requested */
	postPurchasePreCondition?:ValueTypes["ComplianceFormsPreCondition"],
	/** Returns the pre-purchase forms that will be requested signed */
	prePurchaseForms?:ValueTypes["Form"],
	prePurchasePreCondition?:ValueTypes["ComplianceFormsPreCondition"],
		__typename?: boolean | `@${string}`,
	['...on ComplianceFormsData']?: Omit<ValueTypes["ComplianceFormsData"], "...on ComplianceFormsData">
}>;
	["ComplianceFormsPreCondition"]: AliasType<{
	errorCodes?:boolean | `@${string}`,
	result?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ComplianceFormsPreCondition']?: Omit<ValueTypes["ComplianceFormsPreCondition"], "...on ComplianceFormsPreCondition">
}>;
	["ComplianceIdvField"]: AliasType<{
	description?:boolean | `@${string}`,
	hasIdCard?:boolean | `@${string}`,
	hasRequestedVerification?:boolean | `@${string}`,
	latestVerificationId?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ComplianceIdvField']?: Omit<ValueTypes["ComplianceIdvField"], "...on ComplianceIdvField">
}>;
	["ComplianceStatus"]:ComplianceStatus;
	["ContactV2"]: AliasType<{
	createdAt?:boolean | `@${string}`,
customers?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["ContactV2CustomersConnection"]],
	firstName?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	middleName?:boolean | `@${string}`,
	pId?:boolean | `@${string}`,
	profilePicture?:ValueTypes["File"],
	updatedAt?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ContactV2']?: Omit<ValueTypes["ContactV2"], "...on ContactV2">
}>;
	["ContactV2CustomersConnection"]: AliasType<{
	edges?:ValueTypes["ContactV2CustomersConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on ContactV2CustomersConnection']?: Omit<ValueTypes["ContactV2CustomersConnection"], "...on ContactV2CustomersConnection">
}>;
	["ContactV2CustomersConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Customer"],
		__typename?: boolean | `@${string}`,
	['...on ContactV2CustomersConnectionEdge']?: Omit<ValueTypes["ContactV2CustomersConnectionEdge"], "...on ContactV2CustomersConnectionEdge">
}>;
	["ContactV2Filter"]: {
	pId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	userId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["CreateCustomerInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	phoneNumber: string | Variable<any, string>
};
	["CreateEmploymentInput"]: {
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	employerName?: string | undefined | null | Variable<any, string>,
	employerPhoneNumber?: string | undefined | null | Variable<any, string>,
	employmentStatus: string | Variable<any, string>,
	incomeAmount?: number | undefined | null | Variable<any, string>,
	incomeInterval?: string | undefined | null | Variable<any, string>,
	occupation?: string | undefined | null | Variable<any, string>,
	otherIncomeAmount?: number | undefined | null | Variable<any, string>,
	otherIncomeInterval?: string | undefined | null | Variable<any, string>,
	otherIncomeSource?: string | undefined | null | Variable<any, string>,
	timelinePosition: number | Variable<any, string>
};
	["CreateStaffScheduleEventsInput"]: {
	endAt: string | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	staffId: string | Variable<any, string>,
	startAt: string | Variable<any, string>,
	weeklyDuplications: number | Variable<any, string>
};
	["CreateUserInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	phoneNumber: string | Variable<any, string>,
	role: string | Variable<any, string>
};
	["CreditApplicationAddressInformationInput"]: {
	apartmentDetails?: string | undefined | null | Variable<any, string>,
	city: string | Variable<any, string>,
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	state: string | Variable<any, string>,
	street: string | Variable<any, string>,
	zipCode: string | Variable<any, string>
};
	["CreditApplicationEmploymentInformationInput"]: {
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	employerName?: string | undefined | null | Variable<any, string>,
	employerPhoneNumber?: string | undefined | null | Variable<any, string>,
	employmentStatus: ValueTypes["EmploymentStatus"] | Variable<any, string>,
	incomeAmount?: number | undefined | null | Variable<any, string>,
	incomeInterval?: ValueTypes["IncomeInterval"] | undefined | null | Variable<any, string>,
	occupation?: string | undefined | null | Variable<any, string>,
	otherIncomeAmount?: number | undefined | null | Variable<any, string>,
	otherIncomeInterval?: ValueTypes["IncomeInterval"] | undefined | null | Variable<any, string>,
	otherIncomeSource?: string | undefined | null | Variable<any, string>
};
	["CreditApplicationFormSubmissionDataInput"]: {
	addressDuration?: string | undefined | null | Variable<any, string>,
	birthdate?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	customerName?: string | undefined | null | Variable<any, string>,
	dateTime?: string | undefined | null | Variable<any, string>,
	dealerPrivacyAckTmplId?: string | undefined | null | Variable<any, string>,
	dealershipName?: string | undefined | null | Variable<any, string>,
	deviceId?: string | undefined | null | Variable<any, string>,
	eSignAckTmplId?: string | undefined | null | Variable<any, string>,
	employerName?: string | undefined | null | Variable<any, string>,
	employerPhoneNumber?: string | undefined | null | Variable<any, string>,
	employmentStatus?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	hcaReportAckTmplId?: string | undefined | null | Variable<any, string>,
	ipAddress?: string | undefined | null | Variable<any, string>,
	jobTitle?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	middleName?: string | undefined | null | Variable<any, string>,
	modificationAckTmplId?: string | undefined | null | Variable<any, string>,
	mortgageOrRentMonthlyPay?: string | undefined | null | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	otherIncmeSource?: string | undefined | null | Variable<any, string>,
	otherIncomeAmount?: string | undefined | null | Variable<any, string>,
	otherIncomeType?: string | undefined | null | Variable<any, string>,
	phoneNumber?: string | undefined | null | Variable<any, string>,
	prevEmployerInfo?: string | undefined | null | Variable<any, string>,
	previousAddress?: string | undefined | null | Variable<any, string>,
	previousAddressLength?: string | undefined | null | Variable<any, string>,
	refNameAddress?: string | undefined | null | Variable<any, string>,
	refPhoneNumber?: string | undefined | null | Variable<any, string>,
	refRelationship?: string | undefined | null | Variable<any, string>,
	residentialStatus?: string | undefined | null | Variable<any, string>,
	salary?: string | undefined | null | Variable<any, string>,
	signature?: string | undefined | null | Variable<any, string>,
	socialSecurityNumber?: string | undefined | null | Variable<any, string>,
	state?: string | undefined | null | Variable<any, string>,
	streetAddress?: string | undefined | null | Variable<any, string>,
	tdcConsentsAckTmplId?: string | undefined | null | Variable<any, string>,
	timeOnJob?: string | undefined | null | Variable<any, string>,
	type?: string | undefined | null | Variable<any, string>,
	zip?: string | undefined | null | Variable<any, string>
};
	["CreditApplicationFormSubmissionInput"]: {
	submissionData: ValueTypes["CreditApplicationFormSubmissionDataInput"] | Variable<any, string>,
	submissionType: string | Variable<any, string>
};
	["CreditApplicationInput"]: {
	birthdate: string | Variable<any, string>,
	currentAddress: ValueTypes["CreditApplicationAddressInformationInput"] | Variable<any, string>,
	currentAddressHousingStatus: ValueTypes["HousingStatus"] | Variable<any, string>,
	currentAddressMonthlyPayment: number | Variable<any, string>,
	currentEmployment: ValueTypes["CreditApplicationEmploymentInformationInput"] | Variable<any, string>,
	dateTime: string | Variable<any, string>,
	dealerPrivacyAckTmplId: string | Variable<any, string>,
	deviceId: string | Variable<any, string>,
	eSignAckTmplId: string | Variable<any, string>,
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	fullName: string | Variable<any, string>,
	hcaReportAckTmplId: string | Variable<any, string>,
	ipAddress: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	middleName?: string | undefined | null | Variable<any, string>,
	phoneNumber: string | Variable<any, string>,
	previousAddress?: ValueTypes["CreditApplicationAddressInformationInput"] | undefined | null | Variable<any, string>,
	previousEmployment?: ValueTypes["CreditApplicationEmploymentInformationInput"] | undefined | null | Variable<any, string>,
	signature: string | Variable<any, string>,
	socialSecurityNumber: string | Variable<any, string>,
	tdcConsentsAckTmplId: string | Variable<any, string>
};
	["Customer"]: AliasType<{
	birthdate?:boolean | `@${string}`,
	compliance?:ValueTypes["ComplianceData"],
	contact?:ValueTypes["ContactV2"],
	contactAcknowledgement?:ValueTypes["FormSubmission"],
	createdAt?:boolean | `@${string}`,
	dealership?:ValueTypes["Dealership"],
	disassociatedRole?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
documents?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["DocumentOr"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerDocumentsConnection"]],
employments?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerEmploymentsConnection"]],
	firstName?:boolean | `@${string}`,
formSubmissions?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["FormSubmissionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	/** Filter such that only form submissions with missing values are returned */
	hasMissingValues?: boolean | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerFormSubmissionsConnection"]],
hardCreditApplications?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["HardCreditApplicationFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["HardCreditApplicationOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["CustomerHardCreditApplicationsConnection"]],
	hasBeenRemovedFromTransaction?:boolean | `@${string}`,
	hasPrequalApplication?:boolean | `@${string}`,
	hasSubmittedHardCreditApplication?:boolean | `@${string}`,
	idCards?:ValueTypes["IdCard"],
	identityTheftPrevention?:ValueTypes["FormSubmission"],
	languageSelection?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	lastRequestedPrescreenAt?:boolean | `@${string}`,
livelinessSession?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["LivelinessSessionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerLivelinessSessionConnection"]],
	middleName?:boolean | `@${string}`,
nextDocumentsToSign?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerNextDocumentsToSignConnection"]],
	onboardingStep?:boolean | `@${string}`,
prequalApplications?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerPrequalApplicationsConnection"]],
prescreens?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerPrescreensConnection"]],
	privacyPolicy?:ValueTypes["FormSubmission"],
residentialAddresses?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["CustomerResidentialAddressesConnection"]],
	selfieCapture?:ValueTypes["File"],
	socialSecurityNumber?:boolean | `@${string}`,
	testDriveDisclosure?:ValueTypes["FormSubmission"],
	transaction?:ValueTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	userId?:boolean | `@${string}`,
	vehicleRegistrationAddress?:ValueTypes["Address"],
	vehicleRegistrationAddressId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Customer']?: Omit<ValueTypes["Customer"], "...on Customer">
}>;
	["CustomerDocumentsConnection"]: AliasType<{
	edges?:ValueTypes["CustomerDocumentsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomerDocumentsConnection']?: Omit<ValueTypes["CustomerDocumentsConnection"], "...on CustomerDocumentsConnection">
}>;
	["CustomerDocumentsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Document"],
		__typename?: boolean | `@${string}`,
	['...on CustomerDocumentsConnectionEdge']?: Omit<ValueTypes["CustomerDocumentsConnectionEdge"], "...on CustomerDocumentsConnectionEdge">
}>;
	["CustomerEmploymentsConnection"]: AliasType<{
	edges?:ValueTypes["CustomerEmploymentsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on CustomerEmploymentsConnection']?: Omit<ValueTypes["CustomerEmploymentsConnection"], "...on CustomerEmploymentsConnection">
}>;
	["CustomerEmploymentsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Employment"],
		__typename?: boolean | `@${string}`,
	['...on CustomerEmploymentsConnectionEdge']?: Omit<ValueTypes["CustomerEmploymentsConnectionEdge"], "...on CustomerEmploymentsConnectionEdge">
}>;
	["CustomerFilter"]: {
	transactionId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["CustomerFormSubmissionsConnection"]: AliasType<{
	edges?:ValueTypes["CustomerFormSubmissionsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomerFormSubmissionsConnection']?: Omit<ValueTypes["CustomerFormSubmissionsConnection"], "...on CustomerFormSubmissionsConnection">
}>;
	["CustomerFormSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["FormSubmission"],
		__typename?: boolean | `@${string}`,
	['...on CustomerFormSubmissionsConnectionEdge']?: Omit<ValueTypes["CustomerFormSubmissionsConnectionEdge"], "...on CustomerFormSubmissionsConnectionEdge">
}>;
	["CustomerHardCreditApplicationsConnection"]: AliasType<{
	edges?:ValueTypes["CustomerHardCreditApplicationsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomerHardCreditApplicationsConnection']?: Omit<ValueTypes["CustomerHardCreditApplicationsConnection"], "...on CustomerHardCreditApplicationsConnection">
}>;
	["CustomerHardCreditApplicationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["HardCreditApplication"],
		__typename?: boolean | `@${string}`,
	['...on CustomerHardCreditApplicationsConnectionEdge']?: Omit<ValueTypes["CustomerHardCreditApplicationsConnectionEdge"], "...on CustomerHardCreditApplicationsConnectionEdge">
}>;
	["CustomerLivelinessSessionConnection"]: AliasType<{
	edges?:ValueTypes["CustomerLivelinessSessionConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on CustomerLivelinessSessionConnection']?: Omit<ValueTypes["CustomerLivelinessSessionConnection"], "...on CustomerLivelinessSessionConnection">
}>;
	["CustomerLivelinessSessionConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["LivelinessSession"],
		__typename?: boolean | `@${string}`,
	['...on CustomerLivelinessSessionConnectionEdge']?: Omit<ValueTypes["CustomerLivelinessSessionConnectionEdge"], "...on CustomerLivelinessSessionConnectionEdge">
}>;
	["CustomerNextDocumentsToSignConnection"]: AliasType<{
	edges?:ValueTypes["CustomerNextDocumentsToSignConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomerNextDocumentsToSignConnection']?: Omit<ValueTypes["CustomerNextDocumentsToSignConnection"], "...on CustomerNextDocumentsToSignConnection">
}>;
	["CustomerNextDocumentsToSignConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["FormSubmission"],
		__typename?: boolean | `@${string}`,
	['...on CustomerNextDocumentsToSignConnectionEdge']?: Omit<ValueTypes["CustomerNextDocumentsToSignConnectionEdge"], "...on CustomerNextDocumentsToSignConnectionEdge">
}>;
	["CustomerPrequalApplicationsConnection"]: AliasType<{
	edges?:ValueTypes["CustomerPrequalApplicationsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on CustomerPrequalApplicationsConnection']?: Omit<ValueTypes["CustomerPrequalApplicationsConnection"], "...on CustomerPrequalApplicationsConnection">
}>;
	["CustomerPrequalApplicationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["PrequalApplication"],
		__typename?: boolean | `@${string}`,
	['...on CustomerPrequalApplicationsConnectionEdge']?: Omit<ValueTypes["CustomerPrequalApplicationsConnectionEdge"], "...on CustomerPrequalApplicationsConnectionEdge">
}>;
	["CustomerPrescreensConnection"]: AliasType<{
	edges?:ValueTypes["CustomerPrescreensConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on CustomerPrescreensConnection']?: Omit<ValueTypes["CustomerPrescreensConnection"], "...on CustomerPrescreensConnection">
}>;
	["CustomerPrescreensConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Prescreen"],
		__typename?: boolean | `@${string}`,
	['...on CustomerPrescreensConnectionEdge']?: Omit<ValueTypes["CustomerPrescreensConnectionEdge"], "...on CustomerPrescreensConnectionEdge">
}>;
	["CustomerPurchaseVehicleInput"]: {
	lifeCycleStage: ValueTypes["VehicleLifeCycleStage"] | Variable<any, string>,
	make: string | Variable<any, string>,
	mileage: number | Variable<any, string>,
	model: string | Variable<any, string>,
	principalPriorUse?: ValueTypes["VehiclePrincipalPriorUse"] | undefined | null | Variable<any, string>,
	stockNumber?: string | undefined | null | Variable<any, string>,
	trim?: string | undefined | null | Variable<any, string>,
	vin: string | Variable<any, string>,
	year: string | Variable<any, string>
};
	["CustomerResidentialAddressesConnection"]: AliasType<{
	edges?:ValueTypes["CustomerResidentialAddressesConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on CustomerResidentialAddressesConnection']?: Omit<ValueTypes["CustomerResidentialAddressesConnection"], "...on CustomerResidentialAddressesConnection">
}>;
	["CustomerResidentialAddressesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Address"],
		__typename?: boolean | `@${string}`,
	['...on CustomerResidentialAddressesConnectionEdge']?: Omit<ValueTypes["CustomerResidentialAddressesConnectionEdge"], "...on CustomerResidentialAddressesConnectionEdge">
}>;
	["CustomerSharedData"]: AliasType<{
	buyerEmail?:boolean | `@${string}`,
	buyerFirstName?:boolean | `@${string}`,
	buyerLastName?:boolean | `@${string}`,
	buyerName?:boolean | `@${string}`,
	buyerOnboardingStep?:boolean | `@${string}`,
	buyerPhoneNumber?:boolean | `@${string}`,
	coBuyerEmail?:boolean | `@${string}`,
	coBuyerFirstName?:boolean | `@${string}`,
	coBuyerLastName?:boolean | `@${string}`,
	coBuyerName?:boolean | `@${string}`,
	coBuyerOnboardingStep?:boolean | `@${string}`,
	coBuyerPhoneNumber?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomerSharedData']?: Omit<ValueTypes["CustomerSharedData"], "...on CustomerSharedData">
}>;
	["CustomerSignupInput"]: {
	email: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	phoneNumber: string | Variable<any, string>
};
	["CustomerTradeVehicleInput"]: {
	bodyType: ValueTypes["VehicleBodyType"] | Variable<any, string>,
	color: string | Variable<any, string>,
	condition: ValueTypes["VehicleCondition"] | Variable<any, string>,
	make: string | Variable<any, string>,
	mileage: number | Variable<any, string>,
	model: string | Variable<any, string>,
	pictureBackId?: string | undefined | null | Variable<any, string>,
	pictureFrontId?: string | undefined | null | Variable<any, string>,
	pictureInteriorId?: string | undefined | null | Variable<any, string>,
	pictureLeftSideId?: string | undefined | null | Variable<any, string>,
	pictureOdometerId?: string | undefined | null | Variable<any, string>,
	pictureRightSideId?: string | undefined | null | Variable<any, string>,
	pictureVinNumberId?: string | undefined | null | Variable<any, string>,
	registrationCardId?: string | undefined | null | Variable<any, string>,
	registrationName: string | Variable<any, string>,
	registrationState: string | Variable<any, string>,
	vin: string | Variable<any, string>,
	year: string | Variable<any, string>
};
	["CustomerTransactionRole"]:CustomerTransactionRole;
	/** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["Date"]:unknown;
	/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["DateTime"]:unknown;
	["DateTimeFilter"]: {
	equals?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	gt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	gte?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["DateTime"]> | undefined | null | Variable<any, string>,
	lt?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	lte?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	not?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>
};
	["Dealership"]: AliasType<{
	address?:boolean | `@${string}`,
contacts?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["ContactV2Filter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["DealershipContactsConnection"]],
	dealershipGroupId?:boolean | `@${string}`,
	enabledPolicyLayers?:boolean | `@${string}`,
forms?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["DealershipFormsConnection"]],
	hasActiveAgilityCreditSubscription?:boolean | `@${string}`,
	hasEnabledAuthenticom?:boolean | `@${string}`,
	hasEnabledCdkCrm?:boolean | `@${string}`,
	hasEnabledCdkDms?:boolean | `@${string}`,
	hasEnabledChatBot?:boolean | `@${string}`,
	hasEnabledComplianceForms?:boolean | `@${string}`,
	hasEnabledDealJacketGalleryView?:boolean | `@${string}`,
	hasEnabledDealerTrack?:boolean | `@${string}`,
	hasEnabledDriversLicenseVerification?:boolean | `@${string}`,
	hasEnabledFormsCatalog?:boolean | `@${string}`,
	hasEnabledIdVerifOverAgility?:boolean | `@${string}`,
	hasEnabledImplicitPrequalsOnHca?:boolean | `@${string}`,
	hasEnabledPostPurchaseDocs?:boolean | `@${string}`,
	hasEnabledPrequalFormService?:boolean | `@${string}`,
	hasEnabledPrescreen?:boolean | `@${string}`,
	hasEnabledRecallMasters?:boolean | `@${string}`,
	hasEnabledReferrals?:boolean | `@${string}`,
	hasEnabledReportingDashboard?:boolean | `@${string}`,
	hasEnabledRoute1?:boolean | `@${string}`,
	hasEnabledStaffAcknowledgement?:boolean | `@${string}`,
	hasEnabledStaffPlanning?:boolean | `@${string}`,
	hasEnabledZipCodeOnSignUp?:boolean | `@${string}`,
	/** Whether or not the dealership has a TDC CDK app subscription ID set. */
	hasTdcCdkAppSubscriptionId?:boolean | `@${string}`,
homenetVehicles?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["HomenetVehicleDataFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	stockNumberSearchString?: string | undefined | null | Variable<any, string>},ValueTypes["DealershipHomenetVehiclesConnection"]],
	id?:boolean | `@${string}`,
	logoUrl?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	postPurchaseBillOfSaleFormId?:boolean | `@${string}`,
	postPurchasePurchaseOrderFormId?:boolean | `@${string}`,
	recallDetailsFormId?:boolean | `@${string}`,
	recallSummaryFormId?:boolean | `@${string}`,
	/** Only applicable when the feature is enabled. See hasEnabledReferrals */
	referralPayoutAmountInUsdCents?:boolean | `@${string}`,
	/** The sales people of a dealership needs to be presented on the signup page */
	salesPeople?:ValueTypes["ListItem"],
	slug?:boolean | `@${string}`,
staff?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["DealershipStaffConnection"]],
	supportedLanguages?:boolean | `@${string}`,
	timeZone?:boolean | `@${string}`,
transactionStatusUpdateDealershipAnalyticsCount?: [{	filter?: ValueTypes["TransactionStatusUpdateDealershipAnalyticsFilter"] | undefined | null | Variable<any, string>},boolean | `@${string}`],
transactionUpdateDealershipSpotCount?: [{	filter?: ValueTypes["TransactionDealershipAnalyticsSpotFilter"] | undefined | null | Variable<any, string>},boolean | `@${string}`],
transactionUpdateStatusSalesRankingGrouped?: [{	filter?: ValueTypes["TransactionSalesRankingAnalyticsWhereInput"] | undefined | null | Variable<any, string>,	page: number | Variable<any, string>,	pageSize: number | Variable<any, string>,	startDate: string | Variable<any, string>},ValueTypes["SalesRankingGrouppedByMonth"]],
transactions?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["TransactionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderby?: ValueTypes["TransactionOrderBy"] | undefined | null | Variable<any, string>,	searchString?: string | undefined | null | Variable<any, string>},ValueTypes["DealershipTransactionsConnection"]],
users?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["UserDealershipFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	isSuspended?: boolean | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	rolesToExclude?: Array<string> | undefined | null | Variable<any, string>,	rolesToInclude?: Array<string> | undefined | null | Variable<any, string>,	searchString?: string | undefined | null | Variable<any, string>},ValueTypes["DealershipUsersConnection"]],
	website?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Dealership']?: Omit<ValueTypes["Dealership"], "...on Dealership">
}>;
	["DealershipContactsConnection"]: AliasType<{
	edges?:ValueTypes["DealershipContactsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipContactsConnection']?: Omit<ValueTypes["DealershipContactsConnection"], "...on DealershipContactsConnection">
}>;
	["DealershipContactsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["ContactV2"],
		__typename?: boolean | `@${string}`,
	['...on DealershipContactsConnectionEdge']?: Omit<ValueTypes["DealershipContactsConnectionEdge"], "...on DealershipContactsConnectionEdge">
}>;
	["DealershipFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	slug?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["DealershipFormsConnection"]: AliasType<{
	edges?:ValueTypes["DealershipFormsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipFormsConnection']?: Omit<ValueTypes["DealershipFormsConnection"], "...on DealershipFormsConnection">
}>;
	["DealershipFormsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Form"],
		__typename?: boolean | `@${string}`,
	['...on DealershipFormsConnectionEdge']?: Omit<ValueTypes["DealershipFormsConnectionEdge"], "...on DealershipFormsConnectionEdge">
}>;
	["DealershipGroup"]: AliasType<{
	address?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phoneNumber?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipGroup']?: Omit<ValueTypes["DealershipGroup"], "...on DealershipGroup">
}>;
	["DealershipHomenetVehiclesConnection"]: AliasType<{
	edges?:ValueTypes["DealershipHomenetVehiclesConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on DealershipHomenetVehiclesConnection']?: Omit<ValueTypes["DealershipHomenetVehiclesConnection"], "...on DealershipHomenetVehiclesConnection">
}>;
	["DealershipHomenetVehiclesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["HomenetVehicleData"],
		__typename?: boolean | `@${string}`,
	['...on DealershipHomenetVehiclesConnectionEdge']?: Omit<ValueTypes["DealershipHomenetVehiclesConnectionEdge"], "...on DealershipHomenetVehiclesConnectionEdge">
}>;
	["DealershipPermType"]: AliasType<{
	dealershipGroupId?:boolean | `@${string}`,
	dealershipGroupName?:boolean | `@${string}`,
	dealershipId?:boolean | `@${string}`,
	dealershipName?:boolean | `@${string}`,
	extraPermissions?:boolean | `@${string}`,
	groupRole?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipPermType']?: Omit<ValueTypes["DealershipPermType"], "...on DealershipPermType">
}>;
	["DealershipPurchaseVehicleInput"]: {
	bodyType?: ValueTypes["VehicleBodyType"] | undefined | null | Variable<any, string>,
	lifeCycleStage: ValueTypes["VehicleLifeCycleStage"] | Variable<any, string>,
	make: string | Variable<any, string>,
	mileage: number | Variable<any, string>,
	model: string | Variable<any, string>,
	msrp?: number | undefined | null | Variable<any, string>,
	principalPriorUse?: ValueTypes["VehiclePrincipalPriorUse"] | undefined | null | Variable<any, string>,
	stockNumber?: string | undefined | null | Variable<any, string>,
	trim?: string | undefined | null | Variable<any, string>,
	vin: string | Variable<any, string>,
	year: string | Variable<any, string>
};
	["DealershipStaffConnection"]: AliasType<{
	edges?:ValueTypes["DealershipStaffConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipStaffConnection']?: Omit<ValueTypes["DealershipStaffConnection"], "...on DealershipStaffConnection">
}>;
	["DealershipStaffConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Staff"],
		__typename?: boolean | `@${string}`,
	['...on DealershipStaffConnectionEdge']?: Omit<ValueTypes["DealershipStaffConnectionEdge"], "...on DealershipStaffConnectionEdge">
}>;
	["DealershipTradeVehicleInput"]: {
	bodyType: ValueTypes["VehicleBodyType"] | Variable<any, string>,
	color: string | Variable<any, string>,
	condition: ValueTypes["VehicleCondition"] | Variable<any, string>,
	lifeCycleStage?: ValueTypes["VehicleLifeCycleStage"] | undefined | null | Variable<any, string>,
	make: string | Variable<any, string>,
	mileage: number | Variable<any, string>,
	model: string | Variable<any, string>,
	registrationName: string | Variable<any, string>,
	registrationState?: string | undefined | null | Variable<any, string>,
	vin: string | Variable<any, string>,
	year: string | Variable<any, string>
};
	["DealershipTransactionsConnection"]: AliasType<{
	edges?:ValueTypes["DealershipTransactionsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipTransactionsConnection']?: Omit<ValueTypes["DealershipTransactionsConnection"], "...on DealershipTransactionsConnection">
}>;
	["DealershipTransactionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Transaction"],
		__typename?: boolean | `@${string}`,
	['...on DealershipTransactionsConnectionEdge']?: Omit<ValueTypes["DealershipTransactionsConnectionEdge"], "...on DealershipTransactionsConnectionEdge">
}>;
	["DealershipUsersConnection"]: AliasType<{
	edges?:ValueTypes["DealershipUsersConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DealershipUsersConnection']?: Omit<ValueTypes["DealershipUsersConnection"], "...on DealershipUsersConnection">
}>;
	["DealershipUsersConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["UserDealership"],
		__typename?: boolean | `@${string}`,
	['...on DealershipUsersConnectionEdge']?: Omit<ValueTypes["DealershipUsersConnectionEdge"], "...on DealershipUsersConnectionEdge">
}>;
	["Document"]: AliasType<{
	access?:boolean | `@${string}`,
	cdkDealJacketStatus?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	customer?:ValueTypes["Customer"],
	file?:ValueTypes["File"],
	id?:boolean | `@${string}`,
	labels?:ValueTypes["DocumentLabelAttachment"],
	pdfIsEncrypted?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Document']?: Omit<ValueTypes["Document"], "...on Document">
}>;
	["DocumentLabel"]: AliasType<{
	code?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DocumentLabel']?: Omit<ValueTypes["DocumentLabel"], "...on DocumentLabel">
}>;
	["DocumentLabelAttachment"]: AliasType<{
	documentLabel?:ValueTypes["DocumentLabel"],
	isActive?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DocumentLabelAttachment']?: Omit<ValueTypes["DocumentLabelAttachment"], "...on DocumentLabelAttachment">
}>;
	["DocumentLabelOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["DocumentOr"]: {
	access?: ValueTypes["FormSubmissionAccessEmumFilter"] | undefined | null | Variable<any, string>,
	dealershipReadAccess?: ValueTypes["RoleListFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	userId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["DocumentOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["Employment"]: AliasType<{
	customer?:ValueTypes["Customer"],
	durationMonths?:boolean | `@${string}`,
	durationYears?:boolean | `@${string}`,
	employerName?:boolean | `@${string}`,
	employerPhoneNumber?:boolean | `@${string}`,
	employmentStatus?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	incomeAmount?:boolean | `@${string}`,
	incomeInterval?:boolean | `@${string}`,
	occupation?:boolean | `@${string}`,
	otherIncomeAmount?:boolean | `@${string}`,
	otherIncomeInterval?:boolean | `@${string}`,
	otherIncomeSource?:boolean | `@${string}`,
	timelinePosition?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Employment']?: Omit<ValueTypes["Employment"], "...on Employment">
}>;
	["EmploymentStatus"]:EmploymentStatus;
	/** A frequently asked question with its answer. FAQs can be scoped to a specific dealership, a dealership group, or global (visible to all authenticated users). */
["Faq"]: AliasType<{
	/** The answer text. */
	answer?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	/** If set, this FAQ belongs to a dealership group and is visible to all dealerships in that group. */
	dealershipGroupId?:boolean | `@${string}`,
	/** If set, this FAQ belongs to a specific dealership and is only visible to users of that dealership. */
	dealershipId?:boolean | `@${string}`,
	/** Unique identifier for this FAQ. */
	id?:boolean | `@${string}`,
	/** The question text. */
	question?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Faq']?: Omit<ValueTypes["Faq"], "...on Faq">
}>;
	["FieldOrdering"]:FieldOrdering;
	["File"]: AliasType<{
	id?:boolean | `@${string}`,
	uploader?:ValueTypes["User"],
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on File']?: Omit<ValueTypes["File"], "...on File">
}>;
	["FinanceType"]:FinanceType;
	["FinanceTypeFilter"]: {
	equals?: ValueTypes["FinanceType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["FinanceType"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FinanceTypeFilter"] | undefined | null | Variable<any, string>
};
	["Form"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	displayTitle?:boolean | `@${string}`,
formFields?: [{	filter?: ValueTypes["FormFieldFilter"] | undefined | null | Variable<any, string>},ValueTypes["FormField"]],
	formOrder?:ValueTypes["FormOrder"],
	id?:boolean | `@${string}`,
	pdfFileUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Form']?: Omit<ValueTypes["Form"], "...on Form">
}>;
	["FormCollectionStatus"]:FormCollectionStatus;
	["FormCollectionStatusFilter"]: {
	equals?: ValueTypes["FormCollectionStatus"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["FormCollectionStatus"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormCollectionStatusFilter"] | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["FormCollectionStatus"]> | undefined | null | Variable<any, string>
};
	["FormCollectionType"]:FormCollectionType;
	["FormCollectionTypeFilter"]: {
	equals?: ValueTypes["FormCollectionType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["FormCollectionType"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormCollectionTypeFilter"] | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["FormCollectionType"]> | undefined | null | Variable<any, string>
};
	["FormField"]: AliasType<{
	characterListLength?:boolean | `@${string}`,
	checkboxGroup?:ValueTypes["CheckBoxGroup"],
	createdAt?:boolean | `@${string}`,
	demoData?:boolean | `@${string}`,
	enteredBy?:boolean | `@${string}`,
	fixedValue?:boolean | `@${string}`,
	form?:ValueTypes["Form"],
	formFieldId?:boolean | `@${string}`,
	formFieldPlacements?:ValueTypes["FormFieldPlacement"],
	formId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	isAdminAllowed?:boolean | `@${string}`,
	isOptional?:boolean | `@${string}`,
	prefillPath?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on FormField']?: Omit<ValueTypes["FormField"], "...on FormField">
}>;
	["FormFieldFilter"]: {
	isAdminAllowed?: ValueTypes["BooleanFilter"] | undefined | null | Variable<any, string>,
	prefillPath?: string | undefined | null | Variable<any, string>
};
	["FormFieldPlacement"]: AliasType<{
	characterListSpacing?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	formField?:ValueTypes["FormField"],
	formFieldId?:boolean | `@${string}`,
	formFieldPlacementId?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	positionX?:boolean | `@${string}`,
	positionY?:boolean | `@${string}`,
	textAlignment?:boolean | `@${string}`,
	textBold?:boolean | `@${string}`,
	textFontSize?:boolean | `@${string}`,
	textItalic?:boolean | `@${string}`,
	textLineHeight?:boolean | `@${string}`,
	textUnderline?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on FormFieldPlacement']?: Omit<ValueTypes["FormFieldPlacement"], "...on FormFieldPlacement">
}>;
	["FormFieldSubmission"]: AliasType<{
	field?:ValueTypes["FormField"],
	fieldId?:boolean | `@${string}`,
	file?:ValueTypes["File"],
	formSubmission?:ValueTypes["FormSubmission"],
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on FormFieldSubmission']?: Omit<ValueTypes["FormFieldSubmission"], "...on FormFieldSubmission">
}>;
	["FormFieldSubmissionAllowedUserFilter"]: {
	userId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["FormFieldSubmissionAllowedUserListFilter"]: {
	some?: ValueTypes["FormFieldSubmissionAllowedUserFilter"] | undefined | null | Variable<any, string>
};
	["FormFieldSubmissionFilter"]: {
	OR?: Array<ValueTypes["FormFieldSubmissionOrFilter"]> | undefined | null | Variable<any, string>,
	allowedUsers?: ValueTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null | Variable<any, string>,
	field?: ValueTypes["FormFieldFilter"] | undefined | null | Variable<any, string>,
	fileId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	formSubmissionId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	value?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>
};
	["FormFieldSubmissionOrFilter"]: {
	allowedUsers?: ValueTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null | Variable<any, string>,
	field?: ValueTypes["FormFieldFilter"] | undefined | null | Variable<any, string>
};
	["FormFieldSubmissionOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["FormFieldType"]:FormFieldType;
	["FormFieldValue"]: {
	fileId?: string | undefined | null | Variable<any, string>,
	submissionFieldId: string | Variable<any, string>,
	value?: string | undefined | null | Variable<any, string>
};
	["FormOrder"]: AliasType<{
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on FormOrder']?: Omit<ValueTypes["FormOrder"], "...on FormOrder">
}>;
	["FormRequestErrorCode"]:FormRequestErrorCode;
	["FormSubmission"]: AliasType<{
	access?:boolean | `@${string}`,
	cdkDealJacketStatus?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	customer?:ValueTypes["Customer"],
	file?:ValueTypes["File"],
	fileId?:boolean | `@${string}`,
	form?:ValueTypes["Form"],
	formCollection?:ValueTypes["FormSubmissionCollection"],
formFieldSubmissions?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["FormFieldSubmissionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["FormSubmissionFormFieldSubmissionsConnection"]],
	formSubmissionData?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on FormSubmission']?: Omit<ValueTypes["FormSubmission"], "...on FormSubmission">
}>;
	["FormSubmissionAccessEmum"]:FormSubmissionAccessEmum;
	/** If the user filters in elements it can not access, it will fail */
["FormSubmissionAccessEmumFilter"]: {
	equals?: ValueTypes["FormSubmissionAccessEmum"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["FormSubmissionAccessEmum"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormSubmissionAccessEmumFilter"] | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["FormSubmissionAccessEmum"]> | undefined | null | Variable<any, string>
};
	["FormSubmissionCollection"]: AliasType<{
	createdAt?:boolean | `@${string}`,
formSubmissions?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["FormSubmissionCollectionFormSubmissionsConnection"]],
	id?:boolean | `@${string}`,
	isCollectionStale?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on FormSubmissionCollection']?: Omit<ValueTypes["FormSubmissionCollection"], "...on FormSubmissionCollection">
}>;
	["FormSubmissionCollectionFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["FormCollectionStatusFilter"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["FormCollectionTypeFilter"] | undefined | null | Variable<any, string>
};
	["FormSubmissionCollectionFormSubmissionsConnection"]: AliasType<{
	edges?:ValueTypes["FormSubmissionCollectionFormSubmissionsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on FormSubmissionCollectionFormSubmissionsConnection']?: Omit<ValueTypes["FormSubmissionCollectionFormSubmissionsConnection"], "...on FormSubmissionCollectionFormSubmissionsConnection">
}>;
	["FormSubmissionCollectionFormSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["FormSubmission"],
		__typename?: boolean | `@${string}`,
	['...on FormSubmissionCollectionFormSubmissionsConnectionEdge']?: Omit<ValueTypes["FormSubmissionCollectionFormSubmissionsConnectionEdge"], "...on FormSubmissionCollectionFormSubmissionsConnectionEdge">
}>;
	["FormSubmissionCollectionOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["FormSubmissionFilter"]: {
	access?: ValueTypes["FormSubmissionAccessEmumFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["FormSubmissionStatusFilter"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["FormSubmissionTypeFilter"] | undefined | null | Variable<any, string>,
	userId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["FormSubmissionFormFieldSubmissionsConnection"]: AliasType<{
	edges?:ValueTypes["FormSubmissionFormFieldSubmissionsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on FormSubmissionFormFieldSubmissionsConnection']?: Omit<ValueTypes["FormSubmissionFormFieldSubmissionsConnection"], "...on FormSubmissionFormFieldSubmissionsConnection">
}>;
	["FormSubmissionFormFieldSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["FormFieldSubmission"],
		__typename?: boolean | `@${string}`,
	['...on FormSubmissionFormFieldSubmissionsConnectionEdge']?: Omit<ValueTypes["FormSubmissionFormFieldSubmissionsConnectionEdge"], "...on FormSubmissionFormFieldSubmissionsConnectionEdge">
}>;
	["FormSubmissionStatus"]:FormSubmissionStatus;
	["FormSubmissionStatusFilter"]: {
	equals?: ValueTypes["FormSubmissionStatus"] | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormSubmissionStatusFilter"] | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["FormSubmissionStatus"]> | undefined | null | Variable<any, string>
};
	["FormSubmissionType"]:FormSubmissionType;
	["FormSubmissionTypeFilter"]: {
	equals?: ValueTypes["FormSubmissionType"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["FormSubmissionType"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["FormSubmissionTypeFilter"] | undefined | null | Variable<any, string>
};
	["GraphQLError"]: AliasType<{
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on GraphQLError']?: Omit<ValueTypes["GraphQLError"], "...on GraphQLError">
}>;
	["HardCreditApplication"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
	driversLicenseNumber?:boolean | `@${string}`,
	driversLicenseState?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	employments?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	formSubmission?:ValueTypes["FormSubmission"],
	formSubmissionId?:boolean | `@${string}`,
	homePhoneNumber?:boolean | `@${string}`,
	housingCostUsdCents?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	incomeInterval?:boolean | `@${string}`,
	incomeUsdCents?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	middleName?:boolean | `@${string}`,
	personalReferenceAddress?:ValueTypes["Address"],
	personalReferenceAddressId?:boolean | `@${string}`,
	personalReferenceFirstName?:boolean | `@${string}`,
	personalReferenceLastName?:boolean | `@${string}`,
	personalReferenceMiddleName?:boolean | `@${string}`,
	personalReferencePhoneNumber?:boolean | `@${string}`,
	personalReferenceRelationship?:boolean | `@${string}`,
	phoneNumber?:boolean | `@${string}`,
	residentialAddresses?:boolean | `@${string}`,
	/** Full SSN for the data owner, masked (last 4 only) for others */
	socialSecurityNumber?:boolean | `@${string}`,
	transaction?:ValueTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on HardCreditApplication']?: Omit<ValueTypes["HardCreditApplication"], "...on HardCreditApplication">
}>;
	["HardCreditApplicationFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["HardCreditApplicationOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["HomenetVehicleData"]: AliasType<{
	bodyType?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	dealerId?:boolean | `@${string}`,
	fuelType?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	locationId?:boolean | `@${string}`,
	make?:boolean | `@${string}`,
	mileage?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	msrp?:boolean | `@${string}`,
	rooftopId?:boolean | `@${string}`,
	stockNumber?:boolean | `@${string}`,
	transmission?:boolean | `@${string}`,
	trim?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	vehicleId?:boolean | `@${string}`,
	vin?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on HomenetVehicleData']?: Omit<ValueTypes["HomenetVehicleData"], "...on HomenetVehicleData">
}>;
	["HomenetVehicleDataFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["HousingStatus"]:HousingStatus;
	["IDFilter"]: {
	equals?: string | undefined | null | Variable<any, string>,
	in?: Array<string> | undefined | null | Variable<any, string>,
	not?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["IdCard"]: AliasType<{
	captureBack?:ValueTypes["File"],
	captureBackId?:boolean | `@${string}`,
	captureBackRotation?:boolean | `@${string}`,
	captureFront?:ValueTypes["File"],
	captureFrontId?:boolean | `@${string}`,
	captureFrontRotation?:boolean | `@${string}`,
	cityInAddress?:boolean | `@${string}`,
	class?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
	dobDateOnly?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	expirationDateOnly?:boolean | `@${string}`,
	eyeColor?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	idNumber?:boolean | `@${string}`,
	issueDate?:boolean | `@${string}`,
	issueDateOnly?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	middleName?:boolean | `@${string}`,
	requestedIdVerificationAt?:boolean | `@${string}`,
	sex?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	stateInAddress?:boolean | `@${string}`,
	streetInAddress?:boolean | `@${string}`,
	suffix?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	zipCodeInAddress?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on IdCard']?: Omit<ValueTypes["IdCard"], "...on IdCard">
}>;
	["IdCardType"]:IdCardType;
	["ImageRotation"]:ImageRotation;
	["IncomeInterval"]:IncomeInterval;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]:unknown;
	["LenderHardCreditApplication"]: AliasType<{
	buyerHousingCostCents?:boolean | `@${string}`,
	buyerIncomeCents?:boolean | `@${string}`,
	buyerIncomeInterval?:boolean | `@${string}`,
	coBuyerHousingCostCents?:boolean | `@${string}`,
	coBuyerIncomeCents?:boolean | `@${string}`,
	coBuyerIncomeInterval?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LenderHardCreditApplication']?: Omit<ValueTypes["LenderHardCreditApplication"], "...on LenderHardCreditApplication">
}>;
	["LenderHardCreditApplicationOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["LendingPortalAddressEntryInput"]: {
	apartmentDetails?: string | undefined | null | Variable<any, string>,
	city?: string | undefined | null | Variable<any, string>,
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	housingStatus?: ValueTypes["HousingStatus"] | undefined | null | Variable<any, string>,
	monthlyPayment?: number | undefined | null | Variable<any, string>,
	state?: string | undefined | null | Variable<any, string>,
	street?: string | undefined | null | Variable<any, string>,
	timelinePosition: number | Variable<any, string>,
	zipCode?: string | undefined | null | Variable<any, string>
};
	["LendingPortalCustomerDataInput"]: {
	dob?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	middleName?: string | undefined | null | Variable<any, string>,
	socialSecurityNumber?: string | undefined | null | Variable<any, string>
};
	["LendingPortalEmploymentEntryInput"]: {
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	employerName?: string | undefined | null | Variable<any, string>,
	employerPhoneNumber?: string | undefined | null | Variable<any, string>,
	employmentStatus?: ValueTypes["EmploymentStatus"] | undefined | null | Variable<any, string>,
	incomeAmount?: number | undefined | null | Variable<any, string>,
	incomeInterval?: ValueTypes["IncomeInterval"] | undefined | null | Variable<any, string>,
	occupation?: string | undefined | null | Variable<any, string>,
	otherIncomeAmount?: number | undefined | null | Variable<any, string>,
	otherIncomeInterval?: ValueTypes["IncomeInterval"] | undefined | null | Variable<any, string>,
	otherIncomeSource?: string | undefined | null | Variable<any, string>,
	timelinePosition: number | Variable<any, string>
};
	["LendingPortalPurchaseVehicleDataInput"]: {
	color?: string | undefined | null | Variable<any, string>,
	lifeCycleStage?: ValueTypes["VehicleLifeCycleStage"] | undefined | null | Variable<any, string>,
	make?: string | undefined | null | Variable<any, string>,
	mileage?: number | undefined | null | Variable<any, string>,
	model?: string | undefined | null | Variable<any, string>,
	stockNumber?: string | undefined | null | Variable<any, string>,
	trim?: string | undefined | null | Variable<any, string>,
	vin?: string | undefined | null | Variable<any, string>,
	year?: string | undefined | null | Variable<any, string>
};
	["LendingPortalTradeVehicleDataInput"]: {
	color?: string | undefined | null | Variable<any, string>,
	lifeCycleStage?: ValueTypes["VehicleLifeCycleStage"] | undefined | null | Variable<any, string>,
	make?: string | undefined | null | Variable<any, string>,
	mileage?: number | undefined | null | Variable<any, string>,
	model?: string | undefined | null | Variable<any, string>,
	stockNumber?: string | undefined | null | Variable<any, string>,
	trim?: string | undefined | null | Variable<any, string>,
	vin?: string | undefined | null | Variable<any, string>,
	year?: string | undefined | null | Variable<any, string>
};
	["LicensePrefillData"]: AliasType<{
	make?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	trim?:boolean | `@${string}`,
	vin?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LicensePrefillData']?: Omit<ValueTypes["LicensePrefillData"], "...on LicensePrefillData">
}>;
	["ListItem"]: AliasType<{
	label?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ListItem']?: Omit<ValueTypes["ListItem"], "...on ListItem">
}>;
	["LivelinessSession"]: AliasType<{
	auditImages?:ValueTypes["File"],
	awsLivelinessSessionId?:boolean | `@${string}`,
	confidence?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	dealership?:ValueTypes["Dealership"],
	dealershipId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	referenceImage?:ValueTypes["File"],
	status?:boolean | `@${string}`,
	transaction?:ValueTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	upddatedAt?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LivelinessSession']?: Omit<ValueTypes["LivelinessSession"], "...on LivelinessSession">
}>;
	["LivelinessSessionFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["LoginOptionType"]:LoginOptionType;
	["LoginResponse"]: AliasType<{
	jwt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on LoginResponse']?: Omit<ValueTypes["LoginResponse"], "...on LoginResponse">
}>;
	["MakeFileUploadForScannerType"]: AliasType<{
	fileId?:boolean | `@${string}`,
	uploadUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MakeFileUploadForScannerType']?: Omit<ValueTypes["MakeFileUploadForScannerType"], "...on MakeFileUploadForScannerType">
}>;
	["MakeFileUploadType"]: AliasType<{
	file?:ValueTypes["File"],
	fileId?:boolean | `@${string}`,
	uploadUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MakeFileUploadType']?: Omit<ValueTypes["MakeFileUploadType"], "...on MakeFileUploadType">
}>;
	["MeType"]: AliasType<{
chats?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	id?: string | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["MeTypeChatsConnection"]],
	dealershipGroup?:ValueTypes["DealershipGroup"],
	dealerships?:ValueTypes["Dealership"],
	ipAddress?:boolean | `@${string}`,
	/** List of dealerships the user has access to and is a staff at */
	staffAt?:ValueTypes["DealershipPermType"],
	user?:ValueTypes["User"],
		__typename?: boolean | `@${string}`,
	['...on MeType']?: Omit<ValueTypes["MeType"], "...on MeType">
}>;
	["MeTypeChatsConnection"]: AliasType<{
	edges?:ValueTypes["MeTypeChatsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on MeTypeChatsConnection']?: Omit<ValueTypes["MeTypeChatsConnection"], "...on MeTypeChatsConnection">
}>;
	["MeTypeChatsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Chat"],
		__typename?: boolean | `@${string}`,
	['...on MeTypeChatsConnectionEdge']?: Omit<ValueTypes["MeTypeChatsConnectionEdge"], "...on MeTypeChatsConnectionEdge">
}>;
	["Mutation"]: AliasType<{
addScanToDealerJacket?: [{	access: ValueTypes["FormSubmissionAccessEmum"] | Variable<any, string>,	addTo: ValueTypes["CustomerTransactionRole"] | Variable<any, string>,	fileId: string | Variable<any, string>,	submissionToken: string | Variable<any, string>,	title: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationAddScanToDealerJacketResult"]],
addScanToGloveCompartments?: [{	fileId: string | Variable<any, string>,	submissionToken: string | Variable<any, string>,	title: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationAddScanToGloveCompartmentsResult"]],
assignStaffToTransaction?: [{	assigneeId: string | Variable<any, string>,	role: ValueTypes["Role"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationAssignStaffToTransactionResult"]],
cancelFormCollection?: [{	formCollectionId: string | Variable<any, string>},ValueTypes["MutationCancelFormCollectionResult"]],
cancelPreviousAndRequestSignatures?: [{	lifeCycle: ValueTypes["TransactionLifecycle"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationCancelPreviousAndRequestSignaturesResult"]],
changeDocumentAccess?: [{	/** Document ID */
	documentId: string | Variable<any, string>,	/** New document access */
	newAccess: ValueTypes["FormSubmissionAccessEmum"] | Variable<any, string>},ValueTypes["MutationChangeDocumentAccessResult"]],
changeFormSubmissionAccess?: [{	/** Form Submission ID */
	formSubmissionId: string | Variable<any, string>,	/** New form access */
	newAccess: ValueTypes["FormSubmissionAccessEmum"] | Variable<any, string>},ValueTypes["MutationChangeFormSubmissionAccessResult"]],
createAndSubmitCreditAndPrequalApplication?: [{	formSubmissionData: ValueTypes["CreditApplicationFormSubmissionInput"] | Variable<any, string>,	signedUploadedCreditApplicationDocumentId: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationCreateAndSubmitCreditAndPrequalApplicationResult"]],
createChat?: [{	initialContext: string | Variable<any, string>},ValueTypes["MutationCreateChatResult"]],
createCoBuyer?: [{	coBuyer: ValueTypes["CreateCustomerInput"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationCreateCoBuyerResult"]],
createCreditApplicationAndCreateUser?: [{	dealershipId: string | Variable<any, string>,	formData: ValueTypes["CreditApplicationInput"] | Variable<any, string>},ValueTypes["MutationCreateCreditApplicationAndCreateUserResult"]],
createEmployment?: [{	employment: ValueTypes["CreateEmploymentInput"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationCreateEmploymentResult"]],
createGroupuser?: [{	dealershipId: string | Variable<any, string>,	role: ValueTypes["Role"] | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationCreateGroupuserResult"]],
createMessage?: [{	chatId: string | Variable<any, string>,	message: string | Variable<any, string>},ValueTypes["MutationCreateMessageResult"]],
createStaff?: [{	dealershipId: string | Variable<any, string>,	user: ValueTypes["CreateUserInput"] | Variable<any, string>},ValueTypes["MutationCreateStaffResult"]],
createStaffScheduleEvents?: [{	input: ValueTypes["CreateStaffScheduleEventsInput"] | Variable<any, string>},ValueTypes["MutationCreateStaffScheduleEventsResult"]],
createTransactionAndSubmitTestDrive?: [{	captureBackFileId: string | Variable<any, string>,	captureFrontFileId: string | Variable<any, string>,	contactConsentAckTmplId: string | Variable<any, string>,	dealershipId: string | Variable<any, string>,	dmvForm: string | Variable<any, string>,	dmvPdfFileId: string | Variable<any, string>,	pdf417String?: string | undefined | null | Variable<any, string>,	privacyNoticeFileId: string | Variable<any, string>,	privacyNoticeForm: string | Variable<any, string>,	tdcConsentsAckTmplId: string | Variable<any, string>,	testDriveAckTmplId: string | Variable<any, string>},ValueTypes["MutationCreateTransactionAndSubmitTestDriveResult"]],
createUserFeedback?: [{	category: string | Variable<any, string>,	message: string | Variable<any, string>},ValueTypes["MutationCreateUserFeedbackResult"]],
customerCreatePrefilledTransaction?: [{	dealershipSlug: string | Variable<any, string>,	language: string | Variable<any, string>,	source: ValueTypes["TransactionSource"] | Variable<any, string>},ValueTypes["MutationCustomerCreatePrefilledTransactionResult"]],
customerCreatePurchaseVehicle?: [{	transactionId: string | Variable<any, string>,	vehicle: ValueTypes["CustomerPurchaseVehicleInput"] | Variable<any, string>},ValueTypes["MutationCustomerCreatePurchaseVehicleResult"]],
customerCreateTradeVehicle?: [{	transactionId: string | Variable<any, string>,	vehicle: ValueTypes["CustomerTradeVehicleInput"] | Variable<any, string>},ValueTypes["MutationCustomerCreateTradeVehicleResult"]],
customerCreateTransaction?: [{	dealershipSlug: string | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	language: string | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	salesPersonId?: string | undefined | null | Variable<any, string>,	source: ValueTypes["TransactionSource"] | Variable<any, string>},ValueTypes["MutationCustomerCreateTransactionResult"]],
customerCreateUnauthenticatedTransaction?: [{	dealershipId: string | Variable<any, string>,	language: string | Variable<any, string>,	salesPersonId?: string | undefined | null | Variable<any, string>,	source: ValueTypes["TransactionSource"] | Variable<any, string>,	/** Providing this value indicated accept of the corresponding text */
	tdcConsentsTemplateId: string | Variable<any, string>,	user: ValueTypes["CreateUserInput"] | Variable<any, string>,	zipCode?: string | undefined | null | Variable<any, string>},ValueTypes["MutationCustomerCreateUnauthenticatedTransactionResult"]],
customerReferral?: [{	email: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	phoneNumber: string | Variable<any, string>},ValueTypes["MutationCustomerReferralResult"]],
customerReferralPaid?: [{	paidAmountInUsdCents: number | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationCustomerReferralPaidResult"]],
customerSignupWithCognito?: [{	dealershipId: string | Variable<any, string>,	hasConsentedToSms: boolean | Variable<any, string>,	user: ValueTypes["CustomerSignupInput"] | Variable<any, string>},ValueTypes["MutationCustomerSignupWithCognitoResult"]],
customerUpdatePhoneNumber?: [{	newPhoneNumber: string | Variable<any, string>},ValueTypes["MutationCustomerUpdatePhoneNumberResult"]],
customerUpdatePurchaseVehicle?: [{	vehicle: ValueTypes["CustomerPurchaseVehicleInput"] | Variable<any, string>,	vehicleId: string | Variable<any, string>},ValueTypes["MutationCustomerUpdatePurchaseVehicleResult"]],
customerUpdateTradeVehicle?: [{	vehicle: ValueTypes["CustomerTradeVehicleInput"] | Variable<any, string>,	vehicleId: string | Variable<any, string>},ValueTypes["MutationCustomerUpdateTradeVehicleResult"]],
dealershipCreatePurchaseVehicle?: [{	transactionId: string | Variable<any, string>,	vehicle: ValueTypes["DealershipPurchaseVehicleInput"] | Variable<any, string>},ValueTypes["MutationDealershipCreatePurchaseVehicleResult"]],
dealershipCreateTradeVehicle?: [{	transactionId: string | Variable<any, string>,	vehicle: ValueTypes["DealershipTradeVehicleInput"] | Variable<any, string>},ValueTypes["MutationDealershipCreateTradeVehicleResult"]],
dealershipCreateTransaction?: [{	customer: ValueTypes["CreateCustomerInput"] | Variable<any, string>,	staff?: ValueTypes["UpdateTransactionStaffInput"] | undefined | null | Variable<any, string>},ValueTypes["MutationDealershipCreateTransactionResult"]],
dealershipRemoveTradeVehicle?: [{	vehicleId: string | Variable<any, string>},ValueTypes["MutationDealershipRemoveTradeVehicleResult"]],
dealershipUpdatePurchaseVehicle?: [{	vehicle: ValueTypes["DealershipPurchaseVehicleInput"] | Variable<any, string>,	vehicleId: string | Variable<any, string>},ValueTypes["MutationDealershipUpdatePurchaseVehicleResult"]],
dealershipUpdateTradeVehicle?: [{	vehicle: ValueTypes["DealershipTradeVehicleInput"] | Variable<any, string>,	vehicleId: string | Variable<any, string>},ValueTypes["MutationDealershipUpdateTradeVehicleResult"]],
deleteStaffScheduleEvent?: [{	id: string | Variable<any, string>},ValueTypes["MutationDeleteStaffScheduleEventResult"]],
dismissNotifications?: [{	ids: Array<string> | Variable<any, string>},ValueTypes["MutationDismissNotificationsResult"]],
extractVehicleFromRegistration?: [{	/** When true, the registration PDF will be added as a document to the transaction deal jacket after extraction completes */
	addToDealjacket: boolean | Variable<any, string>,	/** The ID of the uploaded registration PDF file */
	fileId: string | Variable<any, string>,	/** The transaction ID to add the document to */
	transactionId: string | Variable<any, string>},ValueTypes["MutationExtractVehicleFromRegistrationResult"]],
finalizeLivenessAnalysis?: [{	sessionId: string | Variable<any, string>},ValueTypes["MutationFinalizeLivenessAnalysisResult"]],
login?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["MutationLoginResult"]],
	/** Log a user out by deleting the auth cookie */
	logout?:ValueTypes["MutationLogoutResult"],
	/** Make a submission token that is valid for 5 requsts in 30 minutes */
	makeSubmissionToken?:ValueTypes["MutationMakeSubmissionTokenResult"],
makeUpload?: [{	fileExt: string | Variable<any, string>,	mimeType: string | Variable<any, string>},ValueTypes["MutationMakeUploadResult"]],
makeUploadForScanner?: [{	addTo?: ValueTypes["CustomerTransactionRole"] | undefined | null | Variable<any, string>,	submissionToken: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationMakeUploadForScannerResult"]],
makeUploadToTransaction?: [{	addTo: ValueTypes["CustomerTransactionRole"] | Variable<any, string>,	fileExt: string | Variable<any, string>,	mimeType: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationMakeUploadToTransactionResult"]],
markTransactionAsDelivered?: [{	transactionId: string | Variable<any, string>},ValueTypes["MutationMarkTransactionAsDeliveredResult"]],
modifyHardCreditApplication?: [{	formSubmissionData: ValueTypes["CreditApplicationFormSubmissionInput"] | Variable<any, string>,	signedUploadedCreditApplicationDocumentId: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationModifyHardCreditApplicationResult"]],
onboardingSubmitStep1?: [{	isRemoteTransaction: boolean | Variable<any, string>,	step1: ValueTypes["SubmitStep1Input"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationOnboardingSubmitStep1Result"]],
onboardingSubmitStep2?: [{	step2: ValueTypes["SubmitStep2Input"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationOnboardingSubmitStep2Result"]],
overrideTodo?: [{	overrideNote: string | Variable<any, string>,	todoId: string | Variable<any, string>},ValueTypes["MutationOverrideTodoResult"]],
preLoginCheck?: [{	dealershipId?: string | undefined | null | Variable<any, string>,	email: string | Variable<any, string>},ValueTypes["MutationPreLoginCheckResult"]],
prefillLicensePlateOrVin?: [{	licensePlate?: string | undefined | null | Variable<any, string>,	state?: string | undefined | null | Variable<any, string>,	vin?: string | undefined | null | Variable<any, string>},ValueTypes["MutationPrefillLicensePlateOrVinResult"]],
pushDataToCrms?: [{	transactionId: string | Variable<any, string>},ValueTypes["MutationPushDataToCrmsResult"]],
pushDocumentToCdkDealJacket?: [{	documentName: string | Variable<any, string>,	fileId: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationPushDocumentToCdkDealJacketResult"]],
pushDocumentsToCdk?: [{	/** Document IDs */
	ids: Array<string> | Variable<any, string>},ValueTypes["MutationPushDocumentsToCdkResult"]],
pushFormSubmissionsToCdk?: [{	/** Form submission ID */
	ids: Array<string> | Variable<any, string>},ValueTypes["MutationPushFormSubmissionsToCdkResult"]],
pushHardCreditApplication?: [{	submitTo: ValueTypes["SubmitTo"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationPushHardCreditApplicationResult"]],
recordConsent?: [{	consentedToTmplId: string | Variable<any, string>,	email: string | Variable<any, string>,	phoneNumber: string | Variable<any, string>},ValueTypes["MutationRecordConsentResult"]],
removeCoBuyer?: [{	transactionId: string | Variable<any, string>},ValueTypes["MutationRemoveCoBuyerResult"]],
removePrimaryBuyer?: [{	transactionId: string | Variable<any, string>},ValueTypes["MutationRemovePrimaryBuyerResult"]],
requestAgilityCreditPrequal?: [{	bureaus: Array<ValueTypes["PrequalBureau"]> | Variable<any, string>,	transactionId: string | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationRequestAgilityCreditPrequalResult"]],
requestIdentityVerification?: [{	transactionId: string | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationRequestIdentityVerificationResult"]],
requestOtpExistingUserDEV?: [{	email: string | Variable<any, string>},ValueTypes["MutationRequestOtpExistingUserDEVResult"]],
requestPrequalReports?: [{	bureaus: Array<ValueTypes["PrequalBureau"]> | Variable<any, string>,	transactionId: string | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationRequestPrequalReportsResult"]],
requestPrescreen?: [{	transactionId: string | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationRequestPrescreenResult"]],
resendStaffPassword?: [{	userId: string | Variable<any, string>},ValueTypes["MutationResendStaffPasswordResult"]],
saveLendingPortalCustomerData?: [{	addressEntries?: Array<ValueTypes["LendingPortalAddressEntryInput"]> | undefined | null | Variable<any, string>,	customerData?: ValueTypes["LendingPortalCustomerDataInput"] | undefined | null | Variable<any, string>,	employmentEntries?: Array<ValueTypes["LendingPortalEmploymentEntryInput"]> | undefined | null | Variable<any, string>,	/** The ID of the acknowledgement template for edit confirmation */
	lendingPortalEditConfirmationTmplId: string | Variable<any, string>,	transactionId: string | Variable<any, string>,	/** The user ID of the customer (buyer or co-buyer) to update */
	userId: string | Variable<any, string>},ValueTypes["MutationSaveLendingPortalCustomerDataResult"]],
saveLendingPortalPurchaseVehicleData?: [{	transactionId: string | Variable<any, string>,	vehicleData: ValueTypes["LendingPortalPurchaseVehicleDataInput"] | Variable<any, string>},ValueTypes["MutationSaveLendingPortalPurchaseVehicleDataResult"]],
saveLendingPortalTradeVehicleData?: [{	tradeVehicleData: ValueTypes["LendingPortalTradeVehicleDataInput"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationSaveLendingPortalTradeVehicleDataResult"]],
sendFormReadyNotifications?: [{	/** The ID of the form submission collection */
	formCollectionId: string | Variable<any, string>},ValueTypes["MutationSendFormReadyNotificationsResult"]],
setDeliveryMethodForUser?: [{	email: string | Variable<any, string>,	method?: string | undefined | null | Variable<any, string>},ValueTypes["MutationSetDeliveryMethodForUserResult"]],
setDocumentLabels?: [{	/** Document ID */
	documentId: string | Variable<any, string>,	/** the labels to have */
	labels: Array<string> | Variable<any, string>},ValueTypes["MutationSetDocumentLabelsResult"]],
setDocumentTitle?: [{	/** Document ID */
	documentId: string | Variable<any, string>,	/** the new title */
	newTitle: string | Variable<any, string>},ValueTypes["MutationSetDocumentTitleResult"]],
setStaffInformation?: [{	staffInformation: ValueTypes["SetStaffInformationInput"] | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationSetStaffInformationResult"]],
setStaffPlanningEnabled?: [{	isEnabled: boolean | Variable<any, string>,	staffId: string | Variable<any, string>},ValueTypes["MutationSetStaffPlanningEnabledResult"]],
stageAdditionalForms?: [{	forms: Array<ValueTypes["StageFormInput"]> | Variable<any, string>,	notify: boolean | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationStageAdditionalFormsResult"]],
startLivenessAnalysis?: [{	transactionId: string | Variable<any, string>},ValueTypes["MutationStartLivenessAnalysisResult"]],
submitFormValues?: [{	formSubmissionId: string | Variable<any, string>,	values?: Array<ValueTypes["FormFieldValue"]> | undefined | null | Variable<any, string>},ValueTypes["MutationSubmitFormValuesResult"]],
submitPrequalApplicationAndCreateUser?: [{	dealershipId: string | Variable<any, string>,	email: string | Variable<any, string>,	formData: ValueTypes["PrequalInput"] | Variable<any, string>,	phoneNumber: string | Variable<any, string>},ValueTypes["MutationSubmitPrequalApplicationAndCreateUserResult"]],
submitPrequalApplicationOnTransaction?: [{	formData: ValueTypes["PrequalInput"] | Variable<any, string>,	signedUploadedDocumentId: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationSubmitPrequalApplicationOnTransactionResult"]],
submitStaffAcknowledgement?: [{	ackTemplateId: string | Variable<any, string>},ValueTypes["MutationSubmitStaffAcknowledgementResult"]],
submitStandardForm?: [{	formSubmissionData: string | Variable<any, string>,	signedUploadedDocumentId: string | Variable<any, string>,	transactionId: string | Variable<any, string>,	type: ValueTypes["FormSubmissionType"] | Variable<any, string>},ValueTypes["MutationSubmitStandardFormResult"]],
suspendGroupUser?: [{	isSuspended: boolean | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationSuspendGroupUserResult"]],
suspendStaff?: [{	isSuspended: boolean | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationSuspendStaffResult"]],
switchCustomerRoles?: [{	transactionId: string | Variable<any, string>},ValueTypes["MutationSwitchCustomerRolesResult"]],
testDriveEnsureCustomerForDealership?: [{	dealershipId: string | Variable<any, string>,	email: string | Variable<any, string>,	firstName?: string | undefined | null | Variable<any, string>,	lastName?: string | undefined | null | Variable<any, string>,	phoneNumber: string | Variable<any, string>},ValueTypes["MutationTestDriveEnsureCustomerForDealershipResult"]],
trackUserEvent?: [{	operation: ValueTypes["UserEventOperation"] | Variable<any, string>,	transactionPId: string | Variable<any, string>},ValueTypes["MutationTrackUserEventResult"]],
unlockTransaction?: [{	reason: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationUnlockTransactionResult"]],
updateCustomer?: [{	customer: ValueTypes["UpdateCustomerInput"] | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationUpdateCustomerResult"]],
updateEmployment?: [{	employment: ValueTypes["UpdateEmploymentInput"] | Variable<any, string>,	id: string | Variable<any, string>},ValueTypes["MutationUpdateEmploymentResult"]],
updateGroupUser?: [{	role: ValueTypes["Role"] | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationUpdateGroupUserResult"]],
updateIdCardRotation?: [{	captureBackRotation?: ValueTypes["ImageRotation"] | undefined | null | Variable<any, string>,	captureFrontRotation?: ValueTypes["ImageRotation"] | undefined | null | Variable<any, string>,	idCardId: string | Variable<any, string>},ValueTypes["MutationUpdateIdCardRotationResult"]],
updateMyUser?: [{	user: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["MutationUpdateMyUserResult"]],
updateReceivesAuthenticomReport?: [{	receivesAuthenticomReport: boolean | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationUpdateReceivesAuthenticomReportResult"]],
updateStaffAttributes?: [{	attributes: ValueTypes["StaffAttributes"] | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationUpdateStaffAttributesResult"]],
updateStaffExtraPermissions?: [{	extraPermissions: Array<ValueTypes["Permission"]> | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["MutationUpdateStaffExtraPermissionsResult"]],
updateStaffScheduleEvent?: [{	id: string | Variable<any, string>,	input: ValueTypes["UpdateStaffScheduleEventInput"] | Variable<any, string>},ValueTypes["MutationUpdateStaffScheduleEventResult"]],
updateTransaction?: [{	transaction: ValueTypes["UpdateTransactionInput"] | Variable<any, string>},ValueTypes["MutationUpdateTransactionResult"]],
uploadAdditionalDocuments?: [{	pdfIsEncrypted: boolean | Variable<any, string>,	title?: string | undefined | null | Variable<any, string>,	transactionId: string | Variable<any, string>,	uploadedDocumentId: string | Variable<any, string>},ValueTypes["MutationUploadAdditionalDocumentsResult"]],
uploadAdditionalDocumentsToTransaction?: [{	access: ValueTypes["FormSubmissionAccessEmum"] | Variable<any, string>,	addTo: ValueTypes["CustomerTransactionRole"] | Variable<any, string>,	fileId: string | Variable<any, string>,	pdfIsEncrypted: boolean | Variable<any, string>,	/** The title of the document. If null, and AI will set the value */
	title?: string | undefined | null | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationUploadAdditionalDocumentsToTransactionResult"]],
uploadIdCard?: [{	/** Required for all types except PASSPORT */
	captureBackFileId?: string | undefined | null | Variable<any, string>,	captureFrontFileId: string | Variable<any, string>,	dmvForm: string | Variable<any, string>,	dmvPdfFileId: string | Variable<any, string>,	/** Accepts: DRIVERS_LICENSE, STATE_ID, PASSPORT, or OTHER */
	idCardType: ValueTypes["IdCardType"] | Variable<any, string>,	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationUploadIdCardResult"]],
uploadIdCardWithToken?: [{	/** Required for all types except PASSPORT */
	captureBackFileId?: string | undefined | null | Variable<any, string>,	captureFrontFileId: string | Variable<any, string>,	dmvForm: string | Variable<any, string>,	dmvPdfFileId: string | Variable<any, string>,	/** Accepts: DRIVERS_LICENSE, STATE_ID, PASSPORT, or OTHER */
	idCardType: ValueTypes["IdCardType"] | Variable<any, string>,	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null | Variable<any, string>,	/** Submission token for scanner authentication */
	submissionToken: string | Variable<any, string>,	transactionId: string | Variable<any, string>},ValueTypes["MutationUploadIdCardWithTokenResult"]],
userExists?: [{	email: string | Variable<any, string>},ValueTypes["MutationUserExistsResult"]],
verifyOtpForExistingUser?: [{	email: string | Variable<any, string>,	emailCode?: string | undefined | null | Variable<any, string>,	phoneCode?: string | undefined | null | Variable<any, string>,	phoneNumber?: string | undefined | null | Variable<any, string>},ValueTypes["MutationVerifyOtpForExistingUserResult"]],
		__typename?: boolean | `@${string}`,
	['...on Mutation']?: Omit<ValueTypes["Mutation"], "...on Mutation">
}>;
	["MutationAddScanToDealerJacketResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationAddScanToDealerJacketSuccess"]?: ValueTypes["MutationAddScanToDealerJacketSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationAddScanToDealerJacketSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationAddScanToDealerJacketSuccess']?: Omit<ValueTypes["MutationAddScanToDealerJacketSuccess"], "...on MutationAddScanToDealerJacketSuccess">
}>;
	["MutationAddScanToGloveCompartmentsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationAddScanToGloveCompartmentsSuccess"]?: ValueTypes["MutationAddScanToGloveCompartmentsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationAddScanToGloveCompartmentsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationAddScanToGloveCompartmentsSuccess']?: Omit<ValueTypes["MutationAddScanToGloveCompartmentsSuccess"], "...on MutationAddScanToGloveCompartmentsSuccess">
}>;
	["MutationAssignStaffToTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationAssignStaffToTransactionSuccess"]?: ValueTypes["MutationAssignStaffToTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationAssignStaffToTransactionSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationAssignStaffToTransactionSuccess']?: Omit<ValueTypes["MutationAssignStaffToTransactionSuccess"], "...on MutationAssignStaffToTransactionSuccess">
}>;
	["MutationCancelFormCollectionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCancelFormCollectionSuccess"]?: ValueTypes["MutationCancelFormCollectionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCancelFormCollectionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCancelFormCollectionSuccess']?: Omit<ValueTypes["MutationCancelFormCollectionSuccess"], "...on MutationCancelFormCollectionSuccess">
}>;
	["MutationCancelPreviousAndRequestSignaturesResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCancelPreviousAndRequestSignaturesSuccess"]?: ValueTypes["MutationCancelPreviousAndRequestSignaturesSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCancelPreviousAndRequestSignaturesSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCancelPreviousAndRequestSignaturesSuccess']?: Omit<ValueTypes["MutationCancelPreviousAndRequestSignaturesSuccess"], "...on MutationCancelPreviousAndRequestSignaturesSuccess">
}>;
	["MutationChangeDocumentAccessResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationChangeDocumentAccessSuccess"]?: ValueTypes["MutationChangeDocumentAccessSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationChangeDocumentAccessSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationChangeDocumentAccessSuccess']?: Omit<ValueTypes["MutationChangeDocumentAccessSuccess"], "...on MutationChangeDocumentAccessSuccess">
}>;
	["MutationChangeFormSubmissionAccessResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationChangeFormSubmissionAccessSuccess"]?: ValueTypes["MutationChangeFormSubmissionAccessSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationChangeFormSubmissionAccessSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationChangeFormSubmissionAccessSuccess']?: Omit<ValueTypes["MutationChangeFormSubmissionAccessSuccess"], "...on MutationChangeFormSubmissionAccessSuccess">
}>;
	["MutationCreateAndSubmitCreditAndPrequalApplicationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"]?: ValueTypes["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess']?: Omit<ValueTypes["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"], "...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess">
}>;
	["MutationCreateChatResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateChatSuccess"]?: ValueTypes["MutationCreateChatSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateChatSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateChatSuccess']?: Omit<ValueTypes["MutationCreateChatSuccess"], "...on MutationCreateChatSuccess">
}>;
	["MutationCreateCoBuyerResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateCoBuyerSuccess"]?: ValueTypes["MutationCreateCoBuyerSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateCoBuyerSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateCoBuyerSuccess']?: Omit<ValueTypes["MutationCreateCoBuyerSuccess"], "...on MutationCreateCoBuyerSuccess">
}>;
	["MutationCreateCreditApplicationAndCreateUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateCreditApplicationAndCreateUserSuccess"]?: ValueTypes["MutationCreateCreditApplicationAndCreateUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateCreditApplicationAndCreateUserSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateCreditApplicationAndCreateUserSuccess']?: Omit<ValueTypes["MutationCreateCreditApplicationAndCreateUserSuccess"], "...on MutationCreateCreditApplicationAndCreateUserSuccess">
}>;
	["MutationCreateEmploymentResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateEmploymentSuccess"]?: ValueTypes["MutationCreateEmploymentSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateEmploymentSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateEmploymentSuccess']?: Omit<ValueTypes["MutationCreateEmploymentSuccess"], "...on MutationCreateEmploymentSuccess">
}>;
	["MutationCreateGroupuserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateGroupuserSuccess"]?: ValueTypes["MutationCreateGroupuserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateGroupuserSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateGroupuserSuccess']?: Omit<ValueTypes["MutationCreateGroupuserSuccess"], "...on MutationCreateGroupuserSuccess">
}>;
	["MutationCreateMessageResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateMessageSuccess"]?: ValueTypes["MutationCreateMessageSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateMessageSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateMessageSuccess']?: Omit<ValueTypes["MutationCreateMessageSuccess"], "...on MutationCreateMessageSuccess">
}>;
	["MutationCreateStaffResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateStaffSuccess"]?: ValueTypes["MutationCreateStaffSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateStaffScheduleEventsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateStaffScheduleEventsSuccess"]?: ValueTypes["MutationCreateStaffScheduleEventsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateStaffScheduleEventsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateStaffScheduleEventsSuccess']?: Omit<ValueTypes["MutationCreateStaffScheduleEventsSuccess"], "...on MutationCreateStaffScheduleEventsSuccess">
}>;
	["MutationCreateStaffSuccess"]: AliasType<{
	data?:ValueTypes["User"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateStaffSuccess']?: Omit<ValueTypes["MutationCreateStaffSuccess"], "...on MutationCreateStaffSuccess">
}>;
	["MutationCreateTransactionAndSubmitTestDriveResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateTransactionAndSubmitTestDriveSuccess"]?: ValueTypes["MutationCreateTransactionAndSubmitTestDriveSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateTransactionAndSubmitTestDriveSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateTransactionAndSubmitTestDriveSuccess']?: Omit<ValueTypes["MutationCreateTransactionAndSubmitTestDriveSuccess"], "...on MutationCreateTransactionAndSubmitTestDriveSuccess">
}>;
	["MutationCreateUserFeedbackResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCreateUserFeedbackSuccess"]?: ValueTypes["MutationCreateUserFeedbackSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateUserFeedbackSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCreateUserFeedbackSuccess']?: Omit<ValueTypes["MutationCreateUserFeedbackSuccess"], "...on MutationCreateUserFeedbackSuccess">
}>;
	["MutationCustomerCreatePrefilledTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerCreatePrefilledTransactionSuccess"]?: ValueTypes["MutationCustomerCreatePrefilledTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreatePrefilledTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerCreatePrefilledTransactionSuccess']?: Omit<ValueTypes["MutationCustomerCreatePrefilledTransactionSuccess"], "...on MutationCustomerCreatePrefilledTransactionSuccess">
}>;
	["MutationCustomerCreatePurchaseVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerCreatePurchaseVehicleSuccess"]?: ValueTypes["MutationCustomerCreatePurchaseVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreatePurchaseVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerCreatePurchaseVehicleSuccess']?: Omit<ValueTypes["MutationCustomerCreatePurchaseVehicleSuccess"], "...on MutationCustomerCreatePurchaseVehicleSuccess">
}>;
	["MutationCustomerCreateTradeVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerCreateTradeVehicleSuccess"]?: ValueTypes["MutationCustomerCreateTradeVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateTradeVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerCreateTradeVehicleSuccess']?: Omit<ValueTypes["MutationCustomerCreateTradeVehicleSuccess"], "...on MutationCustomerCreateTradeVehicleSuccess">
}>;
	["MutationCustomerCreateTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerCreateTransactionSuccess"]?: ValueTypes["MutationCustomerCreateTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerCreateTransactionSuccess']?: Omit<ValueTypes["MutationCustomerCreateTransactionSuccess"], "...on MutationCustomerCreateTransactionSuccess">
}>;
	["MutationCustomerCreateUnauthenticatedTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerCreateUnauthenticatedTransactionSuccess"]?: ValueTypes["MutationCustomerCreateUnauthenticatedTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateUnauthenticatedTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerCreateUnauthenticatedTransactionSuccess']?: Omit<ValueTypes["MutationCustomerCreateUnauthenticatedTransactionSuccess"], "...on MutationCustomerCreateUnauthenticatedTransactionSuccess">
}>;
	["MutationCustomerReferralPaidResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerReferralPaidSuccess"]?: ValueTypes["MutationCustomerReferralPaidSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerReferralPaidSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerReferralPaidSuccess']?: Omit<ValueTypes["MutationCustomerReferralPaidSuccess"], "...on MutationCustomerReferralPaidSuccess">
}>;
	["MutationCustomerReferralResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerReferralSuccess"]?: ValueTypes["MutationCustomerReferralSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerReferralSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerReferralSuccess']?: Omit<ValueTypes["MutationCustomerReferralSuccess"], "...on MutationCustomerReferralSuccess">
}>;
	["MutationCustomerSignupWithCognitoResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerSignupWithCognitoSuccess"]?: ValueTypes["MutationCustomerSignupWithCognitoSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerSignupWithCognitoSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerSignupWithCognitoSuccess']?: Omit<ValueTypes["MutationCustomerSignupWithCognitoSuccess"], "...on MutationCustomerSignupWithCognitoSuccess">
}>;
	["MutationCustomerUpdatePhoneNumberResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerUpdatePhoneNumberSuccess"]?: ValueTypes["MutationCustomerUpdatePhoneNumberSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdatePhoneNumberSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerUpdatePhoneNumberSuccess']?: Omit<ValueTypes["MutationCustomerUpdatePhoneNumberSuccess"], "...on MutationCustomerUpdatePhoneNumberSuccess">
}>;
	["MutationCustomerUpdatePurchaseVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerUpdatePurchaseVehicleSuccess"]?: ValueTypes["MutationCustomerUpdatePurchaseVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdatePurchaseVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerUpdatePurchaseVehicleSuccess']?: Omit<ValueTypes["MutationCustomerUpdatePurchaseVehicleSuccess"], "...on MutationCustomerUpdatePurchaseVehicleSuccess">
}>;
	["MutationCustomerUpdateTradeVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationCustomerUpdateTradeVehicleSuccess"]?: ValueTypes["MutationCustomerUpdateTradeVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdateTradeVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationCustomerUpdateTradeVehicleSuccess']?: Omit<ValueTypes["MutationCustomerUpdateTradeVehicleSuccess"], "...on MutationCustomerUpdateTradeVehicleSuccess">
}>;
	["MutationDealershipCreatePurchaseVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDealershipCreatePurchaseVehicleSuccess"]?: ValueTypes["MutationDealershipCreatePurchaseVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreatePurchaseVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationDealershipCreatePurchaseVehicleSuccess']?: Omit<ValueTypes["MutationDealershipCreatePurchaseVehicleSuccess"], "...on MutationDealershipCreatePurchaseVehicleSuccess">
}>;
	["MutationDealershipCreateTradeVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDealershipCreateTradeVehicleSuccess"]?: ValueTypes["MutationDealershipCreateTradeVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreateTradeVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationDealershipCreateTradeVehicleSuccess']?: Omit<ValueTypes["MutationDealershipCreateTradeVehicleSuccess"], "...on MutationDealershipCreateTradeVehicleSuccess">
}>;
	["MutationDealershipCreateTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDealershipCreateTransactionSuccess"]?: ValueTypes["MutationDealershipCreateTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreateTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationDealershipCreateTransactionSuccess']?: Omit<ValueTypes["MutationDealershipCreateTransactionSuccess"], "...on MutationDealershipCreateTransactionSuccess">
}>;
	["MutationDealershipRemoveTradeVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDealershipRemoveTradeVehicleSuccess"]?: ValueTypes["MutationDealershipRemoveTradeVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipRemoveTradeVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationDealershipRemoveTradeVehicleSuccess']?: Omit<ValueTypes["MutationDealershipRemoveTradeVehicleSuccess"], "...on MutationDealershipRemoveTradeVehicleSuccess">
}>;
	["MutationDealershipUpdatePurchaseVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDealershipUpdatePurchaseVehicleSuccess"]?: ValueTypes["MutationDealershipUpdatePurchaseVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipUpdatePurchaseVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationDealershipUpdatePurchaseVehicleSuccess']?: Omit<ValueTypes["MutationDealershipUpdatePurchaseVehicleSuccess"], "...on MutationDealershipUpdatePurchaseVehicleSuccess">
}>;
	["MutationDealershipUpdateTradeVehicleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDealershipUpdateTradeVehicleSuccess"]?: ValueTypes["MutationDealershipUpdateTradeVehicleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipUpdateTradeVehicleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationDealershipUpdateTradeVehicleSuccess']?: Omit<ValueTypes["MutationDealershipUpdateTradeVehicleSuccess"], "...on MutationDealershipUpdateTradeVehicleSuccess">
}>;
	["MutationDeleteStaffScheduleEventResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDeleteStaffScheduleEventSuccess"]?: ValueTypes["MutationDeleteStaffScheduleEventSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDeleteStaffScheduleEventSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationDeleteStaffScheduleEventSuccess']?: Omit<ValueTypes["MutationDeleteStaffScheduleEventSuccess"], "...on MutationDeleteStaffScheduleEventSuccess">
}>;
	["MutationDismissNotificationsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationDismissNotificationsSuccess"]?: ValueTypes["MutationDismissNotificationsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationDismissNotificationsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationDismissNotificationsSuccess']?: Omit<ValueTypes["MutationDismissNotificationsSuccess"], "...on MutationDismissNotificationsSuccess">
}>;
	["MutationExtractVehicleFromRegistrationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationExtractVehicleFromRegistrationSuccess"]?: ValueTypes["MutationExtractVehicleFromRegistrationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationExtractVehicleFromRegistrationSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationExtractVehicleFromRegistrationSuccess']?: Omit<ValueTypes["MutationExtractVehicleFromRegistrationSuccess"], "...on MutationExtractVehicleFromRegistrationSuccess">
}>;
	["MutationFinalizeLivenessAnalysisResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationFinalizeLivenessAnalysisSuccess"]?: ValueTypes["MutationFinalizeLivenessAnalysisSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationFinalizeLivenessAnalysisSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationFinalizeLivenessAnalysisSuccess']?: Omit<ValueTypes["MutationFinalizeLivenessAnalysisSuccess"], "...on MutationFinalizeLivenessAnalysisSuccess">
}>;
	["MutationLoginResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationLoginSuccess"]?: ValueTypes["MutationLoginSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationLoginSuccess"]: AliasType<{
	data?:ValueTypes["LoginResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationLoginSuccess']?: Omit<ValueTypes["MutationLoginSuccess"], "...on MutationLoginSuccess">
}>;
	["MutationLogoutResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationLogoutSuccess"]?: ValueTypes["MutationLogoutSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationLogoutSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationLogoutSuccess']?: Omit<ValueTypes["MutationLogoutSuccess"], "...on MutationLogoutSuccess">
}>;
	["MutationMakeSubmissionTokenResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationMakeSubmissionTokenSuccess"]?: ValueTypes["MutationMakeSubmissionTokenSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeSubmissionTokenSuccess"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MutationMakeSubmissionTokenSuccess']?: Omit<ValueTypes["MutationMakeSubmissionTokenSuccess"], "...on MutationMakeSubmissionTokenSuccess">
}>;
	["MutationMakeUploadForScannerResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationMakeUploadForScannerSuccess"]?: ValueTypes["MutationMakeUploadForScannerSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadForScannerSuccess"]: AliasType<{
	data?:ValueTypes["MakeFileUploadForScannerType"],
		__typename?: boolean | `@${string}`,
	['...on MutationMakeUploadForScannerSuccess']?: Omit<ValueTypes["MutationMakeUploadForScannerSuccess"], "...on MutationMakeUploadForScannerSuccess">
}>;
	["MutationMakeUploadResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationMakeUploadSuccess"]?: ValueTypes["MutationMakeUploadSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadSuccess"]: AliasType<{
	data?:ValueTypes["MakeFileUploadType"],
		__typename?: boolean | `@${string}`,
	['...on MutationMakeUploadSuccess']?: Omit<ValueTypes["MutationMakeUploadSuccess"], "...on MutationMakeUploadSuccess">
}>;
	["MutationMakeUploadToTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationMakeUploadToTransactionSuccess"]?: ValueTypes["MutationMakeUploadToTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadToTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MakeFileUploadType"],
		__typename?: boolean | `@${string}`,
	['...on MutationMakeUploadToTransactionSuccess']?: Omit<ValueTypes["MutationMakeUploadToTransactionSuccess"], "...on MutationMakeUploadToTransactionSuccess">
}>;
	["MutationMarkTransactionAsDeliveredResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationMarkTransactionAsDeliveredSuccess"]?: ValueTypes["MutationMarkTransactionAsDeliveredSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationMarkTransactionAsDeliveredSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationMarkTransactionAsDeliveredSuccess']?: Omit<ValueTypes["MutationMarkTransactionAsDeliveredSuccess"], "...on MutationMarkTransactionAsDeliveredSuccess">
}>;
	["MutationModifyHardCreditApplicationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationModifyHardCreditApplicationSuccess"]?: ValueTypes["MutationModifyHardCreditApplicationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationModifyHardCreditApplicationSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationModifyHardCreditApplicationSuccess']?: Omit<ValueTypes["MutationModifyHardCreditApplicationSuccess"], "...on MutationModifyHardCreditApplicationSuccess">
}>;
	["MutationOnboardingSubmitStep1Result"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationOnboardingSubmitStep1Success"]?: ValueTypes["MutationOnboardingSubmitStep1Success"]
		__typename?: boolean | `@${string}`
}>;
	["MutationOnboardingSubmitStep1Success"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationOnboardingSubmitStep1Success']?: Omit<ValueTypes["MutationOnboardingSubmitStep1Success"], "...on MutationOnboardingSubmitStep1Success">
}>;
	["MutationOnboardingSubmitStep2Result"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationOnboardingSubmitStep2Success"]?: ValueTypes["MutationOnboardingSubmitStep2Success"]
		__typename?: boolean | `@${string}`
}>;
	["MutationOnboardingSubmitStep2Success"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationOnboardingSubmitStep2Success']?: Omit<ValueTypes["MutationOnboardingSubmitStep2Success"], "...on MutationOnboardingSubmitStep2Success">
}>;
	["MutationOverrideTodoResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationOverrideTodoSuccess"]?: ValueTypes["MutationOverrideTodoSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationOverrideTodoSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationOverrideTodoSuccess']?: Omit<ValueTypes["MutationOverrideTodoSuccess"], "...on MutationOverrideTodoSuccess">
}>;
	["MutationPreLoginCheckResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPreLoginCheckSuccess"]?: ValueTypes["MutationPreLoginCheckSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPreLoginCheckSuccess"]: AliasType<{
	data?:ValueTypes["PreLoginType"],
		__typename?: boolean | `@${string}`,
	['...on MutationPreLoginCheckSuccess']?: Omit<ValueTypes["MutationPreLoginCheckSuccess"], "...on MutationPreLoginCheckSuccess">
}>;
	["MutationPrefillLicensePlateOrVinResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPrefillLicensePlateOrVinSuccess"]?: ValueTypes["MutationPrefillLicensePlateOrVinSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPrefillLicensePlateOrVinSuccess"]: AliasType<{
	data?:ValueTypes["LicensePrefillData"],
		__typename?: boolean | `@${string}`,
	['...on MutationPrefillLicensePlateOrVinSuccess']?: Omit<ValueTypes["MutationPrefillLicensePlateOrVinSuccess"], "...on MutationPrefillLicensePlateOrVinSuccess">
}>;
	["MutationPushDataToCrmsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPushDataToCrmsSuccess"]?: ValueTypes["MutationPushDataToCrmsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDataToCrmsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationPushDataToCrmsSuccess']?: Omit<ValueTypes["MutationPushDataToCrmsSuccess"], "...on MutationPushDataToCrmsSuccess">
}>;
	["MutationPushDocumentToCdkDealJacketResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPushDocumentToCdkDealJacketSuccess"]?: ValueTypes["MutationPushDocumentToCdkDealJacketSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDocumentToCdkDealJacketSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationPushDocumentToCdkDealJacketSuccess']?: Omit<ValueTypes["MutationPushDocumentToCdkDealJacketSuccess"], "...on MutationPushDocumentToCdkDealJacketSuccess">
}>;
	["MutationPushDocumentsToCdkResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPushDocumentsToCdkSuccess"]?: ValueTypes["MutationPushDocumentsToCdkSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDocumentsToCdkSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationPushDocumentsToCdkSuccess']?: Omit<ValueTypes["MutationPushDocumentsToCdkSuccess"], "...on MutationPushDocumentsToCdkSuccess">
}>;
	["MutationPushFormSubmissionsToCdkResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPushFormSubmissionsToCdkSuccess"]?: ValueTypes["MutationPushFormSubmissionsToCdkSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPushFormSubmissionsToCdkSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationPushFormSubmissionsToCdkSuccess']?: Omit<ValueTypes["MutationPushFormSubmissionsToCdkSuccess"], "...on MutationPushFormSubmissionsToCdkSuccess">
}>;
	["MutationPushHardCreditApplicationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationPushHardCreditApplicationSuccess"]?: ValueTypes["MutationPushHardCreditApplicationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationPushHardCreditApplicationSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationPushHardCreditApplicationSuccess']?: Omit<ValueTypes["MutationPushHardCreditApplicationSuccess"], "...on MutationPushHardCreditApplicationSuccess">
}>;
	["MutationRecordConsentResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRecordConsentSuccess"]?: ValueTypes["MutationRecordConsentSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRecordConsentSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationRecordConsentSuccess']?: Omit<ValueTypes["MutationRecordConsentSuccess"], "...on MutationRecordConsentSuccess">
}>;
	["MutationRemoveCoBuyerResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRemoveCoBuyerSuccess"]?: ValueTypes["MutationRemoveCoBuyerSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRemoveCoBuyerSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationRemoveCoBuyerSuccess']?: Omit<ValueTypes["MutationRemoveCoBuyerSuccess"], "...on MutationRemoveCoBuyerSuccess">
}>;
	["MutationRemovePrimaryBuyerResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRemovePrimaryBuyerSuccess"]?: ValueTypes["MutationRemovePrimaryBuyerSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRemovePrimaryBuyerSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationRemovePrimaryBuyerSuccess']?: Omit<ValueTypes["MutationRemovePrimaryBuyerSuccess"], "...on MutationRemovePrimaryBuyerSuccess">
}>;
	["MutationRequestAgilityCreditPrequalResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRequestAgilityCreditPrequalSuccess"]?: ValueTypes["MutationRequestAgilityCreditPrequalSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestAgilityCreditPrequalSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationRequestAgilityCreditPrequalSuccess']?: Omit<ValueTypes["MutationRequestAgilityCreditPrequalSuccess"], "...on MutationRequestAgilityCreditPrequalSuccess">
}>;
	["MutationRequestIdentityVerificationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRequestIdentityVerificationSuccess"]?: ValueTypes["MutationRequestIdentityVerificationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestIdentityVerificationSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationRequestIdentityVerificationSuccess']?: Omit<ValueTypes["MutationRequestIdentityVerificationSuccess"], "...on MutationRequestIdentityVerificationSuccess">
}>;
	["MutationRequestOtpExistingUserDEVResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRequestOtpExistingUserDEVSuccess"]?: ValueTypes["MutationRequestOtpExistingUserDEVSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestOtpExistingUserDEVSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationRequestOtpExistingUserDEVSuccess']?: Omit<ValueTypes["MutationRequestOtpExistingUserDEVSuccess"], "...on MutationRequestOtpExistingUserDEVSuccess">
}>;
	["MutationRequestPrequalReportsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRequestPrequalReportsSuccess"]?: ValueTypes["MutationRequestPrequalReportsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestPrequalReportsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationRequestPrequalReportsSuccess']?: Omit<ValueTypes["MutationRequestPrequalReportsSuccess"], "...on MutationRequestPrequalReportsSuccess">
}>;
	["MutationRequestPrescreenResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationRequestPrescreenSuccess"]?: ValueTypes["MutationRequestPrescreenSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestPrescreenSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationRequestPrescreenSuccess']?: Omit<ValueTypes["MutationRequestPrescreenSuccess"], "...on MutationRequestPrescreenSuccess">
}>;
	["MutationResendStaffPasswordResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationResendStaffPasswordSuccess"]?: ValueTypes["MutationResendStaffPasswordSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationResendStaffPasswordSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationResendStaffPasswordSuccess']?: Omit<ValueTypes["MutationResendStaffPasswordSuccess"], "...on MutationResendStaffPasswordSuccess">
}>;
	["MutationResponse"]: AliasType<{
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MutationResponse']?: Omit<ValueTypes["MutationResponse"], "...on MutationResponse">
}>;
	["MutationResponseWithId"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MutationResponseWithId']?: Omit<ValueTypes["MutationResponseWithId"], "...on MutationResponseWithId">
}>;
	["MutationSaveLendingPortalCustomerDataResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSaveLendingPortalCustomerDataSuccess"]?: ValueTypes["MutationSaveLendingPortalCustomerDataSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalCustomerDataSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSaveLendingPortalCustomerDataSuccess']?: Omit<ValueTypes["MutationSaveLendingPortalCustomerDataSuccess"], "...on MutationSaveLendingPortalCustomerDataSuccess">
}>;
	["MutationSaveLendingPortalPurchaseVehicleDataResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSaveLendingPortalPurchaseVehicleDataSuccess"]?: ValueTypes["MutationSaveLendingPortalPurchaseVehicleDataSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalPurchaseVehicleDataSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSaveLendingPortalPurchaseVehicleDataSuccess']?: Omit<ValueTypes["MutationSaveLendingPortalPurchaseVehicleDataSuccess"], "...on MutationSaveLendingPortalPurchaseVehicleDataSuccess">
}>;
	["MutationSaveLendingPortalTradeVehicleDataResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSaveLendingPortalTradeVehicleDataSuccess"]?: ValueTypes["MutationSaveLendingPortalTradeVehicleDataSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalTradeVehicleDataSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSaveLendingPortalTradeVehicleDataSuccess']?: Omit<ValueTypes["MutationSaveLendingPortalTradeVehicleDataSuccess"], "...on MutationSaveLendingPortalTradeVehicleDataSuccess">
}>;
	["MutationSendFormReadyNotificationsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSendFormReadyNotificationsSuccess"]?: ValueTypes["MutationSendFormReadyNotificationsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSendFormReadyNotificationsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSendFormReadyNotificationsSuccess']?: Omit<ValueTypes["MutationSendFormReadyNotificationsSuccess"], "...on MutationSendFormReadyNotificationsSuccess">
}>;
	["MutationSetDeliveryMethodForUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSetDeliveryMethodForUserSuccess"]?: ValueTypes["MutationSetDeliveryMethodForUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDeliveryMethodForUserSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSetDeliveryMethodForUserSuccess']?: Omit<ValueTypes["MutationSetDeliveryMethodForUserSuccess"], "...on MutationSetDeliveryMethodForUserSuccess">
}>;
	["MutationSetDocumentLabelsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSetDocumentLabelsSuccess"]?: ValueTypes["MutationSetDocumentLabelsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDocumentLabelsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSetDocumentLabelsSuccess']?: Omit<ValueTypes["MutationSetDocumentLabelsSuccess"], "...on MutationSetDocumentLabelsSuccess">
}>;
	["MutationSetDocumentTitleResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSetDocumentTitleSuccess"]?: ValueTypes["MutationSetDocumentTitleSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDocumentTitleSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSetDocumentTitleSuccess']?: Omit<ValueTypes["MutationSetDocumentTitleSuccess"], "...on MutationSetDocumentTitleSuccess">
}>;
	["MutationSetStaffInformationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSetStaffInformationSuccess"]?: ValueTypes["MutationSetStaffInformationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSetStaffInformationSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSetStaffInformationSuccess']?: Omit<ValueTypes["MutationSetStaffInformationSuccess"], "...on MutationSetStaffInformationSuccess">
}>;
	["MutationSetStaffPlanningEnabledResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSetStaffPlanningEnabledSuccess"]?: ValueTypes["MutationSetStaffPlanningEnabledSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSetStaffPlanningEnabledSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSetStaffPlanningEnabledSuccess']?: Omit<ValueTypes["MutationSetStaffPlanningEnabledSuccess"], "...on MutationSetStaffPlanningEnabledSuccess">
}>;
	["MutationStageAdditionalFormsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationStageAdditionalFormsSuccess"]?: ValueTypes["MutationStageAdditionalFormsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationStageAdditionalFormsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationStageAdditionalFormsSuccess']?: Omit<ValueTypes["MutationStageAdditionalFormsSuccess"], "...on MutationStageAdditionalFormsSuccess">
}>;
	["MutationStartLivenessAnalysisResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationStartLivenessAnalysisSuccess"]?: ValueTypes["MutationStartLivenessAnalysisSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationStartLivenessAnalysisSuccess"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MutationStartLivenessAnalysisSuccess']?: Omit<ValueTypes["MutationStartLivenessAnalysisSuccess"], "...on MutationStartLivenessAnalysisSuccess">
}>;
	["MutationSubmitFormValuesResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSubmitFormValuesSuccess"]?: ValueTypes["MutationSubmitFormValuesSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitFormValuesSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSubmitFormValuesSuccess']?: Omit<ValueTypes["MutationSubmitFormValuesSuccess"], "...on MutationSubmitFormValuesSuccess">
}>;
	["MutationSubmitPrequalApplicationAndCreateUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSubmitPrequalApplicationAndCreateUserSuccess"]?: ValueTypes["MutationSubmitPrequalApplicationAndCreateUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitPrequalApplicationAndCreateUserSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSubmitPrequalApplicationAndCreateUserSuccess']?: Omit<ValueTypes["MutationSubmitPrequalApplicationAndCreateUserSuccess"], "...on MutationSubmitPrequalApplicationAndCreateUserSuccess">
}>;
	["MutationSubmitPrequalApplicationOnTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSubmitPrequalApplicationOnTransactionSuccess"]?: ValueTypes["MutationSubmitPrequalApplicationOnTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitPrequalApplicationOnTransactionSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSubmitPrequalApplicationOnTransactionSuccess']?: Omit<ValueTypes["MutationSubmitPrequalApplicationOnTransactionSuccess"], "...on MutationSubmitPrequalApplicationOnTransactionSuccess">
}>;
	["MutationSubmitStaffAcknowledgementResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSubmitStaffAcknowledgementSuccess"]?: ValueTypes["MutationSubmitStaffAcknowledgementSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitStaffAcknowledgementSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationSubmitStaffAcknowledgementSuccess']?: Omit<ValueTypes["MutationSubmitStaffAcknowledgementSuccess"], "...on MutationSubmitStaffAcknowledgementSuccess">
}>;
	["MutationSubmitStandardFormResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSubmitStandardFormSuccess"]?: ValueTypes["MutationSubmitStandardFormSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitStandardFormSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationSubmitStandardFormSuccess']?: Omit<ValueTypes["MutationSubmitStandardFormSuccess"], "...on MutationSubmitStandardFormSuccess">
}>;
	["MutationSuspendGroupUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSuspendGroupUserSuccess"]?: ValueTypes["MutationSuspendGroupUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSuspendGroupUserSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSuspendGroupUserSuccess']?: Omit<ValueTypes["MutationSuspendGroupUserSuccess"], "...on MutationSuspendGroupUserSuccess">
}>;
	["MutationSuspendStaffResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSuspendStaffSuccess"]?: ValueTypes["MutationSuspendStaffSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSuspendStaffSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSuspendStaffSuccess']?: Omit<ValueTypes["MutationSuspendStaffSuccess"], "...on MutationSuspendStaffSuccess">
}>;
	["MutationSwitchCustomerRolesResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationSwitchCustomerRolesSuccess"]?: ValueTypes["MutationSwitchCustomerRolesSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationSwitchCustomerRolesSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationSwitchCustomerRolesSuccess']?: Omit<ValueTypes["MutationSwitchCustomerRolesSuccess"], "...on MutationSwitchCustomerRolesSuccess">
}>;
	["MutationTestDriveEnsureCustomerForDealershipResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationTestDriveEnsureCustomerForDealershipSuccess"]?: ValueTypes["MutationTestDriveEnsureCustomerForDealershipSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationTestDriveEnsureCustomerForDealershipSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationTestDriveEnsureCustomerForDealershipSuccess']?: Omit<ValueTypes["MutationTestDriveEnsureCustomerForDealershipSuccess"], "...on MutationTestDriveEnsureCustomerForDealershipSuccess">
}>;
	["MutationTrackUserEventResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationTrackUserEventSuccess"]?: ValueTypes["MutationTrackUserEventSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationTrackUserEventSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationTrackUserEventSuccess']?: Omit<ValueTypes["MutationTrackUserEventSuccess"], "...on MutationTrackUserEventSuccess">
}>;
	["MutationUnlockTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUnlockTransactionSuccess"]?: ValueTypes["MutationUnlockTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUnlockTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUnlockTransactionSuccess']?: Omit<ValueTypes["MutationUnlockTransactionSuccess"], "...on MutationUnlockTransactionSuccess">
}>;
	["MutationUpdateCustomerResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateCustomerSuccess"]?: ValueTypes["MutationUpdateCustomerSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateCustomerSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateCustomerSuccess']?: Omit<ValueTypes["MutationUpdateCustomerSuccess"], "...on MutationUpdateCustomerSuccess">
}>;
	["MutationUpdateEmploymentResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateEmploymentSuccess"]?: ValueTypes["MutationUpdateEmploymentSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateEmploymentSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateEmploymentSuccess']?: Omit<ValueTypes["MutationUpdateEmploymentSuccess"], "...on MutationUpdateEmploymentSuccess">
}>;
	["MutationUpdateGroupUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateGroupUserSuccess"]?: ValueTypes["MutationUpdateGroupUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateGroupUserSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateGroupUserSuccess']?: Omit<ValueTypes["MutationUpdateGroupUserSuccess"], "...on MutationUpdateGroupUserSuccess">
}>;
	["MutationUpdateIdCardRotationResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateIdCardRotationSuccess"]?: ValueTypes["MutationUpdateIdCardRotationSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateIdCardRotationSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateIdCardRotationSuccess']?: Omit<ValueTypes["MutationUpdateIdCardRotationSuccess"], "...on MutationUpdateIdCardRotationSuccess">
}>;
	["MutationUpdateMyUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateMyUserSuccess"]?: ValueTypes["MutationUpdateMyUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateMyUserSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateMyUserSuccess']?: Omit<ValueTypes["MutationUpdateMyUserSuccess"], "...on MutationUpdateMyUserSuccess">
}>;
	["MutationUpdateReceivesAuthenticomReportResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateReceivesAuthenticomReportSuccess"]?: ValueTypes["MutationUpdateReceivesAuthenticomReportSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateReceivesAuthenticomReportSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateReceivesAuthenticomReportSuccess']?: Omit<ValueTypes["MutationUpdateReceivesAuthenticomReportSuccess"], "...on MutationUpdateReceivesAuthenticomReportSuccess">
}>;
	["MutationUpdateStaffAttributesResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateStaffAttributesSuccess"]?: ValueTypes["MutationUpdateStaffAttributesSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffAttributesSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateStaffAttributesSuccess']?: Omit<ValueTypes["MutationUpdateStaffAttributesSuccess"], "...on MutationUpdateStaffAttributesSuccess">
}>;
	["MutationUpdateStaffExtraPermissionsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateStaffExtraPermissionsSuccess"]?: ValueTypes["MutationUpdateStaffExtraPermissionsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffExtraPermissionsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateStaffExtraPermissionsSuccess']?: Omit<ValueTypes["MutationUpdateStaffExtraPermissionsSuccess"], "...on MutationUpdateStaffExtraPermissionsSuccess">
}>;
	["MutationUpdateStaffScheduleEventResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateStaffScheduleEventSuccess"]?: ValueTypes["MutationUpdateStaffScheduleEventSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffScheduleEventSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateStaffScheduleEventSuccess']?: Omit<ValueTypes["MutationUpdateStaffScheduleEventSuccess"], "...on MutationUpdateStaffScheduleEventSuccess">
}>;
	["MutationUpdateTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUpdateTransactionSuccess"]?: ValueTypes["MutationUpdateTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateTransactionSuccess"]: AliasType<{
	data?:ValueTypes["Response"],
		__typename?: boolean | `@${string}`,
	['...on MutationUpdateTransactionSuccess']?: Omit<ValueTypes["MutationUpdateTransactionSuccess"], "...on MutationUpdateTransactionSuccess">
}>;
	["MutationUploadAdditionalDocumentsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUploadAdditionalDocumentsSuccess"]?: ValueTypes["MutationUploadAdditionalDocumentsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadAdditionalDocumentsSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationUploadAdditionalDocumentsSuccess']?: Omit<ValueTypes["MutationUploadAdditionalDocumentsSuccess"], "...on MutationUploadAdditionalDocumentsSuccess">
}>;
	["MutationUploadAdditionalDocumentsToTransactionResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUploadAdditionalDocumentsToTransactionSuccess"]?: ValueTypes["MutationUploadAdditionalDocumentsToTransactionSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadAdditionalDocumentsToTransactionSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationUploadAdditionalDocumentsToTransactionSuccess']?: Omit<ValueTypes["MutationUploadAdditionalDocumentsToTransactionSuccess"], "...on MutationUploadAdditionalDocumentsToTransactionSuccess">
}>;
	["MutationUploadIdCardResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUploadIdCardSuccess"]?: ValueTypes["MutationUploadIdCardSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadIdCardSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationUploadIdCardSuccess']?: Omit<ValueTypes["MutationUploadIdCardSuccess"], "...on MutationUploadIdCardSuccess">
}>;
	["MutationUploadIdCardWithTokenResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUploadIdCardWithTokenSuccess"]?: ValueTypes["MutationUploadIdCardWithTokenSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadIdCardWithTokenSuccess"]: AliasType<{
	data?:ValueTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`,
	['...on MutationUploadIdCardWithTokenSuccess']?: Omit<ValueTypes["MutationUploadIdCardWithTokenSuccess"], "...on MutationUploadIdCardWithTokenSuccess">
}>;
	["MutationUserExistsResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationUserExistsSuccess"]?: ValueTypes["MutationUserExistsSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationUserExistsSuccess"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MutationUserExistsSuccess']?: Omit<ValueTypes["MutationUserExistsSuccess"], "...on MutationUserExistsSuccess">
}>;
	["MutationVerifyOtpForExistingUserResult"]: AliasType<{		["...on GraphQLError"]?: ValueTypes["GraphQLError"],
		["...on MutationVerifyOtpForExistingUserSuccess"]?: ValueTypes["MutationVerifyOtpForExistingUserSuccess"]
		__typename?: boolean | `@${string}`
}>;
	["MutationVerifyOtpForExistingUserSuccess"]: AliasType<{
	data?:ValueTypes["LoginResponse"],
		__typename?: boolean | `@${string}`,
	['...on MutationVerifyOtpForExistingUserSuccess']?: Omit<ValueTypes["MutationVerifyOtpForExistingUserSuccess"], "...on MutationVerifyOtpForExistingUserSuccess">
}>;
	["Node"]:AliasType<{
		id?:boolean | `@${string}`;
		['...on UserDealership']?: Omit<ValueTypes["UserDealership"],keyof ValueTypes["Node"]>;
		__typename?: boolean | `@${string}`
}>;
	["Notification"]: AliasType<{
	announcement?:ValueTypes["Announcement"],
	createdAt?:boolean | `@${string}`,
	dismissedAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	payload?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Notification']?: Omit<ValueTypes["Notification"], "...on Notification">
}>;
	["NotificationFilter"]: {
	announcementId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>,
	dismissedAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>
};
	["NotificationOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>,
	dismissedAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["OnboardingStep"]:OnboardingStep;
	["OrderBy"]:OrderBy;
	["PageInfo"]: AliasType<{
	endCursor?:boolean | `@${string}`,
	hasNextPage?:boolean | `@${string}`,
	hasPreviousPage?:boolean | `@${string}`,
	startCursor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PageInfo']?: Omit<ValueTypes["PageInfo"], "...on PageInfo">
}>;
	["Permission"]:Permission;
	["PlatformType"]: AliasType<{
announcements?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["AnnouncementOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["PlatformTypeAnnouncementsConnection"]],
documentLabels?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["DocumentLabelOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["PlatformTypeDocumentLabelsConnection"]],
faqs?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	dealershipId?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["PlatformTypeFaqsConnection"]],
isIpBlocked?: [{	dealershipId: string | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on PlatformType']?: Omit<ValueTypes["PlatformType"], "...on PlatformType">
}>;
	["PlatformTypeAnnouncementsConnection"]: AliasType<{
	edges?:ValueTypes["PlatformTypeAnnouncementsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PlatformTypeAnnouncementsConnection']?: Omit<ValueTypes["PlatformTypeAnnouncementsConnection"], "...on PlatformTypeAnnouncementsConnection">
}>;
	["PlatformTypeAnnouncementsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Announcement"],
		__typename?: boolean | `@${string}`,
	['...on PlatformTypeAnnouncementsConnectionEdge']?: Omit<ValueTypes["PlatformTypeAnnouncementsConnectionEdge"], "...on PlatformTypeAnnouncementsConnectionEdge">
}>;
	["PlatformTypeDocumentLabelsConnection"]: AliasType<{
	edges?:ValueTypes["PlatformTypeDocumentLabelsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PlatformTypeDocumentLabelsConnection']?: Omit<ValueTypes["PlatformTypeDocumentLabelsConnection"], "...on PlatformTypeDocumentLabelsConnection">
}>;
	["PlatformTypeDocumentLabelsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["DocumentLabel"],
		__typename?: boolean | `@${string}`,
	['...on PlatformTypeDocumentLabelsConnectionEdge']?: Omit<ValueTypes["PlatformTypeDocumentLabelsConnectionEdge"], "...on PlatformTypeDocumentLabelsConnectionEdge">
}>;
	["PlatformTypeFaqsConnection"]: AliasType<{
	edges?:ValueTypes["PlatformTypeFaqsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PlatformTypeFaqsConnection']?: Omit<ValueTypes["PlatformTypeFaqsConnection"], "...on PlatformTypeFaqsConnection">
}>;
	["PlatformTypeFaqsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Faq"],
		__typename?: boolean | `@${string}`,
	['...on PlatformTypeFaqsConnectionEdge']?: Omit<ValueTypes["PlatformTypeFaqsConnectionEdge"], "...on PlatformTypeFaqsConnectionEdge">
}>;
	["PolicyLayerType"]:PolicyLayerType;
	["PreLoginType"]: AliasType<{
	hasConsentedToSms?:boolean | `@${string}`,
	loginOptions?:boolean | `@${string}`,
	userExists?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PreLoginType']?: Omit<ValueTypes["PreLoginType"], "...on PreLoginType">
}>;
	["PrequalApplication"]: AliasType<{
agilityCreditPrequalReports?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["AgilityCreditPrequalReportFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["PrequalApplicationAgilityCreditPrequalReportsConnection"]],
	city?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
prequalResponses?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["SevenHundredCreditPrequalReportsFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["PrequalApplicationPrequalResponsesConnection"]],
	state?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PrequalApplication']?: Omit<ValueTypes["PrequalApplication"], "...on PrequalApplication">
}>;
	["PrequalApplicationAgilityCreditPrequalReportsConnection"]: AliasType<{
	edges?:ValueTypes["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on PrequalApplicationAgilityCreditPrequalReportsConnection']?: Omit<ValueTypes["PrequalApplicationAgilityCreditPrequalReportsConnection"], "...on PrequalApplicationAgilityCreditPrequalReportsConnection">
}>;
	["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["AgilityCreditPrequalReport"],
		__typename?: boolean | `@${string}`,
	['...on PrequalApplicationAgilityCreditPrequalReportsConnectionEdge']?: Omit<ValueTypes["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"], "...on PrequalApplicationAgilityCreditPrequalReportsConnectionEdge">
}>;
	["PrequalApplicationPrequalResponsesConnection"]: AliasType<{
	edges?:ValueTypes["PrequalApplicationPrequalResponsesConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on PrequalApplicationPrequalResponsesConnection']?: Omit<ValueTypes["PrequalApplicationPrequalResponsesConnection"], "...on PrequalApplicationPrequalResponsesConnection">
}>;
	["PrequalApplicationPrequalResponsesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["SevenHundredCreditPrequalReports"],
		__typename?: boolean | `@${string}`,
	['...on PrequalApplicationPrequalResponsesConnectionEdge']?: Omit<ValueTypes["PrequalApplicationPrequalResponsesConnectionEdge"], "...on PrequalApplicationPrequalResponsesConnectionEdge">
}>;
	["PrequalBureau"]:PrequalBureau;
	["PrequalBureauFilter"]: {
	equals?: ValueTypes["PrequalBureau"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["PrequalBureau"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["PrequalBureauFilter"] | undefined | null | Variable<any, string>,
	notIn?: Array<ValueTypes["PrequalBureau"]> | undefined | null | Variable<any, string>
};
	["PrequalInput"]: {
	apartmentDetails: string | Variable<any, string>,
	birthdate: string | Variable<any, string>,
	city: string | Variable<any, string>,
	dateTime: string | Variable<any, string>,
	dealerPrivacyAckTmplId?: string | undefined | null | Variable<any, string>,
	deviceId: string | Variable<any, string>,
	eSignAckTmplId?: string | undefined | null | Variable<any, string>,
	firstName: string | Variable<any, string>,
	ipAddress: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	middleName?: string | undefined | null | Variable<any, string>,
	name: string | Variable<any, string>,
	prequalReportAckTmplId?: string | undefined | null | Variable<any, string>,
	signature: string | Variable<any, string>,
	socialSecurityNumber: string | Variable<any, string>,
	state: string | Variable<any, string>,
	street: string | Variable<any, string>,
	suffix: string | Variable<any, string>,
	tdcConsentsAckTmplId?: string | undefined | null | Variable<any, string>,
	zip: string | Variable<any, string>
};
	["Prescreen"]: AliasType<{
	id?:boolean | `@${string}`,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Prescreen']?: Omit<ValueTypes["Prescreen"], "...on Prescreen">
}>;
	["PublicType"]: AliasType<{
acknowledgements?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["AcknowledgementTemplateFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["AcknowledgementTemplateOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["PublicTypeAcknowledgementsConnection"]],
	ipAddress?:boolean | `@${string}`,
	platformVersion?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on PublicType']?: Omit<ValueTypes["PublicType"], "...on PublicType">
}>;
	["PublicTypeAcknowledgementsConnection"]: AliasType<{
	edges?:ValueTypes["PublicTypeAcknowledgementsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on PublicTypeAcknowledgementsConnection']?: Omit<ValueTypes["PublicTypeAcknowledgementsConnection"], "...on PublicTypeAcknowledgementsConnection">
}>;
	["PublicTypeAcknowledgementsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["AcknowledgementTemplate"],
		__typename?: boolean | `@${string}`,
	['...on PublicTypeAcknowledgementsConnectionEdge']?: Omit<ValueTypes["PublicTypeAcknowledgementsConnectionEdge"], "...on PublicTypeAcknowledgementsConnectionEdge">
}>;
	["Query"]: AliasType<{
customer?: [{	contactPId?: string | undefined | null | Variable<any, string>,	transactionId?: string | undefined | null | Variable<any, string>,	transactionPId?: string | undefined | null | Variable<any, string>,	userId?: string | undefined | null | Variable<any, string>},ValueTypes["Customer"]],
dealership?: [{	id?: string | undefined | null | Variable<any, string>,	slug?: string | undefined | null | Variable<any, string>},ValueTypes["Dealership"]],
dealershipStaffScheduleEvents?: [{	dealershipId: string | Variable<any, string>,	fromDate: string | Variable<any, string>,	toDate: string | Variable<any, string>},ValueTypes["StaffScheduleEvent"]],
	/** Return information about the currently logged in user */
	me?:ValueTypes["MeType"],
node?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["Node"]],
nodes?: [{	ids: Array<ValueTypes["ID"]> | Variable<any, string>},ValueTypes["Node"]],
	/** Return platform information */
	platform?:ValueTypes["PlatformType"],
	/** Public query root */
	public?:ValueTypes["PublicType"],
transaction?: [{	id?: string | undefined | null | Variable<any, string>,	/** Public ID, starts with "tx_..." - a human-friendly, URL-safe identifier */
	pId?: string | undefined | null | Variable<any, string>},ValueTypes["Transaction"]],
userDealership?: [{	dealershipId: string | Variable<any, string>,	userId: string | Variable<any, string>},ValueTypes["UserDealership"]],
		__typename?: boolean | `@${string}`,
	['...on Query']?: Omit<ValueTypes["Query"], "...on Query">
}>;
	["RecallMastersRecallReport"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	request?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on RecallMastersRecallReport']?: Omit<ValueTypes["RecallMastersRecallReport"], "...on RecallMastersRecallReport">
}>;
	["RecallMastersRecallReportFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["RecallMastersRecallReportOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["Referral"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dealership?:ValueTypes["Dealership"],
	id?:boolean | `@${string}`,
	pId?:boolean | `@${string}`,
	payoutInCents?:boolean | `@${string}`,
	referringContact?:ValueTypes["ContactV2"],
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Referral']?: Omit<ValueTypes["Referral"], "...on Referral">
}>;
	["ReferralStatus"]:ReferralStatus;
	["Response"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Response']?: Omit<ValueTypes["Response"], "...on Response">
}>;
	["Role"]:Role;
	["RoleFilter"]: {
	equals?: ValueTypes["Role"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["Role"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["RoleFilter"] | undefined | null | Variable<any, string>
};
	["RoleListFilter"]: {
	has?: ValueTypes["Role"] | undefined | null | Variable<any, string>
};
	["SalesRankingGrouppedByMonth"]: AliasType<{
	currentMonth?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastMonth?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	twoMonthsAgo?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SalesRankingGrouppedByMonth']?: Omit<ValueTypes["SalesRankingGrouppedByMonth"], "...on SalesRankingGrouppedByMonth">
}>;
	["SetStaffInformationInput"]: {
	cdkCrmEmployeeId?: string | undefined | null | Variable<any, string>
};
	["SevenHundredCreditPrequalReports"]: AliasType<{
	application?:ValueTypes["PrequalApplication"],
	id?:boolean | `@${string}`,
	idMatchSummary?:boolean | `@${string}`,
	ofacSummary?:boolean | `@${string}`,
	product?:boolean | `@${string}`,
	quizStatus?:boolean | `@${string}`,
	redFlagSummary?:boolean | `@${string}`,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	resultCode?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on SevenHundredCreditPrequalReports']?: Omit<ValueTypes["SevenHundredCreditPrequalReports"], "...on SevenHundredCreditPrequalReports">
}>;
	["SevenHundredCreditPrequalReportsFilter"]: {
	bureau?: ValueTypes["PrequalBureauFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	isForCompliance?: ValueTypes["BooleanFilter"] | undefined | null | Variable<any, string>
};
	["Staff"]: AliasType<{
	dealershipId?:boolean | `@${string}`,
	dealershipRole?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	hasEnabledStaffPlanning?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	receivesAuthenticomReport?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Staff']?: Omit<ValueTypes["Staff"], "...on Staff">
}>;
	["StaffAttributes"]: {
	email?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	phoneNumber?: string | undefined | null | Variable<any, string>,
	role?: ValueTypes["Role"] | undefined | null | Variable<any, string>
};
	["StaffFilter"]: {
	dealershipId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["StaffInformation"]: AliasType<{
	cdkCrmEmployeeId?:boolean | `@${string}`,
	dealership?:ValueTypes["Dealership"],
	dealershipId?:boolean | `@${string}`,
	user?:ValueTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on StaffInformation']?: Omit<ValueTypes["StaffInformation"], "...on StaffInformation">
}>;
	["StaffInformationFilter"]: {
	dealershipId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["StaffScheduleEvent"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dealershipId?:boolean | `@${string}`,
	endAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	staffId?:boolean | `@${string}`,
	startAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on StaffScheduleEvent']?: Omit<ValueTypes["StaffScheduleEvent"], "...on StaffScheduleEvent">
}>;
	["StageFormInput"]: {
	id: string | Variable<any, string>,
	order: number | Variable<any, string>
};
	["StringFilter"]: {
	contains?: string | undefined | null | Variable<any, string>,
	equals?: string | undefined | null | Variable<any, string>,
	mode?: ValueTypes["StringFilterMode"] | undefined | null | Variable<any, string>,
	not?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>,
	startsWith?: string | undefined | null | Variable<any, string>
};
	["StringFilterMode"]:StringFilterMode;
	["SubmitStep1Input"]: {
	captureBackFileId?: string | undefined | null | Variable<any, string>,
	captureFrontFileId?: string | undefined | null | Variable<any, string>,
	/** Signifies contact consent to the consent text at the template ID */
	contactConsentWithTemplateId: string | Variable<any, string>,
	dmvForm?: string | undefined | null | Variable<any, string>,
	dmvPdfFileId?: string | undefined | null | Variable<any, string>,
	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null | Variable<any, string>,
	privacyNoticeFileId: string | Variable<any, string>,
	privacyNoticeForm: string | Variable<any, string>,
	/** Signifies test drive consent to the consent text at the template ID */
	testDriveConsentWithTemplateId: string | Variable<any, string>
};
	["SubmitStep2Input"]: {
	captureFileId: string | Variable<any, string>,
	livenessSessionId?: string | undefined | null | Variable<any, string>,
	selfieAckTmplId: string | Variable<any, string>
};
	["SubmitTo"]:SubmitTo;
	["TextAlignment"]:TextAlignment;
	["Todo"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dealershipGroupId?:boolean | `@${string}`,
	dealershipId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	transaction?:ValueTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Todo']?: Omit<ValueTypes["Todo"], "...on Todo">
}>;
	["TodoFilter"]: {
	createdAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["TodoStatusFilter"] | undefined | null | Variable<any, string>,
	transactionId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	type?: ValueTypes["TodoTypesFilter"] | undefined | null | Variable<any, string>
};
	["TodoOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["TodoStatus"]:TodoStatus;
	["TodoStatusFilter"]: {
	equals?: ValueTypes["TodoStatus"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TodoStatus"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TodoStatusFilter"] | undefined | null | Variable<any, string>
};
	["TodoTypes"]:TodoTypes;
	["TodoTypesFilter"]: {
	equals?: ValueTypes["TodoTypes"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TodoTypes"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TodoTypesFilter"] | undefined | null | Variable<any, string>
};
	["Transaction"]: AliasType<{
agilityCreditVerifications?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["AgilityCreditIdVerificationFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["TransactionAgilityCreditVerificationsConnection"]],
	bdc?:ValueTypes["User"],
	buyer?:ValueTypes["Customer"],
	buyerId?:boolean | `@${string}`,
	cdkDmsDealId?:boolean | `@${string}`,
	/** Optionally, a co-buyer for the transaction */
	coBuyer?:ValueTypes["Customer"],
	coBuyerId?:boolean | `@${string}`,
	complianceFormsData?:ValueTypes["ComplianceFormsData"],
	consumerRebatesInUsdCents?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	customerSharedData?:ValueTypes["CustomerSharedData"],
	dealership?:ValueTypes["Dealership"],
	dealershipCommitment?:boolean | `@${string}`,
documents?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["DocumentOr"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["DocumentOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["TransactionDocumentsConnection"]],
	downPayment?:boolean | `@${string}`,
	downPaymentInUsdCents?:boolean | `@${string}`,
	financeType?:boolean | `@${string}`,
	fniManager?:ValueTypes["User"],
formSubmissionCollections?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["FormSubmissionCollectionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["FormSubmissionCollectionOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["TransactionFormSubmissionCollectionsConnection"]],
formSubmissions?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["FormSubmissionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	/** Filter such that only form submissions with missing values from userId are returned */
	hasMissingValuesBy?: string | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["FormFieldSubmissionOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["TransactionFormSubmissionsConnection"]],
	isLeaseBuyOut?:boolean | `@${string}`,
	leaseTermInMonths?:boolean | `@${string}`,
lenderHardCreditApplications?: [{	orderBy?: ValueTypes["LenderHardCreditApplicationOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["LenderHardCreditApplication"]],
	lockedReason?:boolean | `@${string}`,
logs?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["TransactionLogFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["TransactionLogOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["TransactionLogsConnection"]],
	milesPerYearInLease?:boolean | `@${string}`,
	monthlyLeasePaymentInUsdCents?:boolean | `@${string}`,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "tx_...") */
	pId?:boolean | `@${string}`,
	price?:boolean | `@${string}`,
referrals?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["TransactionReferralsConnection"]],
	routeOneApplicationId?:boolean | `@${string}`,
	salesManager?:ValueTypes["User"],
	salesPerson?:ValueTypes["User"],
	salesPriceInUsdCents?:boolean | `@${string}`,
	salesTaxInMiliBsp?:boolean | `@${string}`,
	source?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	/** The title of a transaction default to the buyers name or email if that is not set */
	title?:boolean | `@${string}`,
todos?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["TodoFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["TodoOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["TransactionTodosConnection"]],
	tradeInPriceInUsdCents?:boolean | `@${string}`,
	tradeVehicle?:ValueTypes["Vehicle"],
	/** This returns a list of all users who have made changes to the transaction. This can be used to filter the list of transaction logs */
	usersWorkingOnTransaction?:ValueTypes["ListItem"],
	vehicle?:ValueTypes["Vehicle"],
vehicleRegistrationExtractions?: [{	filter?: ValueTypes["VehicleRegistrationExtractionFilter"] | undefined | null | Variable<any, string>},ValueTypes["VehicleRegistrationExtraction"]],
		__typename?: boolean | `@${string}`,
	['...on Transaction']?: Omit<ValueTypes["Transaction"], "...on Transaction">
}>;
	["TransactionAgilityCreditVerificationsConnection"]: AliasType<{
	edges?:ValueTypes["TransactionAgilityCreditVerificationsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on TransactionAgilityCreditVerificationsConnection']?: Omit<ValueTypes["TransactionAgilityCreditVerificationsConnection"], "...on TransactionAgilityCreditVerificationsConnection">
}>;
	["TransactionAgilityCreditVerificationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["AgilityCreditIdVerification"],
		__typename?: boolean | `@${string}`,
	['...on TransactionAgilityCreditVerificationsConnectionEdge']?: Omit<ValueTypes["TransactionAgilityCreditVerificationsConnectionEdge"], "...on TransactionAgilityCreditVerificationsConnectionEdge">
}>;
	["TransactionAndFilter"]: {
	OR?: Array<ValueTypes["AssignedStaffOrFilter"]> | undefined | null | Variable<any, string>,
	salesPersonId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["TransactionDealershipAnalyticsSpotFilter"]: {
	eventAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>
};
	["TransactionDocumentsConnection"]: AliasType<{
	edges?:ValueTypes["TransactionDocumentsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TransactionDocumentsConnection']?: Omit<ValueTypes["TransactionDocumentsConnection"], "...on TransactionDocumentsConnection">
}>;
	["TransactionDocumentsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Document"],
		__typename?: boolean | `@${string}`,
	['...on TransactionDocumentsConnectionEdge']?: Omit<ValueTypes["TransactionDocumentsConnectionEdge"], "...on TransactionDocumentsConnectionEdge">
}>;
	["TransactionFilter"]: {
	AND?: Array<ValueTypes["TransactionAndFilter"]> | undefined | null | Variable<any, string>,
	OR?: Array<ValueTypes["AssignedStaffOrFilter"]> | undefined | null | Variable<any, string>,
	buyerId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	coBuyerId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	createdAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>,
	dealership?: ValueTypes["DealershipFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	salesPersonId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	source?: ValueTypes["TransactionSourceFilter"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["TransactionStatusFilter"] | undefined | null | Variable<any, string>
};
	["TransactionFormSubmissionCollectionsConnection"]: AliasType<{
	edges?:ValueTypes["TransactionFormSubmissionCollectionsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TransactionFormSubmissionCollectionsConnection']?: Omit<ValueTypes["TransactionFormSubmissionCollectionsConnection"], "...on TransactionFormSubmissionCollectionsConnection">
}>;
	["TransactionFormSubmissionCollectionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["FormSubmissionCollection"],
		__typename?: boolean | `@${string}`,
	['...on TransactionFormSubmissionCollectionsConnectionEdge']?: Omit<ValueTypes["TransactionFormSubmissionCollectionsConnectionEdge"], "...on TransactionFormSubmissionCollectionsConnectionEdge">
}>;
	["TransactionFormSubmissionsConnection"]: AliasType<{
	edges?:ValueTypes["TransactionFormSubmissionsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TransactionFormSubmissionsConnection']?: Omit<ValueTypes["TransactionFormSubmissionsConnection"], "...on TransactionFormSubmissionsConnection">
}>;
	["TransactionFormSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["FormSubmission"],
		__typename?: boolean | `@${string}`,
	['...on TransactionFormSubmissionsConnectionEdge']?: Omit<ValueTypes["TransactionFormSubmissionsConnectionEdge"], "...on TransactionFormSubmissionsConnectionEdge">
}>;
	["TransactionLifecycle"]:TransactionLifecycle;
	["TransactionLockReason"]:TransactionLockReason;
	["TransactionLog"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	event?:boolean | `@${string}`,
	eventDescription?:boolean | `@${string}`,
	executingUser?:ValueTypes["User"],
	id?:boolean | `@${string}`,
	transaction?:ValueTypes["Transaction"],
		__typename?: boolean | `@${string}`,
	['...on TransactionLog']?: Omit<ValueTypes["TransactionLog"], "...on TransactionLog">
}>;
	["TransactionLogFilter"]: {
	createdAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>,
	executingUserId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["TransactionLogOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["TransactionLogsConnection"]: AliasType<{
	edges?:ValueTypes["TransactionLogsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on TransactionLogsConnection']?: Omit<ValueTypes["TransactionLogsConnection"], "...on TransactionLogsConnection">
}>;
	["TransactionLogsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["TransactionLog"],
		__typename?: boolean | `@${string}`,
	['...on TransactionLogsConnectionEdge']?: Omit<ValueTypes["TransactionLogsConnectionEdge"], "...on TransactionLogsConnectionEdge">
}>;
	["TransactionOrderBy"]: {
	createdAt?: ValueTypes["FieldOrdering"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["FieldOrdering"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["FieldOrdering"] | undefined | null | Variable<any, string>,
	source?: ValueTypes["FieldOrdering"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["FieldOrdering"] | undefined | null | Variable<any, string>
};
	["TransactionReferralsConnection"]: AliasType<{
	edges?:ValueTypes["TransactionReferralsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on TransactionReferralsConnection']?: Omit<ValueTypes["TransactionReferralsConnection"], "...on TransactionReferralsConnection">
}>;
	["TransactionReferralsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Referral"],
		__typename?: boolean | `@${string}`,
	['...on TransactionReferralsConnectionEdge']?: Omit<ValueTypes["TransactionReferralsConnectionEdge"], "...on TransactionReferralsConnectionEdge">
}>;
	["TransactionRole"]:TransactionRole;
	["TransactionSalesRankingAnalyticsWhereInput"]: {
	status?: ValueTypes["TransactionStatusFilter"] | undefined | null | Variable<any, string>
};
	["TransactionSource"]:TransactionSource;
	["TransactionSourceFilter"]: {
	equals?: ValueTypes["TransactionSource"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TransactionSource"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TransactionSourceFilter"] | undefined | null | Variable<any, string>
};
	["TransactionStatus"]:TransactionStatus;
	["TransactionStatusFilter"]: {
	equals?: ValueTypes["TransactionStatus"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["TransactionStatus"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["TransactionStatusFilter"] | undefined | null | Variable<any, string>
};
	["TransactionStatusUpdateDealershipAnalyticsFilter"]: {
	eventAt?: ValueTypes["DateTimeFilter"] | undefined | null | Variable<any, string>,
	financeType?: ValueTypes["FinanceTypeFilter"] | undefined | null | Variable<any, string>,
	isLeaseBuyOut?: boolean | undefined | null | Variable<any, string>,
	purchaseVehicleLifeCycleStage?: ValueTypes["VehicleLifeCycleStageFilter"] | undefined | null | Variable<any, string>,
	source?: ValueTypes["TransactionSourceFilter"] | undefined | null | Variable<any, string>,
	status?: ValueTypes["TransactionStatusFilter"] | undefined | null | Variable<any, string>
};
	["TransactionTodosConnection"]: AliasType<{
	edges?:ValueTypes["TransactionTodosConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on TransactionTodosConnection']?: Omit<ValueTypes["TransactionTodosConnection"], "...on TransactionTodosConnection">
}>;
	["TransactionTodosConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Todo"],
		__typename?: boolean | `@${string}`,
	['...on TransactionTodosConnectionEdge']?: Omit<ValueTypes["TransactionTodosConnectionEdge"], "...on TransactionTodosConnectionEdge">
}>;
	["UpdateCustomerAddress"]: {
	apartmentDetails: string | Variable<any, string>,
	city: string | Variable<any, string>,
	state: string | Variable<any, string>,
	street: string | Variable<any, string>,
	zipCode: string | Variable<any, string>
};
	["UpdateCustomerInput"]: {
	dob?: ValueTypes["DateTime"] | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	middleName?: string | undefined | null | Variable<any, string>,
	removeVehicleRegistrationAddress?: boolean | undefined | null | Variable<any, string>,
	residentialAddresses?: Array<ValueTypes["AddressInput"]> | undefined | null | Variable<any, string>,
	selfieCaptureId?: string | undefined | null | Variable<any, string>,
	socialSecurityNumber?: string | undefined | null | Variable<any, string>,
	vehicleRegistrationAddress?: ValueTypes["UpdateCustomerAddress"] | undefined | null | Variable<any, string>
};
	["UpdateEmploymentInput"]: {
	durationMonths?: number | undefined | null | Variable<any, string>,
	durationYears?: number | undefined | null | Variable<any, string>,
	employerName?: string | undefined | null | Variable<any, string>,
	employerPhoneNumber?: string | undefined | null | Variable<any, string>,
	employmentStatus?: string | undefined | null | Variable<any, string>,
	incomeAmount?: number | undefined | null | Variable<any, string>,
	incomeInterval?: string | undefined | null | Variable<any, string>,
	occupation?: string | undefined | null | Variable<any, string>,
	otherIncomeAmount?: number | undefined | null | Variable<any, string>,
	otherIncomeInterval?: string | undefined | null | Variable<any, string>,
	otherIncomeSource?: string | undefined | null | Variable<any, string>,
	timelinePosition?: number | undefined | null | Variable<any, string>
};
	["UpdateStaffScheduleEventInput"]: {
	endAt?: string | undefined | null | Variable<any, string>,
	note?: string | undefined | null | Variable<any, string>,
	startAt?: string | undefined | null | Variable<any, string>
};
	["UpdateTransactionInput"]: {
	cdkDmsDealId?: string | undefined | null | Variable<any, string>,
	consumerRebatesInUsdCents?: number | undefined | null | Variable<any, string>,
	dealershipCommitment?: string | undefined | null | Variable<any, string>,
	downPaymentInUsdCents?: number | undefined | null | Variable<any, string>,
	financeType?: string | undefined | null | Variable<any, string>,
	id: string | Variable<any, string>,
	isLeaseBuyOut?: boolean | undefined | null | Variable<any, string>,
	leaseTermInMonths?: number | undefined | null | Variable<any, string>,
	milesPerYearInLease?: number | undefined | null | Variable<any, string>,
	monthlyLeasePaymentInUsdCents?: number | undefined | null | Variable<any, string>,
	salesPriceInUsdCents?: number | undefined | null | Variable<any, string>,
	salesTaxInMiliBsp?: number | undefined | null | Variable<any, string>,
	tradeInPriceInUsdCents?: number | undefined | null | Variable<any, string>
};
	["UpdateTransactionStaffInput"]: {
	bdcId?: string | undefined | null | Variable<any, string>,
	fniManagerId?: string | undefined | null | Variable<any, string>,
	salesManagerId?: string | undefined | null | Variable<any, string>,
	salesPersonId?: string | undefined | null | Variable<any, string>
};
	["UpdateUserInput"]: {
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>
};
	["User"]: AliasType<{
buyerFor?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["TransactionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserBuyerForConnection"]],
coBuyerFor?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["TransactionFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserCoBuyerForConnection"]],
	createdAt?:boolean | `@${string}`,
customers?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["CustomerFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserCustomersConnection"]],
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
hasReferred?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserHasReferredConnection"]],
	id?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
notifications?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["NotificationFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	isUnread?: boolean | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["NotificationOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["UserNotificationsConnection"]],
	phoneNumber?:boolean | `@${string}`,
staff?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["StaffFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserStaffConnection"]],
staffInformation?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["StaffInformationFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserStaffInformationConnection"]],
userAcknowledgements?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["UserAcknowledgementFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	order?: ValueTypes["UserAcknowledgementOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["UserUserAcknowledgementsConnection"]],
userGroup?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["UserGroupFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserUserGroupConnection"]],
userLogs?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>},ValueTypes["UserUserLogsConnection"]],
		__typename?: boolean | `@${string}`,
	['...on User']?: Omit<ValueTypes["User"], "...on User">
}>;
	["UserAcknowledgement"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserAcknowledgement']?: Omit<ValueTypes["UserAcknowledgement"], "...on UserAcknowledgement">
}>;
	["UserAcknowledgementFilter"]: {
	acknowledgementId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	dealershipId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	transactionId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["UserAcknowledgementOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["UserBuyerForConnection"]: AliasType<{
	edges?:ValueTypes["UserBuyerForConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserBuyerForConnection']?: Omit<ValueTypes["UserBuyerForConnection"], "...on UserBuyerForConnection">
}>;
	["UserBuyerForConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Transaction"],
		__typename?: boolean | `@${string}`,
	['...on UserBuyerForConnectionEdge']?: Omit<ValueTypes["UserBuyerForConnectionEdge"], "...on UserBuyerForConnectionEdge">
}>;
	["UserCoBuyerForConnection"]: AliasType<{
	edges?:ValueTypes["UserCoBuyerForConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserCoBuyerForConnection']?: Omit<ValueTypes["UserCoBuyerForConnection"], "...on UserCoBuyerForConnection">
}>;
	["UserCoBuyerForConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Transaction"],
		__typename?: boolean | `@${string}`,
	['...on UserCoBuyerForConnectionEdge']?: Omit<ValueTypes["UserCoBuyerForConnectionEdge"], "...on UserCoBuyerForConnectionEdge">
}>;
	["UserCustomersConnection"]: AliasType<{
	edges?:ValueTypes["UserCustomersConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserCustomersConnection']?: Omit<ValueTypes["UserCustomersConnection"], "...on UserCustomersConnection">
}>;
	["UserCustomersConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Customer"],
		__typename?: boolean | `@${string}`,
	['...on UserCustomersConnectionEdge']?: Omit<ValueTypes["UserCustomersConnectionEdge"], "...on UserCustomersConnectionEdge">
}>;
	["UserDealership"]: AliasType<{
	dealership?:ValueTypes["Dealership"],
	dealershipId?:boolean | `@${string}`,
	extraPermissions?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	isSuspended?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	user?:ValueTypes["User"],
		__typename?: boolean | `@${string}`,
	['...on UserDealership']?: Omit<ValueTypes["UserDealership"], "...on UserDealership">
}>;
	["UserDealershipFilter"]: {
	isSuspended?: ValueTypes["BooleanFilter"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["RoleFilter"] | undefined | null | Variable<any, string>,
	user?: ValueTypes["UserFilter"] | undefined | null | Variable<any, string>,
	userId?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["UserEventOperation"]:UserEventOperation;
	["UserFilter"]: {
	OR?: Array<ValueTypes["UserOrFilter"]> | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>
};
	["UserGroup"]: AliasType<{
	group?:ValueTypes["DealershipGroup"],
	groupId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	isSuspended?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	user?:ValueTypes["User"],
		__typename?: boolean | `@${string}`,
	['...on UserGroup']?: Omit<ValueTypes["UserGroup"], "...on UserGroup">
}>;
	["UserGroupFilter"]: {
	isSuspended?: boolean | undefined | null | Variable<any, string>
};
	["UserHasReferredConnection"]: AliasType<{
	edges?:ValueTypes["UserHasReferredConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserHasReferredConnection']?: Omit<ValueTypes["UserHasReferredConnection"], "...on UserHasReferredConnection">
}>;
	["UserHasReferredConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Referral"],
		__typename?: boolean | `@${string}`,
	['...on UserHasReferredConnectionEdge']?: Omit<ValueTypes["UserHasReferredConnectionEdge"], "...on UserHasReferredConnectionEdge">
}>;
	["UserLog"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	event?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserLog']?: Omit<ValueTypes["UserLog"], "...on UserLog">
}>;
	["UserNotificationsConnection"]: AliasType<{
	edges?:ValueTypes["UserNotificationsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserNotificationsConnection']?: Omit<ValueTypes["UserNotificationsConnection"], "...on UserNotificationsConnection">
}>;
	["UserNotificationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Notification"],
		__typename?: boolean | `@${string}`,
	['...on UserNotificationsConnectionEdge']?: Omit<ValueTypes["UserNotificationsConnectionEdge"], "...on UserNotificationsConnectionEdge">
}>;
	["UserOrFilter"]: {
	firstName?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>,
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["StringFilter"] | undefined | null | Variable<any, string>
};
	["UserStaffConnection"]: AliasType<{
	edges?:ValueTypes["UserStaffConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserStaffConnection']?: Omit<ValueTypes["UserStaffConnection"], "...on UserStaffConnection">
}>;
	["UserStaffConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["Staff"],
		__typename?: boolean | `@${string}`,
	['...on UserStaffConnectionEdge']?: Omit<ValueTypes["UserStaffConnectionEdge"], "...on UserStaffConnectionEdge">
}>;
	["UserStaffInformationConnection"]: AliasType<{
	edges?:ValueTypes["UserStaffInformationConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserStaffInformationConnection']?: Omit<ValueTypes["UserStaffInformationConnection"], "...on UserStaffInformationConnection">
}>;
	["UserStaffInformationConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["StaffInformation"],
		__typename?: boolean | `@${string}`,
	['...on UserStaffInformationConnectionEdge']?: Omit<ValueTypes["UserStaffInformationConnectionEdge"], "...on UserStaffInformationConnectionEdge">
}>;
	["UserUserAcknowledgementsConnection"]: AliasType<{
	edges?:ValueTypes["UserUserAcknowledgementsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserUserAcknowledgementsConnection']?: Omit<ValueTypes["UserUserAcknowledgementsConnection"], "...on UserUserAcknowledgementsConnection">
}>;
	["UserUserAcknowledgementsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["UserAcknowledgement"],
		__typename?: boolean | `@${string}`,
	['...on UserUserAcknowledgementsConnectionEdge']?: Omit<ValueTypes["UserUserAcknowledgementsConnectionEdge"], "...on UserUserAcknowledgementsConnectionEdge">
}>;
	["UserUserGroupConnection"]: AliasType<{
	edges?:ValueTypes["UserUserGroupConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserUserGroupConnection']?: Omit<ValueTypes["UserUserGroupConnection"], "...on UserUserGroupConnection">
}>;
	["UserUserGroupConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["UserGroup"],
		__typename?: boolean | `@${string}`,
	['...on UserUserGroupConnectionEdge']?: Omit<ValueTypes["UserUserGroupConnectionEdge"], "...on UserUserGroupConnectionEdge">
}>;
	["UserUserLogsConnection"]: AliasType<{
	edges?:ValueTypes["UserUserLogsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on UserUserLogsConnection']?: Omit<ValueTypes["UserUserLogsConnection"], "...on UserUserLogsConnection">
}>;
	["UserUserLogsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["UserLog"],
		__typename?: boolean | `@${string}`,
	['...on UserUserLogsConnectionEdge']?: Omit<ValueTypes["UserUserLogsConnectionEdge"], "...on UserUserLogsConnectionEdge">
}>;
	["Vehicle"]: AliasType<{
	bodyType?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	condition?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	lifeCycleStage?:boolean | `@${string}`,
	make?:boolean | `@${string}`,
	mileage?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	msrp?:boolean | `@${string}`,
	pictureBack?:ValueTypes["File"],
	pictureFront?:ValueTypes["File"],
	pictureInterior?:ValueTypes["File"],
	pictureLeftSide?:ValueTypes["File"],
	pictureOdometer?:ValueTypes["File"],
	pictureRightSide?:ValueTypes["File"],
	pictureVinNumber?:ValueTypes["File"],
	principalPriorUse?:boolean | `@${string}`,
recallMastersRecallReports?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["RecallMastersRecallReportFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderBy?: ValueTypes["RecallMastersRecallReportOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["VehicleRecallMastersRecallReportsConnection"]],
	registrationName?:boolean | `@${string}`,
	registrationState?:boolean | `@${string}`,
	stockNumber?:boolean | `@${string}`,
	transactionPurchaseVehicle?:ValueTypes["Transaction"],
	transactionTradeVehicle?:ValueTypes["Transaction"],
	/** Pre-packaged groups of features (e.g., base model, performance, etc.) */
	trim?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	updatedByDealership?:boolean | `@${string}`,
vehicleRecallChecks?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["VehicleNhtsaRecallReportFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderby?: ValueTypes["VehicleNhtsaRecallReportOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["VehicleVehicleRecallChecksConnection"]],
	vin?:boolean | `@${string}`,
vinAuditReports?: [{	after?: string | undefined | null | Variable<any, string>,	before?: string | undefined | null | Variable<any, string>,	filter?: ValueTypes["VinAuditReportFilter"] | undefined | null | Variable<any, string>,	first?: number | undefined | null | Variable<any, string>,	last?: number | undefined | null | Variable<any, string>,	orderby?: ValueTypes["VinAuditReportOrderBy"] | undefined | null | Variable<any, string>},ValueTypes["VehicleVinAuditReportsConnection"]],
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Vehicle']?: Omit<ValueTypes["Vehicle"], "...on Vehicle">
}>;
	["VehicleBodyType"]:VehicleBodyType;
	["VehicleCondition"]:VehicleCondition;
	["VehicleLifeCycleStage"]:VehicleLifeCycleStage;
	["VehicleLifeCycleStageFilter"]: {
	equals?: ValueTypes["VehicleLifeCycleStage"] | undefined | null | Variable<any, string>,
	in?: Array<ValueTypes["VehicleLifeCycleStage"]> | undefined | null | Variable<any, string>,
	not?: ValueTypes["VehicleLifeCycleStageFilter"] | undefined | null | Variable<any, string>
};
	["VehicleNhtsaRecallReport"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on VehicleNhtsaRecallReport']?: Omit<ValueTypes["VehicleNhtsaRecallReport"], "...on VehicleNhtsaRecallReport">
}>;
	["VehicleNhtsaRecallReportFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["VehicleNhtsaRecallReportOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["VehiclePrincipalPriorUse"]:VehiclePrincipalPriorUse;
	["VehicleRecallMastersRecallReportsConnection"]: AliasType<{
	edges?:ValueTypes["VehicleRecallMastersRecallReportsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on VehicleRecallMastersRecallReportsConnection']?: Omit<ValueTypes["VehicleRecallMastersRecallReportsConnection"], "...on VehicleRecallMastersRecallReportsConnection">
}>;
	["VehicleRecallMastersRecallReportsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["RecallMastersRecallReport"],
		__typename?: boolean | `@${string}`,
	['...on VehicleRecallMastersRecallReportsConnectionEdge']?: Omit<ValueTypes["VehicleRecallMastersRecallReportsConnectionEdge"], "...on VehicleRecallMastersRecallReportsConnectionEdge">
}>;
	["VehicleRegistrationExtraction"]: AliasType<{
	bodyType?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	condition?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	licensePlate?:boolean | `@${string}`,
	make?:boolean | `@${string}`,
	mileage?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	registrationName?:boolean | `@${string}`,
	registrationState?:boolean | `@${string}`,
	requestedById?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	vin?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on VehicleRegistrationExtraction']?: Omit<ValueTypes["VehicleRegistrationExtraction"], "...on VehicleRegistrationExtraction">
}>;
	["VehicleRegistrationExtractionFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["VehicleRegistrationExtractionStatus"]:VehicleRegistrationExtractionStatus;
	["VehicleVehicleRecallChecksConnection"]: AliasType<{
	edges?:ValueTypes["VehicleVehicleRecallChecksConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on VehicleVehicleRecallChecksConnection']?: Omit<ValueTypes["VehicleVehicleRecallChecksConnection"], "...on VehicleVehicleRecallChecksConnection">
}>;
	["VehicleVehicleRecallChecksConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["VehicleNhtsaRecallReport"],
		__typename?: boolean | `@${string}`,
	['...on VehicleVehicleRecallChecksConnectionEdge']?: Omit<ValueTypes["VehicleVehicleRecallChecksConnectionEdge"], "...on VehicleVehicleRecallChecksConnectionEdge">
}>;
	["VehicleVinAuditReportsConnection"]: AliasType<{
	edges?:ValueTypes["VehicleVinAuditReportsConnectionEdge"],
	pageInfo?:ValueTypes["PageInfo"],
		__typename?: boolean | `@${string}`,
	['...on VehicleVinAuditReportsConnection']?: Omit<ValueTypes["VehicleVinAuditReportsConnection"], "...on VehicleVinAuditReportsConnection">
}>;
	["VehicleVinAuditReportsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ValueTypes["VinAuditReport"],
		__typename?: boolean | `@${string}`,
	['...on VehicleVinAuditReportsConnectionEdge']?: Omit<ValueTypes["VehicleVinAuditReportsConnectionEdge"], "...on VehicleVinAuditReportsConnectionEdge">
}>;
	["VinAuditReport"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on VinAuditReport']?: Omit<ValueTypes["VinAuditReport"], "...on VinAuditReport">
}>;
	["VinAuditReportFilter"]: {
	id?: ValueTypes["IDFilter"] | undefined | null | Variable<any, string>
};
	["VinAuditReportOrderBy"]: {
	createdAt?: ValueTypes["OrderBy"] | undefined | null | Variable<any, string>
};
	["ID"]:unknown
  }

export type ResolverInputTypes = {
    ["Acknowledgement"]:Acknowledgement;
	["AcknowledgementFilter"]: {
	equals?: ResolverInputTypes["Acknowledgement"] | undefined | null,
	in?: Array<ResolverInputTypes["Acknowledgement"]> | undefined | null,
	not?: ResolverInputTypes["AcknowledgementFilter"] | undefined | null
};
	["AcknowledgementTemplate"]: AliasType<{
	code?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	language?:boolean | `@${string}`,
	revision?:boolean | `@${string}`,
	textMarkdown?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AcknowledgementTemplateFilter"]: {
	code?: ResolverInputTypes["AcknowledgementFilter"] | undefined | null,
	language?: ResolverInputTypes["StringFilter"] | undefined | null
};
	["AcknowledgementTemplateOrderBy"]: {
	revision?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["Address"]: AliasType<{
	apartmentDetails?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	customer?:ResolverInputTypes["Customer"],
	durationMonths?:boolean | `@${string}`,
	durationYears?:boolean | `@${string}`,
	fullAddress?:boolean | `@${string}`,
	housingStatus?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	monthlyPayment?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	timelinePosition?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	zipCode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AddressInput"]: {
	apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	housingStatus?: string | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition: number,
	zipCode?: string | undefined | null
};
	["AgilityCreditAccount"]: AliasType<{
	accountNumber?:boolean | `@${string}`,
	acctType?:boolean | `@${string}`,
	balance?:boolean | `@${string}`,
	bureau?:boolean | `@${string}`,
	closedDate?:boolean | `@${string}`,
	creditLimit?:boolean | `@${string}`,
	creditor?:boolean | `@${string}`,
	currentStatus?:boolean | `@${string}`,
	days30?:boolean | `@${string}`,
	days60?:boolean | `@${string}`,
	days90?:boolean | `@${string}`,
	highCredit?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	indJoint?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	monthlyPayment?:boolean | `@${string}`,
	notes?:boolean | `@${string}`,
	openClosed?:boolean | `@${string}`,
	openDate?:boolean | `@${string}`,
	originalAmount?:boolean | `@${string}`,
	pastDue?:boolean | `@${string}`,
	paymentHistory?:boolean | `@${string}`,
	reportedDate?:boolean | `@${string}`,
	timesLate?:boolean | `@${string}`,
	tradeType?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditAccountKind"]:AgilityCreditAccountKind;
	["AgilityCreditAddress"]: AliasType<{
	addressLine1?:boolean | `@${string}`,
	addressLine2?:boolean | `@${string}`,
	addressVarianceCode?:boolean | `@${string}`,
	addressVarianceDescription?:boolean | `@${string}`,
	dateLastReported?:boolean | `@${string}`,
	dateReported?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditAka"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditAlert"]: AliasType<{
	date?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	text?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditApplicantInformation"]: AliasType<{
	address?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	infiledDate?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	ssn?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditEmployment"]: AliasType<{
	dateHired?:boolean | `@${string}`,
	dateTerminated?:boolean | `@${string}`,
	employer?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	income?:boolean | `@${string}`,
	infiledDate?:boolean | `@${string}`,
	lastReportedDate?:boolean | `@${string}`,
	occupation?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditIdVerification"]: AliasType<{
	id?:boolean | `@${string}`,
	idCard?:ResolverInputTypes["IdCard"],
	response?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditIdVerificationFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["AgilityCreditInquiry"]: AliasType<{
	date?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	industry?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	subscriberCode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditPrequalReport"]: AliasType<{
	accounts?:ResolverInputTypes["AgilityCreditAccount"],
	addresses?:ResolverInputTypes["AgilityCreditAddress"],
	akas?:ResolverInputTypes["AgilityCreditAka"],
	alerts?:ResolverInputTypes["AgilityCreditAlert"],
	applicantInformation?:ResolverInputTypes["AgilityCreditApplicantInformation"],
	bureau?:boolean | `@${string}`,
	bureauAbbrev?:boolean | `@${string}`,
	collectionsCount?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	creditScores?:ResolverInputTypes["AgilityCreditScore"],
	disputedAccountsCount?:boolean | `@${string}`,
	employments?:ResolverInputTypes["AgilityCreditEmployment"],
	errorMessage?:boolean | `@${string}`,
	foreclosuresCount?:boolean | `@${string}`,
	hitIndicator?:boolean | `@${string}`,
	inquiries?:ResolverInputTypes["AgilityCreditInquiry"],
	inquiriesCount?:boolean | `@${string}`,
	noScoreIndicator?:boolean | `@${string}`,
	openCollectionsCount?:boolean | `@${string}`,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "ap_...") */
	pId?:boolean | `@${string}`,
	publicRecords?:ResolverInputTypes["AgilityCreditPublicRecord"],
	publicRecordsCount?:boolean | `@${string}`,
	pullType?:boolean | `@${string}`,
	repossessionsCount?:boolean | `@${string}`,
	revolvingCreditUsage?:boolean | `@${string}`,
	stage?:boolean | `@${string}`,
	summaryCategories?:ResolverInputTypes["AgilityCreditSummaryCategory"],
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditPrequalReportFilter"]: {
	bureau?: ResolverInputTypes["PrequalBureauFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	pId?: ResolverInputTypes["StringFilter"] | undefined | null
};
	["AgilityCreditPublicRecord"]: AliasType<{
	courtName?:boolean | `@${string}`,
	dischargeDate?:boolean | `@${string}`,
	docket?:boolean | `@${string}`,
	ecoa?:boolean | `@${string}`,
	filedDate?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	publicRecordType?:boolean | `@${string}`,
	reportedDate?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditPullType"]:AgilityCreditPullType;
	["AgilityCreditScore"]: AliasType<{
	factors?:ResolverInputTypes["AgilityCreditScoreFactor"],
	id?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditScoreFactor"]: AliasType<{
	factorScore?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AgilityCreditSummaryCategory"]: AliasType<{
	balance?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	closed?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
	current?:boolean | `@${string}`,
	days30?:boolean | `@${string}`,
	days60?:boolean | `@${string}`,
	days90?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	open?:boolean | `@${string}`,
	pastDue?:boolean | `@${string}`,
	payments?:boolean | `@${string}`,
	unrated?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Announcement"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	markdownText?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AnnouncementOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["AssignedStaffOrFilter"]: {
	bdcId?: ResolverInputTypes["IDFilter"] | undefined | null,
	fniManagerId?: ResolverInputTypes["IDFilter"] | undefined | null,
	salesManagerId?: ResolverInputTypes["IDFilter"] | undefined | null,
	salesPersonId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	/** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
["BigInt"]:unknown;
	["BooleanFilter"]: {
	equals?: boolean | undefined | null,
	not?: ResolverInputTypes["BooleanFilter"] | undefined | null
};
	["CdkDealJacketStatus"]:CdkDealJacketStatus;
	["Chat"]: AliasType<{
chatMessages?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["ChatChatMessagesConnection"]],
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChatChatMessagesConnection"]: AliasType<{
	edges?:ResolverInputTypes["ChatChatMessagesConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ChatChatMessagesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["ChatMessage"],
		__typename?: boolean | `@${string}`
}>;
	["ChatMessage"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckBoxGroup"]: AliasType<{
	id?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
	n?:boolean | `@${string}`,
	rule?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckBoxGroupRules"]:CheckBoxGroupRules;
	["ComplianceData"]: AliasType<{
	/** ID Verification status, Not enabled for all dealerships */
	hasRequestedIdv?:ResolverInputTypes["ComplianceIdvField"],
	id?:ResolverInputTypes["ComplianceField"],
	idQuizSummary?:ResolverInputTypes["ComplianceField"],
	ofacStatus?:ResolverInputTypes["ComplianceField"],
	recalls?:ResolverInputTypes["ComplianceField"],
	redFlagStatus?:ResolverInputTypes["ComplianceField"],
		__typename?: boolean | `@${string}`
}>;
	["ComplianceField"]: AliasType<{
	description?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ComplianceFormsData"]: AliasType<{
	/** Whether or not the lending portal can be accessed */
	lendingPortalPreCondition?:ResolverInputTypes["ComplianceFormsPreCondition"],
	/** Returns the post-purchase forms that will be requested signed */
	postPurchaseForms?:ResolverInputTypes["Form"],
	/** Whether or not the post-purchase forms can be requested */
	postPurchasePreCondition?:ResolverInputTypes["ComplianceFormsPreCondition"],
	/** Returns the pre-purchase forms that will be requested signed */
	prePurchaseForms?:ResolverInputTypes["Form"],
	prePurchasePreCondition?:ResolverInputTypes["ComplianceFormsPreCondition"],
		__typename?: boolean | `@${string}`
}>;
	["ComplianceFormsPreCondition"]: AliasType<{
	errorCodes?:boolean | `@${string}`,
	result?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ComplianceIdvField"]: AliasType<{
	description?:boolean | `@${string}`,
	hasIdCard?:boolean | `@${string}`,
	hasRequestedVerification?:boolean | `@${string}`,
	latestVerificationId?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ComplianceStatus"]:ComplianceStatus;
	["ContactV2"]: AliasType<{
	createdAt?:boolean | `@${string}`,
customers?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["ContactV2CustomersConnection"]],
	firstName?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	middleName?:boolean | `@${string}`,
	pId?:boolean | `@${string}`,
	profilePicture?:ResolverInputTypes["File"],
	updatedAt?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ContactV2CustomersConnection"]: AliasType<{
	edges?:ResolverInputTypes["ContactV2CustomersConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["ContactV2CustomersConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Customer"],
		__typename?: boolean | `@${string}`
}>;
	["ContactV2Filter"]: {
	pId?: ResolverInputTypes["IDFilter"] | undefined | null,
	userId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["CreateCustomerInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string
};
	["CreateEmploymentInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus: string,
	incomeAmount?: number | undefined | null,
	incomeInterval?: string | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: string | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition: number
};
	["CreateStaffScheduleEventsInput"]: {
	endAt: string,
	note?: string | undefined | null,
	staffId: string,
	startAt: string,
	weeklyDuplications: number
};
	["CreateUserInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string,
	role: string
};
	["CreditApplicationAddressInformationInput"]: {
	apartmentDetails?: string | undefined | null,
	city: string,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	state: string,
	street: string,
	zipCode: string
};
	["CreditApplicationEmploymentInformationInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus: ResolverInputTypes["EmploymentStatus"],
	incomeAmount?: number | undefined | null,
	incomeInterval?: ResolverInputTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: ResolverInputTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null
};
	["CreditApplicationFormSubmissionDataInput"]: {
	addressDuration?: string | undefined | null,
	birthdate?: string | undefined | null,
	city?: string | undefined | null,
	customerName?: string | undefined | null,
	dateTime?: string | undefined | null,
	dealerPrivacyAckTmplId?: string | undefined | null,
	dealershipName?: string | undefined | null,
	deviceId?: string | undefined | null,
	eSignAckTmplId?: string | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: string | undefined | null,
	firstName?: string | undefined | null,
	hcaReportAckTmplId?: string | undefined | null,
	ipAddress?: string | undefined | null,
	jobTitle?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	modificationAckTmplId?: string | undefined | null,
	mortgageOrRentMonthlyPay?: string | undefined | null,
	name?: string | undefined | null,
	otherIncmeSource?: string | undefined | null,
	otherIncomeAmount?: string | undefined | null,
	otherIncomeType?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	prevEmployerInfo?: string | undefined | null,
	previousAddress?: string | undefined | null,
	previousAddressLength?: string | undefined | null,
	refNameAddress?: string | undefined | null,
	refPhoneNumber?: string | undefined | null,
	refRelationship?: string | undefined | null,
	residentialStatus?: string | undefined | null,
	salary?: string | undefined | null,
	signature?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	state?: string | undefined | null,
	streetAddress?: string | undefined | null,
	tdcConsentsAckTmplId?: string | undefined | null,
	timeOnJob?: string | undefined | null,
	type?: string | undefined | null,
	zip?: string | undefined | null
};
	["CreditApplicationFormSubmissionInput"]: {
	submissionData: ResolverInputTypes["CreditApplicationFormSubmissionDataInput"],
	submissionType: string
};
	["CreditApplicationInput"]: {
	birthdate: string,
	currentAddress: ResolverInputTypes["CreditApplicationAddressInformationInput"],
	currentAddressHousingStatus: ResolverInputTypes["HousingStatus"],
	currentAddressMonthlyPayment: number,
	currentEmployment: ResolverInputTypes["CreditApplicationEmploymentInformationInput"],
	dateTime: string,
	dealerPrivacyAckTmplId: string,
	deviceId: string,
	eSignAckTmplId: string,
	email: string,
	firstName: string,
	fullName: string,
	hcaReportAckTmplId: string,
	ipAddress: string,
	lastName: string,
	middleName?: string | undefined | null,
	phoneNumber: string,
	previousAddress?: ResolverInputTypes["CreditApplicationAddressInformationInput"] | undefined | null,
	previousEmployment?: ResolverInputTypes["CreditApplicationEmploymentInformationInput"] | undefined | null,
	signature: string,
	socialSecurityNumber: string,
	tdcConsentsAckTmplId: string
};
	["Customer"]: AliasType<{
	birthdate?:boolean | `@${string}`,
	compliance?:ResolverInputTypes["ComplianceData"],
	contact?:ResolverInputTypes["ContactV2"],
	contactAcknowledgement?:ResolverInputTypes["FormSubmission"],
	createdAt?:boolean | `@${string}`,
	dealership?:ResolverInputTypes["Dealership"],
	disassociatedRole?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
documents?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["DocumentOr"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerDocumentsConnection"]],
employments?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerEmploymentsConnection"]],
	firstName?:boolean | `@${string}`,
formSubmissions?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["FormSubmissionFilter"] | undefined | null,	first?: number | undefined | null,	/** Filter such that only form submissions with missing values are returned */
	hasMissingValues?: boolean | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerFormSubmissionsConnection"]],
hardCreditApplications?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["HardCreditApplicationFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["HardCreditApplicationOrderBy"] | undefined | null},ResolverInputTypes["CustomerHardCreditApplicationsConnection"]],
	hasBeenRemovedFromTransaction?:boolean | `@${string}`,
	hasPrequalApplication?:boolean | `@${string}`,
	hasSubmittedHardCreditApplication?:boolean | `@${string}`,
	idCards?:ResolverInputTypes["IdCard"],
	identityTheftPrevention?:ResolverInputTypes["FormSubmission"],
	languageSelection?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	lastRequestedPrescreenAt?:boolean | `@${string}`,
livelinessSession?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["LivelinessSessionFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerLivelinessSessionConnection"]],
	middleName?:boolean | `@${string}`,
nextDocumentsToSign?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerNextDocumentsToSignConnection"]],
	onboardingStep?:boolean | `@${string}`,
prequalApplications?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerPrequalApplicationsConnection"]],
prescreens?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerPrescreensConnection"]],
	privacyPolicy?:ResolverInputTypes["FormSubmission"],
residentialAddresses?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["CustomerResidentialAddressesConnection"]],
	selfieCapture?:ResolverInputTypes["File"],
	socialSecurityNumber?:boolean | `@${string}`,
	testDriveDisclosure?:ResolverInputTypes["FormSubmission"],
	transaction?:ResolverInputTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	userId?:boolean | `@${string}`,
	vehicleRegistrationAddress?:ResolverInputTypes["Address"],
	vehicleRegistrationAddressId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerDocumentsConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerDocumentsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerDocumentsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Document"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerEmploymentsConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerEmploymentsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerEmploymentsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Employment"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerFilter"]: {
	transactionId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["CustomerFormSubmissionsConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerFormSubmissionsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerFormSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["FormSubmission"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerHardCreditApplicationsConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerHardCreditApplicationsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerHardCreditApplicationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["HardCreditApplication"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerLivelinessSessionConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerLivelinessSessionConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerLivelinessSessionConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["LivelinessSession"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerNextDocumentsToSignConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerNextDocumentsToSignConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerNextDocumentsToSignConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["FormSubmission"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPrequalApplicationsConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerPrequalApplicationsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPrequalApplicationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["PrequalApplication"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPrescreensConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerPrescreensConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPrescreensConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Prescreen"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerPurchaseVehicleInput"]: {
	lifeCycleStage: ResolverInputTypes["VehicleLifeCycleStage"],
	make: string,
	mileage: number,
	model: string,
	principalPriorUse?: ResolverInputTypes["VehiclePrincipalPriorUse"] | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin: string,
	year: string
};
	["CustomerResidentialAddressesConnection"]: AliasType<{
	edges?:ResolverInputTypes["CustomerResidentialAddressesConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerResidentialAddressesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Address"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerSharedData"]: AliasType<{
	buyerEmail?:boolean | `@${string}`,
	buyerFirstName?:boolean | `@${string}`,
	buyerLastName?:boolean | `@${string}`,
	buyerName?:boolean | `@${string}`,
	buyerOnboardingStep?:boolean | `@${string}`,
	buyerPhoneNumber?:boolean | `@${string}`,
	coBuyerEmail?:boolean | `@${string}`,
	coBuyerFirstName?:boolean | `@${string}`,
	coBuyerLastName?:boolean | `@${string}`,
	coBuyerName?:boolean | `@${string}`,
	coBuyerOnboardingStep?:boolean | `@${string}`,
	coBuyerPhoneNumber?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerSignupInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string
};
	["CustomerTradeVehicleInput"]: {
	bodyType: ResolverInputTypes["VehicleBodyType"],
	color: string,
	condition: ResolverInputTypes["VehicleCondition"],
	make: string,
	mileage: number,
	model: string,
	pictureBackId?: string | undefined | null,
	pictureFrontId?: string | undefined | null,
	pictureInteriorId?: string | undefined | null,
	pictureLeftSideId?: string | undefined | null,
	pictureOdometerId?: string | undefined | null,
	pictureRightSideId?: string | undefined | null,
	pictureVinNumberId?: string | undefined | null,
	registrationCardId?: string | undefined | null,
	registrationName: string,
	registrationState: string,
	vin: string,
	year: string
};
	["CustomerTransactionRole"]:CustomerTransactionRole;
	/** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["Date"]:unknown;
	/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["DateTime"]:unknown;
	["DateTimeFilter"]: {
	equals?: ResolverInputTypes["DateTime"] | undefined | null,
	gt?: ResolverInputTypes["DateTime"] | undefined | null,
	gte?: ResolverInputTypes["DateTime"] | undefined | null,
	in?: Array<ResolverInputTypes["DateTime"]> | undefined | null,
	lt?: ResolverInputTypes["DateTime"] | undefined | null,
	lte?: ResolverInputTypes["DateTime"] | undefined | null,
	not?: ResolverInputTypes["DateTimeFilter"] | undefined | null
};
	["Dealership"]: AliasType<{
	address?:boolean | `@${string}`,
contacts?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["ContactV2Filter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["DealershipContactsConnection"]],
	dealershipGroupId?:boolean | `@${string}`,
	enabledPolicyLayers?:boolean | `@${string}`,
forms?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["DealershipFormsConnection"]],
	hasActiveAgilityCreditSubscription?:boolean | `@${string}`,
	hasEnabledAuthenticom?:boolean | `@${string}`,
	hasEnabledCdkCrm?:boolean | `@${string}`,
	hasEnabledCdkDms?:boolean | `@${string}`,
	hasEnabledChatBot?:boolean | `@${string}`,
	hasEnabledComplianceForms?:boolean | `@${string}`,
	hasEnabledDealJacketGalleryView?:boolean | `@${string}`,
	hasEnabledDealerTrack?:boolean | `@${string}`,
	hasEnabledDriversLicenseVerification?:boolean | `@${string}`,
	hasEnabledFormsCatalog?:boolean | `@${string}`,
	hasEnabledIdVerifOverAgility?:boolean | `@${string}`,
	hasEnabledImplicitPrequalsOnHca?:boolean | `@${string}`,
	hasEnabledPostPurchaseDocs?:boolean | `@${string}`,
	hasEnabledPrequalFormService?:boolean | `@${string}`,
	hasEnabledPrescreen?:boolean | `@${string}`,
	hasEnabledRecallMasters?:boolean | `@${string}`,
	hasEnabledReferrals?:boolean | `@${string}`,
	hasEnabledReportingDashboard?:boolean | `@${string}`,
	hasEnabledRoute1?:boolean | `@${string}`,
	hasEnabledStaffAcknowledgement?:boolean | `@${string}`,
	hasEnabledStaffPlanning?:boolean | `@${string}`,
	hasEnabledZipCodeOnSignUp?:boolean | `@${string}`,
	/** Whether or not the dealership has a TDC CDK app subscription ID set. */
	hasTdcCdkAppSubscriptionId?:boolean | `@${string}`,
homenetVehicles?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["HomenetVehicleDataFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	stockNumberSearchString?: string | undefined | null},ResolverInputTypes["DealershipHomenetVehiclesConnection"]],
	id?:boolean | `@${string}`,
	logoUrl?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	postPurchaseBillOfSaleFormId?:boolean | `@${string}`,
	postPurchasePurchaseOrderFormId?:boolean | `@${string}`,
	recallDetailsFormId?:boolean | `@${string}`,
	recallSummaryFormId?:boolean | `@${string}`,
	/** Only applicable when the feature is enabled. See hasEnabledReferrals */
	referralPayoutAmountInUsdCents?:boolean | `@${string}`,
	/** The sales people of a dealership needs to be presented on the signup page */
	salesPeople?:ResolverInputTypes["ListItem"],
	slug?:boolean | `@${string}`,
staff?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["DealershipStaffConnection"]],
	supportedLanguages?:boolean | `@${string}`,
	timeZone?:boolean | `@${string}`,
transactionStatusUpdateDealershipAnalyticsCount?: [{	filter?: ResolverInputTypes["TransactionStatusUpdateDealershipAnalyticsFilter"] | undefined | null},boolean | `@${string}`],
transactionUpdateDealershipSpotCount?: [{	filter?: ResolverInputTypes["TransactionDealershipAnalyticsSpotFilter"] | undefined | null},boolean | `@${string}`],
transactionUpdateStatusSalesRankingGrouped?: [{	filter?: ResolverInputTypes["TransactionSalesRankingAnalyticsWhereInput"] | undefined | null,	page: number,	pageSize: number,	startDate: string},ResolverInputTypes["SalesRankingGrouppedByMonth"]],
transactions?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["TransactionFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderby?: ResolverInputTypes["TransactionOrderBy"] | undefined | null,	searchString?: string | undefined | null},ResolverInputTypes["DealershipTransactionsConnection"]],
users?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["UserDealershipFilter"] | undefined | null,	first?: number | undefined | null,	isSuspended?: boolean | undefined | null,	last?: number | undefined | null,	rolesToExclude?: Array<string> | undefined | null,	rolesToInclude?: Array<string> | undefined | null,	searchString?: string | undefined | null},ResolverInputTypes["DealershipUsersConnection"]],
	website?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipContactsConnection"]: AliasType<{
	edges?:ResolverInputTypes["DealershipContactsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipContactsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["ContactV2"],
		__typename?: boolean | `@${string}`
}>;
	["DealershipFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	slug?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["DealershipFormsConnection"]: AliasType<{
	edges?:ResolverInputTypes["DealershipFormsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipFormsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Form"],
		__typename?: boolean | `@${string}`
}>;
	["DealershipGroup"]: AliasType<{
	address?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phoneNumber?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipHomenetVehiclesConnection"]: AliasType<{
	edges?:ResolverInputTypes["DealershipHomenetVehiclesConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["DealershipHomenetVehiclesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["HomenetVehicleData"],
		__typename?: boolean | `@${string}`
}>;
	["DealershipPermType"]: AliasType<{
	dealershipGroupId?:boolean | `@${string}`,
	dealershipGroupName?:boolean | `@${string}`,
	dealershipId?:boolean | `@${string}`,
	dealershipName?:boolean | `@${string}`,
	extraPermissions?:boolean | `@${string}`,
	groupRole?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipPurchaseVehicleInput"]: {
	bodyType?: ResolverInputTypes["VehicleBodyType"] | undefined | null,
	lifeCycleStage: ResolverInputTypes["VehicleLifeCycleStage"],
	make: string,
	mileage: number,
	model: string,
	msrp?: number | undefined | null,
	principalPriorUse?: ResolverInputTypes["VehiclePrincipalPriorUse"] | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin: string,
	year: string
};
	["DealershipStaffConnection"]: AliasType<{
	edges?:ResolverInputTypes["DealershipStaffConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipStaffConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Staff"],
		__typename?: boolean | `@${string}`
}>;
	["DealershipTradeVehicleInput"]: {
	bodyType: ResolverInputTypes["VehicleBodyType"],
	color: string,
	condition: ResolverInputTypes["VehicleCondition"],
	lifeCycleStage?: ResolverInputTypes["VehicleLifeCycleStage"] | undefined | null,
	make: string,
	mileage: number,
	model: string,
	registrationName: string,
	registrationState?: string | undefined | null,
	vin: string,
	year: string
};
	["DealershipTransactionsConnection"]: AliasType<{
	edges?:ResolverInputTypes["DealershipTransactionsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipTransactionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Transaction"],
		__typename?: boolean | `@${string}`
}>;
	["DealershipUsersConnection"]: AliasType<{
	edges?:ResolverInputTypes["DealershipUsersConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DealershipUsersConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["UserDealership"],
		__typename?: boolean | `@${string}`
}>;
	["Document"]: AliasType<{
	access?:boolean | `@${string}`,
	cdkDealJacketStatus?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	customer?:ResolverInputTypes["Customer"],
	file?:ResolverInputTypes["File"],
	id?:boolean | `@${string}`,
	labels?:ResolverInputTypes["DocumentLabelAttachment"],
	pdfIsEncrypted?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentLabel"]: AliasType<{
	code?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	label?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentLabelAttachment"]: AliasType<{
	documentLabel?:ResolverInputTypes["DocumentLabel"],
	isActive?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentLabelOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["DocumentOr"]: {
	access?: ResolverInputTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	dealershipReadAccess?: ResolverInputTypes["RoleListFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	userId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["DocumentOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["Employment"]: AliasType<{
	customer?:ResolverInputTypes["Customer"],
	durationMonths?:boolean | `@${string}`,
	durationYears?:boolean | `@${string}`,
	employerName?:boolean | `@${string}`,
	employerPhoneNumber?:boolean | `@${string}`,
	employmentStatus?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	incomeAmount?:boolean | `@${string}`,
	incomeInterval?:boolean | `@${string}`,
	occupation?:boolean | `@${string}`,
	otherIncomeAmount?:boolean | `@${string}`,
	otherIncomeInterval?:boolean | `@${string}`,
	otherIncomeSource?:boolean | `@${string}`,
	timelinePosition?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EmploymentStatus"]:EmploymentStatus;
	/** A frequently asked question with its answer. FAQs can be scoped to a specific dealership, a dealership group, or global (visible to all authenticated users). */
["Faq"]: AliasType<{
	/** The answer text. */
	answer?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	/** If set, this FAQ belongs to a dealership group and is visible to all dealerships in that group. */
	dealershipGroupId?:boolean | `@${string}`,
	/** If set, this FAQ belongs to a specific dealership and is only visible to users of that dealership. */
	dealershipId?:boolean | `@${string}`,
	/** Unique identifier for this FAQ. */
	id?:boolean | `@${string}`,
	/** The question text. */
	question?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FieldOrdering"]:FieldOrdering;
	["File"]: AliasType<{
	id?:boolean | `@${string}`,
	uploader?:ResolverInputTypes["User"],
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinanceType"]:FinanceType;
	["FinanceTypeFilter"]: {
	equals?: ResolverInputTypes["FinanceType"] | undefined | null,
	in?: Array<ResolverInputTypes["FinanceType"]> | undefined | null,
	not?: ResolverInputTypes["FinanceTypeFilter"] | undefined | null
};
	["Form"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	displayTitle?:boolean | `@${string}`,
formFields?: [{	filter?: ResolverInputTypes["FormFieldFilter"] | undefined | null},ResolverInputTypes["FormField"]],
	formOrder?:ResolverInputTypes["FormOrder"],
	id?:boolean | `@${string}`,
	pdfFileUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormCollectionStatus"]:FormCollectionStatus;
	["FormCollectionStatusFilter"]: {
	equals?: ResolverInputTypes["FormCollectionStatus"] | undefined | null,
	in?: Array<ResolverInputTypes["FormCollectionStatus"]> | undefined | null,
	not?: ResolverInputTypes["FormCollectionStatusFilter"] | undefined | null,
	notIn?: Array<ResolverInputTypes["FormCollectionStatus"]> | undefined | null
};
	["FormCollectionType"]:FormCollectionType;
	["FormCollectionTypeFilter"]: {
	equals?: ResolverInputTypes["FormCollectionType"] | undefined | null,
	in?: Array<ResolverInputTypes["FormCollectionType"]> | undefined | null,
	not?: ResolverInputTypes["FormCollectionTypeFilter"] | undefined | null,
	notIn?: Array<ResolverInputTypes["FormCollectionType"]> | undefined | null
};
	["FormField"]: AliasType<{
	characterListLength?:boolean | `@${string}`,
	checkboxGroup?:ResolverInputTypes["CheckBoxGroup"],
	createdAt?:boolean | `@${string}`,
	demoData?:boolean | `@${string}`,
	enteredBy?:boolean | `@${string}`,
	fixedValue?:boolean | `@${string}`,
	form?:ResolverInputTypes["Form"],
	formFieldId?:boolean | `@${string}`,
	formFieldPlacements?:ResolverInputTypes["FormFieldPlacement"],
	formId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	isAdminAllowed?:boolean | `@${string}`,
	isOptional?:boolean | `@${string}`,
	prefillPath?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormFieldFilter"]: {
	isAdminAllowed?: ResolverInputTypes["BooleanFilter"] | undefined | null,
	prefillPath?: string | undefined | null
};
	["FormFieldPlacement"]: AliasType<{
	characterListSpacing?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	formField?:ResolverInputTypes["FormField"],
	formFieldId?:boolean | `@${string}`,
	formFieldPlacementId?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	page?:boolean | `@${string}`,
	positionX?:boolean | `@${string}`,
	positionY?:boolean | `@${string}`,
	textAlignment?:boolean | `@${string}`,
	textBold?:boolean | `@${string}`,
	textFontSize?:boolean | `@${string}`,
	textItalic?:boolean | `@${string}`,
	textLineHeight?:boolean | `@${string}`,
	textUnderline?:boolean | `@${string}`,
	width?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormFieldSubmission"]: AliasType<{
	field?:ResolverInputTypes["FormField"],
	fieldId?:boolean | `@${string}`,
	file?:ResolverInputTypes["File"],
	formSubmission?:ResolverInputTypes["FormSubmission"],
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormFieldSubmissionAllowedUserFilter"]: {
	userId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["FormFieldSubmissionAllowedUserListFilter"]: {
	some?: ResolverInputTypes["FormFieldSubmissionAllowedUserFilter"] | undefined | null
};
	["FormFieldSubmissionFilter"]: {
	OR?: Array<ResolverInputTypes["FormFieldSubmissionOrFilter"]> | undefined | null,
	allowedUsers?: ResolverInputTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null,
	field?: ResolverInputTypes["FormFieldFilter"] | undefined | null,
	fileId?: ResolverInputTypes["IDFilter"] | undefined | null,
	formSubmissionId?: ResolverInputTypes["IDFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	value?: ResolverInputTypes["StringFilter"] | undefined | null
};
	["FormFieldSubmissionOrFilter"]: {
	allowedUsers?: ResolverInputTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null,
	field?: ResolverInputTypes["FormFieldFilter"] | undefined | null
};
	["FormFieldSubmissionOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["FormFieldType"]:FormFieldType;
	["FormFieldValue"]: {
	fileId?: string | undefined | null,
	submissionFieldId: string,
	value?: string | undefined | null
};
	["FormOrder"]: AliasType<{
	position?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormRequestErrorCode"]:FormRequestErrorCode;
	["FormSubmission"]: AliasType<{
	access?:boolean | `@${string}`,
	cdkDealJacketStatus?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	customer?:ResolverInputTypes["Customer"],
	file?:ResolverInputTypes["File"],
	fileId?:boolean | `@${string}`,
	form?:ResolverInputTypes["Form"],
	formCollection?:ResolverInputTypes["FormSubmissionCollection"],
formFieldSubmissions?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["FormFieldSubmissionFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["FormSubmissionFormFieldSubmissionsConnection"]],
	formSubmissionData?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormSubmissionAccessEmum"]:FormSubmissionAccessEmum;
	/** If the user filters in elements it can not access, it will fail */
["FormSubmissionAccessEmumFilter"]: {
	equals?: ResolverInputTypes["FormSubmissionAccessEmum"] | undefined | null,
	in?: Array<ResolverInputTypes["FormSubmissionAccessEmum"]> | undefined | null,
	not?: ResolverInputTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	notIn?: Array<ResolverInputTypes["FormSubmissionAccessEmum"]> | undefined | null
};
	["FormSubmissionCollection"]: AliasType<{
	createdAt?:boolean | `@${string}`,
formSubmissions?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["FormSubmissionCollectionFormSubmissionsConnection"]],
	id?:boolean | `@${string}`,
	isCollectionStale?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormSubmissionCollectionFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	status?: ResolverInputTypes["FormCollectionStatusFilter"] | undefined | null,
	type?: ResolverInputTypes["FormCollectionTypeFilter"] | undefined | null
};
	["FormSubmissionCollectionFormSubmissionsConnection"]: AliasType<{
	edges?:ResolverInputTypes["FormSubmissionCollectionFormSubmissionsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["FormSubmissionCollectionFormSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["FormSubmission"],
		__typename?: boolean | `@${string}`
}>;
	["FormSubmissionCollectionOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["FormSubmissionFilter"]: {
	access?: ResolverInputTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	status?: ResolverInputTypes["FormSubmissionStatusFilter"] | undefined | null,
	type?: ResolverInputTypes["FormSubmissionTypeFilter"] | undefined | null,
	userId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["FormSubmissionFormFieldSubmissionsConnection"]: AliasType<{
	edges?:ResolverInputTypes["FormSubmissionFormFieldSubmissionsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["FormSubmissionFormFieldSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["FormFieldSubmission"],
		__typename?: boolean | `@${string}`
}>;
	["FormSubmissionStatus"]:FormSubmissionStatus;
	["FormSubmissionStatusFilter"]: {
	equals?: ResolverInputTypes["FormSubmissionStatus"] | undefined | null,
	not?: ResolverInputTypes["FormSubmissionStatusFilter"] | undefined | null,
	notIn?: Array<ResolverInputTypes["FormSubmissionStatus"]> | undefined | null
};
	["FormSubmissionType"]:FormSubmissionType;
	["FormSubmissionTypeFilter"]: {
	equals?: ResolverInputTypes["FormSubmissionType"] | undefined | null,
	in?: Array<ResolverInputTypes["FormSubmissionType"]> | undefined | null,
	not?: ResolverInputTypes["FormSubmissionTypeFilter"] | undefined | null
};
	["GraphQLError"]: AliasType<{
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HardCreditApplication"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
	driversLicenseNumber?:boolean | `@${string}`,
	driversLicenseState?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	employments?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	formSubmission?:ResolverInputTypes["FormSubmission"],
	formSubmissionId?:boolean | `@${string}`,
	homePhoneNumber?:boolean | `@${string}`,
	housingCostUsdCents?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	incomeInterval?:boolean | `@${string}`,
	incomeUsdCents?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	middleName?:boolean | `@${string}`,
	personalReferenceAddress?:ResolverInputTypes["Address"],
	personalReferenceAddressId?:boolean | `@${string}`,
	personalReferenceFirstName?:boolean | `@${string}`,
	personalReferenceLastName?:boolean | `@${string}`,
	personalReferenceMiddleName?:boolean | `@${string}`,
	personalReferencePhoneNumber?:boolean | `@${string}`,
	personalReferenceRelationship?:boolean | `@${string}`,
	phoneNumber?:boolean | `@${string}`,
	residentialAddresses?:boolean | `@${string}`,
	/** Full SSN for the data owner, masked (last 4 only) for others */
	socialSecurityNumber?:boolean | `@${string}`,
	transaction?:ResolverInputTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HardCreditApplicationFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["HardCreditApplicationOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["HomenetVehicleData"]: AliasType<{
	bodyType?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	dealerId?:boolean | `@${string}`,
	fuelType?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	locationId?:boolean | `@${string}`,
	make?:boolean | `@${string}`,
	mileage?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	msrp?:boolean | `@${string}`,
	rooftopId?:boolean | `@${string}`,
	stockNumber?:boolean | `@${string}`,
	transmission?:boolean | `@${string}`,
	trim?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	vehicleId?:boolean | `@${string}`,
	vin?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HomenetVehicleDataFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["HousingStatus"]:HousingStatus;
	["IDFilter"]: {
	equals?: string | undefined | null,
	in?: Array<string> | undefined | null,
	not?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["IdCard"]: AliasType<{
	captureBack?:ResolverInputTypes["File"],
	captureBackId?:boolean | `@${string}`,
	captureBackRotation?:boolean | `@${string}`,
	captureFront?:ResolverInputTypes["File"],
	captureFrontId?:boolean | `@${string}`,
	captureFrontRotation?:boolean | `@${string}`,
	cityInAddress?:boolean | `@${string}`,
	class?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	dob?:boolean | `@${string}`,
	dobDateOnly?:boolean | `@${string}`,
	expirationDate?:boolean | `@${string}`,
	expirationDateOnly?:boolean | `@${string}`,
	eyeColor?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	height?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	idNumber?:boolean | `@${string}`,
	issueDate?:boolean | `@${string}`,
	issueDateOnly?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	middleName?:boolean | `@${string}`,
	requestedIdVerificationAt?:boolean | `@${string}`,
	sex?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	stateInAddress?:boolean | `@${string}`,
	streetInAddress?:boolean | `@${string}`,
	suffix?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	zipCodeInAddress?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["IdCardType"]:IdCardType;
	["ImageRotation"]:ImageRotation;
	["IncomeInterval"]:IncomeInterval;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]:unknown;
	["LenderHardCreditApplication"]: AliasType<{
	buyerHousingCostCents?:boolean | `@${string}`,
	buyerIncomeCents?:boolean | `@${string}`,
	buyerIncomeInterval?:boolean | `@${string}`,
	coBuyerHousingCostCents?:boolean | `@${string}`,
	coBuyerIncomeCents?:boolean | `@${string}`,
	coBuyerIncomeInterval?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LenderHardCreditApplicationOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["LendingPortalAddressEntryInput"]: {
	apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	housingStatus?: ResolverInputTypes["HousingStatus"] | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition: number,
	zipCode?: string | undefined | null
};
	["LendingPortalCustomerDataInput"]: {
	dob?: ResolverInputTypes["DateTime"] | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null
};
	["LendingPortalEmploymentEntryInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: ResolverInputTypes["EmploymentStatus"] | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: ResolverInputTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: ResolverInputTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition: number
};
	["LendingPortalPurchaseVehicleDataInput"]: {
	color?: string | undefined | null,
	lifeCycleStage?: ResolverInputTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["LendingPortalTradeVehicleDataInput"]: {
	color?: string | undefined | null,
	lifeCycleStage?: ResolverInputTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["LicensePrefillData"]: AliasType<{
	make?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	trim?:boolean | `@${string}`,
	vin?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ListItem"]: AliasType<{
	label?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LivelinessSession"]: AliasType<{
	auditImages?:ResolverInputTypes["File"],
	awsLivelinessSessionId?:boolean | `@${string}`,
	confidence?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	dealership?:ResolverInputTypes["Dealership"],
	dealershipId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	referenceImage?:ResolverInputTypes["File"],
	status?:boolean | `@${string}`,
	transaction?:ResolverInputTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	upddatedAt?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LivelinessSessionFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["LoginOptionType"]:LoginOptionType;
	["LoginResponse"]: AliasType<{
	jwt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MakeFileUploadForScannerType"]: AliasType<{
	fileId?:boolean | `@${string}`,
	uploadUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MakeFileUploadType"]: AliasType<{
	file?:ResolverInputTypes["File"],
	fileId?:boolean | `@${string}`,
	uploadUrl?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MeType"]: AliasType<{
chats?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	id?: string | undefined | null,	last?: number | undefined | null},ResolverInputTypes["MeTypeChatsConnection"]],
	dealershipGroup?:ResolverInputTypes["DealershipGroup"],
	dealerships?:ResolverInputTypes["Dealership"],
	ipAddress?:boolean | `@${string}`,
	/** List of dealerships the user has access to and is a staff at */
	staffAt?:ResolverInputTypes["DealershipPermType"],
	user?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["MeTypeChatsConnection"]: AliasType<{
	edges?:ResolverInputTypes["MeTypeChatsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["MeTypeChatsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Chat"],
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
addScanToDealerJacket?: [{	access: ResolverInputTypes["FormSubmissionAccessEmum"],	addTo: ResolverInputTypes["CustomerTransactionRole"],	fileId: string,	submissionToken: string,	title: string,	transactionId: string},ResolverInputTypes["MutationAddScanToDealerJacketResult"]],
addScanToGloveCompartments?: [{	fileId: string,	submissionToken: string,	title: string,	transactionId: string},ResolverInputTypes["MutationAddScanToGloveCompartmentsResult"]],
assignStaffToTransaction?: [{	assigneeId: string,	role: ResolverInputTypes["Role"],	transactionId: string},ResolverInputTypes["MutationAssignStaffToTransactionResult"]],
cancelFormCollection?: [{	formCollectionId: string},ResolverInputTypes["MutationCancelFormCollectionResult"]],
cancelPreviousAndRequestSignatures?: [{	lifeCycle: ResolverInputTypes["TransactionLifecycle"],	transactionId: string},ResolverInputTypes["MutationCancelPreviousAndRequestSignaturesResult"]],
changeDocumentAccess?: [{	/** Document ID */
	documentId: string,	/** New document access */
	newAccess: ResolverInputTypes["FormSubmissionAccessEmum"]},ResolverInputTypes["MutationChangeDocumentAccessResult"]],
changeFormSubmissionAccess?: [{	/** Form Submission ID */
	formSubmissionId: string,	/** New form access */
	newAccess: ResolverInputTypes["FormSubmissionAccessEmum"]},ResolverInputTypes["MutationChangeFormSubmissionAccessResult"]],
createAndSubmitCreditAndPrequalApplication?: [{	formSubmissionData: ResolverInputTypes["CreditApplicationFormSubmissionInput"],	signedUploadedCreditApplicationDocumentId: string,	transactionId: string},ResolverInputTypes["MutationCreateAndSubmitCreditAndPrequalApplicationResult"]],
createChat?: [{	initialContext: string},ResolverInputTypes["MutationCreateChatResult"]],
createCoBuyer?: [{	coBuyer: ResolverInputTypes["CreateCustomerInput"],	transactionId: string},ResolverInputTypes["MutationCreateCoBuyerResult"]],
createCreditApplicationAndCreateUser?: [{	dealershipId: string,	formData: ResolverInputTypes["CreditApplicationInput"]},ResolverInputTypes["MutationCreateCreditApplicationAndCreateUserResult"]],
createEmployment?: [{	employment: ResolverInputTypes["CreateEmploymentInput"],	transactionId: string},ResolverInputTypes["MutationCreateEmploymentResult"]],
createGroupuser?: [{	dealershipId: string,	role: ResolverInputTypes["Role"],	userId: string},ResolverInputTypes["MutationCreateGroupuserResult"]],
createMessage?: [{	chatId: string,	message: string},ResolverInputTypes["MutationCreateMessageResult"]],
createStaff?: [{	dealershipId: string,	user: ResolverInputTypes["CreateUserInput"]},ResolverInputTypes["MutationCreateStaffResult"]],
createStaffScheduleEvents?: [{	input: ResolverInputTypes["CreateStaffScheduleEventsInput"]},ResolverInputTypes["MutationCreateStaffScheduleEventsResult"]],
createTransactionAndSubmitTestDrive?: [{	captureBackFileId: string,	captureFrontFileId: string,	contactConsentAckTmplId: string,	dealershipId: string,	dmvForm: string,	dmvPdfFileId: string,	pdf417String?: string | undefined | null,	privacyNoticeFileId: string,	privacyNoticeForm: string,	tdcConsentsAckTmplId: string,	testDriveAckTmplId: string},ResolverInputTypes["MutationCreateTransactionAndSubmitTestDriveResult"]],
createUserFeedback?: [{	category: string,	message: string},ResolverInputTypes["MutationCreateUserFeedbackResult"]],
customerCreatePrefilledTransaction?: [{	dealershipSlug: string,	language: string,	source: ResolverInputTypes["TransactionSource"]},ResolverInputTypes["MutationCustomerCreatePrefilledTransactionResult"]],
customerCreatePurchaseVehicle?: [{	transactionId: string,	vehicle: ResolverInputTypes["CustomerPurchaseVehicleInput"]},ResolverInputTypes["MutationCustomerCreatePurchaseVehicleResult"]],
customerCreateTradeVehicle?: [{	transactionId: string,	vehicle: ResolverInputTypes["CustomerTradeVehicleInput"]},ResolverInputTypes["MutationCustomerCreateTradeVehicleResult"]],
customerCreateTransaction?: [{	dealershipSlug: string,	firstName?: string | undefined | null,	language: string,	lastName?: string | undefined | null,	salesPersonId?: string | undefined | null,	source: ResolverInputTypes["TransactionSource"]},ResolverInputTypes["MutationCustomerCreateTransactionResult"]],
customerCreateUnauthenticatedTransaction?: [{	dealershipId: string,	language: string,	salesPersonId?: string | undefined | null,	source: ResolverInputTypes["TransactionSource"],	/** Providing this value indicated accept of the corresponding text */
	tdcConsentsTemplateId: string,	user: ResolverInputTypes["CreateUserInput"],	zipCode?: string | undefined | null},ResolverInputTypes["MutationCustomerCreateUnauthenticatedTransactionResult"]],
customerReferral?: [{	email: string,	firstName: string,	lastName: string,	phoneNumber: string},ResolverInputTypes["MutationCustomerReferralResult"]],
customerReferralPaid?: [{	paidAmountInUsdCents: number,	transactionId: string},ResolverInputTypes["MutationCustomerReferralPaidResult"]],
customerSignupWithCognito?: [{	dealershipId: string,	hasConsentedToSms: boolean,	user: ResolverInputTypes["CustomerSignupInput"]},ResolverInputTypes["MutationCustomerSignupWithCognitoResult"]],
customerUpdatePhoneNumber?: [{	newPhoneNumber: string},ResolverInputTypes["MutationCustomerUpdatePhoneNumberResult"]],
customerUpdatePurchaseVehicle?: [{	vehicle: ResolverInputTypes["CustomerPurchaseVehicleInput"],	vehicleId: string},ResolverInputTypes["MutationCustomerUpdatePurchaseVehicleResult"]],
customerUpdateTradeVehicle?: [{	vehicle: ResolverInputTypes["CustomerTradeVehicleInput"],	vehicleId: string},ResolverInputTypes["MutationCustomerUpdateTradeVehicleResult"]],
dealershipCreatePurchaseVehicle?: [{	transactionId: string,	vehicle: ResolverInputTypes["DealershipPurchaseVehicleInput"]},ResolverInputTypes["MutationDealershipCreatePurchaseVehicleResult"]],
dealershipCreateTradeVehicle?: [{	transactionId: string,	vehicle: ResolverInputTypes["DealershipTradeVehicleInput"]},ResolverInputTypes["MutationDealershipCreateTradeVehicleResult"]],
dealershipCreateTransaction?: [{	customer: ResolverInputTypes["CreateCustomerInput"],	staff?: ResolverInputTypes["UpdateTransactionStaffInput"] | undefined | null},ResolverInputTypes["MutationDealershipCreateTransactionResult"]],
dealershipRemoveTradeVehicle?: [{	vehicleId: string},ResolverInputTypes["MutationDealershipRemoveTradeVehicleResult"]],
dealershipUpdatePurchaseVehicle?: [{	vehicle: ResolverInputTypes["DealershipPurchaseVehicleInput"],	vehicleId: string},ResolverInputTypes["MutationDealershipUpdatePurchaseVehicleResult"]],
dealershipUpdateTradeVehicle?: [{	vehicle: ResolverInputTypes["DealershipTradeVehicleInput"],	vehicleId: string},ResolverInputTypes["MutationDealershipUpdateTradeVehicleResult"]],
deleteStaffScheduleEvent?: [{	id: string},ResolverInputTypes["MutationDeleteStaffScheduleEventResult"]],
dismissNotifications?: [{	ids: Array<string>},ResolverInputTypes["MutationDismissNotificationsResult"]],
extractVehicleFromRegistration?: [{	/** When true, the registration PDF will be added as a document to the transaction deal jacket after extraction completes */
	addToDealjacket: boolean,	/** The ID of the uploaded registration PDF file */
	fileId: string,	/** The transaction ID to add the document to */
	transactionId: string},ResolverInputTypes["MutationExtractVehicleFromRegistrationResult"]],
finalizeLivenessAnalysis?: [{	sessionId: string},ResolverInputTypes["MutationFinalizeLivenessAnalysisResult"]],
login?: [{	email: string,	password: string},ResolverInputTypes["MutationLoginResult"]],
	/** Log a user out by deleting the auth cookie */
	logout?:ResolverInputTypes["MutationLogoutResult"],
	/** Make a submission token that is valid for 5 requsts in 30 minutes */
	makeSubmissionToken?:ResolverInputTypes["MutationMakeSubmissionTokenResult"],
makeUpload?: [{	fileExt: string,	mimeType: string},ResolverInputTypes["MutationMakeUploadResult"]],
makeUploadForScanner?: [{	addTo?: ResolverInputTypes["CustomerTransactionRole"] | undefined | null,	submissionToken: string,	transactionId: string},ResolverInputTypes["MutationMakeUploadForScannerResult"]],
makeUploadToTransaction?: [{	addTo: ResolverInputTypes["CustomerTransactionRole"],	fileExt: string,	mimeType: string,	transactionId: string},ResolverInputTypes["MutationMakeUploadToTransactionResult"]],
markTransactionAsDelivered?: [{	transactionId: string},ResolverInputTypes["MutationMarkTransactionAsDeliveredResult"]],
modifyHardCreditApplication?: [{	formSubmissionData: ResolverInputTypes["CreditApplicationFormSubmissionInput"],	signedUploadedCreditApplicationDocumentId: string,	transactionId: string},ResolverInputTypes["MutationModifyHardCreditApplicationResult"]],
onboardingSubmitStep1?: [{	isRemoteTransaction: boolean,	step1: ResolverInputTypes["SubmitStep1Input"],	transactionId: string},ResolverInputTypes["MutationOnboardingSubmitStep1Result"]],
onboardingSubmitStep2?: [{	step2: ResolverInputTypes["SubmitStep2Input"],	transactionId: string},ResolverInputTypes["MutationOnboardingSubmitStep2Result"]],
overrideTodo?: [{	overrideNote: string,	todoId: string},ResolverInputTypes["MutationOverrideTodoResult"]],
preLoginCheck?: [{	dealershipId?: string | undefined | null,	email: string},ResolverInputTypes["MutationPreLoginCheckResult"]],
prefillLicensePlateOrVin?: [{	licensePlate?: string | undefined | null,	state?: string | undefined | null,	vin?: string | undefined | null},ResolverInputTypes["MutationPrefillLicensePlateOrVinResult"]],
pushDataToCrms?: [{	transactionId: string},ResolverInputTypes["MutationPushDataToCrmsResult"]],
pushDocumentToCdkDealJacket?: [{	documentName: string,	fileId: string,	transactionId: string},ResolverInputTypes["MutationPushDocumentToCdkDealJacketResult"]],
pushDocumentsToCdk?: [{	/** Document IDs */
	ids: Array<string>},ResolverInputTypes["MutationPushDocumentsToCdkResult"]],
pushFormSubmissionsToCdk?: [{	/** Form submission ID */
	ids: Array<string>},ResolverInputTypes["MutationPushFormSubmissionsToCdkResult"]],
pushHardCreditApplication?: [{	submitTo: ResolverInputTypes["SubmitTo"],	transactionId: string},ResolverInputTypes["MutationPushHardCreditApplicationResult"]],
recordConsent?: [{	consentedToTmplId: string,	email: string,	phoneNumber: string},ResolverInputTypes["MutationRecordConsentResult"]],
removeCoBuyer?: [{	transactionId: string},ResolverInputTypes["MutationRemoveCoBuyerResult"]],
removePrimaryBuyer?: [{	transactionId: string},ResolverInputTypes["MutationRemovePrimaryBuyerResult"]],
requestAgilityCreditPrequal?: [{	bureaus: Array<ResolverInputTypes["PrequalBureau"]>,	transactionId: string,	userId: string},ResolverInputTypes["MutationRequestAgilityCreditPrequalResult"]],
requestIdentityVerification?: [{	transactionId: string,	userId: string},ResolverInputTypes["MutationRequestIdentityVerificationResult"]],
requestOtpExistingUserDEV?: [{	email: string},ResolverInputTypes["MutationRequestOtpExistingUserDEVResult"]],
requestPrequalReports?: [{	bureaus: Array<ResolverInputTypes["PrequalBureau"]>,	transactionId: string,	userId: string},ResolverInputTypes["MutationRequestPrequalReportsResult"]],
requestPrescreen?: [{	transactionId: string,	userId: string},ResolverInputTypes["MutationRequestPrescreenResult"]],
resendStaffPassword?: [{	userId: string},ResolverInputTypes["MutationResendStaffPasswordResult"]],
saveLendingPortalCustomerData?: [{	addressEntries?: Array<ResolverInputTypes["LendingPortalAddressEntryInput"]> | undefined | null,	customerData?: ResolverInputTypes["LendingPortalCustomerDataInput"] | undefined | null,	employmentEntries?: Array<ResolverInputTypes["LendingPortalEmploymentEntryInput"]> | undefined | null,	/** The ID of the acknowledgement template for edit confirmation */
	lendingPortalEditConfirmationTmplId: string,	transactionId: string,	/** The user ID of the customer (buyer or co-buyer) to update */
	userId: string},ResolverInputTypes["MutationSaveLendingPortalCustomerDataResult"]],
saveLendingPortalPurchaseVehicleData?: [{	transactionId: string,	vehicleData: ResolverInputTypes["LendingPortalPurchaseVehicleDataInput"]},ResolverInputTypes["MutationSaveLendingPortalPurchaseVehicleDataResult"]],
saveLendingPortalTradeVehicleData?: [{	tradeVehicleData: ResolverInputTypes["LendingPortalTradeVehicleDataInput"],	transactionId: string},ResolverInputTypes["MutationSaveLendingPortalTradeVehicleDataResult"]],
sendFormReadyNotifications?: [{	/** The ID of the form submission collection */
	formCollectionId: string},ResolverInputTypes["MutationSendFormReadyNotificationsResult"]],
setDeliveryMethodForUser?: [{	email: string,	method?: string | undefined | null},ResolverInputTypes["MutationSetDeliveryMethodForUserResult"]],
setDocumentLabels?: [{	/** Document ID */
	documentId: string,	/** the labels to have */
	labels: Array<string>},ResolverInputTypes["MutationSetDocumentLabelsResult"]],
setDocumentTitle?: [{	/** Document ID */
	documentId: string,	/** the new title */
	newTitle: string},ResolverInputTypes["MutationSetDocumentTitleResult"]],
setStaffInformation?: [{	staffInformation: ResolverInputTypes["SetStaffInformationInput"],	userId: string},ResolverInputTypes["MutationSetStaffInformationResult"]],
setStaffPlanningEnabled?: [{	isEnabled: boolean,	staffId: string},ResolverInputTypes["MutationSetStaffPlanningEnabledResult"]],
stageAdditionalForms?: [{	forms: Array<ResolverInputTypes["StageFormInput"]>,	notify: boolean,	transactionId: string},ResolverInputTypes["MutationStageAdditionalFormsResult"]],
startLivenessAnalysis?: [{	transactionId: string},ResolverInputTypes["MutationStartLivenessAnalysisResult"]],
submitFormValues?: [{	formSubmissionId: string,	values?: Array<ResolverInputTypes["FormFieldValue"]> | undefined | null},ResolverInputTypes["MutationSubmitFormValuesResult"]],
submitPrequalApplicationAndCreateUser?: [{	dealershipId: string,	email: string,	formData: ResolverInputTypes["PrequalInput"],	phoneNumber: string},ResolverInputTypes["MutationSubmitPrequalApplicationAndCreateUserResult"]],
submitPrequalApplicationOnTransaction?: [{	formData: ResolverInputTypes["PrequalInput"],	signedUploadedDocumentId: string,	transactionId: string},ResolverInputTypes["MutationSubmitPrequalApplicationOnTransactionResult"]],
submitStaffAcknowledgement?: [{	ackTemplateId: string},ResolverInputTypes["MutationSubmitStaffAcknowledgementResult"]],
submitStandardForm?: [{	formSubmissionData: string,	signedUploadedDocumentId: string,	transactionId: string,	type: ResolverInputTypes["FormSubmissionType"]},ResolverInputTypes["MutationSubmitStandardFormResult"]],
suspendGroupUser?: [{	isSuspended: boolean,	userId: string},ResolverInputTypes["MutationSuspendGroupUserResult"]],
suspendStaff?: [{	isSuspended: boolean,	userId: string},ResolverInputTypes["MutationSuspendStaffResult"]],
switchCustomerRoles?: [{	transactionId: string},ResolverInputTypes["MutationSwitchCustomerRolesResult"]],
testDriveEnsureCustomerForDealership?: [{	dealershipId: string,	email: string,	firstName?: string | undefined | null,	lastName?: string | undefined | null,	phoneNumber: string},ResolverInputTypes["MutationTestDriveEnsureCustomerForDealershipResult"]],
trackUserEvent?: [{	operation: ResolverInputTypes["UserEventOperation"],	transactionPId: string},ResolverInputTypes["MutationTrackUserEventResult"]],
unlockTransaction?: [{	reason: string,	transactionId: string},ResolverInputTypes["MutationUnlockTransactionResult"]],
updateCustomer?: [{	customer: ResolverInputTypes["UpdateCustomerInput"],	transactionId: string},ResolverInputTypes["MutationUpdateCustomerResult"]],
updateEmployment?: [{	employment: ResolverInputTypes["UpdateEmploymentInput"],	id: string},ResolverInputTypes["MutationUpdateEmploymentResult"]],
updateGroupUser?: [{	role: ResolverInputTypes["Role"],	userId: string},ResolverInputTypes["MutationUpdateGroupUserResult"]],
updateIdCardRotation?: [{	captureBackRotation?: ResolverInputTypes["ImageRotation"] | undefined | null,	captureFrontRotation?: ResolverInputTypes["ImageRotation"] | undefined | null,	idCardId: string},ResolverInputTypes["MutationUpdateIdCardRotationResult"]],
updateMyUser?: [{	user: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["MutationUpdateMyUserResult"]],
updateReceivesAuthenticomReport?: [{	receivesAuthenticomReport: boolean,	userId: string},ResolverInputTypes["MutationUpdateReceivesAuthenticomReportResult"]],
updateStaffAttributes?: [{	attributes: ResolverInputTypes["StaffAttributes"],	userId: string},ResolverInputTypes["MutationUpdateStaffAttributesResult"]],
updateStaffExtraPermissions?: [{	extraPermissions: Array<ResolverInputTypes["Permission"]>,	userId: string},ResolverInputTypes["MutationUpdateStaffExtraPermissionsResult"]],
updateStaffScheduleEvent?: [{	id: string,	input: ResolverInputTypes["UpdateStaffScheduleEventInput"]},ResolverInputTypes["MutationUpdateStaffScheduleEventResult"]],
updateTransaction?: [{	transaction: ResolverInputTypes["UpdateTransactionInput"]},ResolverInputTypes["MutationUpdateTransactionResult"]],
uploadAdditionalDocuments?: [{	pdfIsEncrypted: boolean,	title?: string | undefined | null,	transactionId: string,	uploadedDocumentId: string},ResolverInputTypes["MutationUploadAdditionalDocumentsResult"]],
uploadAdditionalDocumentsToTransaction?: [{	access: ResolverInputTypes["FormSubmissionAccessEmum"],	addTo: ResolverInputTypes["CustomerTransactionRole"],	fileId: string,	pdfIsEncrypted: boolean,	/** The title of the document. If null, and AI will set the value */
	title?: string | undefined | null,	transactionId: string},ResolverInputTypes["MutationUploadAdditionalDocumentsToTransactionResult"]],
uploadIdCard?: [{	/** Required for all types except PASSPORT */
	captureBackFileId?: string | undefined | null,	captureFrontFileId: string,	dmvForm: string,	dmvPdfFileId: string,	/** Accepts: DRIVERS_LICENSE, STATE_ID, PASSPORT, or OTHER */
	idCardType: ResolverInputTypes["IdCardType"],	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null,	transactionId: string},ResolverInputTypes["MutationUploadIdCardResult"]],
uploadIdCardWithToken?: [{	/** Required for all types except PASSPORT */
	captureBackFileId?: string | undefined | null,	captureFrontFileId: string,	dmvForm: string,	dmvPdfFileId: string,	/** Accepts: DRIVERS_LICENSE, STATE_ID, PASSPORT, or OTHER */
	idCardType: ResolverInputTypes["IdCardType"],	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null,	/** Submission token for scanner authentication */
	submissionToken: string,	transactionId: string},ResolverInputTypes["MutationUploadIdCardWithTokenResult"]],
userExists?: [{	email: string},ResolverInputTypes["MutationUserExistsResult"]],
verifyOtpForExistingUser?: [{	email: string,	emailCode?: string | undefined | null,	phoneCode?: string | undefined | null,	phoneNumber?: string | undefined | null},ResolverInputTypes["MutationVerifyOtpForExistingUserResult"]],
		__typename?: boolean | `@${string}`
}>;
	["MutationAddScanToDealerJacketResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationAddScanToDealerJacketSuccess?:ResolverInputTypes["MutationAddScanToDealerJacketSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationAddScanToDealerJacketSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationAddScanToGloveCompartmentsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationAddScanToGloveCompartmentsSuccess?:ResolverInputTypes["MutationAddScanToGloveCompartmentsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationAddScanToGloveCompartmentsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationAssignStaffToTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationAssignStaffToTransactionSuccess?:ResolverInputTypes["MutationAssignStaffToTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationAssignStaffToTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCancelFormCollectionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCancelFormCollectionSuccess?:ResolverInputTypes["MutationCancelFormCollectionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCancelFormCollectionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCancelPreviousAndRequestSignaturesResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCancelPreviousAndRequestSignaturesSuccess?:ResolverInputTypes["MutationCancelPreviousAndRequestSignaturesSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCancelPreviousAndRequestSignaturesSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationChangeDocumentAccessResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationChangeDocumentAccessSuccess?:ResolverInputTypes["MutationChangeDocumentAccessSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationChangeDocumentAccessSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationChangeFormSubmissionAccessResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationChangeFormSubmissionAccessSuccess?:ResolverInputTypes["MutationChangeFormSubmissionAccessSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationChangeFormSubmissionAccessSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateAndSubmitCreditAndPrequalApplicationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateAndSubmitCreditAndPrequalApplicationSuccess?:ResolverInputTypes["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateChatResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateChatSuccess?:ResolverInputTypes["MutationCreateChatSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateChatSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateCoBuyerResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateCoBuyerSuccess?:ResolverInputTypes["MutationCreateCoBuyerSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateCoBuyerSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateCreditApplicationAndCreateUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateCreditApplicationAndCreateUserSuccess?:ResolverInputTypes["MutationCreateCreditApplicationAndCreateUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateCreditApplicationAndCreateUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateEmploymentResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateEmploymentSuccess?:ResolverInputTypes["MutationCreateEmploymentSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateEmploymentSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateGroupuserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateGroupuserSuccess?:ResolverInputTypes["MutationCreateGroupuserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateGroupuserSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateMessageResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateMessageSuccess?:ResolverInputTypes["MutationCreateMessageSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateMessageSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateStaffResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateStaffSuccess?:ResolverInputTypes["MutationCreateStaffSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateStaffScheduleEventsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateStaffScheduleEventsSuccess?:ResolverInputTypes["MutationCreateStaffScheduleEventsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateStaffScheduleEventsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateStaffSuccess"]: AliasType<{
	data?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateTransactionAndSubmitTestDriveResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateTransactionAndSubmitTestDriveSuccess?:ResolverInputTypes["MutationCreateTransactionAndSubmitTestDriveSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateTransactionAndSubmitTestDriveSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateUserFeedbackResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCreateUserFeedbackSuccess?:ResolverInputTypes["MutationCreateUserFeedbackSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCreateUserFeedbackSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreatePrefilledTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerCreatePrefilledTransactionSuccess?:ResolverInputTypes["MutationCustomerCreatePrefilledTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreatePrefilledTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreatePurchaseVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerCreatePurchaseVehicleSuccess?:ResolverInputTypes["MutationCustomerCreatePurchaseVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreatePurchaseVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateTradeVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerCreateTradeVehicleSuccess?:ResolverInputTypes["MutationCustomerCreateTradeVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateTradeVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerCreateTransactionSuccess?:ResolverInputTypes["MutationCustomerCreateTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateUnauthenticatedTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerCreateUnauthenticatedTransactionSuccess?:ResolverInputTypes["MutationCustomerCreateUnauthenticatedTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerCreateUnauthenticatedTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerReferralPaidResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerReferralPaidSuccess?:ResolverInputTypes["MutationCustomerReferralPaidSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerReferralPaidSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerReferralResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerReferralSuccess?:ResolverInputTypes["MutationCustomerReferralSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerReferralSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerSignupWithCognitoResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerSignupWithCognitoSuccess?:ResolverInputTypes["MutationCustomerSignupWithCognitoSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerSignupWithCognitoSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdatePhoneNumberResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerUpdatePhoneNumberSuccess?:ResolverInputTypes["MutationCustomerUpdatePhoneNumberSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdatePhoneNumberSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdatePurchaseVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerUpdatePurchaseVehicleSuccess?:ResolverInputTypes["MutationCustomerUpdatePurchaseVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdatePurchaseVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdateTradeVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationCustomerUpdateTradeVehicleSuccess?:ResolverInputTypes["MutationCustomerUpdateTradeVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationCustomerUpdateTradeVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreatePurchaseVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDealershipCreatePurchaseVehicleSuccess?:ResolverInputTypes["MutationDealershipCreatePurchaseVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreatePurchaseVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreateTradeVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDealershipCreateTradeVehicleSuccess?:ResolverInputTypes["MutationDealershipCreateTradeVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreateTradeVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreateTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDealershipCreateTransactionSuccess?:ResolverInputTypes["MutationDealershipCreateTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipCreateTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipRemoveTradeVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDealershipRemoveTradeVehicleSuccess?:ResolverInputTypes["MutationDealershipRemoveTradeVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipRemoveTradeVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipUpdatePurchaseVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDealershipUpdatePurchaseVehicleSuccess?:ResolverInputTypes["MutationDealershipUpdatePurchaseVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipUpdatePurchaseVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipUpdateTradeVehicleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDealershipUpdateTradeVehicleSuccess?:ResolverInputTypes["MutationDealershipUpdateTradeVehicleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDealershipUpdateTradeVehicleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDeleteStaffScheduleEventResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDeleteStaffScheduleEventSuccess?:ResolverInputTypes["MutationDeleteStaffScheduleEventSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDeleteStaffScheduleEventSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDismissNotificationsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationDismissNotificationsSuccess?:ResolverInputTypes["MutationDismissNotificationsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationDismissNotificationsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationExtractVehicleFromRegistrationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationExtractVehicleFromRegistrationSuccess?:ResolverInputTypes["MutationExtractVehicleFromRegistrationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationExtractVehicleFromRegistrationSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationFinalizeLivenessAnalysisResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationFinalizeLivenessAnalysisSuccess?:ResolverInputTypes["MutationFinalizeLivenessAnalysisSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationFinalizeLivenessAnalysisSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationLoginResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationLoginSuccess?:ResolverInputTypes["MutationLoginSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationLoginSuccess"]: AliasType<{
	data?:ResolverInputTypes["LoginResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationLogoutResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationLogoutSuccess?:ResolverInputTypes["MutationLogoutSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationLogoutSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeSubmissionTokenResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationMakeSubmissionTokenSuccess?:ResolverInputTypes["MutationMakeSubmissionTokenSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeSubmissionTokenSuccess"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadForScannerResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationMakeUploadForScannerSuccess?:ResolverInputTypes["MutationMakeUploadForScannerSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadForScannerSuccess"]: AliasType<{
	data?:ResolverInputTypes["MakeFileUploadForScannerType"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationMakeUploadSuccess?:ResolverInputTypes["MutationMakeUploadSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadSuccess"]: AliasType<{
	data?:ResolverInputTypes["MakeFileUploadType"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadToTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationMakeUploadToTransactionSuccess?:ResolverInputTypes["MutationMakeUploadToTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMakeUploadToTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MakeFileUploadType"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMarkTransactionAsDeliveredResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationMarkTransactionAsDeliveredSuccess?:ResolverInputTypes["MutationMarkTransactionAsDeliveredSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationMarkTransactionAsDeliveredSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationModifyHardCreditApplicationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationModifyHardCreditApplicationSuccess?:ResolverInputTypes["MutationModifyHardCreditApplicationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationModifyHardCreditApplicationSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationOnboardingSubmitStep1Result"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationOnboardingSubmitStep1Success?:ResolverInputTypes["MutationOnboardingSubmitStep1Success"],
		__typename?: boolean | `@${string}`
}>;
	["MutationOnboardingSubmitStep1Success"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationOnboardingSubmitStep2Result"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationOnboardingSubmitStep2Success?:ResolverInputTypes["MutationOnboardingSubmitStep2Success"],
		__typename?: boolean | `@${string}`
}>;
	["MutationOnboardingSubmitStep2Success"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationOverrideTodoResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationOverrideTodoSuccess?:ResolverInputTypes["MutationOverrideTodoSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationOverrideTodoSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPreLoginCheckResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPreLoginCheckSuccess?:ResolverInputTypes["MutationPreLoginCheckSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPreLoginCheckSuccess"]: AliasType<{
	data?:ResolverInputTypes["PreLoginType"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPrefillLicensePlateOrVinResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPrefillLicensePlateOrVinSuccess?:ResolverInputTypes["MutationPrefillLicensePlateOrVinSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPrefillLicensePlateOrVinSuccess"]: AliasType<{
	data?:ResolverInputTypes["LicensePrefillData"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDataToCrmsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPushDataToCrmsSuccess?:ResolverInputTypes["MutationPushDataToCrmsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDataToCrmsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDocumentToCdkDealJacketResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPushDocumentToCdkDealJacketSuccess?:ResolverInputTypes["MutationPushDocumentToCdkDealJacketSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDocumentToCdkDealJacketSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDocumentsToCdkResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPushDocumentsToCdkSuccess?:ResolverInputTypes["MutationPushDocumentsToCdkSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushDocumentsToCdkSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushFormSubmissionsToCdkResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPushFormSubmissionsToCdkSuccess?:ResolverInputTypes["MutationPushFormSubmissionsToCdkSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushFormSubmissionsToCdkSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushHardCreditApplicationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationPushHardCreditApplicationSuccess?:ResolverInputTypes["MutationPushHardCreditApplicationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationPushHardCreditApplicationSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRecordConsentResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRecordConsentSuccess?:ResolverInputTypes["MutationRecordConsentSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRecordConsentSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRemoveCoBuyerResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRemoveCoBuyerSuccess?:ResolverInputTypes["MutationRemoveCoBuyerSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRemoveCoBuyerSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRemovePrimaryBuyerResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRemovePrimaryBuyerSuccess?:ResolverInputTypes["MutationRemovePrimaryBuyerSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRemovePrimaryBuyerSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestAgilityCreditPrequalResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRequestAgilityCreditPrequalSuccess?:ResolverInputTypes["MutationRequestAgilityCreditPrequalSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestAgilityCreditPrequalSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestIdentityVerificationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRequestIdentityVerificationSuccess?:ResolverInputTypes["MutationRequestIdentityVerificationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestIdentityVerificationSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestOtpExistingUserDEVResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRequestOtpExistingUserDEVSuccess?:ResolverInputTypes["MutationRequestOtpExistingUserDEVSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestOtpExistingUserDEVSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestPrequalReportsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRequestPrequalReportsSuccess?:ResolverInputTypes["MutationRequestPrequalReportsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestPrequalReportsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestPrescreenResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationRequestPrescreenSuccess?:ResolverInputTypes["MutationRequestPrescreenSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationRequestPrescreenSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResendStaffPasswordResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationResendStaffPasswordSuccess?:ResolverInputTypes["MutationResendStaffPasswordSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResendStaffPasswordSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationResponse"]: AliasType<{
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MutationResponseWithId"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalCustomerDataResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSaveLendingPortalCustomerDataSuccess?:ResolverInputTypes["MutationSaveLendingPortalCustomerDataSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalCustomerDataSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalPurchaseVehicleDataResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSaveLendingPortalPurchaseVehicleDataSuccess?:ResolverInputTypes["MutationSaveLendingPortalPurchaseVehicleDataSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalPurchaseVehicleDataSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalTradeVehicleDataResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSaveLendingPortalTradeVehicleDataSuccess?:ResolverInputTypes["MutationSaveLendingPortalTradeVehicleDataSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSaveLendingPortalTradeVehicleDataSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSendFormReadyNotificationsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSendFormReadyNotificationsSuccess?:ResolverInputTypes["MutationSendFormReadyNotificationsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSendFormReadyNotificationsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDeliveryMethodForUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSetDeliveryMethodForUserSuccess?:ResolverInputTypes["MutationSetDeliveryMethodForUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDeliveryMethodForUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDocumentLabelsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSetDocumentLabelsSuccess?:ResolverInputTypes["MutationSetDocumentLabelsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDocumentLabelsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDocumentTitleResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSetDocumentTitleSuccess?:ResolverInputTypes["MutationSetDocumentTitleSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetDocumentTitleSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetStaffInformationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSetStaffInformationSuccess?:ResolverInputTypes["MutationSetStaffInformationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetStaffInformationSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetStaffPlanningEnabledResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSetStaffPlanningEnabledSuccess?:ResolverInputTypes["MutationSetStaffPlanningEnabledSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSetStaffPlanningEnabledSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationStageAdditionalFormsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationStageAdditionalFormsSuccess?:ResolverInputTypes["MutationStageAdditionalFormsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationStageAdditionalFormsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationStartLivenessAnalysisResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationStartLivenessAnalysisSuccess?:ResolverInputTypes["MutationStartLivenessAnalysisSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationStartLivenessAnalysisSuccess"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitFormValuesResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSubmitFormValuesSuccess?:ResolverInputTypes["MutationSubmitFormValuesSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitFormValuesSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitPrequalApplicationAndCreateUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSubmitPrequalApplicationAndCreateUserSuccess?:ResolverInputTypes["MutationSubmitPrequalApplicationAndCreateUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitPrequalApplicationAndCreateUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitPrequalApplicationOnTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSubmitPrequalApplicationOnTransactionSuccess?:ResolverInputTypes["MutationSubmitPrequalApplicationOnTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitPrequalApplicationOnTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitStaffAcknowledgementResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSubmitStaffAcknowledgementSuccess?:ResolverInputTypes["MutationSubmitStaffAcknowledgementSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitStaffAcknowledgementSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitStandardFormResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSubmitStandardFormSuccess?:ResolverInputTypes["MutationSubmitStandardFormSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSubmitStandardFormSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSuspendGroupUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSuspendGroupUserSuccess?:ResolverInputTypes["MutationSuspendGroupUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSuspendGroupUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSuspendStaffResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSuspendStaffSuccess?:ResolverInputTypes["MutationSuspendStaffSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSuspendStaffSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSwitchCustomerRolesResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationSwitchCustomerRolesSuccess?:ResolverInputTypes["MutationSwitchCustomerRolesSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationSwitchCustomerRolesSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTestDriveEnsureCustomerForDealershipResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationTestDriveEnsureCustomerForDealershipSuccess?:ResolverInputTypes["MutationTestDriveEnsureCustomerForDealershipSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTestDriveEnsureCustomerForDealershipSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTrackUserEventResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationTrackUserEventSuccess?:ResolverInputTypes["MutationTrackUserEventSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationTrackUserEventSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUnlockTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUnlockTransactionSuccess?:ResolverInputTypes["MutationUnlockTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUnlockTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateCustomerResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateCustomerSuccess?:ResolverInputTypes["MutationUpdateCustomerSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateCustomerSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateEmploymentResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateEmploymentSuccess?:ResolverInputTypes["MutationUpdateEmploymentSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateEmploymentSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateGroupUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateGroupUserSuccess?:ResolverInputTypes["MutationUpdateGroupUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateGroupUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateIdCardRotationResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateIdCardRotationSuccess?:ResolverInputTypes["MutationUpdateIdCardRotationSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateIdCardRotationSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateMyUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateMyUserSuccess?:ResolverInputTypes["MutationUpdateMyUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateMyUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateReceivesAuthenticomReportResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateReceivesAuthenticomReportSuccess?:ResolverInputTypes["MutationUpdateReceivesAuthenticomReportSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateReceivesAuthenticomReportSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffAttributesResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateStaffAttributesSuccess?:ResolverInputTypes["MutationUpdateStaffAttributesSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffAttributesSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffExtraPermissionsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateStaffExtraPermissionsSuccess?:ResolverInputTypes["MutationUpdateStaffExtraPermissionsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffExtraPermissionsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffScheduleEventResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateStaffScheduleEventSuccess?:ResolverInputTypes["MutationUpdateStaffScheduleEventSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateStaffScheduleEventSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponse"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUpdateTransactionSuccess?:ResolverInputTypes["MutationUpdateTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUpdateTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["Response"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadAdditionalDocumentsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUploadAdditionalDocumentsSuccess?:ResolverInputTypes["MutationUploadAdditionalDocumentsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadAdditionalDocumentsSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadAdditionalDocumentsToTransactionResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUploadAdditionalDocumentsToTransactionSuccess?:ResolverInputTypes["MutationUploadAdditionalDocumentsToTransactionSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadAdditionalDocumentsToTransactionSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadIdCardResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUploadIdCardSuccess?:ResolverInputTypes["MutationUploadIdCardSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadIdCardSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadIdCardWithTokenResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUploadIdCardWithTokenSuccess?:ResolverInputTypes["MutationUploadIdCardWithTokenSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUploadIdCardWithTokenSuccess"]: AliasType<{
	data?:ResolverInputTypes["MutationResponseWithId"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUserExistsResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationUserExistsSuccess?:ResolverInputTypes["MutationUserExistsSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationUserExistsSuccess"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MutationVerifyOtpForExistingUserResult"]: AliasType<{
	GraphQLError?:ResolverInputTypes["GraphQLError"],
	MutationVerifyOtpForExistingUserSuccess?:ResolverInputTypes["MutationVerifyOtpForExistingUserSuccess"],
		__typename?: boolean | `@${string}`
}>;
	["MutationVerifyOtpForExistingUserSuccess"]: AliasType<{
	data?:ResolverInputTypes["LoginResponse"],
		__typename?: boolean | `@${string}`
}>;
	["Node"]:AliasType<{
		id?:boolean | `@${string}`;
		['...on UserDealership']?: Omit<ResolverInputTypes["UserDealership"],keyof ResolverInputTypes["Node"]>;
		__typename?: boolean | `@${string}`
}>;
	["Notification"]: AliasType<{
	announcement?:ResolverInputTypes["Announcement"],
	createdAt?:boolean | `@${string}`,
	dismissedAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	payload?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationFilter"]: {
	announcementId?: ResolverInputTypes["IDFilter"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null,
	dismissedAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null
};
	["NotificationOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null,
	dismissedAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["OnboardingStep"]:OnboardingStep;
	["OrderBy"]:OrderBy;
	["PageInfo"]: AliasType<{
	endCursor?:boolean | `@${string}`,
	hasNextPage?:boolean | `@${string}`,
	hasPreviousPage?:boolean | `@${string}`,
	startCursor?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Permission"]:Permission;
	["PlatformType"]: AliasType<{
announcements?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["AnnouncementOrderBy"] | undefined | null},ResolverInputTypes["PlatformTypeAnnouncementsConnection"]],
documentLabels?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["DocumentLabelOrderBy"] | undefined | null},ResolverInputTypes["PlatformTypeDocumentLabelsConnection"]],
faqs?: [{	after?: string | undefined | null,	before?: string | undefined | null,	dealershipId?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["PlatformTypeFaqsConnection"]],
isIpBlocked?: [{	dealershipId: string},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["PlatformTypeAnnouncementsConnection"]: AliasType<{
	edges?:ResolverInputTypes["PlatformTypeAnnouncementsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PlatformTypeAnnouncementsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Announcement"],
		__typename?: boolean | `@${string}`
}>;
	["PlatformTypeDocumentLabelsConnection"]: AliasType<{
	edges?:ResolverInputTypes["PlatformTypeDocumentLabelsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PlatformTypeDocumentLabelsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["DocumentLabel"],
		__typename?: boolean | `@${string}`
}>;
	["PlatformTypeFaqsConnection"]: AliasType<{
	edges?:ResolverInputTypes["PlatformTypeFaqsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PlatformTypeFaqsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Faq"],
		__typename?: boolean | `@${string}`
}>;
	["PolicyLayerType"]:PolicyLayerType;
	["PreLoginType"]: AliasType<{
	hasConsentedToSms?:boolean | `@${string}`,
	loginOptions?:boolean | `@${string}`,
	userExists?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PrequalApplication"]: AliasType<{
agilityCreditPrequalReports?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["AgilityCreditPrequalReportFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["PrequalApplicationAgilityCreditPrequalReportsConnection"]],
	city?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
prequalResponses?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["SevenHundredCreditPrequalReportsFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["PrequalApplicationPrequalResponsesConnection"]],
	state?:boolean | `@${string}`,
	transactionId?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PrequalApplicationAgilityCreditPrequalReportsConnection"]: AliasType<{
	edges?:ResolverInputTypes["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["AgilityCreditPrequalReport"],
		__typename?: boolean | `@${string}`
}>;
	["PrequalApplicationPrequalResponsesConnection"]: AliasType<{
	edges?:ResolverInputTypes["PrequalApplicationPrequalResponsesConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["PrequalApplicationPrequalResponsesConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["SevenHundredCreditPrequalReports"],
		__typename?: boolean | `@${string}`
}>;
	["PrequalBureau"]:PrequalBureau;
	["PrequalBureauFilter"]: {
	equals?: ResolverInputTypes["PrequalBureau"] | undefined | null,
	in?: Array<ResolverInputTypes["PrequalBureau"]> | undefined | null,
	not?: ResolverInputTypes["PrequalBureauFilter"] | undefined | null,
	notIn?: Array<ResolverInputTypes["PrequalBureau"]> | undefined | null
};
	["PrequalInput"]: {
	apartmentDetails: string,
	birthdate: string,
	city: string,
	dateTime: string,
	dealerPrivacyAckTmplId?: string | undefined | null,
	deviceId: string,
	eSignAckTmplId?: string | undefined | null,
	firstName: string,
	ipAddress: string,
	lastName: string,
	middleName?: string | undefined | null,
	name: string,
	prequalReportAckTmplId?: string | undefined | null,
	signature: string,
	socialSecurityNumber: string,
	state: string,
	street: string,
	suffix: string,
	tdcConsentsAckTmplId?: string | undefined | null,
	zip: string
};
	["Prescreen"]: AliasType<{
	id?:boolean | `@${string}`,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PublicType"]: AliasType<{
acknowledgements?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["AcknowledgementTemplateFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["AcknowledgementTemplateOrderBy"] | undefined | null},ResolverInputTypes["PublicTypeAcknowledgementsConnection"]],
	ipAddress?:boolean | `@${string}`,
	platformVersion?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PublicTypeAcknowledgementsConnection"]: AliasType<{
	edges?:ResolverInputTypes["PublicTypeAcknowledgementsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["PublicTypeAcknowledgementsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["AcknowledgementTemplate"],
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
customer?: [{	contactPId?: string | undefined | null,	transactionId?: string | undefined | null,	transactionPId?: string | undefined | null,	userId?: string | undefined | null},ResolverInputTypes["Customer"]],
dealership?: [{	id?: string | undefined | null,	slug?: string | undefined | null},ResolverInputTypes["Dealership"]],
dealershipStaffScheduleEvents?: [{	dealershipId: string,	fromDate: string,	toDate: string},ResolverInputTypes["StaffScheduleEvent"]],
	/** Return information about the currently logged in user */
	me?:ResolverInputTypes["MeType"],
node?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["Node"]],
nodes?: [{	ids: Array<ResolverInputTypes["ID"]>},ResolverInputTypes["Node"]],
	/** Return platform information */
	platform?:ResolverInputTypes["PlatformType"],
	/** Public query root */
	public?:ResolverInputTypes["PublicType"],
transaction?: [{	id?: string | undefined | null,	/** Public ID, starts with "tx_..." - a human-friendly, URL-safe identifier */
	pId?: string | undefined | null},ResolverInputTypes["Transaction"]],
userDealership?: [{	dealershipId: string,	userId: string},ResolverInputTypes["UserDealership"]],
		__typename?: boolean | `@${string}`
}>;
	["RecallMastersRecallReport"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	request?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RecallMastersRecallReportFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["RecallMastersRecallReportOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["Referral"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dealership?:ResolverInputTypes["Dealership"],
	id?:boolean | `@${string}`,
	pId?:boolean | `@${string}`,
	payoutInCents?:boolean | `@${string}`,
	referringContact?:ResolverInputTypes["ContactV2"],
	status?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ReferralStatus"]:ReferralStatus;
	["Response"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Role"]:Role;
	["RoleFilter"]: {
	equals?: ResolverInputTypes["Role"] | undefined | null,
	in?: Array<ResolverInputTypes["Role"]> | undefined | null,
	not?: ResolverInputTypes["RoleFilter"] | undefined | null
};
	["RoleListFilter"]: {
	has?: ResolverInputTypes["Role"] | undefined | null
};
	["SalesRankingGrouppedByMonth"]: AliasType<{
	currentMonth?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastMonth?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	twoMonthsAgo?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SetStaffInformationInput"]: {
	cdkCrmEmployeeId?: string | undefined | null
};
	["SevenHundredCreditPrequalReports"]: AliasType<{
	application?:ResolverInputTypes["PrequalApplication"],
	id?:boolean | `@${string}`,
	idMatchSummary?:boolean | `@${string}`,
	ofacSummary?:boolean | `@${string}`,
	product?:boolean | `@${string}`,
	quizStatus?:boolean | `@${string}`,
	redFlagSummary?:boolean | `@${string}`,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	resultCode?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SevenHundredCreditPrequalReportsFilter"]: {
	bureau?: ResolverInputTypes["PrequalBureauFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	isForCompliance?: ResolverInputTypes["BooleanFilter"] | undefined | null
};
	["Staff"]: AliasType<{
	dealershipId?:boolean | `@${string}`,
	dealershipRole?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	hasEnabledStaffPlanning?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	receivesAuthenticomReport?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StaffAttributes"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	role?: ResolverInputTypes["Role"] | undefined | null
};
	["StaffFilter"]: {
	dealershipId?: ResolverInputTypes["IDFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["StaffInformation"]: AliasType<{
	cdkCrmEmployeeId?:boolean | `@${string}`,
	dealership?:ResolverInputTypes["Dealership"],
	dealershipId?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StaffInformationFilter"]: {
	dealershipId?: ResolverInputTypes["IDFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["StaffScheduleEvent"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dealershipId?:boolean | `@${string}`,
	endAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	note?:boolean | `@${string}`,
	staffId?:boolean | `@${string}`,
	startAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StageFormInput"]: {
	id: string,
	order: number
};
	["StringFilter"]: {
	contains?: string | undefined | null,
	equals?: string | undefined | null,
	mode?: ResolverInputTypes["StringFilterMode"] | undefined | null,
	not?: ResolverInputTypes["StringFilter"] | undefined | null,
	startsWith?: string | undefined | null
};
	["StringFilterMode"]:StringFilterMode;
	["SubmitStep1Input"]: {
	captureBackFileId?: string | undefined | null,
	captureFrontFileId?: string | undefined | null,
	/** Signifies contact consent to the consent text at the template ID */
	contactConsentWithTemplateId: string,
	dmvForm?: string | undefined | null,
	dmvPdfFileId?: string | undefined | null,
	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null,
	privacyNoticeFileId: string,
	privacyNoticeForm: string,
	/** Signifies test drive consent to the consent text at the template ID */
	testDriveConsentWithTemplateId: string
};
	["SubmitStep2Input"]: {
	captureFileId: string,
	livenessSessionId?: string | undefined | null,
	selfieAckTmplId: string
};
	["SubmitTo"]:SubmitTo;
	["TextAlignment"]:TextAlignment;
	["Todo"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	dealershipGroupId?:boolean | `@${string}`,
	dealershipId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	transaction?:ResolverInputTypes["Transaction"],
	transactionId?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TodoFilter"]: {
	createdAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null,
	status?: ResolverInputTypes["TodoStatusFilter"] | undefined | null,
	transactionId?: ResolverInputTypes["IDFilter"] | undefined | null,
	type?: ResolverInputTypes["TodoTypesFilter"] | undefined | null
};
	["TodoOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["TodoStatus"]:TodoStatus;
	["TodoStatusFilter"]: {
	equals?: ResolverInputTypes["TodoStatus"] | undefined | null,
	in?: Array<ResolverInputTypes["TodoStatus"]> | undefined | null,
	not?: ResolverInputTypes["TodoStatusFilter"] | undefined | null
};
	["TodoTypes"]:TodoTypes;
	["TodoTypesFilter"]: {
	equals?: ResolverInputTypes["TodoTypes"] | undefined | null,
	in?: Array<ResolverInputTypes["TodoTypes"]> | undefined | null,
	not?: ResolverInputTypes["TodoTypesFilter"] | undefined | null
};
	["Transaction"]: AliasType<{
agilityCreditVerifications?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["AgilityCreditIdVerificationFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["TransactionAgilityCreditVerificationsConnection"]],
	bdc?:ResolverInputTypes["User"],
	buyer?:ResolverInputTypes["Customer"],
	buyerId?:boolean | `@${string}`,
	cdkDmsDealId?:boolean | `@${string}`,
	/** Optionally, a co-buyer for the transaction */
	coBuyer?:ResolverInputTypes["Customer"],
	coBuyerId?:boolean | `@${string}`,
	complianceFormsData?:ResolverInputTypes["ComplianceFormsData"],
	consumerRebatesInUsdCents?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	customerSharedData?:ResolverInputTypes["CustomerSharedData"],
	dealership?:ResolverInputTypes["Dealership"],
	dealershipCommitment?:boolean | `@${string}`,
documents?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["DocumentOr"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["DocumentOrderBy"] | undefined | null},ResolverInputTypes["TransactionDocumentsConnection"]],
	downPayment?:boolean | `@${string}`,
	downPaymentInUsdCents?:boolean | `@${string}`,
	financeType?:boolean | `@${string}`,
	fniManager?:ResolverInputTypes["User"],
formSubmissionCollections?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["FormSubmissionCollectionFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["FormSubmissionCollectionOrderBy"] | undefined | null},ResolverInputTypes["TransactionFormSubmissionCollectionsConnection"]],
formSubmissions?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["FormSubmissionFilter"] | undefined | null,	first?: number | undefined | null,	/** Filter such that only form submissions with missing values from userId are returned */
	hasMissingValuesBy?: string | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["FormFieldSubmissionOrderBy"] | undefined | null},ResolverInputTypes["TransactionFormSubmissionsConnection"]],
	isLeaseBuyOut?:boolean | `@${string}`,
	leaseTermInMonths?:boolean | `@${string}`,
lenderHardCreditApplications?: [{	orderBy?: ResolverInputTypes["LenderHardCreditApplicationOrderBy"] | undefined | null},ResolverInputTypes["LenderHardCreditApplication"]],
	lockedReason?:boolean | `@${string}`,
logs?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["TransactionLogFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["TransactionLogOrderBy"] | undefined | null},ResolverInputTypes["TransactionLogsConnection"]],
	milesPerYearInLease?:boolean | `@${string}`,
	monthlyLeasePaymentInUsdCents?:boolean | `@${string}`,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "tx_...") */
	pId?:boolean | `@${string}`,
	price?:boolean | `@${string}`,
referrals?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["TransactionReferralsConnection"]],
	routeOneApplicationId?:boolean | `@${string}`,
	salesManager?:ResolverInputTypes["User"],
	salesPerson?:ResolverInputTypes["User"],
	salesPriceInUsdCents?:boolean | `@${string}`,
	salesTaxInMiliBsp?:boolean | `@${string}`,
	source?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	/** The title of a transaction default to the buyers name or email if that is not set */
	title?:boolean | `@${string}`,
todos?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["TodoFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["TodoOrderBy"] | undefined | null},ResolverInputTypes["TransactionTodosConnection"]],
	tradeInPriceInUsdCents?:boolean | `@${string}`,
	tradeVehicle?:ResolverInputTypes["Vehicle"],
	/** This returns a list of all users who have made changes to the transaction. This can be used to filter the list of transaction logs */
	usersWorkingOnTransaction?:ResolverInputTypes["ListItem"],
	vehicle?:ResolverInputTypes["Vehicle"],
vehicleRegistrationExtractions?: [{	filter?: ResolverInputTypes["VehicleRegistrationExtractionFilter"] | undefined | null},ResolverInputTypes["VehicleRegistrationExtraction"]],
		__typename?: boolean | `@${string}`
}>;
	["TransactionAgilityCreditVerificationsConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionAgilityCreditVerificationsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionAgilityCreditVerificationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["AgilityCreditIdVerification"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionAndFilter"]: {
	OR?: Array<ResolverInputTypes["AssignedStaffOrFilter"]> | undefined | null,
	salesPersonId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["TransactionDealershipAnalyticsSpotFilter"]: {
	eventAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null
};
	["TransactionDocumentsConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionDocumentsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TransactionDocumentsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Document"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionFilter"]: {
	AND?: Array<ResolverInputTypes["TransactionAndFilter"]> | undefined | null,
	OR?: Array<ResolverInputTypes["AssignedStaffOrFilter"]> | undefined | null,
	buyerId?: ResolverInputTypes["IDFilter"] | undefined | null,
	coBuyerId?: ResolverInputTypes["IDFilter"] | undefined | null,
	createdAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null,
	dealership?: ResolverInputTypes["DealershipFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	salesPersonId?: ResolverInputTypes["IDFilter"] | undefined | null,
	source?: ResolverInputTypes["TransactionSourceFilter"] | undefined | null,
	status?: ResolverInputTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionFormSubmissionCollectionsConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionFormSubmissionCollectionsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TransactionFormSubmissionCollectionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["FormSubmissionCollection"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionFormSubmissionsConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionFormSubmissionsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TransactionFormSubmissionsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["FormSubmission"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionLifecycle"]:TransactionLifecycle;
	["TransactionLockReason"]:TransactionLockReason;
	["TransactionLog"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	event?:boolean | `@${string}`,
	eventDescription?:boolean | `@${string}`,
	executingUser?:ResolverInputTypes["User"],
	id?:boolean | `@${string}`,
	transaction?:ResolverInputTypes["Transaction"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionLogFilter"]: {
	createdAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null,
	executingUserId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["TransactionLogOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["TransactionLogsConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionLogsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionLogsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["TransactionLog"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionOrderBy"]: {
	createdAt?: ResolverInputTypes["FieldOrdering"] | undefined | null,
	firstName?: ResolverInputTypes["FieldOrdering"] | undefined | null,
	lastName?: ResolverInputTypes["FieldOrdering"] | undefined | null,
	source?: ResolverInputTypes["FieldOrdering"] | undefined | null,
	status?: ResolverInputTypes["FieldOrdering"] | undefined | null
};
	["TransactionReferralsConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionReferralsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionReferralsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Referral"],
		__typename?: boolean | `@${string}`
}>;
	["TransactionRole"]:TransactionRole;
	["TransactionSalesRankingAnalyticsWhereInput"]: {
	status?: ResolverInputTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionSource"]:TransactionSource;
	["TransactionSourceFilter"]: {
	equals?: ResolverInputTypes["TransactionSource"] | undefined | null,
	in?: Array<ResolverInputTypes["TransactionSource"]> | undefined | null,
	not?: ResolverInputTypes["TransactionSourceFilter"] | undefined | null
};
	["TransactionStatus"]:TransactionStatus;
	["TransactionStatusFilter"]: {
	equals?: ResolverInputTypes["TransactionStatus"] | undefined | null,
	in?: Array<ResolverInputTypes["TransactionStatus"]> | undefined | null,
	not?: ResolverInputTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionStatusUpdateDealershipAnalyticsFilter"]: {
	eventAt?: ResolverInputTypes["DateTimeFilter"] | undefined | null,
	financeType?: ResolverInputTypes["FinanceTypeFilter"] | undefined | null,
	isLeaseBuyOut?: boolean | undefined | null,
	purchaseVehicleLifeCycleStage?: ResolverInputTypes["VehicleLifeCycleStageFilter"] | undefined | null,
	source?: ResolverInputTypes["TransactionSourceFilter"] | undefined | null,
	status?: ResolverInputTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionTodosConnection"]: AliasType<{
	edges?:ResolverInputTypes["TransactionTodosConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TransactionTodosConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Todo"],
		__typename?: boolean | `@${string}`
}>;
	["UpdateCustomerAddress"]: {
	apartmentDetails: string,
	city: string,
	state: string,
	street: string,
	zipCode: string
};
	["UpdateCustomerInput"]: {
	dob?: ResolverInputTypes["DateTime"] | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	removeVehicleRegistrationAddress?: boolean | undefined | null,
	residentialAddresses?: Array<ResolverInputTypes["AddressInput"]> | undefined | null,
	selfieCaptureId?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	vehicleRegistrationAddress?: ResolverInputTypes["UpdateCustomerAddress"] | undefined | null
};
	["UpdateEmploymentInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: string | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: string | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: string | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition?: number | undefined | null
};
	["UpdateStaffScheduleEventInput"]: {
	endAt?: string | undefined | null,
	note?: string | undefined | null,
	startAt?: string | undefined | null
};
	["UpdateTransactionInput"]: {
	cdkDmsDealId?: string | undefined | null,
	consumerRebatesInUsdCents?: number | undefined | null,
	dealershipCommitment?: string | undefined | null,
	downPaymentInUsdCents?: number | undefined | null,
	financeType?: string | undefined | null,
	id: string,
	isLeaseBuyOut?: boolean | undefined | null,
	leaseTermInMonths?: number | undefined | null,
	milesPerYearInLease?: number | undefined | null,
	monthlyLeasePaymentInUsdCents?: number | undefined | null,
	salesPriceInUsdCents?: number | undefined | null,
	salesTaxInMiliBsp?: number | undefined | null,
	tradeInPriceInUsdCents?: number | undefined | null
};
	["UpdateTransactionStaffInput"]: {
	bdcId?: string | undefined | null,
	fniManagerId?: string | undefined | null,
	salesManagerId?: string | undefined | null,
	salesPersonId?: string | undefined | null
};
	["UpdateUserInput"]: {
	firstName?: string | undefined | null,
	lastName?: string | undefined | null
};
	["User"]: AliasType<{
buyerFor?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["TransactionFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserBuyerForConnection"]],
coBuyerFor?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["TransactionFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserCoBuyerForConnection"]],
	createdAt?:boolean | `@${string}`,
customers?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["CustomerFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserCustomersConnection"]],
	email?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
hasReferred?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserHasReferredConnection"]],
	id?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
notifications?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["NotificationFilter"] | undefined | null,	first?: number | undefined | null,	isUnread?: boolean | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["NotificationOrderBy"] | undefined | null},ResolverInputTypes["UserNotificationsConnection"]],
	phoneNumber?:boolean | `@${string}`,
staff?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["StaffFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserStaffConnection"]],
staffInformation?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["StaffInformationFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserStaffInformationConnection"]],
userAcknowledgements?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["UserAcknowledgementFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	order?: ResolverInputTypes["UserAcknowledgementOrderBy"] | undefined | null},ResolverInputTypes["UserUserAcknowledgementsConnection"]],
userGroup?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["UserGroupFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserUserGroupConnection"]],
userLogs?: [{	after?: string | undefined | null,	before?: string | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null},ResolverInputTypes["UserUserLogsConnection"]],
		__typename?: boolean | `@${string}`
}>;
	["UserAcknowledgement"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserAcknowledgementFilter"]: {
	acknowledgementId?: ResolverInputTypes["IDFilter"] | undefined | null,
	dealershipId?: ResolverInputTypes["IDFilter"] | undefined | null,
	transactionId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["UserAcknowledgementOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["UserBuyerForConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserBuyerForConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserBuyerForConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Transaction"],
		__typename?: boolean | `@${string}`
}>;
	["UserCoBuyerForConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserCoBuyerForConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserCoBuyerForConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Transaction"],
		__typename?: boolean | `@${string}`
}>;
	["UserCustomersConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserCustomersConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserCustomersConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Customer"],
		__typename?: boolean | `@${string}`
}>;
	["UserDealership"]: AliasType<{
	dealership?:ResolverInputTypes["Dealership"],
	dealershipId?:boolean | `@${string}`,
	extraPermissions?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	isSuspended?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserDealershipFilter"]: {
	isSuspended?: ResolverInputTypes["BooleanFilter"] | undefined | null,
	role?: ResolverInputTypes["RoleFilter"] | undefined | null,
	user?: ResolverInputTypes["UserFilter"] | undefined | null,
	userId?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["UserEventOperation"]:UserEventOperation;
	["UserFilter"]: {
	OR?: Array<ResolverInputTypes["UserOrFilter"]> | undefined | null,
	firstName?: ResolverInputTypes["StringFilter"] | undefined | null,
	lastName?: ResolverInputTypes["StringFilter"] | undefined | null
};
	["UserGroup"]: AliasType<{
	group?:ResolverInputTypes["DealershipGroup"],
	groupId?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	isSuspended?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	user?:ResolverInputTypes["User"],
		__typename?: boolean | `@${string}`
}>;
	["UserGroupFilter"]: {
	isSuspended?: boolean | undefined | null
};
	["UserHasReferredConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserHasReferredConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserHasReferredConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Referral"],
		__typename?: boolean | `@${string}`
}>;
	["UserLog"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	event?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserNotificationsConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserNotificationsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
	totalCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserNotificationsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Notification"],
		__typename?: boolean | `@${string}`
}>;
	["UserOrFilter"]: {
	firstName?: ResolverInputTypes["StringFilter"] | undefined | null,
	id?: ResolverInputTypes["IDFilter"] | undefined | null,
	lastName?: ResolverInputTypes["StringFilter"] | undefined | null
};
	["UserStaffConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserStaffConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserStaffConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["Staff"],
		__typename?: boolean | `@${string}`
}>;
	["UserStaffInformationConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserStaffInformationConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserStaffInformationConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["StaffInformation"],
		__typename?: boolean | `@${string}`
}>;
	["UserUserAcknowledgementsConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserUserAcknowledgementsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserUserAcknowledgementsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["UserAcknowledgement"],
		__typename?: boolean | `@${string}`
}>;
	["UserUserGroupConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserUserGroupConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserUserGroupConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["UserGroup"],
		__typename?: boolean | `@${string}`
}>;
	["UserUserLogsConnection"]: AliasType<{
	edges?:ResolverInputTypes["UserUserLogsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["UserUserLogsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["UserLog"],
		__typename?: boolean | `@${string}`
}>;
	["Vehicle"]: AliasType<{
	bodyType?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	condition?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	lifeCycleStage?:boolean | `@${string}`,
	make?:boolean | `@${string}`,
	mileage?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	msrp?:boolean | `@${string}`,
	pictureBack?:ResolverInputTypes["File"],
	pictureFront?:ResolverInputTypes["File"],
	pictureInterior?:ResolverInputTypes["File"],
	pictureLeftSide?:ResolverInputTypes["File"],
	pictureOdometer?:ResolverInputTypes["File"],
	pictureRightSide?:ResolverInputTypes["File"],
	pictureVinNumber?:ResolverInputTypes["File"],
	principalPriorUse?:boolean | `@${string}`,
recallMastersRecallReports?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["RecallMastersRecallReportFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderBy?: ResolverInputTypes["RecallMastersRecallReportOrderBy"] | undefined | null},ResolverInputTypes["VehicleRecallMastersRecallReportsConnection"]],
	registrationName?:boolean | `@${string}`,
	registrationState?:boolean | `@${string}`,
	stockNumber?:boolean | `@${string}`,
	transactionPurchaseVehicle?:ResolverInputTypes["Transaction"],
	transactionTradeVehicle?:ResolverInputTypes["Transaction"],
	/** Pre-packaged groups of features (e.g., base model, performance, etc.) */
	trim?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	updatedByDealership?:boolean | `@${string}`,
vehicleRecallChecks?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["VehicleNhtsaRecallReportFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderby?: ResolverInputTypes["VehicleNhtsaRecallReportOrderBy"] | undefined | null},ResolverInputTypes["VehicleVehicleRecallChecksConnection"]],
	vin?:boolean | `@${string}`,
vinAuditReports?: [{	after?: string | undefined | null,	before?: string | undefined | null,	filter?: ResolverInputTypes["VinAuditReportFilter"] | undefined | null,	first?: number | undefined | null,	last?: number | undefined | null,	orderby?: ResolverInputTypes["VinAuditReportOrderBy"] | undefined | null},ResolverInputTypes["VehicleVinAuditReportsConnection"]],
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VehicleBodyType"]:VehicleBodyType;
	["VehicleCondition"]:VehicleCondition;
	["VehicleLifeCycleStage"]:VehicleLifeCycleStage;
	["VehicleLifeCycleStageFilter"]: {
	equals?: ResolverInputTypes["VehicleLifeCycleStage"] | undefined | null,
	in?: Array<ResolverInputTypes["VehicleLifeCycleStage"]> | undefined | null,
	not?: ResolverInputTypes["VehicleLifeCycleStageFilter"] | undefined | null
};
	["VehicleNhtsaRecallReport"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VehicleNhtsaRecallReportFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["VehicleNhtsaRecallReportOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["VehiclePrincipalPriorUse"]:VehiclePrincipalPriorUse;
	["VehicleRecallMastersRecallReportsConnection"]: AliasType<{
	edges?:ResolverInputTypes["VehicleRecallMastersRecallReportsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["VehicleRecallMastersRecallReportsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["RecallMastersRecallReport"],
		__typename?: boolean | `@${string}`
}>;
	["VehicleRegistrationExtraction"]: AliasType<{
	bodyType?:boolean | `@${string}`,
	color?:boolean | `@${string}`,
	condition?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	errorMessage?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	licensePlate?:boolean | `@${string}`,
	make?:boolean | `@${string}`,
	mileage?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	registrationName?:boolean | `@${string}`,
	registrationState?:boolean | `@${string}`,
	requestedById?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	vin?:boolean | `@${string}`,
	year?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VehicleRegistrationExtractionFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["VehicleRegistrationExtractionStatus"]:VehicleRegistrationExtractionStatus;
	["VehicleVehicleRecallChecksConnection"]: AliasType<{
	edges?:ResolverInputTypes["VehicleVehicleRecallChecksConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["VehicleVehicleRecallChecksConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["VehicleNhtsaRecallReport"],
		__typename?: boolean | `@${string}`
}>;
	["VehicleVinAuditReportsConnection"]: AliasType<{
	edges?:ResolverInputTypes["VehicleVinAuditReportsConnectionEdge"],
	pageInfo?:ResolverInputTypes["PageInfo"],
		__typename?: boolean | `@${string}`
}>;
	["VehicleVinAuditReportsConnectionEdge"]: AliasType<{
	cursor?:boolean | `@${string}`,
	node?:ResolverInputTypes["VinAuditReport"],
		__typename?: boolean | `@${string}`
}>;
	["VinAuditReport"]: AliasType<{
	createdAt?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	response?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["VinAuditReportFilter"]: {
	id?: ResolverInputTypes["IDFilter"] | undefined | null
};
	["VinAuditReportOrderBy"]: {
	createdAt?: ResolverInputTypes["OrderBy"] | undefined | null
};
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ModelTypes = {
    ["Acknowledgement"]:Acknowledgement;
	["AcknowledgementFilter"]: {
	equals?: ModelTypes["Acknowledgement"] | undefined | null,
	in?: Array<ModelTypes["Acknowledgement"]> | undefined | null,
	not?: ModelTypes["AcknowledgementFilter"] | undefined | null
};
	["AcknowledgementTemplate"]: {
		code: ModelTypes["Acknowledgement"],
	createdAt: ModelTypes["DateTime"],
	id: string,
	language?: string | undefined | null,
	revision: number,
	textMarkdown: string
};
	["AcknowledgementTemplateFilter"]: {
	code?: ModelTypes["AcknowledgementFilter"] | undefined | null,
	language?: ModelTypes["StringFilter"] | undefined | null
};
	["AcknowledgementTemplateOrderBy"]: {
	revision?: ModelTypes["OrderBy"] | undefined | null
};
	["Address"]: {
		apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	customer?: ModelTypes["Customer"] | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	fullAddress?: string | undefined | null,
	housingStatus?: ModelTypes["HousingStatus"] | undefined | null,
	id?: string | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition?: number | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null,
	zipCode?: string | undefined | null
};
	["AddressInput"]: {
	apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	housingStatus?: string | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition: number,
	zipCode?: string | undefined | null
};
	["AgilityCreditAccount"]: {
		accountNumber?: string | undefined | null,
	acctType?: string | undefined | null,
	balance?: number | undefined | null,
	bureau?: string | undefined | null,
	closedDate?: string | undefined | null,
	creditLimit?: number | undefined | null,
	creditor?: string | undefined | null,
	currentStatus?: string | undefined | null,
	days30?: number | undefined | null,
	days60?: number | undefined | null,
	days90?: number | undefined | null,
	highCredit?: number | undefined | null,
	id?: string | undefined | null,
	indJoint?: string | undefined | null,
	kind?: ModelTypes["AgilityCreditAccountKind"] | undefined | null,
	monthlyPayment?: number | undefined | null,
	notes?: string | undefined | null,
	openClosed?: string | undefined | null,
	openDate?: string | undefined | null,
	originalAmount?: number | undefined | null,
	pastDue?: number | undefined | null,
	paymentHistory?: string | undefined | null,
	reportedDate?: string | undefined | null,
	timesLate?: number | undefined | null,
	tradeType?: string | undefined | null
};
	["AgilityCreditAccountKind"]:AgilityCreditAccountKind;
	["AgilityCreditAddress"]: {
		addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	addressVarianceCode?: string | undefined | null,
	addressVarianceDescription?: string | undefined | null,
	dateLastReported?: string | undefined | null,
	dateReported?: string | undefined | null,
	id?: string | undefined | null,
	name?: string | undefined | null
};
	["AgilityCreditAka"]: {
		id?: string | undefined | null,
	name?: string | undefined | null
};
	["AgilityCreditAlert"]: {
		date?: string | undefined | null,
	id?: string | undefined | null,
	text?: string | undefined | null,
	type?: string | undefined | null
};
	["AgilityCreditApplicantInformation"]: {
		address?: string | undefined | null,
	dob?: string | undefined | null,
	id?: string | undefined | null,
	infiledDate?: string | undefined | null,
	name?: string | undefined | null,
	phone?: string | undefined | null,
	ssn?: string | undefined | null
};
	["AgilityCreditEmployment"]: {
		dateHired?: string | undefined | null,
	dateTerminated?: string | undefined | null,
	employer?: string | undefined | null,
	id?: string | undefined | null,
	income?: string | undefined | null,
	infiledDate?: string | undefined | null,
	lastReportedDate?: string | undefined | null,
	occupation?: string | undefined | null,
	status?: string | undefined | null
};
	["AgilityCreditIdVerification"]: {
		id?: string | undefined | null,
	idCard?: ModelTypes["IdCard"] | undefined | null,
	response?: ModelTypes["JSON"] | undefined | null
};
	["AgilityCreditIdVerificationFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["AgilityCreditInquiry"]: {
		date?: string | undefined | null,
	id?: string | undefined | null,
	industry?: string | undefined | null,
	name?: string | undefined | null,
	subscriberCode?: string | undefined | null
};
	["AgilityCreditPrequalReport"]: {
		accounts?: Array<ModelTypes["AgilityCreditAccount"]> | undefined | null,
	addresses?: Array<ModelTypes["AgilityCreditAddress"]> | undefined | null,
	akas?: Array<ModelTypes["AgilityCreditAka"]> | undefined | null,
	alerts?: Array<ModelTypes["AgilityCreditAlert"]> | undefined | null,
	applicantInformation?: Array<ModelTypes["AgilityCreditApplicantInformation"]> | undefined | null,
	bureau?: ModelTypes["PrequalBureau"] | undefined | null,
	bureauAbbrev?: string | undefined | null,
	collectionsCount?: number | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	creditScores?: Array<ModelTypes["AgilityCreditScore"]> | undefined | null,
	disputedAccountsCount?: number | undefined | null,
	employments?: Array<ModelTypes["AgilityCreditEmployment"]> | undefined | null,
	errorMessage?: string | undefined | null,
	foreclosuresCount?: number | undefined | null,
	hitIndicator?: string | undefined | null,
	inquiries?: Array<ModelTypes["AgilityCreditInquiry"]> | undefined | null,
	inquiriesCount?: number | undefined | null,
	noScoreIndicator?: boolean | undefined | null,
	openCollectionsCount?: number | undefined | null,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "ap_...") */
	pId?: string | undefined | null,
	publicRecords?: Array<ModelTypes["AgilityCreditPublicRecord"]> | undefined | null,
	publicRecordsCount?: number | undefined | null,
	pullType?: ModelTypes["AgilityCreditPullType"] | undefined | null,
	repossessionsCount?: number | undefined | null,
	revolvingCreditUsage?: string | undefined | null,
	stage?: string | undefined | null,
	summaryCategories?: Array<ModelTypes["AgilityCreditSummaryCategory"]> | undefined | null
};
	["AgilityCreditPrequalReportFilter"]: {
	bureau?: ModelTypes["PrequalBureauFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	pId?: ModelTypes["StringFilter"] | undefined | null
};
	["AgilityCreditPublicRecord"]: {
		courtName?: string | undefined | null,
	dischargeDate?: string | undefined | null,
	docket?: string | undefined | null,
	ecoa?: string | undefined | null,
	filedDate?: string | undefined | null,
	id?: string | undefined | null,
	publicRecordType?: string | undefined | null,
	reportedDate?: string | undefined | null,
	status?: string | undefined | null
};
	["AgilityCreditPullType"]:AgilityCreditPullType;
	["AgilityCreditScore"]: {
		factors?: Array<ModelTypes["AgilityCreditScoreFactor"]> | undefined | null,
	id?: string | undefined | null,
	model?: string | undefined | null,
	score?: number | undefined | null
};
	["AgilityCreditScoreFactor"]: {
		factorScore?: string | undefined | null,
	id?: string | undefined | null,
	reason?: string | undefined | null
};
	["AgilityCreditSummaryCategory"]: {
		balance?: number | undefined | null,
	category?: string | undefined | null,
	closed?: number | undefined | null,
	count?: number | undefined | null,
	current?: number | undefined | null,
	days30?: number | undefined | null,
	days60?: number | undefined | null,
	days90?: number | undefined | null,
	id?: string | undefined | null,
	open?: number | undefined | null,
	pastDue?: number | undefined | null,
	payments?: number | undefined | null,
	unrated?: number | undefined | null
};
	["Announcement"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	markdownText?: string | undefined | null
};
	["AnnouncementOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["AssignedStaffOrFilter"]: {
	bdcId?: ModelTypes["IDFilter"] | undefined | null,
	fniManagerId?: ModelTypes["IDFilter"] | undefined | null,
	salesManagerId?: ModelTypes["IDFilter"] | undefined | null,
	salesPersonId?: ModelTypes["IDFilter"] | undefined | null
};
	/** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
["BigInt"]:any;
	["BooleanFilter"]: {
	equals?: boolean | undefined | null,
	not?: ModelTypes["BooleanFilter"] | undefined | null
};
	["CdkDealJacketStatus"]:CdkDealJacketStatus;
	["Chat"]: {
		chatMessages?: ModelTypes["ChatChatMessagesConnection"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	title?: string | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["ChatChatMessagesConnection"]: {
		edges?: Array<ModelTypes["ChatChatMessagesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["ChatChatMessagesConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["ChatMessage"] | undefined | null
};
	["ChatMessage"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	message?: ModelTypes["JSON"] | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["CheckBoxGroup"]: {
		id: string,
	label: string,
	n?: number | undefined | null,
	rule: ModelTypes["CheckBoxGroupRules"]
};
	["CheckBoxGroupRules"]:CheckBoxGroupRules;
	["ComplianceData"]: {
		/** ID Verification status, Not enabled for all dealerships */
	hasRequestedIdv: ModelTypes["ComplianceIdvField"],
	id: ModelTypes["ComplianceField"],
	idQuizSummary: ModelTypes["ComplianceField"],
	ofacStatus: ModelTypes["ComplianceField"],
	recalls: ModelTypes["ComplianceField"],
	redFlagStatus: ModelTypes["ComplianceField"]
};
	["ComplianceField"]: {
		description: string,
	status: ModelTypes["ComplianceStatus"],
	title: string
};
	["ComplianceFormsData"]: {
		/** Whether or not the lending portal can be accessed */
	lendingPortalPreCondition: ModelTypes["ComplianceFormsPreCondition"],
	/** Returns the post-purchase forms that will be requested signed */
	postPurchaseForms?: Array<ModelTypes["Form"]> | undefined | null,
	/** Whether or not the post-purchase forms can be requested */
	postPurchasePreCondition: ModelTypes["ComplianceFormsPreCondition"],
	/** Returns the pre-purchase forms that will be requested signed */
	prePurchaseForms?: Array<ModelTypes["Form"]> | undefined | null,
	prePurchasePreCondition: ModelTypes["ComplianceFormsPreCondition"]
};
	["ComplianceFormsPreCondition"]: {
		errorCodes?: Array<ModelTypes["FormRequestErrorCode"]> | undefined | null,
	result: boolean
};
	["ComplianceIdvField"]: {
		description: string,
	hasIdCard: boolean,
	hasRequestedVerification: boolean,
	latestVerificationId?: string | undefined | null,
	status: ModelTypes["ComplianceStatus"],
	title: string
};
	["ComplianceStatus"]:ComplianceStatus;
	["ContactV2"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	customers?: ModelTypes["ContactV2CustomersConnection"] | undefined | null,
	firstName?: string | undefined | null,
	id: string,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	pId?: string | undefined | null,
	profilePicture?: ModelTypes["File"] | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userId?: string | undefined | null
};
	["ContactV2CustomersConnection"]: {
		edges: Array<ModelTypes["ContactV2CustomersConnectionEdge"]>,
	pageInfo: ModelTypes["PageInfo"]
};
	["ContactV2CustomersConnectionEdge"]: {
		cursor: string,
	node: ModelTypes["Customer"]
};
	["ContactV2Filter"]: {
	pId?: ModelTypes["IDFilter"] | undefined | null,
	userId?: ModelTypes["IDFilter"] | undefined | null
};
	["CreateCustomerInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string
};
	["CreateEmploymentInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus: string,
	incomeAmount?: number | undefined | null,
	incomeInterval?: string | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: string | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition: number
};
	["CreateStaffScheduleEventsInput"]: {
	endAt: string,
	note?: string | undefined | null,
	staffId: string,
	startAt: string,
	weeklyDuplications: number
};
	["CreateUserInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string,
	role: string
};
	["CreditApplicationAddressInformationInput"]: {
	apartmentDetails?: string | undefined | null,
	city: string,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	state: string,
	street: string,
	zipCode: string
};
	["CreditApplicationEmploymentInformationInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus: ModelTypes["EmploymentStatus"],
	incomeAmount?: number | undefined | null,
	incomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null
};
	["CreditApplicationFormSubmissionDataInput"]: {
	addressDuration?: string | undefined | null,
	birthdate?: string | undefined | null,
	city?: string | undefined | null,
	customerName?: string | undefined | null,
	dateTime?: string | undefined | null,
	dealerPrivacyAckTmplId?: string | undefined | null,
	dealershipName?: string | undefined | null,
	deviceId?: string | undefined | null,
	eSignAckTmplId?: string | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: string | undefined | null,
	firstName?: string | undefined | null,
	hcaReportAckTmplId?: string | undefined | null,
	ipAddress?: string | undefined | null,
	jobTitle?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	modificationAckTmplId?: string | undefined | null,
	mortgageOrRentMonthlyPay?: string | undefined | null,
	name?: string | undefined | null,
	otherIncmeSource?: string | undefined | null,
	otherIncomeAmount?: string | undefined | null,
	otherIncomeType?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	prevEmployerInfo?: string | undefined | null,
	previousAddress?: string | undefined | null,
	previousAddressLength?: string | undefined | null,
	refNameAddress?: string | undefined | null,
	refPhoneNumber?: string | undefined | null,
	refRelationship?: string | undefined | null,
	residentialStatus?: string | undefined | null,
	salary?: string | undefined | null,
	signature?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	state?: string | undefined | null,
	streetAddress?: string | undefined | null,
	tdcConsentsAckTmplId?: string | undefined | null,
	timeOnJob?: string | undefined | null,
	type?: string | undefined | null,
	zip?: string | undefined | null
};
	["CreditApplicationFormSubmissionInput"]: {
	submissionData: ModelTypes["CreditApplicationFormSubmissionDataInput"],
	submissionType: string
};
	["CreditApplicationInput"]: {
	birthdate: string,
	currentAddress: ModelTypes["CreditApplicationAddressInformationInput"],
	currentAddressHousingStatus: ModelTypes["HousingStatus"],
	currentAddressMonthlyPayment: number,
	currentEmployment: ModelTypes["CreditApplicationEmploymentInformationInput"],
	dateTime: string,
	dealerPrivacyAckTmplId: string,
	deviceId: string,
	eSignAckTmplId: string,
	email: string,
	firstName: string,
	fullName: string,
	hcaReportAckTmplId: string,
	ipAddress: string,
	lastName: string,
	middleName?: string | undefined | null,
	phoneNumber: string,
	previousAddress?: ModelTypes["CreditApplicationAddressInformationInput"] | undefined | null,
	previousEmployment?: ModelTypes["CreditApplicationEmploymentInformationInput"] | undefined | null,
	signature: string,
	socialSecurityNumber: string,
	tdcConsentsAckTmplId: string
};
	["Customer"]: {
		birthdate?: string | undefined | null,
	compliance: ModelTypes["ComplianceData"],
	contact: ModelTypes["ContactV2"],
	contactAcknowledgement?: ModelTypes["FormSubmission"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	dealership?: ModelTypes["Dealership"] | undefined | null,
	disassociatedRole?: string | undefined | null,
	dob?: string | undefined | null,
	documents?: ModelTypes["CustomerDocumentsConnection"] | undefined | null,
	employments?: ModelTypes["CustomerEmploymentsConnection"] | undefined | null,
	firstName?: string | undefined | null,
	formSubmissions?: ModelTypes["CustomerFormSubmissionsConnection"] | undefined | null,
	hardCreditApplications?: ModelTypes["CustomerHardCreditApplicationsConnection"] | undefined | null,
	hasBeenRemovedFromTransaction?: boolean | undefined | null,
	hasPrequalApplication: boolean,
	hasSubmittedHardCreditApplication: boolean,
	idCards?: Array<ModelTypes["IdCard"]> | undefined | null,
	identityTheftPrevention?: ModelTypes["FormSubmission"] | undefined | null,
	languageSelection: Array<string>,
	lastName?: string | undefined | null,
	lastRequestedPrescreenAt?: ModelTypes["DateTime"] | undefined | null,
	livelinessSession?: ModelTypes["CustomerLivelinessSessionConnection"] | undefined | null,
	middleName?: string | undefined | null,
	/** Returns an entity that explains the next document to sign ordered in signing order */
	nextDocumentsToSign?: ModelTypes["CustomerNextDocumentsToSignConnection"] | undefined | null,
	onboardingStep: ModelTypes["OnboardingStep"],
	prequalApplications?: ModelTypes["CustomerPrequalApplicationsConnection"] | undefined | null,
	prescreens?: ModelTypes["CustomerPrescreensConnection"] | undefined | null,
	privacyPolicy?: ModelTypes["FormSubmission"] | undefined | null,
	residentialAddresses?: ModelTypes["CustomerResidentialAddressesConnection"] | undefined | null,
	selfieCapture?: ModelTypes["File"] | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	testDriveDisclosure?: ModelTypes["FormSubmission"] | undefined | null,
	transaction?: ModelTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	vehicleRegistrationAddress?: ModelTypes["Address"] | undefined | null,
	vehicleRegistrationAddressId?: string | undefined | null
};
	["CustomerDocumentsConnection"]: {
		edges?: Array<ModelTypes["CustomerDocumentsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["CustomerDocumentsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Document"] | undefined | null
};
	["CustomerEmploymentsConnection"]: {
		edges?: Array<ModelTypes["CustomerEmploymentsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["CustomerEmploymentsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Employment"] | undefined | null
};
	["CustomerFilter"]: {
	transactionId?: ModelTypes["IDFilter"] | undefined | null
};
	["CustomerFormSubmissionsConnection"]: {
		edges?: Array<ModelTypes["CustomerFormSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["CustomerFormSubmissionsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["FormSubmission"] | undefined | null
};
	["CustomerHardCreditApplicationsConnection"]: {
		edges?: Array<ModelTypes["CustomerHardCreditApplicationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["CustomerHardCreditApplicationsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["HardCreditApplication"] | undefined | null
};
	["CustomerLivelinessSessionConnection"]: {
		edges?: Array<ModelTypes["CustomerLivelinessSessionConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["CustomerLivelinessSessionConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["LivelinessSession"] | undefined | null
};
	["CustomerNextDocumentsToSignConnection"]: {
		edges?: Array<ModelTypes["CustomerNextDocumentsToSignConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["CustomerNextDocumentsToSignConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["FormSubmission"] | undefined | null
};
	["CustomerPrequalApplicationsConnection"]: {
		edges?: Array<ModelTypes["CustomerPrequalApplicationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["CustomerPrequalApplicationsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["PrequalApplication"] | undefined | null
};
	["CustomerPrescreensConnection"]: {
		edges?: Array<ModelTypes["CustomerPrescreensConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["CustomerPrescreensConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Prescreen"] | undefined | null
};
	["CustomerPurchaseVehicleInput"]: {
	lifeCycleStage: ModelTypes["VehicleLifeCycleStage"],
	make: string,
	mileage: number,
	model: string,
	principalPriorUse?: ModelTypes["VehiclePrincipalPriorUse"] | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin: string,
	year: string
};
	["CustomerResidentialAddressesConnection"]: {
		edges?: Array<ModelTypes["CustomerResidentialAddressesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["CustomerResidentialAddressesConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Address"] | undefined | null
};
	["CustomerSharedData"]: {
		buyerEmail?: string | undefined | null,
	buyerFirstName?: string | undefined | null,
	buyerLastName?: string | undefined | null,
	buyerName?: string | undefined | null,
	buyerOnboardingStep?: ModelTypes["OnboardingStep"] | undefined | null,
	buyerPhoneNumber?: string | undefined | null,
	coBuyerEmail?: string | undefined | null,
	coBuyerFirstName?: string | undefined | null,
	coBuyerLastName?: string | undefined | null,
	coBuyerName?: string | undefined | null,
	coBuyerOnboardingStep?: ModelTypes["OnboardingStep"] | undefined | null,
	coBuyerPhoneNumber?: string | undefined | null
};
	["CustomerSignupInput"]: {
	email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string
};
	["CustomerTradeVehicleInput"]: {
	bodyType: ModelTypes["VehicleBodyType"],
	color: string,
	condition: ModelTypes["VehicleCondition"],
	make: string,
	mileage: number,
	model: string,
	pictureBackId?: string | undefined | null,
	pictureFrontId?: string | undefined | null,
	pictureInteriorId?: string | undefined | null,
	pictureLeftSideId?: string | undefined | null,
	pictureOdometerId?: string | undefined | null,
	pictureRightSideId?: string | undefined | null,
	pictureVinNumberId?: string | undefined | null,
	registrationCardId?: string | undefined | null,
	registrationName: string,
	registrationState: string,
	vin: string,
	year: string
};
	["CustomerTransactionRole"]:CustomerTransactionRole;
	/** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["Date"]:any;
	/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["DateTime"]:any;
	["DateTimeFilter"]: {
	equals?: ModelTypes["DateTime"] | undefined | null,
	gt?: ModelTypes["DateTime"] | undefined | null,
	gte?: ModelTypes["DateTime"] | undefined | null,
	in?: Array<ModelTypes["DateTime"]> | undefined | null,
	lt?: ModelTypes["DateTime"] | undefined | null,
	lte?: ModelTypes["DateTime"] | undefined | null,
	not?: ModelTypes["DateTimeFilter"] | undefined | null
};
	["Dealership"]: {
		address: string,
	contacts: ModelTypes["DealershipContactsConnection"],
	dealershipGroupId?: string | undefined | null,
	enabledPolicyLayers?: Array<ModelTypes["PolicyLayerType"]> | undefined | null,
	forms?: ModelTypes["DealershipFormsConnection"] | undefined | null,
	hasActiveAgilityCreditSubscription?: boolean | undefined | null,
	hasEnabledAuthenticom?: boolean | undefined | null,
	hasEnabledCdkCrm?: boolean | undefined | null,
	hasEnabledCdkDms?: boolean | undefined | null,
	hasEnabledChatBot?: boolean | undefined | null,
	hasEnabledComplianceForms?: boolean | undefined | null,
	hasEnabledDealJacketGalleryView?: boolean | undefined | null,
	hasEnabledDealerTrack?: boolean | undefined | null,
	hasEnabledDriversLicenseVerification?: boolean | undefined | null,
	hasEnabledFormsCatalog?: boolean | undefined | null,
	hasEnabledIdVerifOverAgility?: boolean | undefined | null,
	hasEnabledImplicitPrequalsOnHca?: boolean | undefined | null,
	hasEnabledPostPurchaseDocs?: boolean | undefined | null,
	hasEnabledPrequalFormService?: boolean | undefined | null,
	hasEnabledPrescreen?: boolean | undefined | null,
	hasEnabledRecallMasters?: boolean | undefined | null,
	hasEnabledReferrals?: boolean | undefined | null,
	hasEnabledReportingDashboard?: boolean | undefined | null,
	hasEnabledRoute1?: boolean | undefined | null,
	hasEnabledStaffAcknowledgement?: boolean | undefined | null,
	hasEnabledStaffPlanning?: boolean | undefined | null,
	hasEnabledZipCodeOnSignUp?: boolean | undefined | null,
	/** Whether or not the dealership has a TDC CDK app subscription ID set. */
	hasTdcCdkAppSubscriptionId?: boolean | undefined | null,
	homenetVehicles?: ModelTypes["DealershipHomenetVehiclesConnection"] | undefined | null,
	id: string,
	logoUrl?: string | undefined | null,
	name: string,
	phone: string,
	postPurchaseBillOfSaleFormId?: string | undefined | null,
	postPurchasePurchaseOrderFormId?: string | undefined | null,
	recallDetailsFormId?: string | undefined | null,
	recallSummaryFormId?: string | undefined | null,
	/** Only applicable when the feature is enabled. See hasEnabledReferrals */
	referralPayoutAmountInUsdCents?: number | undefined | null,
	/** The sales people of a dealership needs to be presented on the signup page */
	salesPeople?: Array<ModelTypes["ListItem"]> | undefined | null,
	slug: string,
	staff?: ModelTypes["DealershipStaffConnection"] | undefined | null,
	supportedLanguages?: Array<string> | undefined | null,
	timeZone?: string | undefined | null,
	transactionStatusUpdateDealershipAnalyticsCount?: number | undefined | null,
	transactionUpdateDealershipSpotCount?: number | undefined | null,
	transactionUpdateStatusSalesRankingGrouped?: Array<ModelTypes["SalesRankingGrouppedByMonth"]> | undefined | null,
	transactions?: ModelTypes["DealershipTransactionsConnection"] | undefined | null,
	users?: ModelTypes["DealershipUsersConnection"] | undefined | null,
	website?: string | undefined | null
};
	["DealershipContactsConnection"]: {
		edges: Array<ModelTypes["DealershipContactsConnectionEdge"]>,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["DealershipContactsConnectionEdge"]: {
		cursor: string,
	node: ModelTypes["ContactV2"]
};
	["DealershipFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null,
	slug?: ModelTypes["IDFilter"] | undefined | null
};
	["DealershipFormsConnection"]: {
		edges?: Array<ModelTypes["DealershipFormsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["DealershipFormsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Form"] | undefined | null
};
	["DealershipGroup"]: {
		address?: string | undefined | null,
	id?: string | undefined | null,
	name?: string | undefined | null,
	phoneNumber?: string | undefined | null
};
	["DealershipHomenetVehiclesConnection"]: {
		edges?: Array<ModelTypes["DealershipHomenetVehiclesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["DealershipHomenetVehiclesConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["HomenetVehicleData"] | undefined | null
};
	["DealershipPermType"]: {
		dealershipGroupId?: string | undefined | null,
	dealershipGroupName?: string | undefined | null,
	dealershipId: string,
	dealershipName: string,
	extraPermissions?: Array<ModelTypes["Permission"]> | undefined | null,
	groupRole?: ModelTypes["Role"] | undefined | null,
	role?: ModelTypes["Role"] | undefined | null
};
	["DealershipPurchaseVehicleInput"]: {
	bodyType?: ModelTypes["VehicleBodyType"] | undefined | null,
	lifeCycleStage: ModelTypes["VehicleLifeCycleStage"],
	make: string,
	mileage: number,
	model: string,
	msrp?: number | undefined | null,
	principalPriorUse?: ModelTypes["VehiclePrincipalPriorUse"] | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin: string,
	year: string
};
	["DealershipStaffConnection"]: {
		edges?: Array<ModelTypes["DealershipStaffConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["DealershipStaffConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Staff"] | undefined | null
};
	["DealershipTradeVehicleInput"]: {
	bodyType: ModelTypes["VehicleBodyType"],
	color: string,
	condition: ModelTypes["VehicleCondition"],
	lifeCycleStage?: ModelTypes["VehicleLifeCycleStage"] | undefined | null,
	make: string,
	mileage: number,
	model: string,
	registrationName: string,
	registrationState?: string | undefined | null,
	vin: string,
	year: string
};
	["DealershipTransactionsConnection"]: {
		edges?: Array<ModelTypes["DealershipTransactionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["DealershipTransactionsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Transaction"] | undefined | null
};
	["DealershipUsersConnection"]: {
		edges?: Array<ModelTypes["DealershipUsersConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["DealershipUsersConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["UserDealership"] | undefined | null
};
	["Document"]: {
		access?: string | undefined | null,
	cdkDealJacketStatus?: ModelTypes["CdkDealJacketStatus"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	customer?: ModelTypes["Customer"] | undefined | null,
	file?: ModelTypes["File"] | undefined | null,
	id: string,
	labels?: Array<ModelTypes["DocumentLabelAttachment"]> | undefined | null,
	pdfIsEncrypted?: boolean | undefined | null,
	title?: string | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null
};
	["DocumentLabel"]: {
		code?: string | undefined | null,
	id: string,
	label: string
};
	["DocumentLabelAttachment"]: {
		documentLabel: ModelTypes["DocumentLabel"],
	isActive: boolean
};
	["DocumentLabelOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["DocumentOr"]: {
	access?: ModelTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	dealershipReadAccess?: ModelTypes["RoleListFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	userId?: ModelTypes["IDFilter"] | undefined | null
};
	["DocumentOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["Employment"]: {
		customer?: ModelTypes["Customer"] | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: ModelTypes["EmploymentStatus"] | undefined | null,
	id?: string | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition?: number | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null
};
	["EmploymentStatus"]:EmploymentStatus;
	/** A frequently asked question with its answer. FAQs can be scoped to a specific dealership, a dealership group, or global (visible to all authenticated users). */
["Faq"]: {
		/** The answer text. */
	answer?: string | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	/** If set, this FAQ belongs to a dealership group and is visible to all dealerships in that group. */
	dealershipGroupId?: string | undefined | null,
	/** If set, this FAQ belongs to a specific dealership and is only visible to users of that dealership. */
	dealershipId?: string | undefined | null,
	/** Unique identifier for this FAQ. */
	id?: string | undefined | null,
	/** The question text. */
	question?: string | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["FieldOrdering"]:FieldOrdering;
	["File"]: {
		id?: string | undefined | null,
	uploader?: ModelTypes["User"] | undefined | null,
	url?: string | undefined | null
};
	["FinanceType"]:FinanceType;
	["FinanceTypeFilter"]: {
	equals?: ModelTypes["FinanceType"] | undefined | null,
	in?: Array<ModelTypes["FinanceType"]> | undefined | null,
	not?: ModelTypes["FinanceTypeFilter"] | undefined | null
};
	["Form"]: {
		createdAt: ModelTypes["DateTime"],
	displayTitle: string,
	formFields: Array<ModelTypes["FormField"]>,
	formOrder?: ModelTypes["FormOrder"] | undefined | null,
	id: string,
	pdfFileUrl?: string | undefined | null
};
	["FormCollectionStatus"]:FormCollectionStatus;
	["FormCollectionStatusFilter"]: {
	equals?: ModelTypes["FormCollectionStatus"] | undefined | null,
	in?: Array<ModelTypes["FormCollectionStatus"]> | undefined | null,
	not?: ModelTypes["FormCollectionStatusFilter"] | undefined | null,
	notIn?: Array<ModelTypes["FormCollectionStatus"]> | undefined | null
};
	["FormCollectionType"]:FormCollectionType;
	["FormCollectionTypeFilter"]: {
	equals?: ModelTypes["FormCollectionType"] | undefined | null,
	in?: Array<ModelTypes["FormCollectionType"]> | undefined | null,
	not?: ModelTypes["FormCollectionTypeFilter"] | undefined | null,
	notIn?: Array<ModelTypes["FormCollectionType"]> | undefined | null
};
	["FormField"]: {
		characterListLength?: number | undefined | null,
	checkboxGroup?: ModelTypes["CheckBoxGroup"] | undefined | null,
	createdAt: ModelTypes["DateTime"],
	demoData?: string | undefined | null,
	enteredBy?: Array<ModelTypes["TransactionRole"]> | undefined | null,
	fixedValue?: string | undefined | null,
	form: ModelTypes["Form"],
	formFieldId: string,
	formFieldPlacements: Array<ModelTypes["FormFieldPlacement"]>,
	formId: string,
	id: string,
	isAdminAllowed: boolean,
	isOptional: boolean,
	prefillPath?: string | undefined | null,
	type: ModelTypes["FormFieldType"]
};
	["FormFieldFilter"]: {
	isAdminAllowed?: ModelTypes["BooleanFilter"] | undefined | null,
	prefillPath?: string | undefined | null
};
	["FormFieldPlacement"]: {
		characterListSpacing?: number | undefined | null,
	createdAt: ModelTypes["DateTime"],
	formField: ModelTypes["FormField"],
	formFieldId: string,
	formFieldPlacementId: string,
	height: number,
	id: string,
	page: number,
	positionX: number,
	positionY: number,
	textAlignment?: ModelTypes["TextAlignment"] | undefined | null,
	textBold: boolean,
	textFontSize?: number | undefined | null,
	textItalic: boolean,
	textLineHeight?: number | undefined | null,
	textUnderline: boolean,
	width: number
};
	["FormFieldSubmission"]: {
		field?: ModelTypes["FormField"] | undefined | null,
	fieldId?: ModelTypes["ID"] | undefined | null,
	file?: ModelTypes["File"] | undefined | null,
	formSubmission?: ModelTypes["FormSubmission"] | undefined | null,
	value?: string | undefined | null
};
	["FormFieldSubmissionAllowedUserFilter"]: {
	userId?: ModelTypes["IDFilter"] | undefined | null
};
	["FormFieldSubmissionAllowedUserListFilter"]: {
	some?: ModelTypes["FormFieldSubmissionAllowedUserFilter"] | undefined | null
};
	["FormFieldSubmissionFilter"]: {
	OR?: Array<ModelTypes["FormFieldSubmissionOrFilter"]> | undefined | null,
	allowedUsers?: ModelTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null,
	field?: ModelTypes["FormFieldFilter"] | undefined | null,
	fileId?: ModelTypes["IDFilter"] | undefined | null,
	formSubmissionId?: ModelTypes["IDFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	value?: ModelTypes["StringFilter"] | undefined | null
};
	["FormFieldSubmissionOrFilter"]: {
	allowedUsers?: ModelTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null,
	field?: ModelTypes["FormFieldFilter"] | undefined | null
};
	["FormFieldSubmissionOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["FormFieldType"]:FormFieldType;
	["FormFieldValue"]: {
	fileId?: string | undefined | null,
	submissionFieldId: string,
	value?: string | undefined | null
};
	["FormOrder"]: {
		position?: number | undefined | null
};
	["FormRequestErrorCode"]:FormRequestErrorCode;
	["FormSubmission"]: {
		access?: string | undefined | null,
	cdkDealJacketStatus?: ModelTypes["CdkDealJacketStatus"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	customer: ModelTypes["Customer"],
	file?: ModelTypes["File"] | undefined | null,
	fileId?: string | undefined | null,
	form?: ModelTypes["Form"] | undefined | null,
	formCollection?: ModelTypes["FormSubmissionCollection"] | undefined | null,
	formFieldSubmissions?: ModelTypes["FormSubmissionFormFieldSubmissionsConnection"] | undefined | null,
	formSubmissionData?: string | undefined | null,
	id: string,
	status?: string | undefined | null,
	type?: string | undefined | null,
	userId?: string | undefined | null
};
	["FormSubmissionAccessEmum"]:FormSubmissionAccessEmum;
	/** If the user filters in elements it can not access, it will fail */
["FormSubmissionAccessEmumFilter"]: {
	equals?: ModelTypes["FormSubmissionAccessEmum"] | undefined | null,
	in?: Array<ModelTypes["FormSubmissionAccessEmum"]> | undefined | null,
	not?: ModelTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	notIn?: Array<ModelTypes["FormSubmissionAccessEmum"]> | undefined | null
};
	["FormSubmissionCollection"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	formSubmissions?: ModelTypes["FormSubmissionCollectionFormSubmissionsConnection"] | undefined | null,
	id?: string | undefined | null,
	isCollectionStale: boolean,
	status?: ModelTypes["FormCollectionStatus"] | undefined | null,
	type?: ModelTypes["FormCollectionType"] | undefined | null
};
	["FormSubmissionCollectionFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null,
	status?: ModelTypes["FormCollectionStatusFilter"] | undefined | null,
	type?: ModelTypes["FormCollectionTypeFilter"] | undefined | null
};
	["FormSubmissionCollectionFormSubmissionsConnection"]: {
		edges?: Array<ModelTypes["FormSubmissionCollectionFormSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["FormSubmissionCollectionFormSubmissionsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["FormSubmission"] | undefined | null
};
	["FormSubmissionCollectionOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["FormSubmissionFilter"]: {
	access?: ModelTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	status?: ModelTypes["FormSubmissionStatusFilter"] | undefined | null,
	type?: ModelTypes["FormSubmissionTypeFilter"] | undefined | null,
	userId?: ModelTypes["IDFilter"] | undefined | null
};
	["FormSubmissionFormFieldSubmissionsConnection"]: {
		edges?: Array<ModelTypes["FormSubmissionFormFieldSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["FormSubmissionFormFieldSubmissionsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["FormFieldSubmission"] | undefined | null
};
	["FormSubmissionStatus"]:FormSubmissionStatus;
	["FormSubmissionStatusFilter"]: {
	equals?: ModelTypes["FormSubmissionStatus"] | undefined | null,
	not?: ModelTypes["FormSubmissionStatusFilter"] | undefined | null,
	notIn?: Array<ModelTypes["FormSubmissionStatus"]> | undefined | null
};
	["FormSubmissionType"]:FormSubmissionType;
	["FormSubmissionTypeFilter"]: {
	equals?: ModelTypes["FormSubmissionType"] | undefined | null,
	in?: Array<ModelTypes["FormSubmissionType"]> | undefined | null,
	not?: ModelTypes["FormSubmissionTypeFilter"] | undefined | null
};
	["GraphQLError"]: {
		message?: string | undefined | null
};
	["HardCreditApplication"]: {
		createdAt: ModelTypes["DateTime"],
	dob?: ModelTypes["Date"] | undefined | null,
	driversLicenseNumber?: string | undefined | null,
	driversLicenseState?: string | undefined | null,
	email?: string | undefined | null,
	employments?: ModelTypes["JSON"] | undefined | null,
	firstName?: string | undefined | null,
	formSubmission?: ModelTypes["FormSubmission"] | undefined | null,
	formSubmissionId?: string | undefined | null,
	homePhoneNumber?: string | undefined | null,
	housingCostUsdCents?: ModelTypes["BigInt"] | undefined | null,
	id?: string | undefined | null,
	incomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	incomeUsdCents?: ModelTypes["BigInt"] | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	personalReferenceAddress?: ModelTypes["Address"] | undefined | null,
	personalReferenceAddressId?: string | undefined | null,
	personalReferenceFirstName?: string | undefined | null,
	personalReferenceLastName?: string | undefined | null,
	personalReferenceMiddleName?: string | undefined | null,
	personalReferencePhoneNumber?: string | undefined | null,
	personalReferenceRelationship?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	residentialAddresses?: ModelTypes["JSON"] | undefined | null,
	/** Full SSN for the data owner, masked (last 4 only) for others */
	socialSecurityNumber?: string | undefined | null,
	transaction?: ModelTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userId?: string | undefined | null
};
	["HardCreditApplicationFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["HardCreditApplicationOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["HomenetVehicleData"]: {
		bodyType?: string | undefined | null,
	color?: string | undefined | null,
	dealerId?: string | undefined | null,
	fuelType?: string | undefined | null,
	id?: string | undefined | null,
	locationId?: string | undefined | null,
	make?: string | undefined | null,
	mileage?: string | undefined | null,
	model?: string | undefined | null,
	msrp?: string | undefined | null,
	rooftopId?: string | undefined | null,
	stockNumber?: string | undefined | null,
	transmission?: string | undefined | null,
	trim?: string | undefined | null,
	type?: string | undefined | null,
	vehicleId?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["HomenetVehicleDataFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["HousingStatus"]:HousingStatus;
	["IDFilter"]: {
	equals?: string | undefined | null,
	in?: Array<string> | undefined | null,
	not?: ModelTypes["IDFilter"] | undefined | null
};
	["IdCard"]: {
		captureBack?: ModelTypes["File"] | undefined | null,
	captureBackId?: string | undefined | null,
	captureBackRotation: ModelTypes["ImageRotation"],
	captureFront?: ModelTypes["File"] | undefined | null,
	captureFrontId?: string | undefined | null,
	captureFrontRotation: ModelTypes["ImageRotation"],
	cityInAddress?: string | undefined | null,
	class?: string | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	dob?: ModelTypes["DateTime"] | undefined | null,
	dobDateOnly?: ModelTypes["Date"] | undefined | null,
	expirationDate?: ModelTypes["DateTime"] | undefined | null,
	expirationDateOnly?: ModelTypes["Date"] | undefined | null,
	eyeColor?: string | undefined | null,
	firstName?: string | undefined | null,
	height?: string | undefined | null,
	id?: string | undefined | null,
	idNumber?: string | undefined | null,
	issueDate?: ModelTypes["DateTime"] | undefined | null,
	issueDateOnly?: ModelTypes["Date"] | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	requestedIdVerificationAt?: ModelTypes["DateTime"] | undefined | null,
	sex?: string | undefined | null,
	state?: string | undefined | null,
	stateInAddress?: string | undefined | null,
	streetInAddress?: string | undefined | null,
	suffix?: string | undefined | null,
	transactionId?: string | undefined | null,
	type?: string | undefined | null,
	userId?: string | undefined | null,
	zipCodeInAddress?: string | undefined | null
};
	["IdCardType"]:IdCardType;
	["ImageRotation"]:ImageRotation;
	["IncomeInterval"]:IncomeInterval;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]:any;
	["LenderHardCreditApplication"]: {
		buyerHousingCostCents?: ModelTypes["BigInt"] | undefined | null,
	buyerIncomeCents?: ModelTypes["BigInt"] | undefined | null,
	buyerIncomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	coBuyerHousingCostCents?: ModelTypes["BigInt"] | undefined | null,
	coBuyerIncomeCents?: ModelTypes["BigInt"] | undefined | null,
	coBuyerIncomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	transactionId?: string | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["LenderHardCreditApplicationOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["LendingPortalAddressEntryInput"]: {
	apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	housingStatus?: ModelTypes["HousingStatus"] | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition: number,
	zipCode?: string | undefined | null
};
	["LendingPortalCustomerDataInput"]: {
	dob?: ModelTypes["DateTime"] | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null
};
	["LendingPortalEmploymentEntryInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: ModelTypes["EmploymentStatus"] | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: ModelTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition: number
};
	["LendingPortalPurchaseVehicleDataInput"]: {
	color?: string | undefined | null,
	lifeCycleStage?: ModelTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["LendingPortalTradeVehicleDataInput"]: {
	color?: string | undefined | null,
	lifeCycleStage?: ModelTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["LicensePrefillData"]: {
		make?: string | undefined | null,
	model?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["ListItem"]: {
		label?: string | undefined | null,
	value?: string | undefined | null
};
	["LivelinessSession"]: {
		auditImages?: Array<ModelTypes["File"]> | undefined | null,
	awsLivelinessSessionId?: string | undefined | null,
	confidence?: number | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	dealership?: ModelTypes["Dealership"] | undefined | null,
	dealershipId?: string | undefined | null,
	id?: string | undefined | null,
	referenceImage?: ModelTypes["File"] | undefined | null,
	status?: string | undefined | null,
	transaction?: ModelTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	upddatedAt?: ModelTypes["DateTime"] | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userId?: string | undefined | null
};
	["LivelinessSessionFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["LoginOptionType"]:LoginOptionType;
	["LoginResponse"]: {
		jwt?: string | undefined | null
};
	["MakeFileUploadForScannerType"]: {
		fileId?: string | undefined | null,
	uploadUrl?: string | undefined | null
};
	["MakeFileUploadType"]: {
		file?: ModelTypes["File"] | undefined | null,
	fileId?: string | undefined | null,
	uploadUrl?: string | undefined | null
};
	["MeType"]: {
		chats?: ModelTypes["MeTypeChatsConnection"] | undefined | null,
	dealershipGroup?: Array<ModelTypes["DealershipGroup"]> | undefined | null,
	dealerships?: Array<ModelTypes["Dealership"]> | undefined | null,
	ipAddress?: string | undefined | null,
	/** List of dealerships the user has access to and is a staff at */
	staffAt?: Array<ModelTypes["DealershipPermType"]> | undefined | null,
	user?: ModelTypes["User"] | undefined | null
};
	["MeTypeChatsConnection"]: {
		edges?: Array<ModelTypes["MeTypeChatsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["MeTypeChatsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Chat"] | undefined | null
};
	["Mutation"]: {
		/** Upload scanned document using scann to Deal Jacket */
	addScanToDealerJacket?: ModelTypes["MutationAddScanToDealerJacketResult"] | undefined | null,
	/** Upload scanned document using scan to Glove Compartment */
	addScanToGloveCompartments?: ModelTypes["MutationAddScanToGloveCompartmentsResult"] | undefined | null,
	assignStaffToTransaction?: ModelTypes["MutationAssignStaffToTransactionResult"] | undefined | null,
	/** Cancel a form collection */
	cancelFormCollection?: ModelTypes["MutationCancelFormCollectionResult"] | undefined | null,
	/** Cancels previously requested forms and regenerates a new set of forms */
	cancelPreviousAndRequestSignatures?: ModelTypes["MutationCancelPreviousAndRequestSignaturesResult"] | undefined | null,
	/** Change document access */
	changeDocumentAccess?: ModelTypes["MutationChangeDocumentAccessResult"] | undefined | null,
	/** Change form submission access */
	changeFormSubmissionAccess?: ModelTypes["MutationChangeFormSubmissionAccessResult"] | undefined | null,
	/** Creates and submits a credit application and prequal if necessary */
	createAndSubmitCreditAndPrequalApplication?: ModelTypes["MutationCreateAndSubmitCreditAndPrequalApplicationResult"] | undefined | null,
	/** Create a new chat for a user */
	createChat?: ModelTypes["MutationCreateChatResult"] | undefined | null,
	/** Create a co-buyer and add it to the transaction */
	createCoBuyer?: ModelTypes["MutationCreateCoBuyerResult"] | undefined | null,
	/** Creates a user, submits a Prequal, and creates a HCA */
	createCreditApplicationAndCreateUser?: ModelTypes["MutationCreateCreditApplicationAndCreateUserResult"] | undefined | null,
	/** Create an employment for a user */
	createEmployment?: ModelTypes["MutationCreateEmploymentResult"] | undefined | null,
	/** Create a new group level staff based on existing dealership user */
	createGroupuser?: ModelTypes["MutationCreateGroupuserResult"] | undefined | null,
	/** Create a new chat for a user */
	createMessage?: ModelTypes["MutationCreateMessageResult"] | undefined | null,
	/** Create a new staff */
	createStaff?: ModelTypes["MutationCreateStaffResult"] | undefined | null,
	/** Create one or more schedule events for a staff member (optionally duplicated across N weeks). */
	createStaffScheduleEvents?: ModelTypes["MutationCreateStaffScheduleEventsResult"] | undefined | null,
	/** Submit a test drive request */
	createTransactionAndSubmitTestDrive?: ModelTypes["MutationCreateTransactionAndSubmitTestDriveResult"] | undefined | null,
	/** Submit feedback or a bug report from the dealership dashboard */
	createUserFeedback?: ModelTypes["MutationCreateUserFeedbackResult"] | undefined | null,
	/** Creates new transaction for the logged-in customer at the given dealership, using their existing contact info as prefill */
	customerCreatePrefilledTransaction?: ModelTypes["MutationCustomerCreatePrefilledTransactionResult"] | undefined | null,
	/** Create a purchase vehicle for a transaction as a customer */
	customerCreatePurchaseVehicle?: ModelTypes["MutationCustomerCreatePurchaseVehicleResult"] | undefined | null,
	/** Create a trade vehicle for a transaction as a customer */
	customerCreateTradeVehicle?: ModelTypes["MutationCustomerCreateTradeVehicleResult"] | undefined | null,
	/** Create a transaction and sets the logged in user as the buyer. Meant to be used for customers */
	customerCreateTransaction?: ModelTypes["MutationCustomerCreateTransactionResult"] | undefined | null,
	/** Create a transaction and user without authenticated email and phone number */
	customerCreateUnauthenticatedTransaction?: ModelTypes["MutationCustomerCreateUnauthenticatedTransactionResult"] | undefined | null,
	/** Record consent based on phone number and email */
	customerReferral?: ModelTypes["MutationCustomerReferralResult"] | undefined | null,
	/** Record a payment on a referral */
	customerReferralPaid?: ModelTypes["MutationCustomerReferralPaidResult"] | undefined | null,
	/** Signs up a new customer that is signed in with cognito */
	customerSignupWithCognito?: ModelTypes["MutationCustomerSignupWithCognitoResult"] | undefined | null,
	/** Update phone number for logged in user */
	customerUpdatePhoneNumber?: ModelTypes["MutationCustomerUpdatePhoneNumberResult"] | undefined | null,
	/** Update the purchase vehicle on the transaction as a customer */
	customerUpdatePurchaseVehicle?: ModelTypes["MutationCustomerUpdatePurchaseVehicleResult"] | undefined | null,
	/** Update a trade vehicle for a transaction as a customer */
	customerUpdateTradeVehicle?: ModelTypes["MutationCustomerUpdateTradeVehicleResult"] | undefined | null,
	/** Create a purchase vehicle for a transaction as a dealership staff member */
	dealershipCreatePurchaseVehicle?: ModelTypes["MutationDealershipCreatePurchaseVehicleResult"] | undefined | null,
	/** Create a trade vehicle for a transaction as a dealership staff member */
	dealershipCreateTradeVehicle?: ModelTypes["MutationDealershipCreateTradeVehicleResult"] | undefined | null,
	/** Create a basic transaction for a dealership returning the ID of the new transaction */
	dealershipCreateTransaction?: ModelTypes["MutationDealershipCreateTransactionResult"] | undefined | null,
	/** Remove a trade vehicle from a transaction as a dealership staff member */
	dealershipRemoveTradeVehicle?: ModelTypes["MutationDealershipRemoveTradeVehicleResult"] | undefined | null,
	/** Update the purchase vehicle on the transaction as a dealership staff member */
	dealershipUpdatePurchaseVehicle?: ModelTypes["MutationDealershipUpdatePurchaseVehicleResult"] | undefined | null,
	/** Update a trade vehicle for a transaction as a dealership staff member */
	dealershipUpdateTradeVehicle?: ModelTypes["MutationDealershipUpdateTradeVehicleResult"] | undefined | null,
	/** Delete a single schedule event. */
	deleteStaffScheduleEvent?: ModelTypes["MutationDeleteStaffScheduleEventResult"] | undefined | null,
	/** Dismiss notifications */
	dismissNotifications?: ModelTypes["MutationDismissNotificationsResult"] | undefined | null,
	/** Dispatch async job to extract vehicle information from a registration PDF and add it to the deal jacket. */
	extractVehicleFromRegistration?: ModelTypes["MutationExtractVehicleFromRegistrationResult"] | undefined | null,
	/** Finalize a liveness session, and return ID as acknowledgement */
	finalizeLivenessAnalysis?: ModelTypes["MutationFinalizeLivenessAnalysisResult"] | undefined | null,
	login?: ModelTypes["MutationLoginResult"] | undefined | null,
	/** Log a user out by deleting the auth cookie */
	logout?: ModelTypes["MutationLogoutResult"] | undefined | null,
	/** Make a submission token that is valid for 5 requsts in 30 minutes */
	makeSubmissionToken?: ModelTypes["MutationMakeSubmissionTokenResult"] | undefined | null,
	/** Generic file upload for self-upload */
	makeUpload?: ModelTypes["MutationMakeUploadResult"] | undefined | null,
	/** Provision PDF file for scanner upload using submissionToken */
	makeUploadForScanner?: ModelTypes["MutationMakeUploadForScannerResult"] | undefined | null,
	/** Dashboard function to upload file to a transaction */
	makeUploadToTransaction?: ModelTypes["MutationMakeUploadToTransactionResult"] | undefined | null,
	/** Manually mark a transaction as delivered when post-purchase docs are disabled */
	markTransactionAsDelivered?: ModelTypes["MutationMarkTransactionAsDeliveredResult"] | undefined | null,
	/** Modify an existing hard credit application by submitting a new one after address and employment data have been updated */
	modifyHardCreditApplication?: ModelTypes["MutationModifyHardCreditApplicationResult"] | undefined | null,
	/** Submit step 1 of the onboarding process */
	onboardingSubmitStep1?: ModelTypes["MutationOnboardingSubmitStep1Result"] | undefined | null,
	/** Submit step 1 of the onboarding process */
	onboardingSubmitStep2?: ModelTypes["MutationOnboardingSubmitStep2Result"] | undefined | null,
	/** Override a todo by checking received todo id against the OverridableTodos */
	overrideTodo?: ModelTypes["MutationOverrideTodoResult"] | undefined | null,
	/** Test if a user has given proper consent to TDC_CONSENTS which is needed to login and informs about login options */
	preLoginCheck?: ModelTypes["MutationPreLoginCheckResult"] | undefined | null,
	/** Prefill vehicle data using license plate or vin number */
	prefillLicensePlateOrVin?: ModelTypes["MutationPrefillLicensePlateOrVinResult"] | undefined | null,
	/** Manually push existing transaction data to CRMs */
	pushDataToCrms?: ModelTypes["MutationPushDataToCrmsResult"] | undefined | null,
	/** Push a file (PDF) to the CDK Deal Jacket of the dealership */
	pushDocumentToCdkDealJacket?: ModelTypes["MutationPushDocumentToCdkDealJacketResult"] | undefined | null,
	/** Push documents to the CDK Deal Jacket of the dealership */
	pushDocumentsToCdk?: ModelTypes["MutationPushDocumentsToCdkResult"] | undefined | null,
	/** Push form submissions to the CDK Deal Jacket of the dealership */
	pushFormSubmissionsToCdk?: ModelTypes["MutationPushFormSubmissionsToCdkResult"] | undefined | null,
	/** Push hard credit application to third party. */
	pushHardCreditApplication?: ModelTypes["MutationPushHardCreditApplicationResult"] | undefined | null,
	/** Record consent based on phone number and email */
	recordConsent?: ModelTypes["MutationRecordConsentResult"] | undefined | null,
	/** Remove the co-buyer from a transaction. After the disassociation, the customer isn't deleted but marked as removed. */
	removeCoBuyer?: ModelTypes["MutationRemoveCoBuyerResult"] | undefined | null,
	/** Remove the primary buyer from a transaction, when co-buyer exists. The co-buyer then becomes the primary buyer. After the disassociation, the old primary isn't deleted but marked as removed. */
	removePrimaryBuyer?: ModelTypes["MutationRemovePrimaryBuyerResult"] | undefined | null,
	/** Request prequal reports via Agility Credit */
	requestAgilityCreditPrequal?: ModelTypes["MutationRequestAgilityCreditPrequalResult"] | undefined | null,
	/** Request identity verification for customer */
	requestIdentityVerification?: ModelTypes["MutationRequestIdentityVerificationResult"] | undefined | null,
	requestOtpExistingUserDEV?: ModelTypes["MutationRequestOtpExistingUserDEVResult"] | undefined | null,
	/** Request prequal reports for a customer */
	requestPrequalReports?: ModelTypes["MutationRequestPrequalReportsResult"] | undefined | null,
	/** Requests a prescreen on customer */
	requestPrescreen?: ModelTypes["MutationRequestPrescreenResult"] | undefined | null,
	/** Flag staff as deactivated / active */
	resendStaffPassword?: ModelTypes["MutationResendStaffPasswordResult"] | undefined | null,
	/** Save dealer edits to customer data (personal info, employment, address) before pushing to R1/DT */
	saveLendingPortalCustomerData?: ModelTypes["MutationSaveLendingPortalCustomerDataResult"] | undefined | null,
	/** Save dealer edits to purchase vehicle data before pushing to R1/DT */
	saveLendingPortalPurchaseVehicleData?: ModelTypes["MutationSaveLendingPortalPurchaseVehicleDataResult"] | undefined | null,
	/** Save dealer edits to trade vehicle data before pushing to R1/DT */
	saveLendingPortalTradeVehicleData?: ModelTypes["MutationSaveLendingPortalTradeVehicleDataResult"] | undefined | null,
	/** Send "document ready to be signed" notifications to buyer/co-buyer for forms in a collection. Takes a collection ID and fetches forms server-side to enable future notification tracking. */
	sendFormReadyNotifications?: ModelTypes["MutationSendFormReadyNotificationsResult"] | undefined | null,
	/** Set challenge delivery method */
	setDeliveryMethodForUser?: ModelTypes["MutationSetDeliveryMethodForUserResult"] | undefined | null,
	/** Set the title for a document */
	setDocumentLabels?: ModelTypes["MutationSetDocumentLabelsResult"] | undefined | null,
	/** Set the title for a document */
	setDocumentTitle?: ModelTypes["MutationSetDocumentTitleResult"] | undefined | null,
	/** Set staff information */
	setStaffInformation?: ModelTypes["MutationSetStaffInformationResult"] | undefined | null,
	/** Enable or disable the staff planning feature for an individual staff member. */
	setStaffPlanningEnabled?: ModelTypes["MutationSetStaffPlanningEnabledResult"] | undefined | null,
	/** Stages additional forms from the catalog for signature. These are manually triggered forms stored in an ADDITIONAL collection, distinct from lifecycle PRE_PURCHASE/POST_PURCHASE forms. */
	stageAdditionalForms?: ModelTypes["MutationStageAdditionalFormsResult"] | undefined | null,
	/** Start a liveness analysis session & return AWS session id */
	startLivenessAnalysis?: ModelTypes["MutationStartLivenessAnalysisResult"] | undefined | null,
	/** Submit values on a form */
	submitFormValues?: ModelTypes["MutationSubmitFormValuesResult"] | undefined | null,
	/** Create a form submission for a transaction */
	submitPrequalApplicationAndCreateUser?: ModelTypes["MutationSubmitPrequalApplicationAndCreateUserResult"] | undefined | null,
	/** Create a form submission for a transaction */
	submitPrequalApplicationOnTransaction?: ModelTypes["MutationSubmitPrequalApplicationOnTransactionResult"] | undefined | null,
	/** Record staff acknowledgement of information safeguarding obligations for a dealership */
	submitStaffAcknowledgement?: ModelTypes["MutationSubmitStaffAcknowledgementResult"] | undefined | null,
	/** Create a form submission for a transaction */
	submitStandardForm?: ModelTypes["MutationSubmitStandardFormResult"] | undefined | null,
	/** Modify a user group suspenstion status */
	suspendGroupUser?: ModelTypes["MutationSuspendGroupUserResult"] | undefined | null,
	/** Flag staff as deactivated / active */
	suspendStaff?: ModelTypes["MutationSuspendStaffResult"] | undefined | null,
	/** Switch co-buyer to the primary buyer, and the buyer to the co-buyer */
	switchCustomerRoles?: ModelTypes["MutationSwitchCustomerRolesResult"] | undefined | null,
	/** Create a user if they do not exist and link them to the dealership. Used during test drive flow to allow OTP to work for both new and existing users. */
	testDriveEnsureCustomerForDealership?: ModelTypes["MutationTestDriveEnsureCustomerForDealershipResult"] | undefined | null,
	/** Track a user event from the frontend */
	trackUserEvent?: ModelTypes["MutationTrackUserEventResult"] | undefined | null,
	/** Dismiss notifications */
	unlockTransaction?: ModelTypes["MutationUnlockTransactionResult"] | undefined | null,
	/** Update the customer logged in user */
	updateCustomer?: ModelTypes["MutationUpdateCustomerResult"] | undefined | null,
	/** Update an employment of a user */
	updateEmployment?: ModelTypes["MutationUpdateEmploymentResult"] | undefined | null,
	/** Update a group user */
	updateGroupUser?: ModelTypes["MutationUpdateGroupUserResult"] | undefined | null,
	/** Update rotation for ID card images */
	updateIdCardRotation?: ModelTypes["MutationUpdateIdCardRotationResult"] | undefined | null,
	/** Update the currently logged in user */
	updateMyUser?: ModelTypes["MutationUpdateMyUserResult"] | undefined | null,
	/** Update whether a staff member receives the authenticom report */
	updateReceivesAuthenticomReport?: ModelTypes["MutationUpdateReceivesAuthenticomReportResult"] | undefined | null,
	/** Update role of a user dealership */
	updateStaffAttributes?: ModelTypes["MutationUpdateStaffAttributesResult"] | undefined | null,
	/** Update staff extra permissions for dealership */
	updateStaffExtraPermissions?: ModelTypes["MutationUpdateStaffExtraPermissionsResult"] | undefined | null,
	/** Update a single schedule event (move or resize). */
	updateStaffScheduleEvent?: ModelTypes["MutationUpdateStaffScheduleEventResult"] | undefined | null,
	/** Update a transaction */
	updateTransaction?: ModelTypes["MutationUpdateTransactionResult"] | undefined | null,
	/** Upload additional documents for a transaction */
	uploadAdditionalDocuments?: ModelTypes["MutationUploadAdditionalDocumentsResult"] | undefined | null,
	/** Upload additional documents to a transaction as dealership dashboard user */
	uploadAdditionalDocumentsToTransaction?: ModelTypes["MutationUploadAdditionalDocumentsToTransactionResult"] | undefined | null,
	/** Upload driver license (or id card), save a DMV Form, and create ID Card */
	uploadIdCard?: ModelTypes["MutationUploadIdCardResult"] | undefined | null,
	/** Upload driver license (or other id card) using submission token for scanner flow */
	uploadIdCardWithToken?: ModelTypes["MutationUploadIdCardWithTokenResult"] | undefined | null,
	/** Check if user already exists */
	userExists?: ModelTypes["MutationUserExistsResult"] | undefined | null,
	verifyOtpForExistingUser?: ModelTypes["MutationVerifyOtpForExistingUserResult"] | undefined | null
};
	["MutationAddScanToDealerJacketResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationAddScanToDealerJacketSuccess"];
	["MutationAddScanToDealerJacketSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationAddScanToGloveCompartmentsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationAddScanToGloveCompartmentsSuccess"];
	["MutationAddScanToGloveCompartmentsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationAssignStaffToTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationAssignStaffToTransactionSuccess"];
	["MutationAssignStaffToTransactionSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationCancelFormCollectionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCancelFormCollectionSuccess"];
	["MutationCancelFormCollectionSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCancelPreviousAndRequestSignaturesResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCancelPreviousAndRequestSignaturesSuccess"];
	["MutationCancelPreviousAndRequestSignaturesSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationChangeDocumentAccessResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationChangeDocumentAccessSuccess"];
	["MutationChangeDocumentAccessSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationChangeFormSubmissionAccessResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationChangeFormSubmissionAccessSuccess"];
	["MutationChangeFormSubmissionAccessSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCreateAndSubmitCreditAndPrequalApplicationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"];
	["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationCreateChatResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateChatSuccess"];
	["MutationCreateChatSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCreateCoBuyerResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateCoBuyerSuccess"];
	["MutationCreateCoBuyerSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCreateCreditApplicationAndCreateUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateCreditApplicationAndCreateUserSuccess"];
	["MutationCreateCreditApplicationAndCreateUserSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationCreateEmploymentResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateEmploymentSuccess"];
	["MutationCreateEmploymentSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCreateGroupuserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateGroupuserSuccess"];
	["MutationCreateGroupuserSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCreateMessageResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateMessageSuccess"];
	["MutationCreateMessageSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCreateStaffResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateStaffSuccess"];
	["MutationCreateStaffScheduleEventsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateStaffScheduleEventsSuccess"];
	["MutationCreateStaffScheduleEventsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCreateStaffSuccess"]: {
		data: ModelTypes["User"]
};
	["MutationCreateTransactionAndSubmitTestDriveResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateTransactionAndSubmitTestDriveSuccess"];
	["MutationCreateTransactionAndSubmitTestDriveSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCreateUserFeedbackResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCreateUserFeedbackSuccess"];
	["MutationCreateUserFeedbackSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCustomerCreatePrefilledTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerCreatePrefilledTransactionSuccess"];
	["MutationCustomerCreatePrefilledTransactionSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCustomerCreatePurchaseVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerCreatePurchaseVehicleSuccess"];
	["MutationCustomerCreatePurchaseVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCustomerCreateTradeVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerCreateTradeVehicleSuccess"];
	["MutationCustomerCreateTradeVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCustomerCreateTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerCreateTransactionSuccess"];
	["MutationCustomerCreateTransactionSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCustomerCreateUnauthenticatedTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerCreateUnauthenticatedTransactionSuccess"];
	["MutationCustomerCreateUnauthenticatedTransactionSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCustomerReferralPaidResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerReferralPaidSuccess"];
	["MutationCustomerReferralPaidSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationCustomerReferralResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerReferralSuccess"];
	["MutationCustomerReferralSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationCustomerSignupWithCognitoResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerSignupWithCognitoSuccess"];
	["MutationCustomerSignupWithCognitoSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCustomerUpdatePhoneNumberResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerUpdatePhoneNumberSuccess"];
	["MutationCustomerUpdatePhoneNumberSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationCustomerUpdatePurchaseVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerUpdatePurchaseVehicleSuccess"];
	["MutationCustomerUpdatePurchaseVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationCustomerUpdateTradeVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationCustomerUpdateTradeVehicleSuccess"];
	["MutationCustomerUpdateTradeVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDealershipCreatePurchaseVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDealershipCreatePurchaseVehicleSuccess"];
	["MutationDealershipCreatePurchaseVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDealershipCreateTradeVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDealershipCreateTradeVehicleSuccess"];
	["MutationDealershipCreateTradeVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDealershipCreateTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDealershipCreateTransactionSuccess"];
	["MutationDealershipCreateTransactionSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDealershipRemoveTradeVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDealershipRemoveTradeVehicleSuccess"];
	["MutationDealershipRemoveTradeVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDealershipUpdatePurchaseVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDealershipUpdatePurchaseVehicleSuccess"];
	["MutationDealershipUpdatePurchaseVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDealershipUpdateTradeVehicleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDealershipUpdateTradeVehicleSuccess"];
	["MutationDealershipUpdateTradeVehicleSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationDeleteStaffScheduleEventResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDeleteStaffScheduleEventSuccess"];
	["MutationDeleteStaffScheduleEventSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationDismissNotificationsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationDismissNotificationsSuccess"];
	["MutationDismissNotificationsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationExtractVehicleFromRegistrationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationExtractVehicleFromRegistrationSuccess"];
	["MutationExtractVehicleFromRegistrationSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationFinalizeLivenessAnalysisResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationFinalizeLivenessAnalysisSuccess"];
	["MutationFinalizeLivenessAnalysisSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationLoginResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationLoginSuccess"];
	["MutationLoginSuccess"]: {
		data: ModelTypes["LoginResponse"]
};
	["MutationLogoutResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationLogoutSuccess"];
	["MutationLogoutSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationMakeSubmissionTokenResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationMakeSubmissionTokenSuccess"];
	["MutationMakeSubmissionTokenSuccess"]: {
		data: string
};
	["MutationMakeUploadForScannerResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationMakeUploadForScannerSuccess"];
	["MutationMakeUploadForScannerSuccess"]: {
		data: ModelTypes["MakeFileUploadForScannerType"]
};
	["MutationMakeUploadResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationMakeUploadSuccess"];
	["MutationMakeUploadSuccess"]: {
		data: ModelTypes["MakeFileUploadType"]
};
	["MutationMakeUploadToTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationMakeUploadToTransactionSuccess"];
	["MutationMakeUploadToTransactionSuccess"]: {
		data: ModelTypes["MakeFileUploadType"]
};
	["MutationMarkTransactionAsDeliveredResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationMarkTransactionAsDeliveredSuccess"];
	["MutationMarkTransactionAsDeliveredSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationModifyHardCreditApplicationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationModifyHardCreditApplicationSuccess"];
	["MutationModifyHardCreditApplicationSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationOnboardingSubmitStep1Result"]:ModelTypes["GraphQLError"] | ModelTypes["MutationOnboardingSubmitStep1Success"];
	["MutationOnboardingSubmitStep1Success"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationOnboardingSubmitStep2Result"]:ModelTypes["GraphQLError"] | ModelTypes["MutationOnboardingSubmitStep2Success"];
	["MutationOnboardingSubmitStep2Success"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationOverrideTodoResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationOverrideTodoSuccess"];
	["MutationOverrideTodoSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationPreLoginCheckResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPreLoginCheckSuccess"];
	["MutationPreLoginCheckSuccess"]: {
		data: ModelTypes["PreLoginType"]
};
	["MutationPrefillLicensePlateOrVinResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPrefillLicensePlateOrVinSuccess"];
	["MutationPrefillLicensePlateOrVinSuccess"]: {
		data: ModelTypes["LicensePrefillData"]
};
	["MutationPushDataToCrmsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPushDataToCrmsSuccess"];
	["MutationPushDataToCrmsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationPushDocumentToCdkDealJacketResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPushDocumentToCdkDealJacketSuccess"];
	["MutationPushDocumentToCdkDealJacketSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationPushDocumentsToCdkResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPushDocumentsToCdkSuccess"];
	["MutationPushDocumentsToCdkSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationPushFormSubmissionsToCdkResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPushFormSubmissionsToCdkSuccess"];
	["MutationPushFormSubmissionsToCdkSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationPushHardCreditApplicationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationPushHardCreditApplicationSuccess"];
	["MutationPushHardCreditApplicationSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationRecordConsentResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRecordConsentSuccess"];
	["MutationRecordConsentSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationRemoveCoBuyerResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRemoveCoBuyerSuccess"];
	["MutationRemoveCoBuyerSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationRemovePrimaryBuyerResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRemovePrimaryBuyerSuccess"];
	["MutationRemovePrimaryBuyerSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationRequestAgilityCreditPrequalResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRequestAgilityCreditPrequalSuccess"];
	["MutationRequestAgilityCreditPrequalSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationRequestIdentityVerificationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRequestIdentityVerificationSuccess"];
	["MutationRequestIdentityVerificationSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationRequestOtpExistingUserDEVResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRequestOtpExistingUserDEVSuccess"];
	["MutationRequestOtpExistingUserDEVSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationRequestPrequalReportsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRequestPrequalReportsSuccess"];
	["MutationRequestPrequalReportsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationRequestPrescreenResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationRequestPrescreenSuccess"];
	["MutationRequestPrescreenSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationResendStaffPasswordResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationResendStaffPasswordSuccess"];
	["MutationResendStaffPasswordSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationResponse"]: {
		status?: string | undefined | null
};
	["MutationResponseWithId"]: {
		id?: string | undefined | null,
	status?: string | undefined | null
};
	["MutationSaveLendingPortalCustomerDataResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSaveLendingPortalCustomerDataSuccess"];
	["MutationSaveLendingPortalCustomerDataSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSaveLendingPortalPurchaseVehicleDataResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSaveLendingPortalPurchaseVehicleDataSuccess"];
	["MutationSaveLendingPortalPurchaseVehicleDataSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSaveLendingPortalTradeVehicleDataResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSaveLendingPortalTradeVehicleDataSuccess"];
	["MutationSaveLendingPortalTradeVehicleDataSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSendFormReadyNotificationsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSendFormReadyNotificationsSuccess"];
	["MutationSendFormReadyNotificationsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSetDeliveryMethodForUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSetDeliveryMethodForUserSuccess"];
	["MutationSetDeliveryMethodForUserSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSetDocumentLabelsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSetDocumentLabelsSuccess"];
	["MutationSetDocumentLabelsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSetDocumentTitleResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSetDocumentTitleSuccess"];
	["MutationSetDocumentTitleSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSetStaffInformationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSetStaffInformationSuccess"];
	["MutationSetStaffInformationSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSetStaffPlanningEnabledResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSetStaffPlanningEnabledSuccess"];
	["MutationSetStaffPlanningEnabledSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationStageAdditionalFormsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationStageAdditionalFormsSuccess"];
	["MutationStageAdditionalFormsSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationStartLivenessAnalysisResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationStartLivenessAnalysisSuccess"];
	["MutationStartLivenessAnalysisSuccess"]: {
		data: string
};
	["MutationSubmitFormValuesResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSubmitFormValuesSuccess"];
	["MutationSubmitFormValuesSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSubmitPrequalApplicationAndCreateUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSubmitPrequalApplicationAndCreateUserSuccess"];
	["MutationSubmitPrequalApplicationAndCreateUserSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSubmitPrequalApplicationOnTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSubmitPrequalApplicationOnTransactionSuccess"];
	["MutationSubmitPrequalApplicationOnTransactionSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSubmitStaffAcknowledgementResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSubmitStaffAcknowledgementSuccess"];
	["MutationSubmitStaffAcknowledgementSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationSubmitStandardFormResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSubmitStandardFormSuccess"];
	["MutationSubmitStandardFormSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationSuspendGroupUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSuspendGroupUserSuccess"];
	["MutationSuspendGroupUserSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSuspendStaffResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSuspendStaffSuccess"];
	["MutationSuspendStaffSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationSwitchCustomerRolesResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationSwitchCustomerRolesSuccess"];
	["MutationSwitchCustomerRolesSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationTestDriveEnsureCustomerForDealershipResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationTestDriveEnsureCustomerForDealershipSuccess"];
	["MutationTestDriveEnsureCustomerForDealershipSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationTrackUserEventResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationTrackUserEventSuccess"];
	["MutationTrackUserEventSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUnlockTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUnlockTransactionSuccess"];
	["MutationUnlockTransactionSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateCustomerResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateCustomerSuccess"];
	["MutationUpdateCustomerSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateEmploymentResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateEmploymentSuccess"];
	["MutationUpdateEmploymentSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateGroupUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateGroupUserSuccess"];
	["MutationUpdateGroupUserSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateIdCardRotationResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateIdCardRotationSuccess"];
	["MutationUpdateIdCardRotationSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateMyUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateMyUserSuccess"];
	["MutationUpdateMyUserSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateReceivesAuthenticomReportResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateReceivesAuthenticomReportSuccess"];
	["MutationUpdateReceivesAuthenticomReportSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateStaffAttributesResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateStaffAttributesSuccess"];
	["MutationUpdateStaffAttributesSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateStaffExtraPermissionsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateStaffExtraPermissionsSuccess"];
	["MutationUpdateStaffExtraPermissionsSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateStaffScheduleEventResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateStaffScheduleEventSuccess"];
	["MutationUpdateStaffScheduleEventSuccess"]: {
		data: ModelTypes["MutationResponse"]
};
	["MutationUpdateTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUpdateTransactionSuccess"];
	["MutationUpdateTransactionSuccess"]: {
		data: ModelTypes["Response"]
};
	["MutationUploadAdditionalDocumentsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUploadAdditionalDocumentsSuccess"];
	["MutationUploadAdditionalDocumentsSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationUploadAdditionalDocumentsToTransactionResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUploadAdditionalDocumentsToTransactionSuccess"];
	["MutationUploadAdditionalDocumentsToTransactionSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationUploadIdCardResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUploadIdCardSuccess"];
	["MutationUploadIdCardSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationUploadIdCardWithTokenResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUploadIdCardWithTokenSuccess"];
	["MutationUploadIdCardWithTokenSuccess"]: {
		data: ModelTypes["MutationResponseWithId"]
};
	["MutationUserExistsResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationUserExistsSuccess"];
	["MutationUserExistsSuccess"]: {
		data: boolean
};
	["MutationVerifyOtpForExistingUserResult"]:ModelTypes["GraphQLError"] | ModelTypes["MutationVerifyOtpForExistingUserSuccess"];
	["MutationVerifyOtpForExistingUserSuccess"]: {
		data: ModelTypes["LoginResponse"]
};
	["Node"]: ModelTypes["UserDealership"];
	["Notification"]: {
		announcement?: ModelTypes["Announcement"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	dismissedAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	payload?: ModelTypes["JSON"] | undefined | null
};
	["NotificationFilter"]: {
	announcementId?: ModelTypes["IDFilter"] | undefined | null,
	createdAt?: ModelTypes["DateTimeFilter"] | undefined | null,
	dismissedAt?: ModelTypes["DateTimeFilter"] | undefined | null
};
	["NotificationOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null,
	dismissedAt?: ModelTypes["OrderBy"] | undefined | null
};
	["OnboardingStep"]:OnboardingStep;
	["OrderBy"]:OrderBy;
	["PageInfo"]: {
		endCursor?: string | undefined | null,
	hasNextPage: boolean,
	hasPreviousPage: boolean,
	startCursor?: string | undefined | null
};
	["Permission"]:Permission;
	["PlatformType"]: {
		announcements?: ModelTypes["PlatformTypeAnnouncementsConnection"] | undefined | null,
	documentLabels?: ModelTypes["PlatformTypeDocumentLabelsConnection"] | undefined | null,
	faqs?: ModelTypes["PlatformTypeFaqsConnection"] | undefined | null,
	/** Check if the current request IP is blocked by the dealership IP whitelist. Accepts an explicit dealershipId so the query can be made without the DealershipId header (which would be rejected by the IP-whitelist middleware). */
	isIpBlocked?: boolean | undefined | null
};
	["PlatformTypeAnnouncementsConnection"]: {
		edges?: Array<ModelTypes["PlatformTypeAnnouncementsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["PlatformTypeAnnouncementsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Announcement"] | undefined | null
};
	["PlatformTypeDocumentLabelsConnection"]: {
		edges?: Array<ModelTypes["PlatformTypeDocumentLabelsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["PlatformTypeDocumentLabelsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["DocumentLabel"] | undefined | null
};
	["PlatformTypeFaqsConnection"]: {
		edges?: Array<ModelTypes["PlatformTypeFaqsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["PlatformTypeFaqsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Faq"] | undefined | null
};
	["PolicyLayerType"]:PolicyLayerType;
	["PreLoginType"]: {
		hasConsentedToSms?: boolean | undefined | null,
	loginOptions?: Array<ModelTypes["LoginOptionType"]> | undefined | null,
	userExists?: boolean | undefined | null
};
	["PrequalApplication"]: {
		agilityCreditPrequalReports?: ModelTypes["PrequalApplicationAgilityCreditPrequalReportsConnection"] | undefined | null,
	city?: string | undefined | null,
	id?: string | undefined | null,
	prequalResponses?: ModelTypes["PrequalApplicationPrequalResponsesConnection"] | undefined | null,
	state?: string | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null
};
	["PrequalApplicationAgilityCreditPrequalReportsConnection"]: {
		edges?: Array<ModelTypes["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["AgilityCreditPrequalReport"] | undefined | null
};
	["PrequalApplicationPrequalResponsesConnection"]: {
		edges?: Array<ModelTypes["PrequalApplicationPrequalResponsesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["PrequalApplicationPrequalResponsesConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["SevenHundredCreditPrequalReports"] | undefined | null
};
	["PrequalBureau"]:PrequalBureau;
	["PrequalBureauFilter"]: {
	equals?: ModelTypes["PrequalBureau"] | undefined | null,
	in?: Array<ModelTypes["PrequalBureau"]> | undefined | null,
	not?: ModelTypes["PrequalBureauFilter"] | undefined | null,
	notIn?: Array<ModelTypes["PrequalBureau"]> | undefined | null
};
	["PrequalInput"]: {
	apartmentDetails: string,
	birthdate: string,
	city: string,
	dateTime: string,
	dealerPrivacyAckTmplId?: string | undefined | null,
	deviceId: string,
	eSignAckTmplId?: string | undefined | null,
	firstName: string,
	ipAddress: string,
	lastName: string,
	middleName?: string | undefined | null,
	name: string,
	prequalReportAckTmplId?: string | undefined | null,
	signature: string,
	socialSecurityNumber: string,
	state: string,
	street: string,
	suffix: string,
	tdcConsentsAckTmplId?: string | undefined | null,
	zip: string
};
	["Prescreen"]: {
		id?: string | undefined | null,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?: string | undefined | null,
	score?: string | undefined | null
};
	["PublicType"]: {
		acknowledgements?: ModelTypes["PublicTypeAcknowledgementsConnection"] | undefined | null,
	ipAddress?: string | undefined | null,
	platformVersion?: string | undefined | null
};
	["PublicTypeAcknowledgementsConnection"]: {
		edges?: Array<ModelTypes["PublicTypeAcknowledgementsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["PublicTypeAcknowledgementsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["AcknowledgementTemplate"] | undefined | null
};
	["Query"]: {
		customer?: ModelTypes["Customer"] | undefined | null,
	/** Return information about a dealership either by slug or by id */
	dealership?: ModelTypes["Dealership"] | undefined | null,
	dealershipStaffScheduleEvents?: Array<ModelTypes["StaffScheduleEvent"]> | undefined | null,
	/** Return information about the currently logged in user */
	me?: ModelTypes["MeType"] | undefined | null,
	node?: ModelTypes["Node"] | undefined | null,
	nodes: Array<ModelTypes["Node"] | undefined | null>,
	/** Return platform information */
	platform?: ModelTypes["PlatformType"] | undefined | null,
	/** Public query root */
	public?: ModelTypes["PublicType"] | undefined | null,
	/** Return information about a transaction either by internal id or by pId (Public ID) */
	transaction?: ModelTypes["Transaction"] | undefined | null,
	userDealership?: ModelTypes["UserDealership"] | undefined | null
};
	["RecallMastersRecallReport"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	request?: string | undefined | null,
	response?: ModelTypes["JSON"] | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["RecallMastersRecallReportFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["RecallMastersRecallReportOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["Referral"]: {
		createdAt: ModelTypes["DateTime"],
	dealership: ModelTypes["Dealership"],
	id: string,
	pId: string,
	payoutInCents: number,
	referringContact: ModelTypes["ContactV2"],
	status: ModelTypes["ReferralStatus"],
	title: string
};
	["ReferralStatus"]:ReferralStatus;
	["Response"]: {
		id?: string | undefined | null,
	status?: string | undefined | null
};
	["Role"]:Role;
	["RoleFilter"]: {
	equals?: ModelTypes["Role"] | undefined | null,
	in?: Array<ModelTypes["Role"]> | undefined | null,
	not?: ModelTypes["RoleFilter"] | undefined | null
};
	["RoleListFilter"]: {
	has?: ModelTypes["Role"] | undefined | null
};
	["SalesRankingGrouppedByMonth"]: {
		currentMonth?: number | undefined | null,
	firstName?: string | undefined | null,
	lastMonth?: number | undefined | null,
	lastName?: string | undefined | null,
	twoMonthsAgo?: number | undefined | null,
	userId?: string | undefined | null
};
	["SetStaffInformationInput"]: {
	cdkCrmEmployeeId?: string | undefined | null
};
	["SevenHundredCreditPrequalReports"]: {
		application?: ModelTypes["PrequalApplication"] | undefined | null,
	id?: string | undefined | null,
	idMatchSummary?: string | undefined | null,
	ofacSummary?: string | undefined | null,
	product?: string | undefined | null,
	quizStatus?: string | undefined | null,
	redFlagSummary?: string | undefined | null,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?: string | undefined | null,
	response?: string | undefined | null,
	resultCode?: string | undefined | null,
	score?: string | undefined | null
};
	["SevenHundredCreditPrequalReportsFilter"]: {
	bureau?: ModelTypes["PrequalBureauFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	isForCompliance?: ModelTypes["BooleanFilter"] | undefined | null
};
	["Staff"]: {
		dealershipId?: string | undefined | null,
	dealershipRole?: ModelTypes["Role"] | undefined | null,
	firstName?: string | undefined | null,
	hasEnabledStaffPlanning?: boolean | undefined | null,
	id?: string | undefined | null,
	lastName?: string | undefined | null,
	receivesAuthenticomReport?: boolean | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userId?: string | undefined | null
};
	["StaffAttributes"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	role?: ModelTypes["Role"] | undefined | null
};
	["StaffFilter"]: {
	dealershipId?: ModelTypes["IDFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["StaffInformation"]: {
		cdkCrmEmployeeId?: string | undefined | null,
	dealership?: ModelTypes["Dealership"] | undefined | null,
	dealershipId?: string | undefined | null,
	user?: ModelTypes["User"] | undefined | null,
	userId?: string | undefined | null
};
	["StaffInformationFilter"]: {
	dealershipId?: ModelTypes["IDFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["StaffScheduleEvent"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	dealershipId?: string | undefined | null,
	endAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	note?: string | undefined | null,
	staffId?: string | undefined | null,
	startAt?: ModelTypes["DateTime"] | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["StageFormInput"]: {
	id: string,
	order: number
};
	["StringFilter"]: {
	contains?: string | undefined | null,
	equals?: string | undefined | null,
	mode?: ModelTypes["StringFilterMode"] | undefined | null,
	not?: ModelTypes["StringFilter"] | undefined | null,
	startsWith?: string | undefined | null
};
	["StringFilterMode"]:StringFilterMode;
	["SubmitStep1Input"]: {
	captureBackFileId?: string | undefined | null,
	captureFrontFileId?: string | undefined | null,
	/** Signifies contact consent to the consent text at the template ID */
	contactConsentWithTemplateId: string,
	dmvForm?: string | undefined | null,
	dmvPdfFileId?: string | undefined | null,
	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null,
	privacyNoticeFileId: string,
	privacyNoticeForm: string,
	/** Signifies test drive consent to the consent text at the template ID */
	testDriveConsentWithTemplateId: string
};
	["SubmitStep2Input"]: {
	captureFileId: string,
	livenessSessionId?: string | undefined | null,
	selfieAckTmplId: string
};
	["SubmitTo"]:SubmitTo;
	["TextAlignment"]:TextAlignment;
	["Todo"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	dealershipGroupId?: string | undefined | null,
	dealershipId?: string | undefined | null,
	id?: string | undefined | null,
	status: ModelTypes["TodoStatus"],
	transaction?: ModelTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	type: ModelTypes["TodoTypes"],
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["TodoFilter"]: {
	createdAt?: ModelTypes["DateTimeFilter"] | undefined | null,
	status?: ModelTypes["TodoStatusFilter"] | undefined | null,
	transactionId?: ModelTypes["IDFilter"] | undefined | null,
	type?: ModelTypes["TodoTypesFilter"] | undefined | null
};
	["TodoOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["TodoStatus"]:TodoStatus;
	["TodoStatusFilter"]: {
	equals?: ModelTypes["TodoStatus"] | undefined | null,
	in?: Array<ModelTypes["TodoStatus"]> | undefined | null,
	not?: ModelTypes["TodoStatusFilter"] | undefined | null
};
	["TodoTypes"]:TodoTypes;
	["TodoTypesFilter"]: {
	equals?: ModelTypes["TodoTypes"] | undefined | null,
	in?: Array<ModelTypes["TodoTypes"]> | undefined | null,
	not?: ModelTypes["TodoTypesFilter"] | undefined | null
};
	["Transaction"]: {
		agilityCreditVerifications?: ModelTypes["TransactionAgilityCreditVerificationsConnection"] | undefined | null,
	bdc?: ModelTypes["User"] | undefined | null,
	buyer?: ModelTypes["Customer"] | undefined | null,
	buyerId?: string | undefined | null,
	cdkDmsDealId?: string | undefined | null,
	/** Optionally, a co-buyer for the transaction */
	coBuyer?: ModelTypes["Customer"] | undefined | null,
	coBuyerId?: string | undefined | null,
	complianceFormsData: ModelTypes["ComplianceFormsData"],
	consumerRebatesInUsdCents?: number | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	customerSharedData?: ModelTypes["CustomerSharedData"] | undefined | null,
	dealership?: ModelTypes["Dealership"] | undefined | null,
	dealershipCommitment?: string | undefined | null,
	documents?: ModelTypes["TransactionDocumentsConnection"] | undefined | null,
	downPayment?: number | undefined | null,
	downPaymentInUsdCents?: number | undefined | null,
	financeType?: string | undefined | null,
	fniManager?: ModelTypes["User"] | undefined | null,
	formSubmissionCollections?: ModelTypes["TransactionFormSubmissionCollectionsConnection"] | undefined | null,
	formSubmissions?: ModelTypes["TransactionFormSubmissionsConnection"] | undefined | null,
	isLeaseBuyOut?: boolean | undefined | null,
	leaseTermInMonths?: number | undefined | null,
	lenderHardCreditApplications: Array<ModelTypes["LenderHardCreditApplication"]>,
	lockedReason?: ModelTypes["TransactionLockReason"] | undefined | null,
	logs?: ModelTypes["TransactionLogsConnection"] | undefined | null,
	milesPerYearInLease?: number | undefined | null,
	monthlyLeasePaymentInUsdCents?: number | undefined | null,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "tx_...") */
	pId: string,
	price?: number | undefined | null,
	referrals?: ModelTypes["TransactionReferralsConnection"] | undefined | null,
	routeOneApplicationId?: string | undefined | null,
	salesManager?: ModelTypes["User"] | undefined | null,
	salesPerson?: ModelTypes["User"] | undefined | null,
	salesPriceInUsdCents?: number | undefined | null,
	salesTaxInMiliBsp?: number | undefined | null,
	source: ModelTypes["TransactionSource"],
	status: ModelTypes["TransactionStatus"],
	/** The title of a transaction default to the buyers name or email if that is not set */
	title?: string | undefined | null,
	todos?: ModelTypes["TransactionTodosConnection"] | undefined | null,
	tradeInPriceInUsdCents?: number | undefined | null,
	tradeVehicle?: ModelTypes["Vehicle"] | undefined | null,
	/** This returns a list of all users who have made changes to the transaction. This can be used to filter the list of transaction logs */
	usersWorkingOnTransaction?: Array<ModelTypes["ListItem"]> | undefined | null,
	vehicle?: ModelTypes["Vehicle"] | undefined | null,
	vehicleRegistrationExtractions: Array<ModelTypes["VehicleRegistrationExtraction"]>
};
	["TransactionAgilityCreditVerificationsConnection"]: {
		edges?: Array<ModelTypes["TransactionAgilityCreditVerificationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["TransactionAgilityCreditVerificationsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["AgilityCreditIdVerification"] | undefined | null
};
	["TransactionAndFilter"]: {
	OR?: Array<ModelTypes["AssignedStaffOrFilter"]> | undefined | null,
	salesPersonId?: ModelTypes["IDFilter"] | undefined | null
};
	["TransactionDealershipAnalyticsSpotFilter"]: {
	eventAt?: ModelTypes["DateTimeFilter"] | undefined | null
};
	["TransactionDocumentsConnection"]: {
		edges?: Array<ModelTypes["TransactionDocumentsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["TransactionDocumentsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Document"] | undefined | null
};
	["TransactionFilter"]: {
	AND?: Array<ModelTypes["TransactionAndFilter"]> | undefined | null,
	OR?: Array<ModelTypes["AssignedStaffOrFilter"]> | undefined | null,
	buyerId?: ModelTypes["IDFilter"] | undefined | null,
	coBuyerId?: ModelTypes["IDFilter"] | undefined | null,
	createdAt?: ModelTypes["DateTimeFilter"] | undefined | null,
	dealership?: ModelTypes["DealershipFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	salesPersonId?: ModelTypes["IDFilter"] | undefined | null,
	source?: ModelTypes["TransactionSourceFilter"] | undefined | null,
	status?: ModelTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionFormSubmissionCollectionsConnection"]: {
		edges?: Array<ModelTypes["TransactionFormSubmissionCollectionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["TransactionFormSubmissionCollectionsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["FormSubmissionCollection"] | undefined | null
};
	["TransactionFormSubmissionsConnection"]: {
		edges?: Array<ModelTypes["TransactionFormSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["TransactionFormSubmissionsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["FormSubmission"] | undefined | null
};
	["TransactionLifecycle"]:TransactionLifecycle;
	["TransactionLockReason"]:TransactionLockReason;
	["TransactionLog"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	event?: ModelTypes["JSON"] | undefined | null,
	eventDescription?: string | undefined | null,
	executingUser?: ModelTypes["User"] | undefined | null,
	id?: string | undefined | null,
	transaction?: ModelTypes["Transaction"] | undefined | null
};
	["TransactionLogFilter"]: {
	createdAt?: ModelTypes["DateTimeFilter"] | undefined | null,
	executingUserId?: ModelTypes["IDFilter"] | undefined | null
};
	["TransactionLogOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["TransactionLogsConnection"]: {
		edges?: Array<ModelTypes["TransactionLogsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["TransactionLogsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["TransactionLog"] | undefined | null
};
	["TransactionOrderBy"]: {
	createdAt?: ModelTypes["FieldOrdering"] | undefined | null,
	firstName?: ModelTypes["FieldOrdering"] | undefined | null,
	lastName?: ModelTypes["FieldOrdering"] | undefined | null,
	source?: ModelTypes["FieldOrdering"] | undefined | null,
	status?: ModelTypes["FieldOrdering"] | undefined | null
};
	["TransactionReferralsConnection"]: {
		edges?: Array<ModelTypes["TransactionReferralsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["TransactionReferralsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Referral"] | undefined | null
};
	["TransactionRole"]:TransactionRole;
	["TransactionSalesRankingAnalyticsWhereInput"]: {
	status?: ModelTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionSource"]:TransactionSource;
	["TransactionSourceFilter"]: {
	equals?: ModelTypes["TransactionSource"] | undefined | null,
	in?: Array<ModelTypes["TransactionSource"]> | undefined | null,
	not?: ModelTypes["TransactionSourceFilter"] | undefined | null
};
	["TransactionStatus"]:TransactionStatus;
	["TransactionStatusFilter"]: {
	equals?: ModelTypes["TransactionStatus"] | undefined | null,
	in?: Array<ModelTypes["TransactionStatus"]> | undefined | null,
	not?: ModelTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionStatusUpdateDealershipAnalyticsFilter"]: {
	eventAt?: ModelTypes["DateTimeFilter"] | undefined | null,
	financeType?: ModelTypes["FinanceTypeFilter"] | undefined | null,
	isLeaseBuyOut?: boolean | undefined | null,
	purchaseVehicleLifeCycleStage?: ModelTypes["VehicleLifeCycleStageFilter"] | undefined | null,
	source?: ModelTypes["TransactionSourceFilter"] | undefined | null,
	status?: ModelTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionTodosConnection"]: {
		edges?: Array<ModelTypes["TransactionTodosConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["TransactionTodosConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Todo"] | undefined | null
};
	["UpdateCustomerAddress"]: {
	apartmentDetails: string,
	city: string,
	state: string,
	street: string,
	zipCode: string
};
	["UpdateCustomerInput"]: {
	dob?: ModelTypes["DateTime"] | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	removeVehicleRegistrationAddress?: boolean | undefined | null,
	residentialAddresses?: Array<ModelTypes["AddressInput"]> | undefined | null,
	selfieCaptureId?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	vehicleRegistrationAddress?: ModelTypes["UpdateCustomerAddress"] | undefined | null
};
	["UpdateEmploymentInput"]: {
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: string | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: string | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: string | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition?: number | undefined | null
};
	["UpdateStaffScheduleEventInput"]: {
	endAt?: string | undefined | null,
	note?: string | undefined | null,
	startAt?: string | undefined | null
};
	["UpdateTransactionInput"]: {
	cdkDmsDealId?: string | undefined | null,
	consumerRebatesInUsdCents?: number | undefined | null,
	dealershipCommitment?: string | undefined | null,
	downPaymentInUsdCents?: number | undefined | null,
	financeType?: string | undefined | null,
	id: string,
	isLeaseBuyOut?: boolean | undefined | null,
	leaseTermInMonths?: number | undefined | null,
	milesPerYearInLease?: number | undefined | null,
	monthlyLeasePaymentInUsdCents?: number | undefined | null,
	salesPriceInUsdCents?: number | undefined | null,
	salesTaxInMiliBsp?: number | undefined | null,
	tradeInPriceInUsdCents?: number | undefined | null
};
	["UpdateTransactionStaffInput"]: {
	bdcId?: string | undefined | null,
	fniManagerId?: string | undefined | null,
	salesManagerId?: string | undefined | null,
	salesPersonId?: string | undefined | null
};
	["UpdateUserInput"]: {
	firstName?: string | undefined | null,
	lastName?: string | undefined | null
};
	["User"]: {
		buyerFor?: ModelTypes["UserBuyerForConnection"] | undefined | null,
	coBuyerFor?: ModelTypes["UserCoBuyerForConnection"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	customers?: ModelTypes["UserCustomersConnection"] | undefined | null,
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	hasReferred: ModelTypes["UserHasReferredConnection"],
	id?: string | undefined | null,
	lastName?: string | undefined | null,
	notifications?: ModelTypes["UserNotificationsConnection"] | undefined | null,
	phoneNumber?: string | undefined | null,
	staff?: ModelTypes["UserStaffConnection"] | undefined | null,
	staffInformation?: ModelTypes["UserStaffInformationConnection"] | undefined | null,
	userAcknowledgements?: ModelTypes["UserUserAcknowledgementsConnection"] | undefined | null,
	userGroup?: ModelTypes["UserUserGroupConnection"] | undefined | null,
	userLogs?: ModelTypes["UserUserLogsConnection"] | undefined | null
};
	["UserAcknowledgement"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null
};
	["UserAcknowledgementFilter"]: {
	acknowledgementId?: ModelTypes["IDFilter"] | undefined | null,
	dealershipId?: ModelTypes["IDFilter"] | undefined | null,
	transactionId?: ModelTypes["IDFilter"] | undefined | null
};
	["UserAcknowledgementOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["UserBuyerForConnection"]: {
		edges?: Array<ModelTypes["UserBuyerForConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["UserBuyerForConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Transaction"] | undefined | null
};
	["UserCoBuyerForConnection"]: {
		edges?: Array<ModelTypes["UserCoBuyerForConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["UserCoBuyerForConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Transaction"] | undefined | null
};
	["UserCustomersConnection"]: {
		edges?: Array<ModelTypes["UserCustomersConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserCustomersConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Customer"] | undefined | null
};
	["UserDealership"]: {
		dealership?: ModelTypes["Dealership"] | undefined | null,
	dealershipId?: string | undefined | null,
	extraPermissions?: Array<ModelTypes["Permission"]> | undefined | null,
	id: ModelTypes["ID"],
	isSuspended?: boolean | undefined | null,
	role?: string | undefined | null,
	user?: ModelTypes["User"] | undefined | null
};
	["UserDealershipFilter"]: {
	isSuspended?: ModelTypes["BooleanFilter"] | undefined | null,
	role?: ModelTypes["RoleFilter"] | undefined | null,
	user?: ModelTypes["UserFilter"] | undefined | null,
	userId?: ModelTypes["IDFilter"] | undefined | null
};
	["UserEventOperation"]:UserEventOperation;
	["UserFilter"]: {
	OR?: Array<ModelTypes["UserOrFilter"]> | undefined | null,
	firstName?: ModelTypes["StringFilter"] | undefined | null,
	lastName?: ModelTypes["StringFilter"] | undefined | null
};
	["UserGroup"]: {
		group?: ModelTypes["DealershipGroup"] | undefined | null,
	groupId?: string | undefined | null,
	id?: string | undefined | null,
	isSuspended?: boolean | undefined | null,
	role?: string | undefined | null,
	user?: ModelTypes["User"] | undefined | null
};
	["UserGroupFilter"]: {
	isSuspended?: boolean | undefined | null
};
	["UserHasReferredConnection"]: {
		edges?: Array<ModelTypes["UserHasReferredConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserHasReferredConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Referral"] | undefined | null
};
	["UserLog"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	event?: ModelTypes["JSON"] | undefined | null,
	id?: string | undefined | null,
	userId?: string | undefined | null
};
	["UserNotificationsConnection"]: {
		edges?: Array<ModelTypes["UserNotificationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"],
	totalCount: number
};
	["UserNotificationsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Notification"] | undefined | null
};
	["UserOrFilter"]: {
	firstName?: ModelTypes["StringFilter"] | undefined | null,
	id?: ModelTypes["IDFilter"] | undefined | null,
	lastName?: ModelTypes["StringFilter"] | undefined | null
};
	["UserStaffConnection"]: {
		edges?: Array<ModelTypes["UserStaffConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserStaffConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["Staff"] | undefined | null
};
	["UserStaffInformationConnection"]: {
		edges?: Array<ModelTypes["UserStaffInformationConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserStaffInformationConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["StaffInformation"] | undefined | null
};
	["UserUserAcknowledgementsConnection"]: {
		edges?: Array<ModelTypes["UserUserAcknowledgementsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserUserAcknowledgementsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["UserAcknowledgement"] | undefined | null
};
	["UserUserGroupConnection"]: {
		edges?: Array<ModelTypes["UserUserGroupConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserUserGroupConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["UserGroup"] | undefined | null
};
	["UserUserLogsConnection"]: {
		edges?: Array<ModelTypes["UserUserLogsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["UserUserLogsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["UserLog"] | undefined | null
};
	["Vehicle"]: {
		bodyType?: ModelTypes["VehicleBodyType"] | undefined | null,
	color?: string | undefined | null,
	condition?: ModelTypes["VehicleCondition"] | undefined | null,
	createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	lifeCycleStage?: ModelTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	msrp?: number | undefined | null,
	pictureBack?: ModelTypes["File"] | undefined | null,
	pictureFront?: ModelTypes["File"] | undefined | null,
	pictureInterior?: ModelTypes["File"] | undefined | null,
	pictureLeftSide?: ModelTypes["File"] | undefined | null,
	pictureOdometer?: ModelTypes["File"] | undefined | null,
	pictureRightSide?: ModelTypes["File"] | undefined | null,
	pictureVinNumber?: ModelTypes["File"] | undefined | null,
	principalPriorUse?: ModelTypes["VehiclePrincipalPriorUse"] | undefined | null,
	recallMastersRecallReports?: ModelTypes["VehicleRecallMastersRecallReportsConnection"] | undefined | null,
	registrationName?: string | undefined | null,
	registrationState?: string | undefined | null,
	stockNumber?: string | undefined | null,
	transactionPurchaseVehicle?: Array<ModelTypes["Transaction"]> | undefined | null,
	transactionTradeVehicle?: Array<ModelTypes["Transaction"]> | undefined | null,
	/** Pre-packaged groups of features (e.g., base model, performance, etc.) */
	trim?: string | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null,
	updatedByDealership?: boolean | undefined | null,
	vehicleRecallChecks?: ModelTypes["VehicleVehicleRecallChecksConnection"] | undefined | null,
	vin?: string | undefined | null,
	vinAuditReports?: ModelTypes["VehicleVinAuditReportsConnection"] | undefined | null,
	year?: string | undefined | null
};
	["VehicleBodyType"]:VehicleBodyType;
	["VehicleCondition"]:VehicleCondition;
	["VehicleLifeCycleStage"]:VehicleLifeCycleStage;
	["VehicleLifeCycleStageFilter"]: {
	equals?: ModelTypes["VehicleLifeCycleStage"] | undefined | null,
	in?: Array<ModelTypes["VehicleLifeCycleStage"]> | undefined | null,
	not?: ModelTypes["VehicleLifeCycleStageFilter"] | undefined | null
};
	["VehicleNhtsaRecallReport"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	response?: ModelTypes["JSON"] | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["VehicleNhtsaRecallReportFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["VehicleNhtsaRecallReportOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["VehiclePrincipalPriorUse"]:VehiclePrincipalPriorUse;
	["VehicleRecallMastersRecallReportsConnection"]: {
		edges?: Array<ModelTypes["VehicleRecallMastersRecallReportsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["VehicleRecallMastersRecallReportsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["RecallMastersRecallReport"] | undefined | null
};
	["VehicleRegistrationExtraction"]: {
		bodyType?: string | undefined | null,
	color?: string | undefined | null,
	condition?: string | undefined | null,
	createdAt: ModelTypes["DateTime"],
	errorMessage?: string | undefined | null,
	id: string,
	licensePlate?: string | undefined | null,
	make?: string | undefined | null,
	mileage?: string | undefined | null,
	model?: string | undefined | null,
	registrationName?: string | undefined | null,
	registrationState?: string | undefined | null,
	requestedById: string,
	status: ModelTypes["VehicleRegistrationExtractionStatus"],
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["VehicleRegistrationExtractionFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["VehicleRegistrationExtractionStatus"]:VehicleRegistrationExtractionStatus;
	["VehicleVehicleRecallChecksConnection"]: {
		edges?: Array<ModelTypes["VehicleVehicleRecallChecksConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["VehicleVehicleRecallChecksConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["VehicleNhtsaRecallReport"] | undefined | null
};
	["VehicleVinAuditReportsConnection"]: {
		edges?: Array<ModelTypes["VehicleVinAuditReportsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: ModelTypes["PageInfo"]
};
	["VehicleVinAuditReportsConnectionEdge"]: {
		cursor: string,
	node?: ModelTypes["VinAuditReport"] | undefined | null
};
	["VinAuditReport"]: {
		createdAt?: ModelTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	response?: ModelTypes["JSON"] | undefined | null,
	updatedAt?: ModelTypes["DateTime"] | undefined | null
};
	["VinAuditReportFilter"]: {
	id?: ModelTypes["IDFilter"] | undefined | null
};
	["VinAuditReportOrderBy"]: {
	createdAt?: ModelTypes["OrderBy"] | undefined | null
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined | null,
	mutation?: ModelTypes["Mutation"] | undefined | null
};
	["ID"]:any
    }

export type GraphQLTypes = {
    ["Acknowledgement"]: Acknowledgement;
	["AcknowledgementFilter"]: {
		equals?: GraphQLTypes["Acknowledgement"] | undefined | null,
	in?: Array<GraphQLTypes["Acknowledgement"]> | undefined | null,
	not?: GraphQLTypes["AcknowledgementFilter"] | undefined | null
};
	["AcknowledgementTemplate"]: {
	__typename: "AcknowledgementTemplate",
	code: GraphQLTypes["Acknowledgement"],
	createdAt: GraphQLTypes["DateTime"],
	id: string,
	language?: string | undefined | null,
	revision: number,
	textMarkdown: string,
	['...on AcknowledgementTemplate']: Omit<GraphQLTypes["AcknowledgementTemplate"], "...on AcknowledgementTemplate">
};
	["AcknowledgementTemplateFilter"]: {
		code?: GraphQLTypes["AcknowledgementFilter"] | undefined | null,
	language?: GraphQLTypes["StringFilter"] | undefined | null
};
	["AcknowledgementTemplateOrderBy"]: {
		revision?: GraphQLTypes["OrderBy"] | undefined | null
};
	["Address"]: {
	__typename: "Address",
	apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	customer?: GraphQLTypes["Customer"] | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	fullAddress?: string | undefined | null,
	housingStatus?: GraphQLTypes["HousingStatus"] | undefined | null,
	id?: string | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition?: number | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null,
	zipCode?: string | undefined | null,
	['...on Address']: Omit<GraphQLTypes["Address"], "...on Address">
};
	["AddressInput"]: {
		apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	housingStatus?: string | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition: number,
	zipCode?: string | undefined | null
};
	["AgilityCreditAccount"]: {
	__typename: "AgilityCreditAccount",
	accountNumber?: string | undefined | null,
	acctType?: string | undefined | null,
	balance?: number | undefined | null,
	bureau?: string | undefined | null,
	closedDate?: string | undefined | null,
	creditLimit?: number | undefined | null,
	creditor?: string | undefined | null,
	currentStatus?: string | undefined | null,
	days30?: number | undefined | null,
	days60?: number | undefined | null,
	days90?: number | undefined | null,
	highCredit?: number | undefined | null,
	id?: string | undefined | null,
	indJoint?: string | undefined | null,
	kind?: GraphQLTypes["AgilityCreditAccountKind"] | undefined | null,
	monthlyPayment?: number | undefined | null,
	notes?: string | undefined | null,
	openClosed?: string | undefined | null,
	openDate?: string | undefined | null,
	originalAmount?: number | undefined | null,
	pastDue?: number | undefined | null,
	paymentHistory?: string | undefined | null,
	reportedDate?: string | undefined | null,
	timesLate?: number | undefined | null,
	tradeType?: string | undefined | null,
	['...on AgilityCreditAccount']: Omit<GraphQLTypes["AgilityCreditAccount"], "...on AgilityCreditAccount">
};
	["AgilityCreditAccountKind"]: AgilityCreditAccountKind;
	["AgilityCreditAddress"]: {
	__typename: "AgilityCreditAddress",
	addressLine1?: string | undefined | null,
	addressLine2?: string | undefined | null,
	addressVarianceCode?: string | undefined | null,
	addressVarianceDescription?: string | undefined | null,
	dateLastReported?: string | undefined | null,
	dateReported?: string | undefined | null,
	id?: string | undefined | null,
	name?: string | undefined | null,
	['...on AgilityCreditAddress']: Omit<GraphQLTypes["AgilityCreditAddress"], "...on AgilityCreditAddress">
};
	["AgilityCreditAka"]: {
	__typename: "AgilityCreditAka",
	id?: string | undefined | null,
	name?: string | undefined | null,
	['...on AgilityCreditAka']: Omit<GraphQLTypes["AgilityCreditAka"], "...on AgilityCreditAka">
};
	["AgilityCreditAlert"]: {
	__typename: "AgilityCreditAlert",
	date?: string | undefined | null,
	id?: string | undefined | null,
	text?: string | undefined | null,
	type?: string | undefined | null,
	['...on AgilityCreditAlert']: Omit<GraphQLTypes["AgilityCreditAlert"], "...on AgilityCreditAlert">
};
	["AgilityCreditApplicantInformation"]: {
	__typename: "AgilityCreditApplicantInformation",
	address?: string | undefined | null,
	dob?: string | undefined | null,
	id?: string | undefined | null,
	infiledDate?: string | undefined | null,
	name?: string | undefined | null,
	phone?: string | undefined | null,
	ssn?: string | undefined | null,
	['...on AgilityCreditApplicantInformation']: Omit<GraphQLTypes["AgilityCreditApplicantInformation"], "...on AgilityCreditApplicantInformation">
};
	["AgilityCreditEmployment"]: {
	__typename: "AgilityCreditEmployment",
	dateHired?: string | undefined | null,
	dateTerminated?: string | undefined | null,
	employer?: string | undefined | null,
	id?: string | undefined | null,
	income?: string | undefined | null,
	infiledDate?: string | undefined | null,
	lastReportedDate?: string | undefined | null,
	occupation?: string | undefined | null,
	status?: string | undefined | null,
	['...on AgilityCreditEmployment']: Omit<GraphQLTypes["AgilityCreditEmployment"], "...on AgilityCreditEmployment">
};
	["AgilityCreditIdVerification"]: {
	__typename: "AgilityCreditIdVerification",
	id?: string | undefined | null,
	idCard?: GraphQLTypes["IdCard"] | undefined | null,
	response?: GraphQLTypes["JSON"] | undefined | null,
	['...on AgilityCreditIdVerification']: Omit<GraphQLTypes["AgilityCreditIdVerification"], "...on AgilityCreditIdVerification">
};
	["AgilityCreditIdVerificationFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["AgilityCreditInquiry"]: {
	__typename: "AgilityCreditInquiry",
	date?: string | undefined | null,
	id?: string | undefined | null,
	industry?: string | undefined | null,
	name?: string | undefined | null,
	subscriberCode?: string | undefined | null,
	['...on AgilityCreditInquiry']: Omit<GraphQLTypes["AgilityCreditInquiry"], "...on AgilityCreditInquiry">
};
	["AgilityCreditPrequalReport"]: {
	__typename: "AgilityCreditPrequalReport",
	accounts?: Array<GraphQLTypes["AgilityCreditAccount"]> | undefined | null,
	addresses?: Array<GraphQLTypes["AgilityCreditAddress"]> | undefined | null,
	akas?: Array<GraphQLTypes["AgilityCreditAka"]> | undefined | null,
	alerts?: Array<GraphQLTypes["AgilityCreditAlert"]> | undefined | null,
	applicantInformation?: Array<GraphQLTypes["AgilityCreditApplicantInformation"]> | undefined | null,
	bureau?: GraphQLTypes["PrequalBureau"] | undefined | null,
	bureauAbbrev?: string | undefined | null,
	collectionsCount?: number | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	creditScores?: Array<GraphQLTypes["AgilityCreditScore"]> | undefined | null,
	disputedAccountsCount?: number | undefined | null,
	employments?: Array<GraphQLTypes["AgilityCreditEmployment"]> | undefined | null,
	errorMessage?: string | undefined | null,
	foreclosuresCount?: number | undefined | null,
	hitIndicator?: string | undefined | null,
	inquiries?: Array<GraphQLTypes["AgilityCreditInquiry"]> | undefined | null,
	inquiriesCount?: number | undefined | null,
	noScoreIndicator?: boolean | undefined | null,
	openCollectionsCount?: number | undefined | null,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "ap_...") */
	pId?: string | undefined | null,
	publicRecords?: Array<GraphQLTypes["AgilityCreditPublicRecord"]> | undefined | null,
	publicRecordsCount?: number | undefined | null,
	pullType?: GraphQLTypes["AgilityCreditPullType"] | undefined | null,
	repossessionsCount?: number | undefined | null,
	revolvingCreditUsage?: string | undefined | null,
	stage?: string | undefined | null,
	summaryCategories?: Array<GraphQLTypes["AgilityCreditSummaryCategory"]> | undefined | null,
	['...on AgilityCreditPrequalReport']: Omit<GraphQLTypes["AgilityCreditPrequalReport"], "...on AgilityCreditPrequalReport">
};
	["AgilityCreditPrequalReportFilter"]: {
		bureau?: GraphQLTypes["PrequalBureauFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	pId?: GraphQLTypes["StringFilter"] | undefined | null
};
	["AgilityCreditPublicRecord"]: {
	__typename: "AgilityCreditPublicRecord",
	courtName?: string | undefined | null,
	dischargeDate?: string | undefined | null,
	docket?: string | undefined | null,
	ecoa?: string | undefined | null,
	filedDate?: string | undefined | null,
	id?: string | undefined | null,
	publicRecordType?: string | undefined | null,
	reportedDate?: string | undefined | null,
	status?: string | undefined | null,
	['...on AgilityCreditPublicRecord']: Omit<GraphQLTypes["AgilityCreditPublicRecord"], "...on AgilityCreditPublicRecord">
};
	["AgilityCreditPullType"]: AgilityCreditPullType;
	["AgilityCreditScore"]: {
	__typename: "AgilityCreditScore",
	factors?: Array<GraphQLTypes["AgilityCreditScoreFactor"]> | undefined | null,
	id?: string | undefined | null,
	model?: string | undefined | null,
	score?: number | undefined | null,
	['...on AgilityCreditScore']: Omit<GraphQLTypes["AgilityCreditScore"], "...on AgilityCreditScore">
};
	["AgilityCreditScoreFactor"]: {
	__typename: "AgilityCreditScoreFactor",
	factorScore?: string | undefined | null,
	id?: string | undefined | null,
	reason?: string | undefined | null,
	['...on AgilityCreditScoreFactor']: Omit<GraphQLTypes["AgilityCreditScoreFactor"], "...on AgilityCreditScoreFactor">
};
	["AgilityCreditSummaryCategory"]: {
	__typename: "AgilityCreditSummaryCategory",
	balance?: number | undefined | null,
	category?: string | undefined | null,
	closed?: number | undefined | null,
	count?: number | undefined | null,
	current?: number | undefined | null,
	days30?: number | undefined | null,
	days60?: number | undefined | null,
	days90?: number | undefined | null,
	id?: string | undefined | null,
	open?: number | undefined | null,
	pastDue?: number | undefined | null,
	payments?: number | undefined | null,
	unrated?: number | undefined | null,
	['...on AgilityCreditSummaryCategory']: Omit<GraphQLTypes["AgilityCreditSummaryCategory"], "...on AgilityCreditSummaryCategory">
};
	["Announcement"]: {
	__typename: "Announcement",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	markdownText?: string | undefined | null,
	['...on Announcement']: Omit<GraphQLTypes["Announcement"], "...on Announcement">
};
	["AnnouncementOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["AssignedStaffOrFilter"]: {
		bdcId?: GraphQLTypes["IDFilter"] | undefined | null,
	fniManagerId?: GraphQLTypes["IDFilter"] | undefined | null,
	salesManagerId?: GraphQLTypes["IDFilter"] | undefined | null,
	salesPersonId?: GraphQLTypes["IDFilter"] | undefined | null
};
	/** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
["BigInt"]: "scalar" & { name: "BigInt" };
	["BooleanFilter"]: {
		equals?: boolean | undefined | null,
	not?: GraphQLTypes["BooleanFilter"] | undefined | null
};
	["CdkDealJacketStatus"]: CdkDealJacketStatus;
	["Chat"]: {
	__typename: "Chat",
	chatMessages?: GraphQLTypes["ChatChatMessagesConnection"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	title?: string | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on Chat']: Omit<GraphQLTypes["Chat"], "...on Chat">
};
	["ChatChatMessagesConnection"]: {
	__typename: "ChatChatMessagesConnection",
	edges?: Array<GraphQLTypes["ChatChatMessagesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on ChatChatMessagesConnection']: Omit<GraphQLTypes["ChatChatMessagesConnection"], "...on ChatChatMessagesConnection">
};
	["ChatChatMessagesConnectionEdge"]: {
	__typename: "ChatChatMessagesConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["ChatMessage"] | undefined | null,
	['...on ChatChatMessagesConnectionEdge']: Omit<GraphQLTypes["ChatChatMessagesConnectionEdge"], "...on ChatChatMessagesConnectionEdge">
};
	["ChatMessage"]: {
	__typename: "ChatMessage",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	message?: GraphQLTypes["JSON"] | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on ChatMessage']: Omit<GraphQLTypes["ChatMessage"], "...on ChatMessage">
};
	["CheckBoxGroup"]: {
	__typename: "CheckBoxGroup",
	id: string,
	label: string,
	n?: number | undefined | null,
	rule: GraphQLTypes["CheckBoxGroupRules"],
	['...on CheckBoxGroup']: Omit<GraphQLTypes["CheckBoxGroup"], "...on CheckBoxGroup">
};
	["CheckBoxGroupRules"]: CheckBoxGroupRules;
	["ComplianceData"]: {
	__typename: "ComplianceData",
	/** ID Verification status, Not enabled for all dealerships */
	hasRequestedIdv: GraphQLTypes["ComplianceIdvField"],
	id: GraphQLTypes["ComplianceField"],
	idQuizSummary: GraphQLTypes["ComplianceField"],
	ofacStatus: GraphQLTypes["ComplianceField"],
	recalls: GraphQLTypes["ComplianceField"],
	redFlagStatus: GraphQLTypes["ComplianceField"],
	['...on ComplianceData']: Omit<GraphQLTypes["ComplianceData"], "...on ComplianceData">
};
	["ComplianceField"]: {
	__typename: "ComplianceField",
	description: string,
	status: GraphQLTypes["ComplianceStatus"],
	title: string,
	['...on ComplianceField']: Omit<GraphQLTypes["ComplianceField"], "...on ComplianceField">
};
	["ComplianceFormsData"]: {
	__typename: "ComplianceFormsData",
	/** Whether or not the lending portal can be accessed */
	lendingPortalPreCondition: GraphQLTypes["ComplianceFormsPreCondition"],
	/** Returns the post-purchase forms that will be requested signed */
	postPurchaseForms?: Array<GraphQLTypes["Form"]> | undefined | null,
	/** Whether or not the post-purchase forms can be requested */
	postPurchasePreCondition: GraphQLTypes["ComplianceFormsPreCondition"],
	/** Returns the pre-purchase forms that will be requested signed */
	prePurchaseForms?: Array<GraphQLTypes["Form"]> | undefined | null,
	prePurchasePreCondition: GraphQLTypes["ComplianceFormsPreCondition"],
	['...on ComplianceFormsData']: Omit<GraphQLTypes["ComplianceFormsData"], "...on ComplianceFormsData">
};
	["ComplianceFormsPreCondition"]: {
	__typename: "ComplianceFormsPreCondition",
	errorCodes?: Array<GraphQLTypes["FormRequestErrorCode"]> | undefined | null,
	result: boolean,
	['...on ComplianceFormsPreCondition']: Omit<GraphQLTypes["ComplianceFormsPreCondition"], "...on ComplianceFormsPreCondition">
};
	["ComplianceIdvField"]: {
	__typename: "ComplianceIdvField",
	description: string,
	hasIdCard: boolean,
	hasRequestedVerification: boolean,
	latestVerificationId?: string | undefined | null,
	status: GraphQLTypes["ComplianceStatus"],
	title: string,
	['...on ComplianceIdvField']: Omit<GraphQLTypes["ComplianceIdvField"], "...on ComplianceIdvField">
};
	["ComplianceStatus"]: ComplianceStatus;
	["ContactV2"]: {
	__typename: "ContactV2",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	customers?: GraphQLTypes["ContactV2CustomersConnection"] | undefined | null,
	firstName?: string | undefined | null,
	id: string,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	pId?: string | undefined | null,
	profilePicture?: GraphQLTypes["File"] | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	['...on ContactV2']: Omit<GraphQLTypes["ContactV2"], "...on ContactV2">
};
	["ContactV2CustomersConnection"]: {
	__typename: "ContactV2CustomersConnection",
	edges: Array<GraphQLTypes["ContactV2CustomersConnectionEdge"]>,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on ContactV2CustomersConnection']: Omit<GraphQLTypes["ContactV2CustomersConnection"], "...on ContactV2CustomersConnection">
};
	["ContactV2CustomersConnectionEdge"]: {
	__typename: "ContactV2CustomersConnectionEdge",
	cursor: string,
	node: GraphQLTypes["Customer"],
	['...on ContactV2CustomersConnectionEdge']: Omit<GraphQLTypes["ContactV2CustomersConnectionEdge"], "...on ContactV2CustomersConnectionEdge">
};
	["ContactV2Filter"]: {
		pId?: GraphQLTypes["IDFilter"] | undefined | null,
	userId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["CreateCustomerInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string
};
	["CreateEmploymentInput"]: {
		durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus: string,
	incomeAmount?: number | undefined | null,
	incomeInterval?: string | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: string | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition: number
};
	["CreateStaffScheduleEventsInput"]: {
		endAt: string,
	note?: string | undefined | null,
	staffId: string,
	startAt: string,
	weeklyDuplications: number
};
	["CreateUserInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string,
	role: string
};
	["CreditApplicationAddressInformationInput"]: {
		apartmentDetails?: string | undefined | null,
	city: string,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	state: string,
	street: string,
	zipCode: string
};
	["CreditApplicationEmploymentInformationInput"]: {
		durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus: GraphQLTypes["EmploymentStatus"],
	incomeAmount?: number | undefined | null,
	incomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null
};
	["CreditApplicationFormSubmissionDataInput"]: {
		addressDuration?: string | undefined | null,
	birthdate?: string | undefined | null,
	city?: string | undefined | null,
	customerName?: string | undefined | null,
	dateTime?: string | undefined | null,
	dealerPrivacyAckTmplId?: string | undefined | null,
	dealershipName?: string | undefined | null,
	deviceId?: string | undefined | null,
	eSignAckTmplId?: string | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: string | undefined | null,
	firstName?: string | undefined | null,
	hcaReportAckTmplId?: string | undefined | null,
	ipAddress?: string | undefined | null,
	jobTitle?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	modificationAckTmplId?: string | undefined | null,
	mortgageOrRentMonthlyPay?: string | undefined | null,
	name?: string | undefined | null,
	otherIncmeSource?: string | undefined | null,
	otherIncomeAmount?: string | undefined | null,
	otherIncomeType?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	prevEmployerInfo?: string | undefined | null,
	previousAddress?: string | undefined | null,
	previousAddressLength?: string | undefined | null,
	refNameAddress?: string | undefined | null,
	refPhoneNumber?: string | undefined | null,
	refRelationship?: string | undefined | null,
	residentialStatus?: string | undefined | null,
	salary?: string | undefined | null,
	signature?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	state?: string | undefined | null,
	streetAddress?: string | undefined | null,
	tdcConsentsAckTmplId?: string | undefined | null,
	timeOnJob?: string | undefined | null,
	type?: string | undefined | null,
	zip?: string | undefined | null
};
	["CreditApplicationFormSubmissionInput"]: {
		submissionData: GraphQLTypes["CreditApplicationFormSubmissionDataInput"],
	submissionType: string
};
	["CreditApplicationInput"]: {
		birthdate: string,
	currentAddress: GraphQLTypes["CreditApplicationAddressInformationInput"],
	currentAddressHousingStatus: GraphQLTypes["HousingStatus"],
	currentAddressMonthlyPayment: number,
	currentEmployment: GraphQLTypes["CreditApplicationEmploymentInformationInput"],
	dateTime: string,
	dealerPrivacyAckTmplId: string,
	deviceId: string,
	eSignAckTmplId: string,
	email: string,
	firstName: string,
	fullName: string,
	hcaReportAckTmplId: string,
	ipAddress: string,
	lastName: string,
	middleName?: string | undefined | null,
	phoneNumber: string,
	previousAddress?: GraphQLTypes["CreditApplicationAddressInformationInput"] | undefined | null,
	previousEmployment?: GraphQLTypes["CreditApplicationEmploymentInformationInput"] | undefined | null,
	signature: string,
	socialSecurityNumber: string,
	tdcConsentsAckTmplId: string
};
	["Customer"]: {
	__typename: "Customer",
	birthdate?: string | undefined | null,
	compliance: GraphQLTypes["ComplianceData"],
	contact: GraphQLTypes["ContactV2"],
	contactAcknowledgement?: GraphQLTypes["FormSubmission"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	dealership?: GraphQLTypes["Dealership"] | undefined | null,
	disassociatedRole?: string | undefined | null,
	dob?: string | undefined | null,
	documents?: GraphQLTypes["CustomerDocumentsConnection"] | undefined | null,
	employments?: GraphQLTypes["CustomerEmploymentsConnection"] | undefined | null,
	firstName?: string | undefined | null,
	formSubmissions?: GraphQLTypes["CustomerFormSubmissionsConnection"] | undefined | null,
	hardCreditApplications?: GraphQLTypes["CustomerHardCreditApplicationsConnection"] | undefined | null,
	hasBeenRemovedFromTransaction?: boolean | undefined | null,
	hasPrequalApplication: boolean,
	hasSubmittedHardCreditApplication: boolean,
	idCards?: Array<GraphQLTypes["IdCard"]> | undefined | null,
	identityTheftPrevention?: GraphQLTypes["FormSubmission"] | undefined | null,
	languageSelection: Array<string>,
	lastName?: string | undefined | null,
	lastRequestedPrescreenAt?: GraphQLTypes["DateTime"] | undefined | null,
	livelinessSession?: GraphQLTypes["CustomerLivelinessSessionConnection"] | undefined | null,
	middleName?: string | undefined | null,
	/** Returns an entity that explains the next document to sign ordered in signing order */
	nextDocumentsToSign?: GraphQLTypes["CustomerNextDocumentsToSignConnection"] | undefined | null,
	onboardingStep: GraphQLTypes["OnboardingStep"],
	prequalApplications?: GraphQLTypes["CustomerPrequalApplicationsConnection"] | undefined | null,
	prescreens?: GraphQLTypes["CustomerPrescreensConnection"] | undefined | null,
	privacyPolicy?: GraphQLTypes["FormSubmission"] | undefined | null,
	residentialAddresses?: GraphQLTypes["CustomerResidentialAddressesConnection"] | undefined | null,
	selfieCapture?: GraphQLTypes["File"] | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	testDriveDisclosure?: GraphQLTypes["FormSubmission"] | undefined | null,
	transaction?: GraphQLTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	vehicleRegistrationAddress?: GraphQLTypes["Address"] | undefined | null,
	vehicleRegistrationAddressId?: string | undefined | null,
	['...on Customer']: Omit<GraphQLTypes["Customer"], "...on Customer">
};
	["CustomerDocumentsConnection"]: {
	__typename: "CustomerDocumentsConnection",
	edges?: Array<GraphQLTypes["CustomerDocumentsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on CustomerDocumentsConnection']: Omit<GraphQLTypes["CustomerDocumentsConnection"], "...on CustomerDocumentsConnection">
};
	["CustomerDocumentsConnectionEdge"]: {
	__typename: "CustomerDocumentsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Document"] | undefined | null,
	['...on CustomerDocumentsConnectionEdge']: Omit<GraphQLTypes["CustomerDocumentsConnectionEdge"], "...on CustomerDocumentsConnectionEdge">
};
	["CustomerEmploymentsConnection"]: {
	__typename: "CustomerEmploymentsConnection",
	edges?: Array<GraphQLTypes["CustomerEmploymentsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on CustomerEmploymentsConnection']: Omit<GraphQLTypes["CustomerEmploymentsConnection"], "...on CustomerEmploymentsConnection">
};
	["CustomerEmploymentsConnectionEdge"]: {
	__typename: "CustomerEmploymentsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Employment"] | undefined | null,
	['...on CustomerEmploymentsConnectionEdge']: Omit<GraphQLTypes["CustomerEmploymentsConnectionEdge"], "...on CustomerEmploymentsConnectionEdge">
};
	["CustomerFilter"]: {
		transactionId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["CustomerFormSubmissionsConnection"]: {
	__typename: "CustomerFormSubmissionsConnection",
	edges?: Array<GraphQLTypes["CustomerFormSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on CustomerFormSubmissionsConnection']: Omit<GraphQLTypes["CustomerFormSubmissionsConnection"], "...on CustomerFormSubmissionsConnection">
};
	["CustomerFormSubmissionsConnectionEdge"]: {
	__typename: "CustomerFormSubmissionsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["FormSubmission"] | undefined | null,
	['...on CustomerFormSubmissionsConnectionEdge']: Omit<GraphQLTypes["CustomerFormSubmissionsConnectionEdge"], "...on CustomerFormSubmissionsConnectionEdge">
};
	["CustomerHardCreditApplicationsConnection"]: {
	__typename: "CustomerHardCreditApplicationsConnection",
	edges?: Array<GraphQLTypes["CustomerHardCreditApplicationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on CustomerHardCreditApplicationsConnection']: Omit<GraphQLTypes["CustomerHardCreditApplicationsConnection"], "...on CustomerHardCreditApplicationsConnection">
};
	["CustomerHardCreditApplicationsConnectionEdge"]: {
	__typename: "CustomerHardCreditApplicationsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["HardCreditApplication"] | undefined | null,
	['...on CustomerHardCreditApplicationsConnectionEdge']: Omit<GraphQLTypes["CustomerHardCreditApplicationsConnectionEdge"], "...on CustomerHardCreditApplicationsConnectionEdge">
};
	["CustomerLivelinessSessionConnection"]: {
	__typename: "CustomerLivelinessSessionConnection",
	edges?: Array<GraphQLTypes["CustomerLivelinessSessionConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on CustomerLivelinessSessionConnection']: Omit<GraphQLTypes["CustomerLivelinessSessionConnection"], "...on CustomerLivelinessSessionConnection">
};
	["CustomerLivelinessSessionConnectionEdge"]: {
	__typename: "CustomerLivelinessSessionConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["LivelinessSession"] | undefined | null,
	['...on CustomerLivelinessSessionConnectionEdge']: Omit<GraphQLTypes["CustomerLivelinessSessionConnectionEdge"], "...on CustomerLivelinessSessionConnectionEdge">
};
	["CustomerNextDocumentsToSignConnection"]: {
	__typename: "CustomerNextDocumentsToSignConnection",
	edges?: Array<GraphQLTypes["CustomerNextDocumentsToSignConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on CustomerNextDocumentsToSignConnection']: Omit<GraphQLTypes["CustomerNextDocumentsToSignConnection"], "...on CustomerNextDocumentsToSignConnection">
};
	["CustomerNextDocumentsToSignConnectionEdge"]: {
	__typename: "CustomerNextDocumentsToSignConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["FormSubmission"] | undefined | null,
	['...on CustomerNextDocumentsToSignConnectionEdge']: Omit<GraphQLTypes["CustomerNextDocumentsToSignConnectionEdge"], "...on CustomerNextDocumentsToSignConnectionEdge">
};
	["CustomerPrequalApplicationsConnection"]: {
	__typename: "CustomerPrequalApplicationsConnection",
	edges?: Array<GraphQLTypes["CustomerPrequalApplicationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on CustomerPrequalApplicationsConnection']: Omit<GraphQLTypes["CustomerPrequalApplicationsConnection"], "...on CustomerPrequalApplicationsConnection">
};
	["CustomerPrequalApplicationsConnectionEdge"]: {
	__typename: "CustomerPrequalApplicationsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["PrequalApplication"] | undefined | null,
	['...on CustomerPrequalApplicationsConnectionEdge']: Omit<GraphQLTypes["CustomerPrequalApplicationsConnectionEdge"], "...on CustomerPrequalApplicationsConnectionEdge">
};
	["CustomerPrescreensConnection"]: {
	__typename: "CustomerPrescreensConnection",
	edges?: Array<GraphQLTypes["CustomerPrescreensConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on CustomerPrescreensConnection']: Omit<GraphQLTypes["CustomerPrescreensConnection"], "...on CustomerPrescreensConnection">
};
	["CustomerPrescreensConnectionEdge"]: {
	__typename: "CustomerPrescreensConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Prescreen"] | undefined | null,
	['...on CustomerPrescreensConnectionEdge']: Omit<GraphQLTypes["CustomerPrescreensConnectionEdge"], "...on CustomerPrescreensConnectionEdge">
};
	["CustomerPurchaseVehicleInput"]: {
		lifeCycleStage: GraphQLTypes["VehicleLifeCycleStage"],
	make: string,
	mileage: number,
	model: string,
	principalPriorUse?: GraphQLTypes["VehiclePrincipalPriorUse"] | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin: string,
	year: string
};
	["CustomerResidentialAddressesConnection"]: {
	__typename: "CustomerResidentialAddressesConnection",
	edges?: Array<GraphQLTypes["CustomerResidentialAddressesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on CustomerResidentialAddressesConnection']: Omit<GraphQLTypes["CustomerResidentialAddressesConnection"], "...on CustomerResidentialAddressesConnection">
};
	["CustomerResidentialAddressesConnectionEdge"]: {
	__typename: "CustomerResidentialAddressesConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Address"] | undefined | null,
	['...on CustomerResidentialAddressesConnectionEdge']: Omit<GraphQLTypes["CustomerResidentialAddressesConnectionEdge"], "...on CustomerResidentialAddressesConnectionEdge">
};
	["CustomerSharedData"]: {
	__typename: "CustomerSharedData",
	buyerEmail?: string | undefined | null,
	buyerFirstName?: string | undefined | null,
	buyerLastName?: string | undefined | null,
	buyerName?: string | undefined | null,
	buyerOnboardingStep?: GraphQLTypes["OnboardingStep"] | undefined | null,
	buyerPhoneNumber?: string | undefined | null,
	coBuyerEmail?: string | undefined | null,
	coBuyerFirstName?: string | undefined | null,
	coBuyerLastName?: string | undefined | null,
	coBuyerName?: string | undefined | null,
	coBuyerOnboardingStep?: GraphQLTypes["OnboardingStep"] | undefined | null,
	coBuyerPhoneNumber?: string | undefined | null,
	['...on CustomerSharedData']: Omit<GraphQLTypes["CustomerSharedData"], "...on CustomerSharedData">
};
	["CustomerSignupInput"]: {
		email: string,
	firstName: string,
	lastName: string,
	phoneNumber: string
};
	["CustomerTradeVehicleInput"]: {
		bodyType: GraphQLTypes["VehicleBodyType"],
	color: string,
	condition: GraphQLTypes["VehicleCondition"],
	make: string,
	mileage: number,
	model: string,
	pictureBackId?: string | undefined | null,
	pictureFrontId?: string | undefined | null,
	pictureInteriorId?: string | undefined | null,
	pictureLeftSideId?: string | undefined | null,
	pictureOdometerId?: string | undefined | null,
	pictureRightSideId?: string | undefined | null,
	pictureVinNumberId?: string | undefined | null,
	registrationCardId?: string | undefined | null,
	registrationName: string,
	registrationState: string,
	vin: string,
	year: string
};
	["CustomerTransactionRole"]: CustomerTransactionRole;
	/** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["Date"]: "scalar" & { name: "Date" };
	/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["DateTimeFilter"]: {
		equals?: GraphQLTypes["DateTime"] | undefined | null,
	gt?: GraphQLTypes["DateTime"] | undefined | null,
	gte?: GraphQLTypes["DateTime"] | undefined | null,
	in?: Array<GraphQLTypes["DateTime"]> | undefined | null,
	lt?: GraphQLTypes["DateTime"] | undefined | null,
	lte?: GraphQLTypes["DateTime"] | undefined | null,
	not?: GraphQLTypes["DateTimeFilter"] | undefined | null
};
	["Dealership"]: {
	__typename: "Dealership",
	address: string,
	contacts: GraphQLTypes["DealershipContactsConnection"],
	dealershipGroupId?: string | undefined | null,
	enabledPolicyLayers?: Array<GraphQLTypes["PolicyLayerType"]> | undefined | null,
	forms?: GraphQLTypes["DealershipFormsConnection"] | undefined | null,
	hasActiveAgilityCreditSubscription?: boolean | undefined | null,
	hasEnabledAuthenticom?: boolean | undefined | null,
	hasEnabledCdkCrm?: boolean | undefined | null,
	hasEnabledCdkDms?: boolean | undefined | null,
	hasEnabledChatBot?: boolean | undefined | null,
	hasEnabledComplianceForms?: boolean | undefined | null,
	hasEnabledDealJacketGalleryView?: boolean | undefined | null,
	hasEnabledDealerTrack?: boolean | undefined | null,
	hasEnabledDriversLicenseVerification?: boolean | undefined | null,
	hasEnabledFormsCatalog?: boolean | undefined | null,
	hasEnabledIdVerifOverAgility?: boolean | undefined | null,
	hasEnabledImplicitPrequalsOnHca?: boolean | undefined | null,
	hasEnabledPostPurchaseDocs?: boolean | undefined | null,
	hasEnabledPrequalFormService?: boolean | undefined | null,
	hasEnabledPrescreen?: boolean | undefined | null,
	hasEnabledRecallMasters?: boolean | undefined | null,
	hasEnabledReferrals?: boolean | undefined | null,
	hasEnabledReportingDashboard?: boolean | undefined | null,
	hasEnabledRoute1?: boolean | undefined | null,
	hasEnabledStaffAcknowledgement?: boolean | undefined | null,
	hasEnabledStaffPlanning?: boolean | undefined | null,
	hasEnabledZipCodeOnSignUp?: boolean | undefined | null,
	/** Whether or not the dealership has a TDC CDK app subscription ID set. */
	hasTdcCdkAppSubscriptionId?: boolean | undefined | null,
	homenetVehicles?: GraphQLTypes["DealershipHomenetVehiclesConnection"] | undefined | null,
	id: string,
	logoUrl?: string | undefined | null,
	name: string,
	phone: string,
	postPurchaseBillOfSaleFormId?: string | undefined | null,
	postPurchasePurchaseOrderFormId?: string | undefined | null,
	recallDetailsFormId?: string | undefined | null,
	recallSummaryFormId?: string | undefined | null,
	/** Only applicable when the feature is enabled. See hasEnabledReferrals */
	referralPayoutAmountInUsdCents?: number | undefined | null,
	/** The sales people of a dealership needs to be presented on the signup page */
	salesPeople?: Array<GraphQLTypes["ListItem"]> | undefined | null,
	slug: string,
	staff?: GraphQLTypes["DealershipStaffConnection"] | undefined | null,
	supportedLanguages?: Array<string> | undefined | null,
	timeZone?: string | undefined | null,
	transactionStatusUpdateDealershipAnalyticsCount?: number | undefined | null,
	transactionUpdateDealershipSpotCount?: number | undefined | null,
	transactionUpdateStatusSalesRankingGrouped?: Array<GraphQLTypes["SalesRankingGrouppedByMonth"]> | undefined | null,
	transactions?: GraphQLTypes["DealershipTransactionsConnection"] | undefined | null,
	users?: GraphQLTypes["DealershipUsersConnection"] | undefined | null,
	website?: string | undefined | null,
	['...on Dealership']: Omit<GraphQLTypes["Dealership"], "...on Dealership">
};
	["DealershipContactsConnection"]: {
	__typename: "DealershipContactsConnection",
	edges: Array<GraphQLTypes["DealershipContactsConnectionEdge"]>,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on DealershipContactsConnection']: Omit<GraphQLTypes["DealershipContactsConnection"], "...on DealershipContactsConnection">
};
	["DealershipContactsConnectionEdge"]: {
	__typename: "DealershipContactsConnectionEdge",
	cursor: string,
	node: GraphQLTypes["ContactV2"],
	['...on DealershipContactsConnectionEdge']: Omit<GraphQLTypes["DealershipContactsConnectionEdge"], "...on DealershipContactsConnectionEdge">
};
	["DealershipFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null,
	slug?: GraphQLTypes["IDFilter"] | undefined | null
};
	["DealershipFormsConnection"]: {
	__typename: "DealershipFormsConnection",
	edges?: Array<GraphQLTypes["DealershipFormsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on DealershipFormsConnection']: Omit<GraphQLTypes["DealershipFormsConnection"], "...on DealershipFormsConnection">
};
	["DealershipFormsConnectionEdge"]: {
	__typename: "DealershipFormsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Form"] | undefined | null,
	['...on DealershipFormsConnectionEdge']: Omit<GraphQLTypes["DealershipFormsConnectionEdge"], "...on DealershipFormsConnectionEdge">
};
	["DealershipGroup"]: {
	__typename: "DealershipGroup",
	address?: string | undefined | null,
	id?: string | undefined | null,
	name?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	['...on DealershipGroup']: Omit<GraphQLTypes["DealershipGroup"], "...on DealershipGroup">
};
	["DealershipHomenetVehiclesConnection"]: {
	__typename: "DealershipHomenetVehiclesConnection",
	edges?: Array<GraphQLTypes["DealershipHomenetVehiclesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on DealershipHomenetVehiclesConnection']: Omit<GraphQLTypes["DealershipHomenetVehiclesConnection"], "...on DealershipHomenetVehiclesConnection">
};
	["DealershipHomenetVehiclesConnectionEdge"]: {
	__typename: "DealershipHomenetVehiclesConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["HomenetVehicleData"] | undefined | null,
	['...on DealershipHomenetVehiclesConnectionEdge']: Omit<GraphQLTypes["DealershipHomenetVehiclesConnectionEdge"], "...on DealershipHomenetVehiclesConnectionEdge">
};
	["DealershipPermType"]: {
	__typename: "DealershipPermType",
	dealershipGroupId?: string | undefined | null,
	dealershipGroupName?: string | undefined | null,
	dealershipId: string,
	dealershipName: string,
	extraPermissions?: Array<GraphQLTypes["Permission"]> | undefined | null,
	groupRole?: GraphQLTypes["Role"] | undefined | null,
	role?: GraphQLTypes["Role"] | undefined | null,
	['...on DealershipPermType']: Omit<GraphQLTypes["DealershipPermType"], "...on DealershipPermType">
};
	["DealershipPurchaseVehicleInput"]: {
		bodyType?: GraphQLTypes["VehicleBodyType"] | undefined | null,
	lifeCycleStage: GraphQLTypes["VehicleLifeCycleStage"],
	make: string,
	mileage: number,
	model: string,
	msrp?: number | undefined | null,
	principalPriorUse?: GraphQLTypes["VehiclePrincipalPriorUse"] | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin: string,
	year: string
};
	["DealershipStaffConnection"]: {
	__typename: "DealershipStaffConnection",
	edges?: Array<GraphQLTypes["DealershipStaffConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on DealershipStaffConnection']: Omit<GraphQLTypes["DealershipStaffConnection"], "...on DealershipStaffConnection">
};
	["DealershipStaffConnectionEdge"]: {
	__typename: "DealershipStaffConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Staff"] | undefined | null,
	['...on DealershipStaffConnectionEdge']: Omit<GraphQLTypes["DealershipStaffConnectionEdge"], "...on DealershipStaffConnectionEdge">
};
	["DealershipTradeVehicleInput"]: {
		bodyType: GraphQLTypes["VehicleBodyType"],
	color: string,
	condition: GraphQLTypes["VehicleCondition"],
	lifeCycleStage?: GraphQLTypes["VehicleLifeCycleStage"] | undefined | null,
	make: string,
	mileage: number,
	model: string,
	registrationName: string,
	registrationState?: string | undefined | null,
	vin: string,
	year: string
};
	["DealershipTransactionsConnection"]: {
	__typename: "DealershipTransactionsConnection",
	edges?: Array<GraphQLTypes["DealershipTransactionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on DealershipTransactionsConnection']: Omit<GraphQLTypes["DealershipTransactionsConnection"], "...on DealershipTransactionsConnection">
};
	["DealershipTransactionsConnectionEdge"]: {
	__typename: "DealershipTransactionsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Transaction"] | undefined | null,
	['...on DealershipTransactionsConnectionEdge']: Omit<GraphQLTypes["DealershipTransactionsConnectionEdge"], "...on DealershipTransactionsConnectionEdge">
};
	["DealershipUsersConnection"]: {
	__typename: "DealershipUsersConnection",
	edges?: Array<GraphQLTypes["DealershipUsersConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on DealershipUsersConnection']: Omit<GraphQLTypes["DealershipUsersConnection"], "...on DealershipUsersConnection">
};
	["DealershipUsersConnectionEdge"]: {
	__typename: "DealershipUsersConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["UserDealership"] | undefined | null,
	['...on DealershipUsersConnectionEdge']: Omit<GraphQLTypes["DealershipUsersConnectionEdge"], "...on DealershipUsersConnectionEdge">
};
	["Document"]: {
	__typename: "Document",
	access?: string | undefined | null,
	cdkDealJacketStatus?: GraphQLTypes["CdkDealJacketStatus"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	customer?: GraphQLTypes["Customer"] | undefined | null,
	file?: GraphQLTypes["File"] | undefined | null,
	id: string,
	labels?: Array<GraphQLTypes["DocumentLabelAttachment"]> | undefined | null,
	pdfIsEncrypted?: boolean | undefined | null,
	title?: string | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null,
	['...on Document']: Omit<GraphQLTypes["Document"], "...on Document">
};
	["DocumentLabel"]: {
	__typename: "DocumentLabel",
	code?: string | undefined | null,
	id: string,
	label: string,
	['...on DocumentLabel']: Omit<GraphQLTypes["DocumentLabel"], "...on DocumentLabel">
};
	["DocumentLabelAttachment"]: {
	__typename: "DocumentLabelAttachment",
	documentLabel: GraphQLTypes["DocumentLabel"],
	isActive: boolean,
	['...on DocumentLabelAttachment']: Omit<GraphQLTypes["DocumentLabelAttachment"], "...on DocumentLabelAttachment">
};
	["DocumentLabelOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["DocumentOr"]: {
		access?: GraphQLTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	dealershipReadAccess?: GraphQLTypes["RoleListFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	userId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["DocumentOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["Employment"]: {
	__typename: "Employment",
	customer?: GraphQLTypes["Customer"] | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: GraphQLTypes["EmploymentStatus"] | undefined | null,
	id?: string | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition?: number | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null,
	['...on Employment']: Omit<GraphQLTypes["Employment"], "...on Employment">
};
	["EmploymentStatus"]: EmploymentStatus;
	/** A frequently asked question with its answer. FAQs can be scoped to a specific dealership, a dealership group, or global (visible to all authenticated users). */
["Faq"]: {
	__typename: "Faq",
	/** The answer text. */
	answer?: string | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	/** If set, this FAQ belongs to a dealership group and is visible to all dealerships in that group. */
	dealershipGroupId?: string | undefined | null,
	/** If set, this FAQ belongs to a specific dealership and is only visible to users of that dealership. */
	dealershipId?: string | undefined | null,
	/** Unique identifier for this FAQ. */
	id?: string | undefined | null,
	/** The question text. */
	question?: string | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on Faq']: Omit<GraphQLTypes["Faq"], "...on Faq">
};
	["FieldOrdering"]: FieldOrdering;
	["File"]: {
	__typename: "File",
	id?: string | undefined | null,
	uploader?: GraphQLTypes["User"] | undefined | null,
	url?: string | undefined | null,
	['...on File']: Omit<GraphQLTypes["File"], "...on File">
};
	["FinanceType"]: FinanceType;
	["FinanceTypeFilter"]: {
		equals?: GraphQLTypes["FinanceType"] | undefined | null,
	in?: Array<GraphQLTypes["FinanceType"]> | undefined | null,
	not?: GraphQLTypes["FinanceTypeFilter"] | undefined | null
};
	["Form"]: {
	__typename: "Form",
	createdAt: GraphQLTypes["DateTime"],
	displayTitle: string,
	formFields: Array<GraphQLTypes["FormField"]>,
	formOrder?: GraphQLTypes["FormOrder"] | undefined | null,
	id: string,
	pdfFileUrl?: string | undefined | null,
	['...on Form']: Omit<GraphQLTypes["Form"], "...on Form">
};
	["FormCollectionStatus"]: FormCollectionStatus;
	["FormCollectionStatusFilter"]: {
		equals?: GraphQLTypes["FormCollectionStatus"] | undefined | null,
	in?: Array<GraphQLTypes["FormCollectionStatus"]> | undefined | null,
	not?: GraphQLTypes["FormCollectionStatusFilter"] | undefined | null,
	notIn?: Array<GraphQLTypes["FormCollectionStatus"]> | undefined | null
};
	["FormCollectionType"]: FormCollectionType;
	["FormCollectionTypeFilter"]: {
		equals?: GraphQLTypes["FormCollectionType"] | undefined | null,
	in?: Array<GraphQLTypes["FormCollectionType"]> | undefined | null,
	not?: GraphQLTypes["FormCollectionTypeFilter"] | undefined | null,
	notIn?: Array<GraphQLTypes["FormCollectionType"]> | undefined | null
};
	["FormField"]: {
	__typename: "FormField",
	characterListLength?: number | undefined | null,
	checkboxGroup?: GraphQLTypes["CheckBoxGroup"] | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	demoData?: string | undefined | null,
	enteredBy?: Array<GraphQLTypes["TransactionRole"]> | undefined | null,
	fixedValue?: string | undefined | null,
	form: GraphQLTypes["Form"],
	formFieldId: string,
	formFieldPlacements: Array<GraphQLTypes["FormFieldPlacement"]>,
	formId: string,
	id: string,
	isAdminAllowed: boolean,
	isOptional: boolean,
	prefillPath?: string | undefined | null,
	type: GraphQLTypes["FormFieldType"],
	['...on FormField']: Omit<GraphQLTypes["FormField"], "...on FormField">
};
	["FormFieldFilter"]: {
		isAdminAllowed?: GraphQLTypes["BooleanFilter"] | undefined | null,
	prefillPath?: string | undefined | null
};
	["FormFieldPlacement"]: {
	__typename: "FormFieldPlacement",
	characterListSpacing?: number | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	formField: GraphQLTypes["FormField"],
	formFieldId: string,
	formFieldPlacementId: string,
	height: number,
	id: string,
	page: number,
	positionX: number,
	positionY: number,
	textAlignment?: GraphQLTypes["TextAlignment"] | undefined | null,
	textBold: boolean,
	textFontSize?: number | undefined | null,
	textItalic: boolean,
	textLineHeight?: number | undefined | null,
	textUnderline: boolean,
	width: number,
	['...on FormFieldPlacement']: Omit<GraphQLTypes["FormFieldPlacement"], "...on FormFieldPlacement">
};
	["FormFieldSubmission"]: {
	__typename: "FormFieldSubmission",
	field?: GraphQLTypes["FormField"] | undefined | null,
	fieldId?: GraphQLTypes["ID"] | undefined | null,
	file?: GraphQLTypes["File"] | undefined | null,
	formSubmission?: GraphQLTypes["FormSubmission"] | undefined | null,
	value?: string | undefined | null,
	['...on FormFieldSubmission']: Omit<GraphQLTypes["FormFieldSubmission"], "...on FormFieldSubmission">
};
	["FormFieldSubmissionAllowedUserFilter"]: {
		userId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["FormFieldSubmissionAllowedUserListFilter"]: {
		some?: GraphQLTypes["FormFieldSubmissionAllowedUserFilter"] | undefined | null
};
	["FormFieldSubmissionFilter"]: {
		OR?: Array<GraphQLTypes["FormFieldSubmissionOrFilter"]> | undefined | null,
	allowedUsers?: GraphQLTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null,
	field?: GraphQLTypes["FormFieldFilter"] | undefined | null,
	fileId?: GraphQLTypes["IDFilter"] | undefined | null,
	formSubmissionId?: GraphQLTypes["IDFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	value?: GraphQLTypes["StringFilter"] | undefined | null
};
	["FormFieldSubmissionOrFilter"]: {
		allowedUsers?: GraphQLTypes["FormFieldSubmissionAllowedUserListFilter"] | undefined | null,
	field?: GraphQLTypes["FormFieldFilter"] | undefined | null
};
	["FormFieldSubmissionOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["FormFieldType"]: FormFieldType;
	["FormFieldValue"]: {
		fileId?: string | undefined | null,
	submissionFieldId: string,
	value?: string | undefined | null
};
	["FormOrder"]: {
	__typename: "FormOrder",
	position?: number | undefined | null,
	['...on FormOrder']: Omit<GraphQLTypes["FormOrder"], "...on FormOrder">
};
	["FormRequestErrorCode"]: FormRequestErrorCode;
	["FormSubmission"]: {
	__typename: "FormSubmission",
	access?: string | undefined | null,
	cdkDealJacketStatus?: GraphQLTypes["CdkDealJacketStatus"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	customer: GraphQLTypes["Customer"],
	file?: GraphQLTypes["File"] | undefined | null,
	fileId?: string | undefined | null,
	form?: GraphQLTypes["Form"] | undefined | null,
	formCollection?: GraphQLTypes["FormSubmissionCollection"] | undefined | null,
	formFieldSubmissions?: GraphQLTypes["FormSubmissionFormFieldSubmissionsConnection"] | undefined | null,
	formSubmissionData?: string | undefined | null,
	id: string,
	status?: string | undefined | null,
	type?: string | undefined | null,
	userId?: string | undefined | null,
	['...on FormSubmission']: Omit<GraphQLTypes["FormSubmission"], "...on FormSubmission">
};
	["FormSubmissionAccessEmum"]: FormSubmissionAccessEmum;
	/** If the user filters in elements it can not access, it will fail */
["FormSubmissionAccessEmumFilter"]: {
		equals?: GraphQLTypes["FormSubmissionAccessEmum"] | undefined | null,
	in?: Array<GraphQLTypes["FormSubmissionAccessEmum"]> | undefined | null,
	not?: GraphQLTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	notIn?: Array<GraphQLTypes["FormSubmissionAccessEmum"]> | undefined | null
};
	["FormSubmissionCollection"]: {
	__typename: "FormSubmissionCollection",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	formSubmissions?: GraphQLTypes["FormSubmissionCollectionFormSubmissionsConnection"] | undefined | null,
	id?: string | undefined | null,
	isCollectionStale: boolean,
	status?: GraphQLTypes["FormCollectionStatus"] | undefined | null,
	type?: GraphQLTypes["FormCollectionType"] | undefined | null,
	['...on FormSubmissionCollection']: Omit<GraphQLTypes["FormSubmissionCollection"], "...on FormSubmissionCollection">
};
	["FormSubmissionCollectionFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null,
	status?: GraphQLTypes["FormCollectionStatusFilter"] | undefined | null,
	type?: GraphQLTypes["FormCollectionTypeFilter"] | undefined | null
};
	["FormSubmissionCollectionFormSubmissionsConnection"]: {
	__typename: "FormSubmissionCollectionFormSubmissionsConnection",
	edges?: Array<GraphQLTypes["FormSubmissionCollectionFormSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on FormSubmissionCollectionFormSubmissionsConnection']: Omit<GraphQLTypes["FormSubmissionCollectionFormSubmissionsConnection"], "...on FormSubmissionCollectionFormSubmissionsConnection">
};
	["FormSubmissionCollectionFormSubmissionsConnectionEdge"]: {
	__typename: "FormSubmissionCollectionFormSubmissionsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["FormSubmission"] | undefined | null,
	['...on FormSubmissionCollectionFormSubmissionsConnectionEdge']: Omit<GraphQLTypes["FormSubmissionCollectionFormSubmissionsConnectionEdge"], "...on FormSubmissionCollectionFormSubmissionsConnectionEdge">
};
	["FormSubmissionCollectionOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["FormSubmissionFilter"]: {
		access?: GraphQLTypes["FormSubmissionAccessEmumFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	status?: GraphQLTypes["FormSubmissionStatusFilter"] | undefined | null,
	type?: GraphQLTypes["FormSubmissionTypeFilter"] | undefined | null,
	userId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["FormSubmissionFormFieldSubmissionsConnection"]: {
	__typename: "FormSubmissionFormFieldSubmissionsConnection",
	edges?: Array<GraphQLTypes["FormSubmissionFormFieldSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on FormSubmissionFormFieldSubmissionsConnection']: Omit<GraphQLTypes["FormSubmissionFormFieldSubmissionsConnection"], "...on FormSubmissionFormFieldSubmissionsConnection">
};
	["FormSubmissionFormFieldSubmissionsConnectionEdge"]: {
	__typename: "FormSubmissionFormFieldSubmissionsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["FormFieldSubmission"] | undefined | null,
	['...on FormSubmissionFormFieldSubmissionsConnectionEdge']: Omit<GraphQLTypes["FormSubmissionFormFieldSubmissionsConnectionEdge"], "...on FormSubmissionFormFieldSubmissionsConnectionEdge">
};
	["FormSubmissionStatus"]: FormSubmissionStatus;
	["FormSubmissionStatusFilter"]: {
		equals?: GraphQLTypes["FormSubmissionStatus"] | undefined | null,
	not?: GraphQLTypes["FormSubmissionStatusFilter"] | undefined | null,
	notIn?: Array<GraphQLTypes["FormSubmissionStatus"]> | undefined | null
};
	["FormSubmissionType"]: FormSubmissionType;
	["FormSubmissionTypeFilter"]: {
		equals?: GraphQLTypes["FormSubmissionType"] | undefined | null,
	in?: Array<GraphQLTypes["FormSubmissionType"]> | undefined | null,
	not?: GraphQLTypes["FormSubmissionTypeFilter"] | undefined | null
};
	["GraphQLError"]: {
	__typename: "GraphQLError",
	message?: string | undefined | null,
	['...on GraphQLError']: Omit<GraphQLTypes["GraphQLError"], "...on GraphQLError">
};
	["HardCreditApplication"]: {
	__typename: "HardCreditApplication",
	createdAt: GraphQLTypes["DateTime"],
	dob?: GraphQLTypes["Date"] | undefined | null,
	driversLicenseNumber?: string | undefined | null,
	driversLicenseState?: string | undefined | null,
	email?: string | undefined | null,
	employments?: GraphQLTypes["JSON"] | undefined | null,
	firstName?: string | undefined | null,
	formSubmission?: GraphQLTypes["FormSubmission"] | undefined | null,
	formSubmissionId?: string | undefined | null,
	homePhoneNumber?: string | undefined | null,
	housingCostUsdCents?: GraphQLTypes["BigInt"] | undefined | null,
	id?: string | undefined | null,
	incomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	incomeUsdCents?: GraphQLTypes["BigInt"] | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	personalReferenceAddress?: GraphQLTypes["Address"] | undefined | null,
	personalReferenceAddressId?: string | undefined | null,
	personalReferenceFirstName?: string | undefined | null,
	personalReferenceLastName?: string | undefined | null,
	personalReferenceMiddleName?: string | undefined | null,
	personalReferencePhoneNumber?: string | undefined | null,
	personalReferenceRelationship?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	residentialAddresses?: GraphQLTypes["JSON"] | undefined | null,
	/** Full SSN for the data owner, masked (last 4 only) for others */
	socialSecurityNumber?: string | undefined | null,
	transaction?: GraphQLTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	['...on HardCreditApplication']: Omit<GraphQLTypes["HardCreditApplication"], "...on HardCreditApplication">
};
	["HardCreditApplicationFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["HardCreditApplicationOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["HomenetVehicleData"]: {
	__typename: "HomenetVehicleData",
	bodyType?: string | undefined | null,
	color?: string | undefined | null,
	dealerId?: string | undefined | null,
	fuelType?: string | undefined | null,
	id?: string | undefined | null,
	locationId?: string | undefined | null,
	make?: string | undefined | null,
	mileage?: string | undefined | null,
	model?: string | undefined | null,
	msrp?: string | undefined | null,
	rooftopId?: string | undefined | null,
	stockNumber?: string | undefined | null,
	transmission?: string | undefined | null,
	trim?: string | undefined | null,
	type?: string | undefined | null,
	vehicleId?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null,
	['...on HomenetVehicleData']: Omit<GraphQLTypes["HomenetVehicleData"], "...on HomenetVehicleData">
};
	["HomenetVehicleDataFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["HousingStatus"]: HousingStatus;
	["IDFilter"]: {
		equals?: string | undefined | null,
	in?: Array<string> | undefined | null,
	not?: GraphQLTypes["IDFilter"] | undefined | null
};
	["IdCard"]: {
	__typename: "IdCard",
	captureBack?: GraphQLTypes["File"] | undefined | null,
	captureBackId?: string | undefined | null,
	captureBackRotation: GraphQLTypes["ImageRotation"],
	captureFront?: GraphQLTypes["File"] | undefined | null,
	captureFrontId?: string | undefined | null,
	captureFrontRotation: GraphQLTypes["ImageRotation"],
	cityInAddress?: string | undefined | null,
	class?: string | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	dob?: GraphQLTypes["DateTime"] | undefined | null,
	dobDateOnly?: GraphQLTypes["Date"] | undefined | null,
	expirationDate?: GraphQLTypes["DateTime"] | undefined | null,
	expirationDateOnly?: GraphQLTypes["Date"] | undefined | null,
	eyeColor?: string | undefined | null,
	firstName?: string | undefined | null,
	height?: string | undefined | null,
	id?: string | undefined | null,
	idNumber?: string | undefined | null,
	issueDate?: GraphQLTypes["DateTime"] | undefined | null,
	issueDateOnly?: GraphQLTypes["Date"] | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	requestedIdVerificationAt?: GraphQLTypes["DateTime"] | undefined | null,
	sex?: string | undefined | null,
	state?: string | undefined | null,
	stateInAddress?: string | undefined | null,
	streetInAddress?: string | undefined | null,
	suffix?: string | undefined | null,
	transactionId?: string | undefined | null,
	type?: string | undefined | null,
	userId?: string | undefined | null,
	zipCodeInAddress?: string | undefined | null,
	['...on IdCard']: Omit<GraphQLTypes["IdCard"], "...on IdCard">
};
	["IdCardType"]: IdCardType;
	["ImageRotation"]: ImageRotation;
	["IncomeInterval"]: IncomeInterval;
	/** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["JSON"]: "scalar" & { name: "JSON" };
	["LenderHardCreditApplication"]: {
	__typename: "LenderHardCreditApplication",
	buyerHousingCostCents?: GraphQLTypes["BigInt"] | undefined | null,
	buyerIncomeCents?: GraphQLTypes["BigInt"] | undefined | null,
	buyerIncomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	coBuyerHousingCostCents?: GraphQLTypes["BigInt"] | undefined | null,
	coBuyerIncomeCents?: GraphQLTypes["BigInt"] | undefined | null,
	coBuyerIncomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	transactionId?: string | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on LenderHardCreditApplication']: Omit<GraphQLTypes["LenderHardCreditApplication"], "...on LenderHardCreditApplication">
};
	["LenderHardCreditApplicationOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["LendingPortalAddressEntryInput"]: {
		apartmentDetails?: string | undefined | null,
	city?: string | undefined | null,
	durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	housingStatus?: GraphQLTypes["HousingStatus"] | undefined | null,
	monthlyPayment?: number | undefined | null,
	state?: string | undefined | null,
	street?: string | undefined | null,
	timelinePosition: number,
	zipCode?: string | undefined | null
};
	["LendingPortalCustomerDataInput"]: {
		dob?: GraphQLTypes["DateTime"] | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null
};
	["LendingPortalEmploymentEntryInput"]: {
		durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: GraphQLTypes["EmploymentStatus"] | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: GraphQLTypes["IncomeInterval"] | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition: number
};
	["LendingPortalPurchaseVehicleDataInput"]: {
		color?: string | undefined | null,
	lifeCycleStage?: GraphQLTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["LendingPortalTradeVehicleDataInput"]: {
		color?: string | undefined | null,
	lifeCycleStage?: GraphQLTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	stockNumber?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null
};
	["LicensePrefillData"]: {
	__typename: "LicensePrefillData",
	make?: string | undefined | null,
	model?: string | undefined | null,
	trim?: string | undefined | null,
	vin?: string | undefined | null,
	year?: string | undefined | null,
	['...on LicensePrefillData']: Omit<GraphQLTypes["LicensePrefillData"], "...on LicensePrefillData">
};
	["ListItem"]: {
	__typename: "ListItem",
	label?: string | undefined | null,
	value?: string | undefined | null,
	['...on ListItem']: Omit<GraphQLTypes["ListItem"], "...on ListItem">
};
	["LivelinessSession"]: {
	__typename: "LivelinessSession",
	auditImages?: Array<GraphQLTypes["File"]> | undefined | null,
	awsLivelinessSessionId?: string | undefined | null,
	confidence?: number | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	dealership?: GraphQLTypes["Dealership"] | undefined | null,
	dealershipId?: string | undefined | null,
	id?: string | undefined | null,
	referenceImage?: GraphQLTypes["File"] | undefined | null,
	status?: string | undefined | null,
	transaction?: GraphQLTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	upddatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	['...on LivelinessSession']: Omit<GraphQLTypes["LivelinessSession"], "...on LivelinessSession">
};
	["LivelinessSessionFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["LoginOptionType"]: LoginOptionType;
	["LoginResponse"]: {
	__typename: "LoginResponse",
	jwt?: string | undefined | null,
	['...on LoginResponse']: Omit<GraphQLTypes["LoginResponse"], "...on LoginResponse">
};
	["MakeFileUploadForScannerType"]: {
	__typename: "MakeFileUploadForScannerType",
	fileId?: string | undefined | null,
	uploadUrl?: string | undefined | null,
	['...on MakeFileUploadForScannerType']: Omit<GraphQLTypes["MakeFileUploadForScannerType"], "...on MakeFileUploadForScannerType">
};
	["MakeFileUploadType"]: {
	__typename: "MakeFileUploadType",
	file?: GraphQLTypes["File"] | undefined | null,
	fileId?: string | undefined | null,
	uploadUrl?: string | undefined | null,
	['...on MakeFileUploadType']: Omit<GraphQLTypes["MakeFileUploadType"], "...on MakeFileUploadType">
};
	["MeType"]: {
	__typename: "MeType",
	chats?: GraphQLTypes["MeTypeChatsConnection"] | undefined | null,
	dealershipGroup?: Array<GraphQLTypes["DealershipGroup"]> | undefined | null,
	dealerships?: Array<GraphQLTypes["Dealership"]> | undefined | null,
	ipAddress?: string | undefined | null,
	/** List of dealerships the user has access to and is a staff at */
	staffAt?: Array<GraphQLTypes["DealershipPermType"]> | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	['...on MeType']: Omit<GraphQLTypes["MeType"], "...on MeType">
};
	["MeTypeChatsConnection"]: {
	__typename: "MeTypeChatsConnection",
	edges?: Array<GraphQLTypes["MeTypeChatsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on MeTypeChatsConnection']: Omit<GraphQLTypes["MeTypeChatsConnection"], "...on MeTypeChatsConnection">
};
	["MeTypeChatsConnectionEdge"]: {
	__typename: "MeTypeChatsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Chat"] | undefined | null,
	['...on MeTypeChatsConnectionEdge']: Omit<GraphQLTypes["MeTypeChatsConnectionEdge"], "...on MeTypeChatsConnectionEdge">
};
	["Mutation"]: {
	__typename: "Mutation",
	/** Upload scanned document using scann to Deal Jacket */
	addScanToDealerJacket?: GraphQLTypes["MutationAddScanToDealerJacketResult"] | undefined | null,
	/** Upload scanned document using scan to Glove Compartment */
	addScanToGloveCompartments?: GraphQLTypes["MutationAddScanToGloveCompartmentsResult"] | undefined | null,
	assignStaffToTransaction?: GraphQLTypes["MutationAssignStaffToTransactionResult"] | undefined | null,
	/** Cancel a form collection */
	cancelFormCollection?: GraphQLTypes["MutationCancelFormCollectionResult"] | undefined | null,
	/** Cancels previously requested forms and regenerates a new set of forms */
	cancelPreviousAndRequestSignatures?: GraphQLTypes["MutationCancelPreviousAndRequestSignaturesResult"] | undefined | null,
	/** Change document access */
	changeDocumentAccess?: GraphQLTypes["MutationChangeDocumentAccessResult"] | undefined | null,
	/** Change form submission access */
	changeFormSubmissionAccess?: GraphQLTypes["MutationChangeFormSubmissionAccessResult"] | undefined | null,
	/** Creates and submits a credit application and prequal if necessary */
	createAndSubmitCreditAndPrequalApplication?: GraphQLTypes["MutationCreateAndSubmitCreditAndPrequalApplicationResult"] | undefined | null,
	/** Create a new chat for a user */
	createChat?: GraphQLTypes["MutationCreateChatResult"] | undefined | null,
	/** Create a co-buyer and add it to the transaction */
	createCoBuyer?: GraphQLTypes["MutationCreateCoBuyerResult"] | undefined | null,
	/** Creates a user, submits a Prequal, and creates a HCA */
	createCreditApplicationAndCreateUser?: GraphQLTypes["MutationCreateCreditApplicationAndCreateUserResult"] | undefined | null,
	/** Create an employment for a user */
	createEmployment?: GraphQLTypes["MutationCreateEmploymentResult"] | undefined | null,
	/** Create a new group level staff based on existing dealership user */
	createGroupuser?: GraphQLTypes["MutationCreateGroupuserResult"] | undefined | null,
	/** Create a new chat for a user */
	createMessage?: GraphQLTypes["MutationCreateMessageResult"] | undefined | null,
	/** Create a new staff */
	createStaff?: GraphQLTypes["MutationCreateStaffResult"] | undefined | null,
	/** Create one or more schedule events for a staff member (optionally duplicated across N weeks). */
	createStaffScheduleEvents?: GraphQLTypes["MutationCreateStaffScheduleEventsResult"] | undefined | null,
	/** Submit a test drive request */
	createTransactionAndSubmitTestDrive?: GraphQLTypes["MutationCreateTransactionAndSubmitTestDriveResult"] | undefined | null,
	/** Submit feedback or a bug report from the dealership dashboard */
	createUserFeedback?: GraphQLTypes["MutationCreateUserFeedbackResult"] | undefined | null,
	/** Creates new transaction for the logged-in customer at the given dealership, using their existing contact info as prefill */
	customerCreatePrefilledTransaction?: GraphQLTypes["MutationCustomerCreatePrefilledTransactionResult"] | undefined | null,
	/** Create a purchase vehicle for a transaction as a customer */
	customerCreatePurchaseVehicle?: GraphQLTypes["MutationCustomerCreatePurchaseVehicleResult"] | undefined | null,
	/** Create a trade vehicle for a transaction as a customer */
	customerCreateTradeVehicle?: GraphQLTypes["MutationCustomerCreateTradeVehicleResult"] | undefined | null,
	/** Create a transaction and sets the logged in user as the buyer. Meant to be used for customers */
	customerCreateTransaction?: GraphQLTypes["MutationCustomerCreateTransactionResult"] | undefined | null,
	/** Create a transaction and user without authenticated email and phone number */
	customerCreateUnauthenticatedTransaction?: GraphQLTypes["MutationCustomerCreateUnauthenticatedTransactionResult"] | undefined | null,
	/** Record consent based on phone number and email */
	customerReferral?: GraphQLTypes["MutationCustomerReferralResult"] | undefined | null,
	/** Record a payment on a referral */
	customerReferralPaid?: GraphQLTypes["MutationCustomerReferralPaidResult"] | undefined | null,
	/** Signs up a new customer that is signed in with cognito */
	customerSignupWithCognito?: GraphQLTypes["MutationCustomerSignupWithCognitoResult"] | undefined | null,
	/** Update phone number for logged in user */
	customerUpdatePhoneNumber?: GraphQLTypes["MutationCustomerUpdatePhoneNumberResult"] | undefined | null,
	/** Update the purchase vehicle on the transaction as a customer */
	customerUpdatePurchaseVehicle?: GraphQLTypes["MutationCustomerUpdatePurchaseVehicleResult"] | undefined | null,
	/** Update a trade vehicle for a transaction as a customer */
	customerUpdateTradeVehicle?: GraphQLTypes["MutationCustomerUpdateTradeVehicleResult"] | undefined | null,
	/** Create a purchase vehicle for a transaction as a dealership staff member */
	dealershipCreatePurchaseVehicle?: GraphQLTypes["MutationDealershipCreatePurchaseVehicleResult"] | undefined | null,
	/** Create a trade vehicle for a transaction as a dealership staff member */
	dealershipCreateTradeVehicle?: GraphQLTypes["MutationDealershipCreateTradeVehicleResult"] | undefined | null,
	/** Create a basic transaction for a dealership returning the ID of the new transaction */
	dealershipCreateTransaction?: GraphQLTypes["MutationDealershipCreateTransactionResult"] | undefined | null,
	/** Remove a trade vehicle from a transaction as a dealership staff member */
	dealershipRemoveTradeVehicle?: GraphQLTypes["MutationDealershipRemoveTradeVehicleResult"] | undefined | null,
	/** Update the purchase vehicle on the transaction as a dealership staff member */
	dealershipUpdatePurchaseVehicle?: GraphQLTypes["MutationDealershipUpdatePurchaseVehicleResult"] | undefined | null,
	/** Update a trade vehicle for a transaction as a dealership staff member */
	dealershipUpdateTradeVehicle?: GraphQLTypes["MutationDealershipUpdateTradeVehicleResult"] | undefined | null,
	/** Delete a single schedule event. */
	deleteStaffScheduleEvent?: GraphQLTypes["MutationDeleteStaffScheduleEventResult"] | undefined | null,
	/** Dismiss notifications */
	dismissNotifications?: GraphQLTypes["MutationDismissNotificationsResult"] | undefined | null,
	/** Dispatch async job to extract vehicle information from a registration PDF and add it to the deal jacket. */
	extractVehicleFromRegistration?: GraphQLTypes["MutationExtractVehicleFromRegistrationResult"] | undefined | null,
	/** Finalize a liveness session, and return ID as acknowledgement */
	finalizeLivenessAnalysis?: GraphQLTypes["MutationFinalizeLivenessAnalysisResult"] | undefined | null,
	login?: GraphQLTypes["MutationLoginResult"] | undefined | null,
	/** Log a user out by deleting the auth cookie */
	logout?: GraphQLTypes["MutationLogoutResult"] | undefined | null,
	/** Make a submission token that is valid for 5 requsts in 30 minutes */
	makeSubmissionToken?: GraphQLTypes["MutationMakeSubmissionTokenResult"] | undefined | null,
	/** Generic file upload for self-upload */
	makeUpload?: GraphQLTypes["MutationMakeUploadResult"] | undefined | null,
	/** Provision PDF file for scanner upload using submissionToken */
	makeUploadForScanner?: GraphQLTypes["MutationMakeUploadForScannerResult"] | undefined | null,
	/** Dashboard function to upload file to a transaction */
	makeUploadToTransaction?: GraphQLTypes["MutationMakeUploadToTransactionResult"] | undefined | null,
	/** Manually mark a transaction as delivered when post-purchase docs are disabled */
	markTransactionAsDelivered?: GraphQLTypes["MutationMarkTransactionAsDeliveredResult"] | undefined | null,
	/** Modify an existing hard credit application by submitting a new one after address and employment data have been updated */
	modifyHardCreditApplication?: GraphQLTypes["MutationModifyHardCreditApplicationResult"] | undefined | null,
	/** Submit step 1 of the onboarding process */
	onboardingSubmitStep1?: GraphQLTypes["MutationOnboardingSubmitStep1Result"] | undefined | null,
	/** Submit step 1 of the onboarding process */
	onboardingSubmitStep2?: GraphQLTypes["MutationOnboardingSubmitStep2Result"] | undefined | null,
	/** Override a todo by checking received todo id against the OverridableTodos */
	overrideTodo?: GraphQLTypes["MutationOverrideTodoResult"] | undefined | null,
	/** Test if a user has given proper consent to TDC_CONSENTS which is needed to login and informs about login options */
	preLoginCheck?: GraphQLTypes["MutationPreLoginCheckResult"] | undefined | null,
	/** Prefill vehicle data using license plate or vin number */
	prefillLicensePlateOrVin?: GraphQLTypes["MutationPrefillLicensePlateOrVinResult"] | undefined | null,
	/** Manually push existing transaction data to CRMs */
	pushDataToCrms?: GraphQLTypes["MutationPushDataToCrmsResult"] | undefined | null,
	/** Push a file (PDF) to the CDK Deal Jacket of the dealership */
	pushDocumentToCdkDealJacket?: GraphQLTypes["MutationPushDocumentToCdkDealJacketResult"] | undefined | null,
	/** Push documents to the CDK Deal Jacket of the dealership */
	pushDocumentsToCdk?: GraphQLTypes["MutationPushDocumentsToCdkResult"] | undefined | null,
	/** Push form submissions to the CDK Deal Jacket of the dealership */
	pushFormSubmissionsToCdk?: GraphQLTypes["MutationPushFormSubmissionsToCdkResult"] | undefined | null,
	/** Push hard credit application to third party. */
	pushHardCreditApplication?: GraphQLTypes["MutationPushHardCreditApplicationResult"] | undefined | null,
	/** Record consent based on phone number and email */
	recordConsent?: GraphQLTypes["MutationRecordConsentResult"] | undefined | null,
	/** Remove the co-buyer from a transaction. After the disassociation, the customer isn't deleted but marked as removed. */
	removeCoBuyer?: GraphQLTypes["MutationRemoveCoBuyerResult"] | undefined | null,
	/** Remove the primary buyer from a transaction, when co-buyer exists. The co-buyer then becomes the primary buyer. After the disassociation, the old primary isn't deleted but marked as removed. */
	removePrimaryBuyer?: GraphQLTypes["MutationRemovePrimaryBuyerResult"] | undefined | null,
	/** Request prequal reports via Agility Credit */
	requestAgilityCreditPrequal?: GraphQLTypes["MutationRequestAgilityCreditPrequalResult"] | undefined | null,
	/** Request identity verification for customer */
	requestIdentityVerification?: GraphQLTypes["MutationRequestIdentityVerificationResult"] | undefined | null,
	requestOtpExistingUserDEV?: GraphQLTypes["MutationRequestOtpExistingUserDEVResult"] | undefined | null,
	/** Request prequal reports for a customer */
	requestPrequalReports?: GraphQLTypes["MutationRequestPrequalReportsResult"] | undefined | null,
	/** Requests a prescreen on customer */
	requestPrescreen?: GraphQLTypes["MutationRequestPrescreenResult"] | undefined | null,
	/** Flag staff as deactivated / active */
	resendStaffPassword?: GraphQLTypes["MutationResendStaffPasswordResult"] | undefined | null,
	/** Save dealer edits to customer data (personal info, employment, address) before pushing to R1/DT */
	saveLendingPortalCustomerData?: GraphQLTypes["MutationSaveLendingPortalCustomerDataResult"] | undefined | null,
	/** Save dealer edits to purchase vehicle data before pushing to R1/DT */
	saveLendingPortalPurchaseVehicleData?: GraphQLTypes["MutationSaveLendingPortalPurchaseVehicleDataResult"] | undefined | null,
	/** Save dealer edits to trade vehicle data before pushing to R1/DT */
	saveLendingPortalTradeVehicleData?: GraphQLTypes["MutationSaveLendingPortalTradeVehicleDataResult"] | undefined | null,
	/** Send "document ready to be signed" notifications to buyer/co-buyer for forms in a collection. Takes a collection ID and fetches forms server-side to enable future notification tracking. */
	sendFormReadyNotifications?: GraphQLTypes["MutationSendFormReadyNotificationsResult"] | undefined | null,
	/** Set challenge delivery method */
	setDeliveryMethodForUser?: GraphQLTypes["MutationSetDeliveryMethodForUserResult"] | undefined | null,
	/** Set the title for a document */
	setDocumentLabels?: GraphQLTypes["MutationSetDocumentLabelsResult"] | undefined | null,
	/** Set the title for a document */
	setDocumentTitle?: GraphQLTypes["MutationSetDocumentTitleResult"] | undefined | null,
	/** Set staff information */
	setStaffInformation?: GraphQLTypes["MutationSetStaffInformationResult"] | undefined | null,
	/** Enable or disable the staff planning feature for an individual staff member. */
	setStaffPlanningEnabled?: GraphQLTypes["MutationSetStaffPlanningEnabledResult"] | undefined | null,
	/** Stages additional forms from the catalog for signature. These are manually triggered forms stored in an ADDITIONAL collection, distinct from lifecycle PRE_PURCHASE/POST_PURCHASE forms. */
	stageAdditionalForms?: GraphQLTypes["MutationStageAdditionalFormsResult"] | undefined | null,
	/** Start a liveness analysis session & return AWS session id */
	startLivenessAnalysis?: GraphQLTypes["MutationStartLivenessAnalysisResult"] | undefined | null,
	/** Submit values on a form */
	submitFormValues?: GraphQLTypes["MutationSubmitFormValuesResult"] | undefined | null,
	/** Create a form submission for a transaction */
	submitPrequalApplicationAndCreateUser?: GraphQLTypes["MutationSubmitPrequalApplicationAndCreateUserResult"] | undefined | null,
	/** Create a form submission for a transaction */
	submitPrequalApplicationOnTransaction?: GraphQLTypes["MutationSubmitPrequalApplicationOnTransactionResult"] | undefined | null,
	/** Record staff acknowledgement of information safeguarding obligations for a dealership */
	submitStaffAcknowledgement?: GraphQLTypes["MutationSubmitStaffAcknowledgementResult"] | undefined | null,
	/** Create a form submission for a transaction */
	submitStandardForm?: GraphQLTypes["MutationSubmitStandardFormResult"] | undefined | null,
	/** Modify a user group suspenstion status */
	suspendGroupUser?: GraphQLTypes["MutationSuspendGroupUserResult"] | undefined | null,
	/** Flag staff as deactivated / active */
	suspendStaff?: GraphQLTypes["MutationSuspendStaffResult"] | undefined | null,
	/** Switch co-buyer to the primary buyer, and the buyer to the co-buyer */
	switchCustomerRoles?: GraphQLTypes["MutationSwitchCustomerRolesResult"] | undefined | null,
	/** Create a user if they do not exist and link them to the dealership. Used during test drive flow to allow OTP to work for both new and existing users. */
	testDriveEnsureCustomerForDealership?: GraphQLTypes["MutationTestDriveEnsureCustomerForDealershipResult"] | undefined | null,
	/** Track a user event from the frontend */
	trackUserEvent?: GraphQLTypes["MutationTrackUserEventResult"] | undefined | null,
	/** Dismiss notifications */
	unlockTransaction?: GraphQLTypes["MutationUnlockTransactionResult"] | undefined | null,
	/** Update the customer logged in user */
	updateCustomer?: GraphQLTypes["MutationUpdateCustomerResult"] | undefined | null,
	/** Update an employment of a user */
	updateEmployment?: GraphQLTypes["MutationUpdateEmploymentResult"] | undefined | null,
	/** Update a group user */
	updateGroupUser?: GraphQLTypes["MutationUpdateGroupUserResult"] | undefined | null,
	/** Update rotation for ID card images */
	updateIdCardRotation?: GraphQLTypes["MutationUpdateIdCardRotationResult"] | undefined | null,
	/** Update the currently logged in user */
	updateMyUser?: GraphQLTypes["MutationUpdateMyUserResult"] | undefined | null,
	/** Update whether a staff member receives the authenticom report */
	updateReceivesAuthenticomReport?: GraphQLTypes["MutationUpdateReceivesAuthenticomReportResult"] | undefined | null,
	/** Update role of a user dealership */
	updateStaffAttributes?: GraphQLTypes["MutationUpdateStaffAttributesResult"] | undefined | null,
	/** Update staff extra permissions for dealership */
	updateStaffExtraPermissions?: GraphQLTypes["MutationUpdateStaffExtraPermissionsResult"] | undefined | null,
	/** Update a single schedule event (move or resize). */
	updateStaffScheduleEvent?: GraphQLTypes["MutationUpdateStaffScheduleEventResult"] | undefined | null,
	/** Update a transaction */
	updateTransaction?: GraphQLTypes["MutationUpdateTransactionResult"] | undefined | null,
	/** Upload additional documents for a transaction */
	uploadAdditionalDocuments?: GraphQLTypes["MutationUploadAdditionalDocumentsResult"] | undefined | null,
	/** Upload additional documents to a transaction as dealership dashboard user */
	uploadAdditionalDocumentsToTransaction?: GraphQLTypes["MutationUploadAdditionalDocumentsToTransactionResult"] | undefined | null,
	/** Upload driver license (or id card), save a DMV Form, and create ID Card */
	uploadIdCard?: GraphQLTypes["MutationUploadIdCardResult"] | undefined | null,
	/** Upload driver license (or other id card) using submission token for scanner flow */
	uploadIdCardWithToken?: GraphQLTypes["MutationUploadIdCardWithTokenResult"] | undefined | null,
	/** Check if user already exists */
	userExists?: GraphQLTypes["MutationUserExistsResult"] | undefined | null,
	verifyOtpForExistingUser?: GraphQLTypes["MutationVerifyOtpForExistingUserResult"] | undefined | null,
	['...on Mutation']: Omit<GraphQLTypes["Mutation"], "...on Mutation">
};
	["MutationAddScanToDealerJacketResult"]:{
        	__typename:"GraphQLError" | "MutationAddScanToDealerJacketSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationAddScanToDealerJacketSuccess']: '__union' & GraphQLTypes["MutationAddScanToDealerJacketSuccess"];
};
	["MutationAddScanToDealerJacketSuccess"]: {
	__typename: "MutationAddScanToDealerJacketSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationAddScanToDealerJacketSuccess']: Omit<GraphQLTypes["MutationAddScanToDealerJacketSuccess"], "...on MutationAddScanToDealerJacketSuccess">
};
	["MutationAddScanToGloveCompartmentsResult"]:{
        	__typename:"GraphQLError" | "MutationAddScanToGloveCompartmentsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationAddScanToGloveCompartmentsSuccess']: '__union' & GraphQLTypes["MutationAddScanToGloveCompartmentsSuccess"];
};
	["MutationAddScanToGloveCompartmentsSuccess"]: {
	__typename: "MutationAddScanToGloveCompartmentsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationAddScanToGloveCompartmentsSuccess']: Omit<GraphQLTypes["MutationAddScanToGloveCompartmentsSuccess"], "...on MutationAddScanToGloveCompartmentsSuccess">
};
	["MutationAssignStaffToTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationAssignStaffToTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationAssignStaffToTransactionSuccess']: '__union' & GraphQLTypes["MutationAssignStaffToTransactionSuccess"];
};
	["MutationAssignStaffToTransactionSuccess"]: {
	__typename: "MutationAssignStaffToTransactionSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationAssignStaffToTransactionSuccess']: Omit<GraphQLTypes["MutationAssignStaffToTransactionSuccess"], "...on MutationAssignStaffToTransactionSuccess">
};
	["MutationCancelFormCollectionResult"]:{
        	__typename:"GraphQLError" | "MutationCancelFormCollectionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCancelFormCollectionSuccess']: '__union' & GraphQLTypes["MutationCancelFormCollectionSuccess"];
};
	["MutationCancelFormCollectionSuccess"]: {
	__typename: "MutationCancelFormCollectionSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCancelFormCollectionSuccess']: Omit<GraphQLTypes["MutationCancelFormCollectionSuccess"], "...on MutationCancelFormCollectionSuccess">
};
	["MutationCancelPreviousAndRequestSignaturesResult"]:{
        	__typename:"GraphQLError" | "MutationCancelPreviousAndRequestSignaturesSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCancelPreviousAndRequestSignaturesSuccess']: '__union' & GraphQLTypes["MutationCancelPreviousAndRequestSignaturesSuccess"];
};
	["MutationCancelPreviousAndRequestSignaturesSuccess"]: {
	__typename: "MutationCancelPreviousAndRequestSignaturesSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCancelPreviousAndRequestSignaturesSuccess']: Omit<GraphQLTypes["MutationCancelPreviousAndRequestSignaturesSuccess"], "...on MutationCancelPreviousAndRequestSignaturesSuccess">
};
	["MutationChangeDocumentAccessResult"]:{
        	__typename:"GraphQLError" | "MutationChangeDocumentAccessSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationChangeDocumentAccessSuccess']: '__union' & GraphQLTypes["MutationChangeDocumentAccessSuccess"];
};
	["MutationChangeDocumentAccessSuccess"]: {
	__typename: "MutationChangeDocumentAccessSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationChangeDocumentAccessSuccess']: Omit<GraphQLTypes["MutationChangeDocumentAccessSuccess"], "...on MutationChangeDocumentAccessSuccess">
};
	["MutationChangeFormSubmissionAccessResult"]:{
        	__typename:"GraphQLError" | "MutationChangeFormSubmissionAccessSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationChangeFormSubmissionAccessSuccess']: '__union' & GraphQLTypes["MutationChangeFormSubmissionAccessSuccess"];
};
	["MutationChangeFormSubmissionAccessSuccess"]: {
	__typename: "MutationChangeFormSubmissionAccessSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationChangeFormSubmissionAccessSuccess']: Omit<GraphQLTypes["MutationChangeFormSubmissionAccessSuccess"], "...on MutationChangeFormSubmissionAccessSuccess">
};
	["MutationCreateAndSubmitCreditAndPrequalApplicationResult"]:{
        	__typename:"GraphQLError" | "MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess']: '__union' & GraphQLTypes["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"];
};
	["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"]: {
	__typename: "MutationCreateAndSubmitCreditAndPrequalApplicationSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess']: Omit<GraphQLTypes["MutationCreateAndSubmitCreditAndPrequalApplicationSuccess"], "...on MutationCreateAndSubmitCreditAndPrequalApplicationSuccess">
};
	["MutationCreateChatResult"]:{
        	__typename:"GraphQLError" | "MutationCreateChatSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateChatSuccess']: '__union' & GraphQLTypes["MutationCreateChatSuccess"];
};
	["MutationCreateChatSuccess"]: {
	__typename: "MutationCreateChatSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCreateChatSuccess']: Omit<GraphQLTypes["MutationCreateChatSuccess"], "...on MutationCreateChatSuccess">
};
	["MutationCreateCoBuyerResult"]:{
        	__typename:"GraphQLError" | "MutationCreateCoBuyerSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateCoBuyerSuccess']: '__union' & GraphQLTypes["MutationCreateCoBuyerSuccess"];
};
	["MutationCreateCoBuyerSuccess"]: {
	__typename: "MutationCreateCoBuyerSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCreateCoBuyerSuccess']: Omit<GraphQLTypes["MutationCreateCoBuyerSuccess"], "...on MutationCreateCoBuyerSuccess">
};
	["MutationCreateCreditApplicationAndCreateUserResult"]:{
        	__typename:"GraphQLError" | "MutationCreateCreditApplicationAndCreateUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateCreditApplicationAndCreateUserSuccess']: '__union' & GraphQLTypes["MutationCreateCreditApplicationAndCreateUserSuccess"];
};
	["MutationCreateCreditApplicationAndCreateUserSuccess"]: {
	__typename: "MutationCreateCreditApplicationAndCreateUserSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationCreateCreditApplicationAndCreateUserSuccess']: Omit<GraphQLTypes["MutationCreateCreditApplicationAndCreateUserSuccess"], "...on MutationCreateCreditApplicationAndCreateUserSuccess">
};
	["MutationCreateEmploymentResult"]:{
        	__typename:"GraphQLError" | "MutationCreateEmploymentSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateEmploymentSuccess']: '__union' & GraphQLTypes["MutationCreateEmploymentSuccess"];
};
	["MutationCreateEmploymentSuccess"]: {
	__typename: "MutationCreateEmploymentSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCreateEmploymentSuccess']: Omit<GraphQLTypes["MutationCreateEmploymentSuccess"], "...on MutationCreateEmploymentSuccess">
};
	["MutationCreateGroupuserResult"]:{
        	__typename:"GraphQLError" | "MutationCreateGroupuserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateGroupuserSuccess']: '__union' & GraphQLTypes["MutationCreateGroupuserSuccess"];
};
	["MutationCreateGroupuserSuccess"]: {
	__typename: "MutationCreateGroupuserSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCreateGroupuserSuccess']: Omit<GraphQLTypes["MutationCreateGroupuserSuccess"], "...on MutationCreateGroupuserSuccess">
};
	["MutationCreateMessageResult"]:{
        	__typename:"GraphQLError" | "MutationCreateMessageSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateMessageSuccess']: '__union' & GraphQLTypes["MutationCreateMessageSuccess"];
};
	["MutationCreateMessageSuccess"]: {
	__typename: "MutationCreateMessageSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCreateMessageSuccess']: Omit<GraphQLTypes["MutationCreateMessageSuccess"], "...on MutationCreateMessageSuccess">
};
	["MutationCreateStaffResult"]:{
        	__typename:"GraphQLError" | "MutationCreateStaffSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateStaffSuccess']: '__union' & GraphQLTypes["MutationCreateStaffSuccess"];
};
	["MutationCreateStaffScheduleEventsResult"]:{
        	__typename:"GraphQLError" | "MutationCreateStaffScheduleEventsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateStaffScheduleEventsSuccess']: '__union' & GraphQLTypes["MutationCreateStaffScheduleEventsSuccess"];
};
	["MutationCreateStaffScheduleEventsSuccess"]: {
	__typename: "MutationCreateStaffScheduleEventsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCreateStaffScheduleEventsSuccess']: Omit<GraphQLTypes["MutationCreateStaffScheduleEventsSuccess"], "...on MutationCreateStaffScheduleEventsSuccess">
};
	["MutationCreateStaffSuccess"]: {
	__typename: "MutationCreateStaffSuccess",
	data: GraphQLTypes["User"],
	['...on MutationCreateStaffSuccess']: Omit<GraphQLTypes["MutationCreateStaffSuccess"], "...on MutationCreateStaffSuccess">
};
	["MutationCreateTransactionAndSubmitTestDriveResult"]:{
        	__typename:"GraphQLError" | "MutationCreateTransactionAndSubmitTestDriveSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateTransactionAndSubmitTestDriveSuccess']: '__union' & GraphQLTypes["MutationCreateTransactionAndSubmitTestDriveSuccess"];
};
	["MutationCreateTransactionAndSubmitTestDriveSuccess"]: {
	__typename: "MutationCreateTransactionAndSubmitTestDriveSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCreateTransactionAndSubmitTestDriveSuccess']: Omit<GraphQLTypes["MutationCreateTransactionAndSubmitTestDriveSuccess"], "...on MutationCreateTransactionAndSubmitTestDriveSuccess">
};
	["MutationCreateUserFeedbackResult"]:{
        	__typename:"GraphQLError" | "MutationCreateUserFeedbackSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCreateUserFeedbackSuccess']: '__union' & GraphQLTypes["MutationCreateUserFeedbackSuccess"];
};
	["MutationCreateUserFeedbackSuccess"]: {
	__typename: "MutationCreateUserFeedbackSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCreateUserFeedbackSuccess']: Omit<GraphQLTypes["MutationCreateUserFeedbackSuccess"], "...on MutationCreateUserFeedbackSuccess">
};
	["MutationCustomerCreatePrefilledTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerCreatePrefilledTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerCreatePrefilledTransactionSuccess']: '__union' & GraphQLTypes["MutationCustomerCreatePrefilledTransactionSuccess"];
};
	["MutationCustomerCreatePrefilledTransactionSuccess"]: {
	__typename: "MutationCustomerCreatePrefilledTransactionSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerCreatePrefilledTransactionSuccess']: Omit<GraphQLTypes["MutationCustomerCreatePrefilledTransactionSuccess"], "...on MutationCustomerCreatePrefilledTransactionSuccess">
};
	["MutationCustomerCreatePurchaseVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerCreatePurchaseVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerCreatePurchaseVehicleSuccess']: '__union' & GraphQLTypes["MutationCustomerCreatePurchaseVehicleSuccess"];
};
	["MutationCustomerCreatePurchaseVehicleSuccess"]: {
	__typename: "MutationCustomerCreatePurchaseVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerCreatePurchaseVehicleSuccess']: Omit<GraphQLTypes["MutationCustomerCreatePurchaseVehicleSuccess"], "...on MutationCustomerCreatePurchaseVehicleSuccess">
};
	["MutationCustomerCreateTradeVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerCreateTradeVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerCreateTradeVehicleSuccess']: '__union' & GraphQLTypes["MutationCustomerCreateTradeVehicleSuccess"];
};
	["MutationCustomerCreateTradeVehicleSuccess"]: {
	__typename: "MutationCustomerCreateTradeVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerCreateTradeVehicleSuccess']: Omit<GraphQLTypes["MutationCustomerCreateTradeVehicleSuccess"], "...on MutationCustomerCreateTradeVehicleSuccess">
};
	["MutationCustomerCreateTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerCreateTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerCreateTransactionSuccess']: '__union' & GraphQLTypes["MutationCustomerCreateTransactionSuccess"];
};
	["MutationCustomerCreateTransactionSuccess"]: {
	__typename: "MutationCustomerCreateTransactionSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerCreateTransactionSuccess']: Omit<GraphQLTypes["MutationCustomerCreateTransactionSuccess"], "...on MutationCustomerCreateTransactionSuccess">
};
	["MutationCustomerCreateUnauthenticatedTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerCreateUnauthenticatedTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerCreateUnauthenticatedTransactionSuccess']: '__union' & GraphQLTypes["MutationCustomerCreateUnauthenticatedTransactionSuccess"];
};
	["MutationCustomerCreateUnauthenticatedTransactionSuccess"]: {
	__typename: "MutationCustomerCreateUnauthenticatedTransactionSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerCreateUnauthenticatedTransactionSuccess']: Omit<GraphQLTypes["MutationCustomerCreateUnauthenticatedTransactionSuccess"], "...on MutationCustomerCreateUnauthenticatedTransactionSuccess">
};
	["MutationCustomerReferralPaidResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerReferralPaidSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerReferralPaidSuccess']: '__union' & GraphQLTypes["MutationCustomerReferralPaidSuccess"];
};
	["MutationCustomerReferralPaidSuccess"]: {
	__typename: "MutationCustomerReferralPaidSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationCustomerReferralPaidSuccess']: Omit<GraphQLTypes["MutationCustomerReferralPaidSuccess"], "...on MutationCustomerReferralPaidSuccess">
};
	["MutationCustomerReferralResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerReferralSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerReferralSuccess']: '__union' & GraphQLTypes["MutationCustomerReferralSuccess"];
};
	["MutationCustomerReferralSuccess"]: {
	__typename: "MutationCustomerReferralSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationCustomerReferralSuccess']: Omit<GraphQLTypes["MutationCustomerReferralSuccess"], "...on MutationCustomerReferralSuccess">
};
	["MutationCustomerSignupWithCognitoResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerSignupWithCognitoSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerSignupWithCognitoSuccess']: '__union' & GraphQLTypes["MutationCustomerSignupWithCognitoSuccess"];
};
	["MutationCustomerSignupWithCognitoSuccess"]: {
	__typename: "MutationCustomerSignupWithCognitoSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCustomerSignupWithCognitoSuccess']: Omit<GraphQLTypes["MutationCustomerSignupWithCognitoSuccess"], "...on MutationCustomerSignupWithCognitoSuccess">
};
	["MutationCustomerUpdatePhoneNumberResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerUpdatePhoneNumberSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerUpdatePhoneNumberSuccess']: '__union' & GraphQLTypes["MutationCustomerUpdatePhoneNumberSuccess"];
};
	["MutationCustomerUpdatePhoneNumberSuccess"]: {
	__typename: "MutationCustomerUpdatePhoneNumberSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationCustomerUpdatePhoneNumberSuccess']: Omit<GraphQLTypes["MutationCustomerUpdatePhoneNumberSuccess"], "...on MutationCustomerUpdatePhoneNumberSuccess">
};
	["MutationCustomerUpdatePurchaseVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerUpdatePurchaseVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerUpdatePurchaseVehicleSuccess']: '__union' & GraphQLTypes["MutationCustomerUpdatePurchaseVehicleSuccess"];
};
	["MutationCustomerUpdatePurchaseVehicleSuccess"]: {
	__typename: "MutationCustomerUpdatePurchaseVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerUpdatePurchaseVehicleSuccess']: Omit<GraphQLTypes["MutationCustomerUpdatePurchaseVehicleSuccess"], "...on MutationCustomerUpdatePurchaseVehicleSuccess">
};
	["MutationCustomerUpdateTradeVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationCustomerUpdateTradeVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationCustomerUpdateTradeVehicleSuccess']: '__union' & GraphQLTypes["MutationCustomerUpdateTradeVehicleSuccess"];
};
	["MutationCustomerUpdateTradeVehicleSuccess"]: {
	__typename: "MutationCustomerUpdateTradeVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationCustomerUpdateTradeVehicleSuccess']: Omit<GraphQLTypes["MutationCustomerUpdateTradeVehicleSuccess"], "...on MutationCustomerUpdateTradeVehicleSuccess">
};
	["MutationDealershipCreatePurchaseVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationDealershipCreatePurchaseVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDealershipCreatePurchaseVehicleSuccess']: '__union' & GraphQLTypes["MutationDealershipCreatePurchaseVehicleSuccess"];
};
	["MutationDealershipCreatePurchaseVehicleSuccess"]: {
	__typename: "MutationDealershipCreatePurchaseVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationDealershipCreatePurchaseVehicleSuccess']: Omit<GraphQLTypes["MutationDealershipCreatePurchaseVehicleSuccess"], "...on MutationDealershipCreatePurchaseVehicleSuccess">
};
	["MutationDealershipCreateTradeVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationDealershipCreateTradeVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDealershipCreateTradeVehicleSuccess']: '__union' & GraphQLTypes["MutationDealershipCreateTradeVehicleSuccess"];
};
	["MutationDealershipCreateTradeVehicleSuccess"]: {
	__typename: "MutationDealershipCreateTradeVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationDealershipCreateTradeVehicleSuccess']: Omit<GraphQLTypes["MutationDealershipCreateTradeVehicleSuccess"], "...on MutationDealershipCreateTradeVehicleSuccess">
};
	["MutationDealershipCreateTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationDealershipCreateTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDealershipCreateTransactionSuccess']: '__union' & GraphQLTypes["MutationDealershipCreateTransactionSuccess"];
};
	["MutationDealershipCreateTransactionSuccess"]: {
	__typename: "MutationDealershipCreateTransactionSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationDealershipCreateTransactionSuccess']: Omit<GraphQLTypes["MutationDealershipCreateTransactionSuccess"], "...on MutationDealershipCreateTransactionSuccess">
};
	["MutationDealershipRemoveTradeVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationDealershipRemoveTradeVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDealershipRemoveTradeVehicleSuccess']: '__union' & GraphQLTypes["MutationDealershipRemoveTradeVehicleSuccess"];
};
	["MutationDealershipRemoveTradeVehicleSuccess"]: {
	__typename: "MutationDealershipRemoveTradeVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationDealershipRemoveTradeVehicleSuccess']: Omit<GraphQLTypes["MutationDealershipRemoveTradeVehicleSuccess"], "...on MutationDealershipRemoveTradeVehicleSuccess">
};
	["MutationDealershipUpdatePurchaseVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationDealershipUpdatePurchaseVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDealershipUpdatePurchaseVehicleSuccess']: '__union' & GraphQLTypes["MutationDealershipUpdatePurchaseVehicleSuccess"];
};
	["MutationDealershipUpdatePurchaseVehicleSuccess"]: {
	__typename: "MutationDealershipUpdatePurchaseVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationDealershipUpdatePurchaseVehicleSuccess']: Omit<GraphQLTypes["MutationDealershipUpdatePurchaseVehicleSuccess"], "...on MutationDealershipUpdatePurchaseVehicleSuccess">
};
	["MutationDealershipUpdateTradeVehicleResult"]:{
        	__typename:"GraphQLError" | "MutationDealershipUpdateTradeVehicleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDealershipUpdateTradeVehicleSuccess']: '__union' & GraphQLTypes["MutationDealershipUpdateTradeVehicleSuccess"];
};
	["MutationDealershipUpdateTradeVehicleSuccess"]: {
	__typename: "MutationDealershipUpdateTradeVehicleSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationDealershipUpdateTradeVehicleSuccess']: Omit<GraphQLTypes["MutationDealershipUpdateTradeVehicleSuccess"], "...on MutationDealershipUpdateTradeVehicleSuccess">
};
	["MutationDeleteStaffScheduleEventResult"]:{
        	__typename:"GraphQLError" | "MutationDeleteStaffScheduleEventSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDeleteStaffScheduleEventSuccess']: '__union' & GraphQLTypes["MutationDeleteStaffScheduleEventSuccess"];
};
	["MutationDeleteStaffScheduleEventSuccess"]: {
	__typename: "MutationDeleteStaffScheduleEventSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationDeleteStaffScheduleEventSuccess']: Omit<GraphQLTypes["MutationDeleteStaffScheduleEventSuccess"], "...on MutationDeleteStaffScheduleEventSuccess">
};
	["MutationDismissNotificationsResult"]:{
        	__typename:"GraphQLError" | "MutationDismissNotificationsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationDismissNotificationsSuccess']: '__union' & GraphQLTypes["MutationDismissNotificationsSuccess"];
};
	["MutationDismissNotificationsSuccess"]: {
	__typename: "MutationDismissNotificationsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationDismissNotificationsSuccess']: Omit<GraphQLTypes["MutationDismissNotificationsSuccess"], "...on MutationDismissNotificationsSuccess">
};
	["MutationExtractVehicleFromRegistrationResult"]:{
        	__typename:"GraphQLError" | "MutationExtractVehicleFromRegistrationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationExtractVehicleFromRegistrationSuccess']: '__union' & GraphQLTypes["MutationExtractVehicleFromRegistrationSuccess"];
};
	["MutationExtractVehicleFromRegistrationSuccess"]: {
	__typename: "MutationExtractVehicleFromRegistrationSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationExtractVehicleFromRegistrationSuccess']: Omit<GraphQLTypes["MutationExtractVehicleFromRegistrationSuccess"], "...on MutationExtractVehicleFromRegistrationSuccess">
};
	["MutationFinalizeLivenessAnalysisResult"]:{
        	__typename:"GraphQLError" | "MutationFinalizeLivenessAnalysisSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationFinalizeLivenessAnalysisSuccess']: '__union' & GraphQLTypes["MutationFinalizeLivenessAnalysisSuccess"];
};
	["MutationFinalizeLivenessAnalysisSuccess"]: {
	__typename: "MutationFinalizeLivenessAnalysisSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationFinalizeLivenessAnalysisSuccess']: Omit<GraphQLTypes["MutationFinalizeLivenessAnalysisSuccess"], "...on MutationFinalizeLivenessAnalysisSuccess">
};
	["MutationLoginResult"]:{
        	__typename:"GraphQLError" | "MutationLoginSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationLoginSuccess']: '__union' & GraphQLTypes["MutationLoginSuccess"];
};
	["MutationLoginSuccess"]: {
	__typename: "MutationLoginSuccess",
	data: GraphQLTypes["LoginResponse"],
	['...on MutationLoginSuccess']: Omit<GraphQLTypes["MutationLoginSuccess"], "...on MutationLoginSuccess">
};
	["MutationLogoutResult"]:{
        	__typename:"GraphQLError" | "MutationLogoutSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationLogoutSuccess']: '__union' & GraphQLTypes["MutationLogoutSuccess"];
};
	["MutationLogoutSuccess"]: {
	__typename: "MutationLogoutSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationLogoutSuccess']: Omit<GraphQLTypes["MutationLogoutSuccess"], "...on MutationLogoutSuccess">
};
	["MutationMakeSubmissionTokenResult"]:{
        	__typename:"GraphQLError" | "MutationMakeSubmissionTokenSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationMakeSubmissionTokenSuccess']: '__union' & GraphQLTypes["MutationMakeSubmissionTokenSuccess"];
};
	["MutationMakeSubmissionTokenSuccess"]: {
	__typename: "MutationMakeSubmissionTokenSuccess",
	data: string,
	['...on MutationMakeSubmissionTokenSuccess']: Omit<GraphQLTypes["MutationMakeSubmissionTokenSuccess"], "...on MutationMakeSubmissionTokenSuccess">
};
	["MutationMakeUploadForScannerResult"]:{
        	__typename:"GraphQLError" | "MutationMakeUploadForScannerSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationMakeUploadForScannerSuccess']: '__union' & GraphQLTypes["MutationMakeUploadForScannerSuccess"];
};
	["MutationMakeUploadForScannerSuccess"]: {
	__typename: "MutationMakeUploadForScannerSuccess",
	data: GraphQLTypes["MakeFileUploadForScannerType"],
	['...on MutationMakeUploadForScannerSuccess']: Omit<GraphQLTypes["MutationMakeUploadForScannerSuccess"], "...on MutationMakeUploadForScannerSuccess">
};
	["MutationMakeUploadResult"]:{
        	__typename:"GraphQLError" | "MutationMakeUploadSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationMakeUploadSuccess']: '__union' & GraphQLTypes["MutationMakeUploadSuccess"];
};
	["MutationMakeUploadSuccess"]: {
	__typename: "MutationMakeUploadSuccess",
	data: GraphQLTypes["MakeFileUploadType"],
	['...on MutationMakeUploadSuccess']: Omit<GraphQLTypes["MutationMakeUploadSuccess"], "...on MutationMakeUploadSuccess">
};
	["MutationMakeUploadToTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationMakeUploadToTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationMakeUploadToTransactionSuccess']: '__union' & GraphQLTypes["MutationMakeUploadToTransactionSuccess"];
};
	["MutationMakeUploadToTransactionSuccess"]: {
	__typename: "MutationMakeUploadToTransactionSuccess",
	data: GraphQLTypes["MakeFileUploadType"],
	['...on MutationMakeUploadToTransactionSuccess']: Omit<GraphQLTypes["MutationMakeUploadToTransactionSuccess"], "...on MutationMakeUploadToTransactionSuccess">
};
	["MutationMarkTransactionAsDeliveredResult"]:{
        	__typename:"GraphQLError" | "MutationMarkTransactionAsDeliveredSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationMarkTransactionAsDeliveredSuccess']: '__union' & GraphQLTypes["MutationMarkTransactionAsDeliveredSuccess"];
};
	["MutationMarkTransactionAsDeliveredSuccess"]: {
	__typename: "MutationMarkTransactionAsDeliveredSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationMarkTransactionAsDeliveredSuccess']: Omit<GraphQLTypes["MutationMarkTransactionAsDeliveredSuccess"], "...on MutationMarkTransactionAsDeliveredSuccess">
};
	["MutationModifyHardCreditApplicationResult"]:{
        	__typename:"GraphQLError" | "MutationModifyHardCreditApplicationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationModifyHardCreditApplicationSuccess']: '__union' & GraphQLTypes["MutationModifyHardCreditApplicationSuccess"];
};
	["MutationModifyHardCreditApplicationSuccess"]: {
	__typename: "MutationModifyHardCreditApplicationSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationModifyHardCreditApplicationSuccess']: Omit<GraphQLTypes["MutationModifyHardCreditApplicationSuccess"], "...on MutationModifyHardCreditApplicationSuccess">
};
	["MutationOnboardingSubmitStep1Result"]:{
        	__typename:"GraphQLError" | "MutationOnboardingSubmitStep1Success"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationOnboardingSubmitStep1Success']: '__union' & GraphQLTypes["MutationOnboardingSubmitStep1Success"];
};
	["MutationOnboardingSubmitStep1Success"]: {
	__typename: "MutationOnboardingSubmitStep1Success",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationOnboardingSubmitStep1Success']: Omit<GraphQLTypes["MutationOnboardingSubmitStep1Success"], "...on MutationOnboardingSubmitStep1Success">
};
	["MutationOnboardingSubmitStep2Result"]:{
        	__typename:"GraphQLError" | "MutationOnboardingSubmitStep2Success"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationOnboardingSubmitStep2Success']: '__union' & GraphQLTypes["MutationOnboardingSubmitStep2Success"];
};
	["MutationOnboardingSubmitStep2Success"]: {
	__typename: "MutationOnboardingSubmitStep2Success",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationOnboardingSubmitStep2Success']: Omit<GraphQLTypes["MutationOnboardingSubmitStep2Success"], "...on MutationOnboardingSubmitStep2Success">
};
	["MutationOverrideTodoResult"]:{
        	__typename:"GraphQLError" | "MutationOverrideTodoSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationOverrideTodoSuccess']: '__union' & GraphQLTypes["MutationOverrideTodoSuccess"];
};
	["MutationOverrideTodoSuccess"]: {
	__typename: "MutationOverrideTodoSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationOverrideTodoSuccess']: Omit<GraphQLTypes["MutationOverrideTodoSuccess"], "...on MutationOverrideTodoSuccess">
};
	["MutationPreLoginCheckResult"]:{
        	__typename:"GraphQLError" | "MutationPreLoginCheckSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPreLoginCheckSuccess']: '__union' & GraphQLTypes["MutationPreLoginCheckSuccess"];
};
	["MutationPreLoginCheckSuccess"]: {
	__typename: "MutationPreLoginCheckSuccess",
	data: GraphQLTypes["PreLoginType"],
	['...on MutationPreLoginCheckSuccess']: Omit<GraphQLTypes["MutationPreLoginCheckSuccess"], "...on MutationPreLoginCheckSuccess">
};
	["MutationPrefillLicensePlateOrVinResult"]:{
        	__typename:"GraphQLError" | "MutationPrefillLicensePlateOrVinSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPrefillLicensePlateOrVinSuccess']: '__union' & GraphQLTypes["MutationPrefillLicensePlateOrVinSuccess"];
};
	["MutationPrefillLicensePlateOrVinSuccess"]: {
	__typename: "MutationPrefillLicensePlateOrVinSuccess",
	data: GraphQLTypes["LicensePrefillData"],
	['...on MutationPrefillLicensePlateOrVinSuccess']: Omit<GraphQLTypes["MutationPrefillLicensePlateOrVinSuccess"], "...on MutationPrefillLicensePlateOrVinSuccess">
};
	["MutationPushDataToCrmsResult"]:{
        	__typename:"GraphQLError" | "MutationPushDataToCrmsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPushDataToCrmsSuccess']: '__union' & GraphQLTypes["MutationPushDataToCrmsSuccess"];
};
	["MutationPushDataToCrmsSuccess"]: {
	__typename: "MutationPushDataToCrmsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationPushDataToCrmsSuccess']: Omit<GraphQLTypes["MutationPushDataToCrmsSuccess"], "...on MutationPushDataToCrmsSuccess">
};
	["MutationPushDocumentToCdkDealJacketResult"]:{
        	__typename:"GraphQLError" | "MutationPushDocumentToCdkDealJacketSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPushDocumentToCdkDealJacketSuccess']: '__union' & GraphQLTypes["MutationPushDocumentToCdkDealJacketSuccess"];
};
	["MutationPushDocumentToCdkDealJacketSuccess"]: {
	__typename: "MutationPushDocumentToCdkDealJacketSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationPushDocumentToCdkDealJacketSuccess']: Omit<GraphQLTypes["MutationPushDocumentToCdkDealJacketSuccess"], "...on MutationPushDocumentToCdkDealJacketSuccess">
};
	["MutationPushDocumentsToCdkResult"]:{
        	__typename:"GraphQLError" | "MutationPushDocumentsToCdkSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPushDocumentsToCdkSuccess']: '__union' & GraphQLTypes["MutationPushDocumentsToCdkSuccess"];
};
	["MutationPushDocumentsToCdkSuccess"]: {
	__typename: "MutationPushDocumentsToCdkSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationPushDocumentsToCdkSuccess']: Omit<GraphQLTypes["MutationPushDocumentsToCdkSuccess"], "...on MutationPushDocumentsToCdkSuccess">
};
	["MutationPushFormSubmissionsToCdkResult"]:{
        	__typename:"GraphQLError" | "MutationPushFormSubmissionsToCdkSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPushFormSubmissionsToCdkSuccess']: '__union' & GraphQLTypes["MutationPushFormSubmissionsToCdkSuccess"];
};
	["MutationPushFormSubmissionsToCdkSuccess"]: {
	__typename: "MutationPushFormSubmissionsToCdkSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationPushFormSubmissionsToCdkSuccess']: Omit<GraphQLTypes["MutationPushFormSubmissionsToCdkSuccess"], "...on MutationPushFormSubmissionsToCdkSuccess">
};
	["MutationPushHardCreditApplicationResult"]:{
        	__typename:"GraphQLError" | "MutationPushHardCreditApplicationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationPushHardCreditApplicationSuccess']: '__union' & GraphQLTypes["MutationPushHardCreditApplicationSuccess"];
};
	["MutationPushHardCreditApplicationSuccess"]: {
	__typename: "MutationPushHardCreditApplicationSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationPushHardCreditApplicationSuccess']: Omit<GraphQLTypes["MutationPushHardCreditApplicationSuccess"], "...on MutationPushHardCreditApplicationSuccess">
};
	["MutationRecordConsentResult"]:{
        	__typename:"GraphQLError" | "MutationRecordConsentSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRecordConsentSuccess']: '__union' & GraphQLTypes["MutationRecordConsentSuccess"];
};
	["MutationRecordConsentSuccess"]: {
	__typename: "MutationRecordConsentSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationRecordConsentSuccess']: Omit<GraphQLTypes["MutationRecordConsentSuccess"], "...on MutationRecordConsentSuccess">
};
	["MutationRemoveCoBuyerResult"]:{
        	__typename:"GraphQLError" | "MutationRemoveCoBuyerSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRemoveCoBuyerSuccess']: '__union' & GraphQLTypes["MutationRemoveCoBuyerSuccess"];
};
	["MutationRemoveCoBuyerSuccess"]: {
	__typename: "MutationRemoveCoBuyerSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationRemoveCoBuyerSuccess']: Omit<GraphQLTypes["MutationRemoveCoBuyerSuccess"], "...on MutationRemoveCoBuyerSuccess">
};
	["MutationRemovePrimaryBuyerResult"]:{
        	__typename:"GraphQLError" | "MutationRemovePrimaryBuyerSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRemovePrimaryBuyerSuccess']: '__union' & GraphQLTypes["MutationRemovePrimaryBuyerSuccess"];
};
	["MutationRemovePrimaryBuyerSuccess"]: {
	__typename: "MutationRemovePrimaryBuyerSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationRemovePrimaryBuyerSuccess']: Omit<GraphQLTypes["MutationRemovePrimaryBuyerSuccess"], "...on MutationRemovePrimaryBuyerSuccess">
};
	["MutationRequestAgilityCreditPrequalResult"]:{
        	__typename:"GraphQLError" | "MutationRequestAgilityCreditPrequalSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRequestAgilityCreditPrequalSuccess']: '__union' & GraphQLTypes["MutationRequestAgilityCreditPrequalSuccess"];
};
	["MutationRequestAgilityCreditPrequalSuccess"]: {
	__typename: "MutationRequestAgilityCreditPrequalSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationRequestAgilityCreditPrequalSuccess']: Omit<GraphQLTypes["MutationRequestAgilityCreditPrequalSuccess"], "...on MutationRequestAgilityCreditPrequalSuccess">
};
	["MutationRequestIdentityVerificationResult"]:{
        	__typename:"GraphQLError" | "MutationRequestIdentityVerificationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRequestIdentityVerificationSuccess']: '__union' & GraphQLTypes["MutationRequestIdentityVerificationSuccess"];
};
	["MutationRequestIdentityVerificationSuccess"]: {
	__typename: "MutationRequestIdentityVerificationSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationRequestIdentityVerificationSuccess']: Omit<GraphQLTypes["MutationRequestIdentityVerificationSuccess"], "...on MutationRequestIdentityVerificationSuccess">
};
	["MutationRequestOtpExistingUserDEVResult"]:{
        	__typename:"GraphQLError" | "MutationRequestOtpExistingUserDEVSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRequestOtpExistingUserDEVSuccess']: '__union' & GraphQLTypes["MutationRequestOtpExistingUserDEVSuccess"];
};
	["MutationRequestOtpExistingUserDEVSuccess"]: {
	__typename: "MutationRequestOtpExistingUserDEVSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationRequestOtpExistingUserDEVSuccess']: Omit<GraphQLTypes["MutationRequestOtpExistingUserDEVSuccess"], "...on MutationRequestOtpExistingUserDEVSuccess">
};
	["MutationRequestPrequalReportsResult"]:{
        	__typename:"GraphQLError" | "MutationRequestPrequalReportsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRequestPrequalReportsSuccess']: '__union' & GraphQLTypes["MutationRequestPrequalReportsSuccess"];
};
	["MutationRequestPrequalReportsSuccess"]: {
	__typename: "MutationRequestPrequalReportsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationRequestPrequalReportsSuccess']: Omit<GraphQLTypes["MutationRequestPrequalReportsSuccess"], "...on MutationRequestPrequalReportsSuccess">
};
	["MutationRequestPrescreenResult"]:{
        	__typename:"GraphQLError" | "MutationRequestPrescreenSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationRequestPrescreenSuccess']: '__union' & GraphQLTypes["MutationRequestPrescreenSuccess"];
};
	["MutationRequestPrescreenSuccess"]: {
	__typename: "MutationRequestPrescreenSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationRequestPrescreenSuccess']: Omit<GraphQLTypes["MutationRequestPrescreenSuccess"], "...on MutationRequestPrescreenSuccess">
};
	["MutationResendStaffPasswordResult"]:{
        	__typename:"GraphQLError" | "MutationResendStaffPasswordSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationResendStaffPasswordSuccess']: '__union' & GraphQLTypes["MutationResendStaffPasswordSuccess"];
};
	["MutationResendStaffPasswordSuccess"]: {
	__typename: "MutationResendStaffPasswordSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationResendStaffPasswordSuccess']: Omit<GraphQLTypes["MutationResendStaffPasswordSuccess"], "...on MutationResendStaffPasswordSuccess">
};
	["MutationResponse"]: {
	__typename: "MutationResponse",
	status?: string | undefined | null,
	['...on MutationResponse']: Omit<GraphQLTypes["MutationResponse"], "...on MutationResponse">
};
	["MutationResponseWithId"]: {
	__typename: "MutationResponseWithId",
	id?: string | undefined | null,
	status?: string | undefined | null,
	['...on MutationResponseWithId']: Omit<GraphQLTypes["MutationResponseWithId"], "...on MutationResponseWithId">
};
	["MutationSaveLendingPortalCustomerDataResult"]:{
        	__typename:"GraphQLError" | "MutationSaveLendingPortalCustomerDataSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSaveLendingPortalCustomerDataSuccess']: '__union' & GraphQLTypes["MutationSaveLendingPortalCustomerDataSuccess"];
};
	["MutationSaveLendingPortalCustomerDataSuccess"]: {
	__typename: "MutationSaveLendingPortalCustomerDataSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSaveLendingPortalCustomerDataSuccess']: Omit<GraphQLTypes["MutationSaveLendingPortalCustomerDataSuccess"], "...on MutationSaveLendingPortalCustomerDataSuccess">
};
	["MutationSaveLendingPortalPurchaseVehicleDataResult"]:{
        	__typename:"GraphQLError" | "MutationSaveLendingPortalPurchaseVehicleDataSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSaveLendingPortalPurchaseVehicleDataSuccess']: '__union' & GraphQLTypes["MutationSaveLendingPortalPurchaseVehicleDataSuccess"];
};
	["MutationSaveLendingPortalPurchaseVehicleDataSuccess"]: {
	__typename: "MutationSaveLendingPortalPurchaseVehicleDataSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSaveLendingPortalPurchaseVehicleDataSuccess']: Omit<GraphQLTypes["MutationSaveLendingPortalPurchaseVehicleDataSuccess"], "...on MutationSaveLendingPortalPurchaseVehicleDataSuccess">
};
	["MutationSaveLendingPortalTradeVehicleDataResult"]:{
        	__typename:"GraphQLError" | "MutationSaveLendingPortalTradeVehicleDataSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSaveLendingPortalTradeVehicleDataSuccess']: '__union' & GraphQLTypes["MutationSaveLendingPortalTradeVehicleDataSuccess"];
};
	["MutationSaveLendingPortalTradeVehicleDataSuccess"]: {
	__typename: "MutationSaveLendingPortalTradeVehicleDataSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSaveLendingPortalTradeVehicleDataSuccess']: Omit<GraphQLTypes["MutationSaveLendingPortalTradeVehicleDataSuccess"], "...on MutationSaveLendingPortalTradeVehicleDataSuccess">
};
	["MutationSendFormReadyNotificationsResult"]:{
        	__typename:"GraphQLError" | "MutationSendFormReadyNotificationsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSendFormReadyNotificationsSuccess']: '__union' & GraphQLTypes["MutationSendFormReadyNotificationsSuccess"];
};
	["MutationSendFormReadyNotificationsSuccess"]: {
	__typename: "MutationSendFormReadyNotificationsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSendFormReadyNotificationsSuccess']: Omit<GraphQLTypes["MutationSendFormReadyNotificationsSuccess"], "...on MutationSendFormReadyNotificationsSuccess">
};
	["MutationSetDeliveryMethodForUserResult"]:{
        	__typename:"GraphQLError" | "MutationSetDeliveryMethodForUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSetDeliveryMethodForUserSuccess']: '__union' & GraphQLTypes["MutationSetDeliveryMethodForUserSuccess"];
};
	["MutationSetDeliveryMethodForUserSuccess"]: {
	__typename: "MutationSetDeliveryMethodForUserSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSetDeliveryMethodForUserSuccess']: Omit<GraphQLTypes["MutationSetDeliveryMethodForUserSuccess"], "...on MutationSetDeliveryMethodForUserSuccess">
};
	["MutationSetDocumentLabelsResult"]:{
        	__typename:"GraphQLError" | "MutationSetDocumentLabelsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSetDocumentLabelsSuccess']: '__union' & GraphQLTypes["MutationSetDocumentLabelsSuccess"];
};
	["MutationSetDocumentLabelsSuccess"]: {
	__typename: "MutationSetDocumentLabelsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSetDocumentLabelsSuccess']: Omit<GraphQLTypes["MutationSetDocumentLabelsSuccess"], "...on MutationSetDocumentLabelsSuccess">
};
	["MutationSetDocumentTitleResult"]:{
        	__typename:"GraphQLError" | "MutationSetDocumentTitleSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSetDocumentTitleSuccess']: '__union' & GraphQLTypes["MutationSetDocumentTitleSuccess"];
};
	["MutationSetDocumentTitleSuccess"]: {
	__typename: "MutationSetDocumentTitleSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSetDocumentTitleSuccess']: Omit<GraphQLTypes["MutationSetDocumentTitleSuccess"], "...on MutationSetDocumentTitleSuccess">
};
	["MutationSetStaffInformationResult"]:{
        	__typename:"GraphQLError" | "MutationSetStaffInformationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSetStaffInformationSuccess']: '__union' & GraphQLTypes["MutationSetStaffInformationSuccess"];
};
	["MutationSetStaffInformationSuccess"]: {
	__typename: "MutationSetStaffInformationSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSetStaffInformationSuccess']: Omit<GraphQLTypes["MutationSetStaffInformationSuccess"], "...on MutationSetStaffInformationSuccess">
};
	["MutationSetStaffPlanningEnabledResult"]:{
        	__typename:"GraphQLError" | "MutationSetStaffPlanningEnabledSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSetStaffPlanningEnabledSuccess']: '__union' & GraphQLTypes["MutationSetStaffPlanningEnabledSuccess"];
};
	["MutationSetStaffPlanningEnabledSuccess"]: {
	__typename: "MutationSetStaffPlanningEnabledSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSetStaffPlanningEnabledSuccess']: Omit<GraphQLTypes["MutationSetStaffPlanningEnabledSuccess"], "...on MutationSetStaffPlanningEnabledSuccess">
};
	["MutationStageAdditionalFormsResult"]:{
        	__typename:"GraphQLError" | "MutationStageAdditionalFormsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationStageAdditionalFormsSuccess']: '__union' & GraphQLTypes["MutationStageAdditionalFormsSuccess"];
};
	["MutationStageAdditionalFormsSuccess"]: {
	__typename: "MutationStageAdditionalFormsSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationStageAdditionalFormsSuccess']: Omit<GraphQLTypes["MutationStageAdditionalFormsSuccess"], "...on MutationStageAdditionalFormsSuccess">
};
	["MutationStartLivenessAnalysisResult"]:{
        	__typename:"GraphQLError" | "MutationStartLivenessAnalysisSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationStartLivenessAnalysisSuccess']: '__union' & GraphQLTypes["MutationStartLivenessAnalysisSuccess"];
};
	["MutationStartLivenessAnalysisSuccess"]: {
	__typename: "MutationStartLivenessAnalysisSuccess",
	data: string,
	['...on MutationStartLivenessAnalysisSuccess']: Omit<GraphQLTypes["MutationStartLivenessAnalysisSuccess"], "...on MutationStartLivenessAnalysisSuccess">
};
	["MutationSubmitFormValuesResult"]:{
        	__typename:"GraphQLError" | "MutationSubmitFormValuesSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSubmitFormValuesSuccess']: '__union' & GraphQLTypes["MutationSubmitFormValuesSuccess"];
};
	["MutationSubmitFormValuesSuccess"]: {
	__typename: "MutationSubmitFormValuesSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSubmitFormValuesSuccess']: Omit<GraphQLTypes["MutationSubmitFormValuesSuccess"], "...on MutationSubmitFormValuesSuccess">
};
	["MutationSubmitPrequalApplicationAndCreateUserResult"]:{
        	__typename:"GraphQLError" | "MutationSubmitPrequalApplicationAndCreateUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSubmitPrequalApplicationAndCreateUserSuccess']: '__union' & GraphQLTypes["MutationSubmitPrequalApplicationAndCreateUserSuccess"];
};
	["MutationSubmitPrequalApplicationAndCreateUserSuccess"]: {
	__typename: "MutationSubmitPrequalApplicationAndCreateUserSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSubmitPrequalApplicationAndCreateUserSuccess']: Omit<GraphQLTypes["MutationSubmitPrequalApplicationAndCreateUserSuccess"], "...on MutationSubmitPrequalApplicationAndCreateUserSuccess">
};
	["MutationSubmitPrequalApplicationOnTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationSubmitPrequalApplicationOnTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSubmitPrequalApplicationOnTransactionSuccess']: '__union' & GraphQLTypes["MutationSubmitPrequalApplicationOnTransactionSuccess"];
};
	["MutationSubmitPrequalApplicationOnTransactionSuccess"]: {
	__typename: "MutationSubmitPrequalApplicationOnTransactionSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSubmitPrequalApplicationOnTransactionSuccess']: Omit<GraphQLTypes["MutationSubmitPrequalApplicationOnTransactionSuccess"], "...on MutationSubmitPrequalApplicationOnTransactionSuccess">
};
	["MutationSubmitStaffAcknowledgementResult"]:{
        	__typename:"GraphQLError" | "MutationSubmitStaffAcknowledgementSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSubmitStaffAcknowledgementSuccess']: '__union' & GraphQLTypes["MutationSubmitStaffAcknowledgementSuccess"];
};
	["MutationSubmitStaffAcknowledgementSuccess"]: {
	__typename: "MutationSubmitStaffAcknowledgementSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationSubmitStaffAcknowledgementSuccess']: Omit<GraphQLTypes["MutationSubmitStaffAcknowledgementSuccess"], "...on MutationSubmitStaffAcknowledgementSuccess">
};
	["MutationSubmitStandardFormResult"]:{
        	__typename:"GraphQLError" | "MutationSubmitStandardFormSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSubmitStandardFormSuccess']: '__union' & GraphQLTypes["MutationSubmitStandardFormSuccess"];
};
	["MutationSubmitStandardFormSuccess"]: {
	__typename: "MutationSubmitStandardFormSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationSubmitStandardFormSuccess']: Omit<GraphQLTypes["MutationSubmitStandardFormSuccess"], "...on MutationSubmitStandardFormSuccess">
};
	["MutationSuspendGroupUserResult"]:{
        	__typename:"GraphQLError" | "MutationSuspendGroupUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSuspendGroupUserSuccess']: '__union' & GraphQLTypes["MutationSuspendGroupUserSuccess"];
};
	["MutationSuspendGroupUserSuccess"]: {
	__typename: "MutationSuspendGroupUserSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSuspendGroupUserSuccess']: Omit<GraphQLTypes["MutationSuspendGroupUserSuccess"], "...on MutationSuspendGroupUserSuccess">
};
	["MutationSuspendStaffResult"]:{
        	__typename:"GraphQLError" | "MutationSuspendStaffSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSuspendStaffSuccess']: '__union' & GraphQLTypes["MutationSuspendStaffSuccess"];
};
	["MutationSuspendStaffSuccess"]: {
	__typename: "MutationSuspendStaffSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSuspendStaffSuccess']: Omit<GraphQLTypes["MutationSuspendStaffSuccess"], "...on MutationSuspendStaffSuccess">
};
	["MutationSwitchCustomerRolesResult"]:{
        	__typename:"GraphQLError" | "MutationSwitchCustomerRolesSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationSwitchCustomerRolesSuccess']: '__union' & GraphQLTypes["MutationSwitchCustomerRolesSuccess"];
};
	["MutationSwitchCustomerRolesSuccess"]: {
	__typename: "MutationSwitchCustomerRolesSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationSwitchCustomerRolesSuccess']: Omit<GraphQLTypes["MutationSwitchCustomerRolesSuccess"], "...on MutationSwitchCustomerRolesSuccess">
};
	["MutationTestDriveEnsureCustomerForDealershipResult"]:{
        	__typename:"GraphQLError" | "MutationTestDriveEnsureCustomerForDealershipSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationTestDriveEnsureCustomerForDealershipSuccess']: '__union' & GraphQLTypes["MutationTestDriveEnsureCustomerForDealershipSuccess"];
};
	["MutationTestDriveEnsureCustomerForDealershipSuccess"]: {
	__typename: "MutationTestDriveEnsureCustomerForDealershipSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationTestDriveEnsureCustomerForDealershipSuccess']: Omit<GraphQLTypes["MutationTestDriveEnsureCustomerForDealershipSuccess"], "...on MutationTestDriveEnsureCustomerForDealershipSuccess">
};
	["MutationTrackUserEventResult"]:{
        	__typename:"GraphQLError" | "MutationTrackUserEventSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationTrackUserEventSuccess']: '__union' & GraphQLTypes["MutationTrackUserEventSuccess"];
};
	["MutationTrackUserEventSuccess"]: {
	__typename: "MutationTrackUserEventSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationTrackUserEventSuccess']: Omit<GraphQLTypes["MutationTrackUserEventSuccess"], "...on MutationTrackUserEventSuccess">
};
	["MutationUnlockTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationUnlockTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUnlockTransactionSuccess']: '__union' & GraphQLTypes["MutationUnlockTransactionSuccess"];
};
	["MutationUnlockTransactionSuccess"]: {
	__typename: "MutationUnlockTransactionSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUnlockTransactionSuccess']: Omit<GraphQLTypes["MutationUnlockTransactionSuccess"], "...on MutationUnlockTransactionSuccess">
};
	["MutationUpdateCustomerResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateCustomerSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateCustomerSuccess']: '__union' & GraphQLTypes["MutationUpdateCustomerSuccess"];
};
	["MutationUpdateCustomerSuccess"]: {
	__typename: "MutationUpdateCustomerSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateCustomerSuccess']: Omit<GraphQLTypes["MutationUpdateCustomerSuccess"], "...on MutationUpdateCustomerSuccess">
};
	["MutationUpdateEmploymentResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateEmploymentSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateEmploymentSuccess']: '__union' & GraphQLTypes["MutationUpdateEmploymentSuccess"];
};
	["MutationUpdateEmploymentSuccess"]: {
	__typename: "MutationUpdateEmploymentSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateEmploymentSuccess']: Omit<GraphQLTypes["MutationUpdateEmploymentSuccess"], "...on MutationUpdateEmploymentSuccess">
};
	["MutationUpdateGroupUserResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateGroupUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateGroupUserSuccess']: '__union' & GraphQLTypes["MutationUpdateGroupUserSuccess"];
};
	["MutationUpdateGroupUserSuccess"]: {
	__typename: "MutationUpdateGroupUserSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateGroupUserSuccess']: Omit<GraphQLTypes["MutationUpdateGroupUserSuccess"], "...on MutationUpdateGroupUserSuccess">
};
	["MutationUpdateIdCardRotationResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateIdCardRotationSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateIdCardRotationSuccess']: '__union' & GraphQLTypes["MutationUpdateIdCardRotationSuccess"];
};
	["MutationUpdateIdCardRotationSuccess"]: {
	__typename: "MutationUpdateIdCardRotationSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateIdCardRotationSuccess']: Omit<GraphQLTypes["MutationUpdateIdCardRotationSuccess"], "...on MutationUpdateIdCardRotationSuccess">
};
	["MutationUpdateMyUserResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateMyUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateMyUserSuccess']: '__union' & GraphQLTypes["MutationUpdateMyUserSuccess"];
};
	["MutationUpdateMyUserSuccess"]: {
	__typename: "MutationUpdateMyUserSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateMyUserSuccess']: Omit<GraphQLTypes["MutationUpdateMyUserSuccess"], "...on MutationUpdateMyUserSuccess">
};
	["MutationUpdateReceivesAuthenticomReportResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateReceivesAuthenticomReportSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateReceivesAuthenticomReportSuccess']: '__union' & GraphQLTypes["MutationUpdateReceivesAuthenticomReportSuccess"];
};
	["MutationUpdateReceivesAuthenticomReportSuccess"]: {
	__typename: "MutationUpdateReceivesAuthenticomReportSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateReceivesAuthenticomReportSuccess']: Omit<GraphQLTypes["MutationUpdateReceivesAuthenticomReportSuccess"], "...on MutationUpdateReceivesAuthenticomReportSuccess">
};
	["MutationUpdateStaffAttributesResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateStaffAttributesSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateStaffAttributesSuccess']: '__union' & GraphQLTypes["MutationUpdateStaffAttributesSuccess"];
};
	["MutationUpdateStaffAttributesSuccess"]: {
	__typename: "MutationUpdateStaffAttributesSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateStaffAttributesSuccess']: Omit<GraphQLTypes["MutationUpdateStaffAttributesSuccess"], "...on MutationUpdateStaffAttributesSuccess">
};
	["MutationUpdateStaffExtraPermissionsResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateStaffExtraPermissionsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateStaffExtraPermissionsSuccess']: '__union' & GraphQLTypes["MutationUpdateStaffExtraPermissionsSuccess"];
};
	["MutationUpdateStaffExtraPermissionsSuccess"]: {
	__typename: "MutationUpdateStaffExtraPermissionsSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateStaffExtraPermissionsSuccess']: Omit<GraphQLTypes["MutationUpdateStaffExtraPermissionsSuccess"], "...on MutationUpdateStaffExtraPermissionsSuccess">
};
	["MutationUpdateStaffScheduleEventResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateStaffScheduleEventSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateStaffScheduleEventSuccess']: '__union' & GraphQLTypes["MutationUpdateStaffScheduleEventSuccess"];
};
	["MutationUpdateStaffScheduleEventSuccess"]: {
	__typename: "MutationUpdateStaffScheduleEventSuccess",
	data: GraphQLTypes["MutationResponse"],
	['...on MutationUpdateStaffScheduleEventSuccess']: Omit<GraphQLTypes["MutationUpdateStaffScheduleEventSuccess"], "...on MutationUpdateStaffScheduleEventSuccess">
};
	["MutationUpdateTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationUpdateTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUpdateTransactionSuccess']: '__union' & GraphQLTypes["MutationUpdateTransactionSuccess"];
};
	["MutationUpdateTransactionSuccess"]: {
	__typename: "MutationUpdateTransactionSuccess",
	data: GraphQLTypes["Response"],
	['...on MutationUpdateTransactionSuccess']: Omit<GraphQLTypes["MutationUpdateTransactionSuccess"], "...on MutationUpdateTransactionSuccess">
};
	["MutationUploadAdditionalDocumentsResult"]:{
        	__typename:"GraphQLError" | "MutationUploadAdditionalDocumentsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUploadAdditionalDocumentsSuccess']: '__union' & GraphQLTypes["MutationUploadAdditionalDocumentsSuccess"];
};
	["MutationUploadAdditionalDocumentsSuccess"]: {
	__typename: "MutationUploadAdditionalDocumentsSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationUploadAdditionalDocumentsSuccess']: Omit<GraphQLTypes["MutationUploadAdditionalDocumentsSuccess"], "...on MutationUploadAdditionalDocumentsSuccess">
};
	["MutationUploadAdditionalDocumentsToTransactionResult"]:{
        	__typename:"GraphQLError" | "MutationUploadAdditionalDocumentsToTransactionSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUploadAdditionalDocumentsToTransactionSuccess']: '__union' & GraphQLTypes["MutationUploadAdditionalDocumentsToTransactionSuccess"];
};
	["MutationUploadAdditionalDocumentsToTransactionSuccess"]: {
	__typename: "MutationUploadAdditionalDocumentsToTransactionSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationUploadAdditionalDocumentsToTransactionSuccess']: Omit<GraphQLTypes["MutationUploadAdditionalDocumentsToTransactionSuccess"], "...on MutationUploadAdditionalDocumentsToTransactionSuccess">
};
	["MutationUploadIdCardResult"]:{
        	__typename:"GraphQLError" | "MutationUploadIdCardSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUploadIdCardSuccess']: '__union' & GraphQLTypes["MutationUploadIdCardSuccess"];
};
	["MutationUploadIdCardSuccess"]: {
	__typename: "MutationUploadIdCardSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationUploadIdCardSuccess']: Omit<GraphQLTypes["MutationUploadIdCardSuccess"], "...on MutationUploadIdCardSuccess">
};
	["MutationUploadIdCardWithTokenResult"]:{
        	__typename:"GraphQLError" | "MutationUploadIdCardWithTokenSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUploadIdCardWithTokenSuccess']: '__union' & GraphQLTypes["MutationUploadIdCardWithTokenSuccess"];
};
	["MutationUploadIdCardWithTokenSuccess"]: {
	__typename: "MutationUploadIdCardWithTokenSuccess",
	data: GraphQLTypes["MutationResponseWithId"],
	['...on MutationUploadIdCardWithTokenSuccess']: Omit<GraphQLTypes["MutationUploadIdCardWithTokenSuccess"], "...on MutationUploadIdCardWithTokenSuccess">
};
	["MutationUserExistsResult"]:{
        	__typename:"GraphQLError" | "MutationUserExistsSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationUserExistsSuccess']: '__union' & GraphQLTypes["MutationUserExistsSuccess"];
};
	["MutationUserExistsSuccess"]: {
	__typename: "MutationUserExistsSuccess",
	data: boolean,
	['...on MutationUserExistsSuccess']: Omit<GraphQLTypes["MutationUserExistsSuccess"], "...on MutationUserExistsSuccess">
};
	["MutationVerifyOtpForExistingUserResult"]:{
        	__typename:"GraphQLError" | "MutationVerifyOtpForExistingUserSuccess"
        	['...on GraphQLError']: '__union' & GraphQLTypes["GraphQLError"];
	['...on MutationVerifyOtpForExistingUserSuccess']: '__union' & GraphQLTypes["MutationVerifyOtpForExistingUserSuccess"];
};
	["MutationVerifyOtpForExistingUserSuccess"]: {
	__typename: "MutationVerifyOtpForExistingUserSuccess",
	data: GraphQLTypes["LoginResponse"],
	['...on MutationVerifyOtpForExistingUserSuccess']: Omit<GraphQLTypes["MutationVerifyOtpForExistingUserSuccess"], "...on MutationVerifyOtpForExistingUserSuccess">
};
	["Node"]: {
	__typename:"UserDealership",
	id: GraphQLTypes["ID"]
	['...on UserDealership']: '__union' & GraphQLTypes["UserDealership"];
};
	["Notification"]: {
	__typename: "Notification",
	announcement?: GraphQLTypes["Announcement"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	dismissedAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	payload?: GraphQLTypes["JSON"] | undefined | null,
	['...on Notification']: Omit<GraphQLTypes["Notification"], "...on Notification">
};
	["NotificationFilter"]: {
		announcementId?: GraphQLTypes["IDFilter"] | undefined | null,
	createdAt?: GraphQLTypes["DateTimeFilter"] | undefined | null,
	dismissedAt?: GraphQLTypes["DateTimeFilter"] | undefined | null
};
	["NotificationOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null,
	dismissedAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["OnboardingStep"]: OnboardingStep;
	["OrderBy"]: OrderBy;
	["PageInfo"]: {
	__typename: "PageInfo",
	endCursor?: string | undefined | null,
	hasNextPage: boolean,
	hasPreviousPage: boolean,
	startCursor?: string | undefined | null,
	['...on PageInfo']: Omit<GraphQLTypes["PageInfo"], "...on PageInfo">
};
	["Permission"]: Permission;
	["PlatformType"]: {
	__typename: "PlatformType",
	announcements?: GraphQLTypes["PlatformTypeAnnouncementsConnection"] | undefined | null,
	documentLabels?: GraphQLTypes["PlatformTypeDocumentLabelsConnection"] | undefined | null,
	faqs?: GraphQLTypes["PlatformTypeFaqsConnection"] | undefined | null,
	/** Check if the current request IP is blocked by the dealership IP whitelist. Accepts an explicit dealershipId so the query can be made without the DealershipId header (which would be rejected by the IP-whitelist middleware). */
	isIpBlocked?: boolean | undefined | null,
	['...on PlatformType']: Omit<GraphQLTypes["PlatformType"], "...on PlatformType">
};
	["PlatformTypeAnnouncementsConnection"]: {
	__typename: "PlatformTypeAnnouncementsConnection",
	edges?: Array<GraphQLTypes["PlatformTypeAnnouncementsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on PlatformTypeAnnouncementsConnection']: Omit<GraphQLTypes["PlatformTypeAnnouncementsConnection"], "...on PlatformTypeAnnouncementsConnection">
};
	["PlatformTypeAnnouncementsConnectionEdge"]: {
	__typename: "PlatformTypeAnnouncementsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Announcement"] | undefined | null,
	['...on PlatformTypeAnnouncementsConnectionEdge']: Omit<GraphQLTypes["PlatformTypeAnnouncementsConnectionEdge"], "...on PlatformTypeAnnouncementsConnectionEdge">
};
	["PlatformTypeDocumentLabelsConnection"]: {
	__typename: "PlatformTypeDocumentLabelsConnection",
	edges?: Array<GraphQLTypes["PlatformTypeDocumentLabelsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on PlatformTypeDocumentLabelsConnection']: Omit<GraphQLTypes["PlatformTypeDocumentLabelsConnection"], "...on PlatformTypeDocumentLabelsConnection">
};
	["PlatformTypeDocumentLabelsConnectionEdge"]: {
	__typename: "PlatformTypeDocumentLabelsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["DocumentLabel"] | undefined | null,
	['...on PlatformTypeDocumentLabelsConnectionEdge']: Omit<GraphQLTypes["PlatformTypeDocumentLabelsConnectionEdge"], "...on PlatformTypeDocumentLabelsConnectionEdge">
};
	["PlatformTypeFaqsConnection"]: {
	__typename: "PlatformTypeFaqsConnection",
	edges?: Array<GraphQLTypes["PlatformTypeFaqsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on PlatformTypeFaqsConnection']: Omit<GraphQLTypes["PlatformTypeFaqsConnection"], "...on PlatformTypeFaqsConnection">
};
	["PlatformTypeFaqsConnectionEdge"]: {
	__typename: "PlatformTypeFaqsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Faq"] | undefined | null,
	['...on PlatformTypeFaqsConnectionEdge']: Omit<GraphQLTypes["PlatformTypeFaqsConnectionEdge"], "...on PlatformTypeFaqsConnectionEdge">
};
	["PolicyLayerType"]: PolicyLayerType;
	["PreLoginType"]: {
	__typename: "PreLoginType",
	hasConsentedToSms?: boolean | undefined | null,
	loginOptions?: Array<GraphQLTypes["LoginOptionType"]> | undefined | null,
	userExists?: boolean | undefined | null,
	['...on PreLoginType']: Omit<GraphQLTypes["PreLoginType"], "...on PreLoginType">
};
	["PrequalApplication"]: {
	__typename: "PrequalApplication",
	agilityCreditPrequalReports?: GraphQLTypes["PrequalApplicationAgilityCreditPrequalReportsConnection"] | undefined | null,
	city?: string | undefined | null,
	id?: string | undefined | null,
	prequalResponses?: GraphQLTypes["PrequalApplicationPrequalResponsesConnection"] | undefined | null,
	state?: string | undefined | null,
	transactionId?: string | undefined | null,
	userId?: string | undefined | null,
	['...on PrequalApplication']: Omit<GraphQLTypes["PrequalApplication"], "...on PrequalApplication">
};
	["PrequalApplicationAgilityCreditPrequalReportsConnection"]: {
	__typename: "PrequalApplicationAgilityCreditPrequalReportsConnection",
	edges?: Array<GraphQLTypes["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on PrequalApplicationAgilityCreditPrequalReportsConnection']: Omit<GraphQLTypes["PrequalApplicationAgilityCreditPrequalReportsConnection"], "...on PrequalApplicationAgilityCreditPrequalReportsConnection">
};
	["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"]: {
	__typename: "PrequalApplicationAgilityCreditPrequalReportsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["AgilityCreditPrequalReport"] | undefined | null,
	['...on PrequalApplicationAgilityCreditPrequalReportsConnectionEdge']: Omit<GraphQLTypes["PrequalApplicationAgilityCreditPrequalReportsConnectionEdge"], "...on PrequalApplicationAgilityCreditPrequalReportsConnectionEdge">
};
	["PrequalApplicationPrequalResponsesConnection"]: {
	__typename: "PrequalApplicationPrequalResponsesConnection",
	edges?: Array<GraphQLTypes["PrequalApplicationPrequalResponsesConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on PrequalApplicationPrequalResponsesConnection']: Omit<GraphQLTypes["PrequalApplicationPrequalResponsesConnection"], "...on PrequalApplicationPrequalResponsesConnection">
};
	["PrequalApplicationPrequalResponsesConnectionEdge"]: {
	__typename: "PrequalApplicationPrequalResponsesConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["SevenHundredCreditPrequalReports"] | undefined | null,
	['...on PrequalApplicationPrequalResponsesConnectionEdge']: Omit<GraphQLTypes["PrequalApplicationPrequalResponsesConnectionEdge"], "...on PrequalApplicationPrequalResponsesConnectionEdge">
};
	["PrequalBureau"]: PrequalBureau;
	["PrequalBureauFilter"]: {
		equals?: GraphQLTypes["PrequalBureau"] | undefined | null,
	in?: Array<GraphQLTypes["PrequalBureau"]> | undefined | null,
	not?: GraphQLTypes["PrequalBureauFilter"] | undefined | null,
	notIn?: Array<GraphQLTypes["PrequalBureau"]> | undefined | null
};
	["PrequalInput"]: {
		apartmentDetails: string,
	birthdate: string,
	city: string,
	dateTime: string,
	dealerPrivacyAckTmplId?: string | undefined | null,
	deviceId: string,
	eSignAckTmplId?: string | undefined | null,
	firstName: string,
	ipAddress: string,
	lastName: string,
	middleName?: string | undefined | null,
	name: string,
	prequalReportAckTmplId?: string | undefined | null,
	signature: string,
	socialSecurityNumber: string,
	state: string,
	street: string,
	suffix: string,
	tdcConsentsAckTmplId?: string | undefined | null,
	zip: string
};
	["Prescreen"]: {
	__typename: "Prescreen",
	id?: string | undefined | null,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?: string | undefined | null,
	score?: string | undefined | null,
	['...on Prescreen']: Omit<GraphQLTypes["Prescreen"], "...on Prescreen">
};
	["PublicType"]: {
	__typename: "PublicType",
	acknowledgements?: GraphQLTypes["PublicTypeAcknowledgementsConnection"] | undefined | null,
	ipAddress?: string | undefined | null,
	platformVersion?: string | undefined | null,
	['...on PublicType']: Omit<GraphQLTypes["PublicType"], "...on PublicType">
};
	["PublicTypeAcknowledgementsConnection"]: {
	__typename: "PublicTypeAcknowledgementsConnection",
	edges?: Array<GraphQLTypes["PublicTypeAcknowledgementsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on PublicTypeAcknowledgementsConnection']: Omit<GraphQLTypes["PublicTypeAcknowledgementsConnection"], "...on PublicTypeAcknowledgementsConnection">
};
	["PublicTypeAcknowledgementsConnectionEdge"]: {
	__typename: "PublicTypeAcknowledgementsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["AcknowledgementTemplate"] | undefined | null,
	['...on PublicTypeAcknowledgementsConnectionEdge']: Omit<GraphQLTypes["PublicTypeAcknowledgementsConnectionEdge"], "...on PublicTypeAcknowledgementsConnectionEdge">
};
	["Query"]: {
	__typename: "Query",
	customer?: GraphQLTypes["Customer"] | undefined | null,
	/** Return information about a dealership either by slug or by id */
	dealership?: GraphQLTypes["Dealership"] | undefined | null,
	dealershipStaffScheduleEvents?: Array<GraphQLTypes["StaffScheduleEvent"]> | undefined | null,
	/** Return information about the currently logged in user */
	me?: GraphQLTypes["MeType"] | undefined | null,
	node?: GraphQLTypes["Node"] | undefined | null,
	nodes: Array<GraphQLTypes["Node"] | undefined | null>,
	/** Return platform information */
	platform?: GraphQLTypes["PlatformType"] | undefined | null,
	/** Public query root */
	public?: GraphQLTypes["PublicType"] | undefined | null,
	/** Return information about a transaction either by internal id or by pId (Public ID) */
	transaction?: GraphQLTypes["Transaction"] | undefined | null,
	userDealership?: GraphQLTypes["UserDealership"] | undefined | null,
	['...on Query']: Omit<GraphQLTypes["Query"], "...on Query">
};
	["RecallMastersRecallReport"]: {
	__typename: "RecallMastersRecallReport",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	request?: string | undefined | null,
	response?: GraphQLTypes["JSON"] | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on RecallMastersRecallReport']: Omit<GraphQLTypes["RecallMastersRecallReport"], "...on RecallMastersRecallReport">
};
	["RecallMastersRecallReportFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["RecallMastersRecallReportOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["Referral"]: {
	__typename: "Referral",
	createdAt: GraphQLTypes["DateTime"],
	dealership: GraphQLTypes["Dealership"],
	id: string,
	pId: string,
	payoutInCents: number,
	referringContact: GraphQLTypes["ContactV2"],
	status: GraphQLTypes["ReferralStatus"],
	title: string,
	['...on Referral']: Omit<GraphQLTypes["Referral"], "...on Referral">
};
	["ReferralStatus"]: ReferralStatus;
	["Response"]: {
	__typename: "Response",
	id?: string | undefined | null,
	status?: string | undefined | null,
	['...on Response']: Omit<GraphQLTypes["Response"], "...on Response">
};
	["Role"]: Role;
	["RoleFilter"]: {
		equals?: GraphQLTypes["Role"] | undefined | null,
	in?: Array<GraphQLTypes["Role"]> | undefined | null,
	not?: GraphQLTypes["RoleFilter"] | undefined | null
};
	["RoleListFilter"]: {
		has?: GraphQLTypes["Role"] | undefined | null
};
	["SalesRankingGrouppedByMonth"]: {
	__typename: "SalesRankingGrouppedByMonth",
	currentMonth?: number | undefined | null,
	firstName?: string | undefined | null,
	lastMonth?: number | undefined | null,
	lastName?: string | undefined | null,
	twoMonthsAgo?: number | undefined | null,
	userId?: string | undefined | null,
	['...on SalesRankingGrouppedByMonth']: Omit<GraphQLTypes["SalesRankingGrouppedByMonth"], "...on SalesRankingGrouppedByMonth">
};
	["SetStaffInformationInput"]: {
		cdkCrmEmployeeId?: string | undefined | null
};
	["SevenHundredCreditPrequalReports"]: {
	__typename: "SevenHundredCreditPrequalReports",
	application?: GraphQLTypes["PrequalApplication"] | undefined | null,
	id?: string | undefined | null,
	idMatchSummary?: string | undefined | null,
	ofacSummary?: string | undefined | null,
	product?: string | undefined | null,
	quizStatus?: string | undefined | null,
	redFlagSummary?: string | undefined | null,
	/** URL for using with a iFrame to show the 700 credit report */
	reportUrl?: string | undefined | null,
	response?: string | undefined | null,
	resultCode?: string | undefined | null,
	score?: string | undefined | null,
	['...on SevenHundredCreditPrequalReports']: Omit<GraphQLTypes["SevenHundredCreditPrequalReports"], "...on SevenHundredCreditPrequalReports">
};
	["SevenHundredCreditPrequalReportsFilter"]: {
		bureau?: GraphQLTypes["PrequalBureauFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	isForCompliance?: GraphQLTypes["BooleanFilter"] | undefined | null
};
	["Staff"]: {
	__typename: "Staff",
	dealershipId?: string | undefined | null,
	dealershipRole?: GraphQLTypes["Role"] | undefined | null,
	firstName?: string | undefined | null,
	hasEnabledStaffPlanning?: boolean | undefined | null,
	id?: string | undefined | null,
	lastName?: string | undefined | null,
	receivesAuthenticomReport?: boolean | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	['...on Staff']: Omit<GraphQLTypes["Staff"], "...on Staff">
};
	["StaffAttributes"]: {
		email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	phoneNumber?: string | undefined | null,
	role?: GraphQLTypes["Role"] | undefined | null
};
	["StaffFilter"]: {
		dealershipId?: GraphQLTypes["IDFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["StaffInformation"]: {
	__typename: "StaffInformation",
	cdkCrmEmployeeId?: string | undefined | null,
	dealership?: GraphQLTypes["Dealership"] | undefined | null,
	dealershipId?: string | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	userId?: string | undefined | null,
	['...on StaffInformation']: Omit<GraphQLTypes["StaffInformation"], "...on StaffInformation">
};
	["StaffInformationFilter"]: {
		dealershipId?: GraphQLTypes["IDFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["StaffScheduleEvent"]: {
	__typename: "StaffScheduleEvent",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	dealershipId?: string | undefined | null,
	endAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	note?: string | undefined | null,
	staffId?: string | undefined | null,
	startAt?: GraphQLTypes["DateTime"] | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on StaffScheduleEvent']: Omit<GraphQLTypes["StaffScheduleEvent"], "...on StaffScheduleEvent">
};
	["StageFormInput"]: {
		id: string,
	order: number
};
	["StringFilter"]: {
		contains?: string | undefined | null,
	equals?: string | undefined | null,
	mode?: GraphQLTypes["StringFilterMode"] | undefined | null,
	not?: GraphQLTypes["StringFilter"] | undefined | null,
	startsWith?: string | undefined | null
};
	["StringFilterMode"]: StringFilterMode;
	["SubmitStep1Input"]: {
		captureBackFileId?: string | undefined | null,
	captureFrontFileId?: string | undefined | null,
	/** Signifies contact consent to the consent text at the template ID */
	contactConsentWithTemplateId: string,
	dmvForm?: string | undefined | null,
	dmvPdfFileId?: string | undefined | null,
	/** PDF417 string from the scanned id cards bar code. */
	pdf417String?: string | undefined | null,
	privacyNoticeFileId: string,
	privacyNoticeForm: string,
	/** Signifies test drive consent to the consent text at the template ID */
	testDriveConsentWithTemplateId: string
};
	["SubmitStep2Input"]: {
		captureFileId: string,
	livenessSessionId?: string | undefined | null,
	selfieAckTmplId: string
};
	["SubmitTo"]: SubmitTo;
	["TextAlignment"]: TextAlignment;
	["Todo"]: {
	__typename: "Todo",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	dealershipGroupId?: string | undefined | null,
	dealershipId?: string | undefined | null,
	id?: string | undefined | null,
	status: GraphQLTypes["TodoStatus"],
	transaction?: GraphQLTypes["Transaction"] | undefined | null,
	transactionId?: string | undefined | null,
	type: GraphQLTypes["TodoTypes"],
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on Todo']: Omit<GraphQLTypes["Todo"], "...on Todo">
};
	["TodoFilter"]: {
		createdAt?: GraphQLTypes["DateTimeFilter"] | undefined | null,
	status?: GraphQLTypes["TodoStatusFilter"] | undefined | null,
	transactionId?: GraphQLTypes["IDFilter"] | undefined | null,
	type?: GraphQLTypes["TodoTypesFilter"] | undefined | null
};
	["TodoOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["TodoStatus"]: TodoStatus;
	["TodoStatusFilter"]: {
		equals?: GraphQLTypes["TodoStatus"] | undefined | null,
	in?: Array<GraphQLTypes["TodoStatus"]> | undefined | null,
	not?: GraphQLTypes["TodoStatusFilter"] | undefined | null
};
	["TodoTypes"]: TodoTypes;
	["TodoTypesFilter"]: {
		equals?: GraphQLTypes["TodoTypes"] | undefined | null,
	in?: Array<GraphQLTypes["TodoTypes"]> | undefined | null,
	not?: GraphQLTypes["TodoTypesFilter"] | undefined | null
};
	["Transaction"]: {
	__typename: "Transaction",
	agilityCreditVerifications?: GraphQLTypes["TransactionAgilityCreditVerificationsConnection"] | undefined | null,
	bdc?: GraphQLTypes["User"] | undefined | null,
	buyer?: GraphQLTypes["Customer"] | undefined | null,
	buyerId?: string | undefined | null,
	cdkDmsDealId?: string | undefined | null,
	/** Optionally, a co-buyer for the transaction */
	coBuyer?: GraphQLTypes["Customer"] | undefined | null,
	coBuyerId?: string | undefined | null,
	complianceFormsData: GraphQLTypes["ComplianceFormsData"],
	consumerRebatesInUsdCents?: number | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	customerSharedData?: GraphQLTypes["CustomerSharedData"] | undefined | null,
	dealership?: GraphQLTypes["Dealership"] | undefined | null,
	dealershipCommitment?: string | undefined | null,
	documents?: GraphQLTypes["TransactionDocumentsConnection"] | undefined | null,
	downPayment?: number | undefined | null,
	downPaymentInUsdCents?: number | undefined | null,
	financeType?: string | undefined | null,
	fniManager?: GraphQLTypes["User"] | undefined | null,
	formSubmissionCollections?: GraphQLTypes["TransactionFormSubmissionCollectionsConnection"] | undefined | null,
	formSubmissions?: GraphQLTypes["TransactionFormSubmissionsConnection"] | undefined | null,
	isLeaseBuyOut?: boolean | undefined | null,
	leaseTermInMonths?: number | undefined | null,
	lenderHardCreditApplications: Array<GraphQLTypes["LenderHardCreditApplication"]>,
	lockedReason?: GraphQLTypes["TransactionLockReason"] | undefined | null,
	logs?: GraphQLTypes["TransactionLogsConnection"] | undefined | null,
	milesPerYearInLease?: number | undefined | null,
	monthlyLeasePaymentInUsdCents?: number | undefined | null,
	/** Public ID - a human-friendly, URL-safe identifier (e.g. "tx_...") */
	pId: string,
	price?: number | undefined | null,
	referrals?: GraphQLTypes["TransactionReferralsConnection"] | undefined | null,
	routeOneApplicationId?: string | undefined | null,
	salesManager?: GraphQLTypes["User"] | undefined | null,
	salesPerson?: GraphQLTypes["User"] | undefined | null,
	salesPriceInUsdCents?: number | undefined | null,
	salesTaxInMiliBsp?: number | undefined | null,
	source: GraphQLTypes["TransactionSource"],
	status: GraphQLTypes["TransactionStatus"],
	/** The title of a transaction default to the buyers name or email if that is not set */
	title?: string | undefined | null,
	todos?: GraphQLTypes["TransactionTodosConnection"] | undefined | null,
	tradeInPriceInUsdCents?: number | undefined | null,
	tradeVehicle?: GraphQLTypes["Vehicle"] | undefined | null,
	/** This returns a list of all users who have made changes to the transaction. This can be used to filter the list of transaction logs */
	usersWorkingOnTransaction?: Array<GraphQLTypes["ListItem"]> | undefined | null,
	vehicle?: GraphQLTypes["Vehicle"] | undefined | null,
	vehicleRegistrationExtractions: Array<GraphQLTypes["VehicleRegistrationExtraction"]>,
	['...on Transaction']: Omit<GraphQLTypes["Transaction"], "...on Transaction">
};
	["TransactionAgilityCreditVerificationsConnection"]: {
	__typename: "TransactionAgilityCreditVerificationsConnection",
	edges?: Array<GraphQLTypes["TransactionAgilityCreditVerificationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on TransactionAgilityCreditVerificationsConnection']: Omit<GraphQLTypes["TransactionAgilityCreditVerificationsConnection"], "...on TransactionAgilityCreditVerificationsConnection">
};
	["TransactionAgilityCreditVerificationsConnectionEdge"]: {
	__typename: "TransactionAgilityCreditVerificationsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["AgilityCreditIdVerification"] | undefined | null,
	['...on TransactionAgilityCreditVerificationsConnectionEdge']: Omit<GraphQLTypes["TransactionAgilityCreditVerificationsConnectionEdge"], "...on TransactionAgilityCreditVerificationsConnectionEdge">
};
	["TransactionAndFilter"]: {
		OR?: Array<GraphQLTypes["AssignedStaffOrFilter"]> | undefined | null,
	salesPersonId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["TransactionDealershipAnalyticsSpotFilter"]: {
		eventAt?: GraphQLTypes["DateTimeFilter"] | undefined | null
};
	["TransactionDocumentsConnection"]: {
	__typename: "TransactionDocumentsConnection",
	edges?: Array<GraphQLTypes["TransactionDocumentsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on TransactionDocumentsConnection']: Omit<GraphQLTypes["TransactionDocumentsConnection"], "...on TransactionDocumentsConnection">
};
	["TransactionDocumentsConnectionEdge"]: {
	__typename: "TransactionDocumentsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Document"] | undefined | null,
	['...on TransactionDocumentsConnectionEdge']: Omit<GraphQLTypes["TransactionDocumentsConnectionEdge"], "...on TransactionDocumentsConnectionEdge">
};
	["TransactionFilter"]: {
		AND?: Array<GraphQLTypes["TransactionAndFilter"]> | undefined | null,
	OR?: Array<GraphQLTypes["AssignedStaffOrFilter"]> | undefined | null,
	buyerId?: GraphQLTypes["IDFilter"] | undefined | null,
	coBuyerId?: GraphQLTypes["IDFilter"] | undefined | null,
	createdAt?: GraphQLTypes["DateTimeFilter"] | undefined | null,
	dealership?: GraphQLTypes["DealershipFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	salesPersonId?: GraphQLTypes["IDFilter"] | undefined | null,
	source?: GraphQLTypes["TransactionSourceFilter"] | undefined | null,
	status?: GraphQLTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionFormSubmissionCollectionsConnection"]: {
	__typename: "TransactionFormSubmissionCollectionsConnection",
	edges?: Array<GraphQLTypes["TransactionFormSubmissionCollectionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on TransactionFormSubmissionCollectionsConnection']: Omit<GraphQLTypes["TransactionFormSubmissionCollectionsConnection"], "...on TransactionFormSubmissionCollectionsConnection">
};
	["TransactionFormSubmissionCollectionsConnectionEdge"]: {
	__typename: "TransactionFormSubmissionCollectionsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["FormSubmissionCollection"] | undefined | null,
	['...on TransactionFormSubmissionCollectionsConnectionEdge']: Omit<GraphQLTypes["TransactionFormSubmissionCollectionsConnectionEdge"], "...on TransactionFormSubmissionCollectionsConnectionEdge">
};
	["TransactionFormSubmissionsConnection"]: {
	__typename: "TransactionFormSubmissionsConnection",
	edges?: Array<GraphQLTypes["TransactionFormSubmissionsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on TransactionFormSubmissionsConnection']: Omit<GraphQLTypes["TransactionFormSubmissionsConnection"], "...on TransactionFormSubmissionsConnection">
};
	["TransactionFormSubmissionsConnectionEdge"]: {
	__typename: "TransactionFormSubmissionsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["FormSubmission"] | undefined | null,
	['...on TransactionFormSubmissionsConnectionEdge']: Omit<GraphQLTypes["TransactionFormSubmissionsConnectionEdge"], "...on TransactionFormSubmissionsConnectionEdge">
};
	["TransactionLifecycle"]: TransactionLifecycle;
	["TransactionLockReason"]: TransactionLockReason;
	["TransactionLog"]: {
	__typename: "TransactionLog",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	event?: GraphQLTypes["JSON"] | undefined | null,
	eventDescription?: string | undefined | null,
	executingUser?: GraphQLTypes["User"] | undefined | null,
	id?: string | undefined | null,
	transaction?: GraphQLTypes["Transaction"] | undefined | null,
	['...on TransactionLog']: Omit<GraphQLTypes["TransactionLog"], "...on TransactionLog">
};
	["TransactionLogFilter"]: {
		createdAt?: GraphQLTypes["DateTimeFilter"] | undefined | null,
	executingUserId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["TransactionLogOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["TransactionLogsConnection"]: {
	__typename: "TransactionLogsConnection",
	edges?: Array<GraphQLTypes["TransactionLogsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on TransactionLogsConnection']: Omit<GraphQLTypes["TransactionLogsConnection"], "...on TransactionLogsConnection">
};
	["TransactionLogsConnectionEdge"]: {
	__typename: "TransactionLogsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["TransactionLog"] | undefined | null,
	['...on TransactionLogsConnectionEdge']: Omit<GraphQLTypes["TransactionLogsConnectionEdge"], "...on TransactionLogsConnectionEdge">
};
	["TransactionOrderBy"]: {
		createdAt?: GraphQLTypes["FieldOrdering"] | undefined | null,
	firstName?: GraphQLTypes["FieldOrdering"] | undefined | null,
	lastName?: GraphQLTypes["FieldOrdering"] | undefined | null,
	source?: GraphQLTypes["FieldOrdering"] | undefined | null,
	status?: GraphQLTypes["FieldOrdering"] | undefined | null
};
	["TransactionReferralsConnection"]: {
	__typename: "TransactionReferralsConnection",
	edges?: Array<GraphQLTypes["TransactionReferralsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on TransactionReferralsConnection']: Omit<GraphQLTypes["TransactionReferralsConnection"], "...on TransactionReferralsConnection">
};
	["TransactionReferralsConnectionEdge"]: {
	__typename: "TransactionReferralsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Referral"] | undefined | null,
	['...on TransactionReferralsConnectionEdge']: Omit<GraphQLTypes["TransactionReferralsConnectionEdge"], "...on TransactionReferralsConnectionEdge">
};
	["TransactionRole"]: TransactionRole;
	["TransactionSalesRankingAnalyticsWhereInput"]: {
		status?: GraphQLTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionSource"]: TransactionSource;
	["TransactionSourceFilter"]: {
		equals?: GraphQLTypes["TransactionSource"] | undefined | null,
	in?: Array<GraphQLTypes["TransactionSource"]> | undefined | null,
	not?: GraphQLTypes["TransactionSourceFilter"] | undefined | null
};
	["TransactionStatus"]: TransactionStatus;
	["TransactionStatusFilter"]: {
		equals?: GraphQLTypes["TransactionStatus"] | undefined | null,
	in?: Array<GraphQLTypes["TransactionStatus"]> | undefined | null,
	not?: GraphQLTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionStatusUpdateDealershipAnalyticsFilter"]: {
		eventAt?: GraphQLTypes["DateTimeFilter"] | undefined | null,
	financeType?: GraphQLTypes["FinanceTypeFilter"] | undefined | null,
	isLeaseBuyOut?: boolean | undefined | null,
	purchaseVehicleLifeCycleStage?: GraphQLTypes["VehicleLifeCycleStageFilter"] | undefined | null,
	source?: GraphQLTypes["TransactionSourceFilter"] | undefined | null,
	status?: GraphQLTypes["TransactionStatusFilter"] | undefined | null
};
	["TransactionTodosConnection"]: {
	__typename: "TransactionTodosConnection",
	edges?: Array<GraphQLTypes["TransactionTodosConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on TransactionTodosConnection']: Omit<GraphQLTypes["TransactionTodosConnection"], "...on TransactionTodosConnection">
};
	["TransactionTodosConnectionEdge"]: {
	__typename: "TransactionTodosConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Todo"] | undefined | null,
	['...on TransactionTodosConnectionEdge']: Omit<GraphQLTypes["TransactionTodosConnectionEdge"], "...on TransactionTodosConnectionEdge">
};
	["UpdateCustomerAddress"]: {
		apartmentDetails: string,
	city: string,
	state: string,
	street: string,
	zipCode: string
};
	["UpdateCustomerInput"]: {
		dob?: GraphQLTypes["DateTime"] | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	middleName?: string | undefined | null,
	removeVehicleRegistrationAddress?: boolean | undefined | null,
	residentialAddresses?: Array<GraphQLTypes["AddressInput"]> | undefined | null,
	selfieCaptureId?: string | undefined | null,
	socialSecurityNumber?: string | undefined | null,
	vehicleRegistrationAddress?: GraphQLTypes["UpdateCustomerAddress"] | undefined | null
};
	["UpdateEmploymentInput"]: {
		durationMonths?: number | undefined | null,
	durationYears?: number | undefined | null,
	employerName?: string | undefined | null,
	employerPhoneNumber?: string | undefined | null,
	employmentStatus?: string | undefined | null,
	incomeAmount?: number | undefined | null,
	incomeInterval?: string | undefined | null,
	occupation?: string | undefined | null,
	otherIncomeAmount?: number | undefined | null,
	otherIncomeInterval?: string | undefined | null,
	otherIncomeSource?: string | undefined | null,
	timelinePosition?: number | undefined | null
};
	["UpdateStaffScheduleEventInput"]: {
		endAt?: string | undefined | null,
	note?: string | undefined | null,
	startAt?: string | undefined | null
};
	["UpdateTransactionInput"]: {
		cdkDmsDealId?: string | undefined | null,
	consumerRebatesInUsdCents?: number | undefined | null,
	dealershipCommitment?: string | undefined | null,
	downPaymentInUsdCents?: number | undefined | null,
	financeType?: string | undefined | null,
	id: string,
	isLeaseBuyOut?: boolean | undefined | null,
	leaseTermInMonths?: number | undefined | null,
	milesPerYearInLease?: number | undefined | null,
	monthlyLeasePaymentInUsdCents?: number | undefined | null,
	salesPriceInUsdCents?: number | undefined | null,
	salesTaxInMiliBsp?: number | undefined | null,
	tradeInPriceInUsdCents?: number | undefined | null
};
	["UpdateTransactionStaffInput"]: {
		bdcId?: string | undefined | null,
	fniManagerId?: string | undefined | null,
	salesManagerId?: string | undefined | null,
	salesPersonId?: string | undefined | null
};
	["UpdateUserInput"]: {
		firstName?: string | undefined | null,
	lastName?: string | undefined | null
};
	["User"]: {
	__typename: "User",
	buyerFor?: GraphQLTypes["UserBuyerForConnection"] | undefined | null,
	coBuyerFor?: GraphQLTypes["UserCoBuyerForConnection"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	customers?: GraphQLTypes["UserCustomersConnection"] | undefined | null,
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	hasReferred: GraphQLTypes["UserHasReferredConnection"],
	id?: string | undefined | null,
	lastName?: string | undefined | null,
	notifications?: GraphQLTypes["UserNotificationsConnection"] | undefined | null,
	phoneNumber?: string | undefined | null,
	staff?: GraphQLTypes["UserStaffConnection"] | undefined | null,
	staffInformation?: GraphQLTypes["UserStaffInformationConnection"] | undefined | null,
	userAcknowledgements?: GraphQLTypes["UserUserAcknowledgementsConnection"] | undefined | null,
	userGroup?: GraphQLTypes["UserUserGroupConnection"] | undefined | null,
	userLogs?: GraphQLTypes["UserUserLogsConnection"] | undefined | null,
	['...on User']: Omit<GraphQLTypes["User"], "...on User">
};
	["UserAcknowledgement"]: {
	__typename: "UserAcknowledgement",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	['...on UserAcknowledgement']: Omit<GraphQLTypes["UserAcknowledgement"], "...on UserAcknowledgement">
};
	["UserAcknowledgementFilter"]: {
		acknowledgementId?: GraphQLTypes["IDFilter"] | undefined | null,
	dealershipId?: GraphQLTypes["IDFilter"] | undefined | null,
	transactionId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["UserAcknowledgementOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["UserBuyerForConnection"]: {
	__typename: "UserBuyerForConnection",
	edges?: Array<GraphQLTypes["UserBuyerForConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on UserBuyerForConnection']: Omit<GraphQLTypes["UserBuyerForConnection"], "...on UserBuyerForConnection">
};
	["UserBuyerForConnectionEdge"]: {
	__typename: "UserBuyerForConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Transaction"] | undefined | null,
	['...on UserBuyerForConnectionEdge']: Omit<GraphQLTypes["UserBuyerForConnectionEdge"], "...on UserBuyerForConnectionEdge">
};
	["UserCoBuyerForConnection"]: {
	__typename: "UserCoBuyerForConnection",
	edges?: Array<GraphQLTypes["UserCoBuyerForConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on UserCoBuyerForConnection']: Omit<GraphQLTypes["UserCoBuyerForConnection"], "...on UserCoBuyerForConnection">
};
	["UserCoBuyerForConnectionEdge"]: {
	__typename: "UserCoBuyerForConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Transaction"] | undefined | null,
	['...on UserCoBuyerForConnectionEdge']: Omit<GraphQLTypes["UserCoBuyerForConnectionEdge"], "...on UserCoBuyerForConnectionEdge">
};
	["UserCustomersConnection"]: {
	__typename: "UserCustomersConnection",
	edges?: Array<GraphQLTypes["UserCustomersConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserCustomersConnection']: Omit<GraphQLTypes["UserCustomersConnection"], "...on UserCustomersConnection">
};
	["UserCustomersConnectionEdge"]: {
	__typename: "UserCustomersConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Customer"] | undefined | null,
	['...on UserCustomersConnectionEdge']: Omit<GraphQLTypes["UserCustomersConnectionEdge"], "...on UserCustomersConnectionEdge">
};
	["UserDealership"]: {
	__typename: "UserDealership",
	dealership?: GraphQLTypes["Dealership"] | undefined | null,
	dealershipId?: string | undefined | null,
	extraPermissions?: Array<GraphQLTypes["Permission"]> | undefined | null,
	id: GraphQLTypes["ID"],
	isSuspended?: boolean | undefined | null,
	role?: string | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	['...on UserDealership']: Omit<GraphQLTypes["UserDealership"], "...on UserDealership">
};
	["UserDealershipFilter"]: {
		isSuspended?: GraphQLTypes["BooleanFilter"] | undefined | null,
	role?: GraphQLTypes["RoleFilter"] | undefined | null,
	user?: GraphQLTypes["UserFilter"] | undefined | null,
	userId?: GraphQLTypes["IDFilter"] | undefined | null
};
	["UserEventOperation"]: UserEventOperation;
	["UserFilter"]: {
		OR?: Array<GraphQLTypes["UserOrFilter"]> | undefined | null,
	firstName?: GraphQLTypes["StringFilter"] | undefined | null,
	lastName?: GraphQLTypes["StringFilter"] | undefined | null
};
	["UserGroup"]: {
	__typename: "UserGroup",
	group?: GraphQLTypes["DealershipGroup"] | undefined | null,
	groupId?: string | undefined | null,
	id?: string | undefined | null,
	isSuspended?: boolean | undefined | null,
	role?: string | undefined | null,
	user?: GraphQLTypes["User"] | undefined | null,
	['...on UserGroup']: Omit<GraphQLTypes["UserGroup"], "...on UserGroup">
};
	["UserGroupFilter"]: {
		isSuspended?: boolean | undefined | null
};
	["UserHasReferredConnection"]: {
	__typename: "UserHasReferredConnection",
	edges?: Array<GraphQLTypes["UserHasReferredConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserHasReferredConnection']: Omit<GraphQLTypes["UserHasReferredConnection"], "...on UserHasReferredConnection">
};
	["UserHasReferredConnectionEdge"]: {
	__typename: "UserHasReferredConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Referral"] | undefined | null,
	['...on UserHasReferredConnectionEdge']: Omit<GraphQLTypes["UserHasReferredConnectionEdge"], "...on UserHasReferredConnectionEdge">
};
	["UserLog"]: {
	__typename: "UserLog",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	event?: GraphQLTypes["JSON"] | undefined | null,
	id?: string | undefined | null,
	userId?: string | undefined | null,
	['...on UserLog']: Omit<GraphQLTypes["UserLog"], "...on UserLog">
};
	["UserNotificationsConnection"]: {
	__typename: "UserNotificationsConnection",
	edges?: Array<GraphQLTypes["UserNotificationsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	totalCount: number,
	['...on UserNotificationsConnection']: Omit<GraphQLTypes["UserNotificationsConnection"], "...on UserNotificationsConnection">
};
	["UserNotificationsConnectionEdge"]: {
	__typename: "UserNotificationsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Notification"] | undefined | null,
	['...on UserNotificationsConnectionEdge']: Omit<GraphQLTypes["UserNotificationsConnectionEdge"], "...on UserNotificationsConnectionEdge">
};
	["UserOrFilter"]: {
		firstName?: GraphQLTypes["StringFilter"] | undefined | null,
	id?: GraphQLTypes["IDFilter"] | undefined | null,
	lastName?: GraphQLTypes["StringFilter"] | undefined | null
};
	["UserStaffConnection"]: {
	__typename: "UserStaffConnection",
	edges?: Array<GraphQLTypes["UserStaffConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserStaffConnection']: Omit<GraphQLTypes["UserStaffConnection"], "...on UserStaffConnection">
};
	["UserStaffConnectionEdge"]: {
	__typename: "UserStaffConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["Staff"] | undefined | null,
	['...on UserStaffConnectionEdge']: Omit<GraphQLTypes["UserStaffConnectionEdge"], "...on UserStaffConnectionEdge">
};
	["UserStaffInformationConnection"]: {
	__typename: "UserStaffInformationConnection",
	edges?: Array<GraphQLTypes["UserStaffInformationConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserStaffInformationConnection']: Omit<GraphQLTypes["UserStaffInformationConnection"], "...on UserStaffInformationConnection">
};
	["UserStaffInformationConnectionEdge"]: {
	__typename: "UserStaffInformationConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["StaffInformation"] | undefined | null,
	['...on UserStaffInformationConnectionEdge']: Omit<GraphQLTypes["UserStaffInformationConnectionEdge"], "...on UserStaffInformationConnectionEdge">
};
	["UserUserAcknowledgementsConnection"]: {
	__typename: "UserUserAcknowledgementsConnection",
	edges?: Array<GraphQLTypes["UserUserAcknowledgementsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserUserAcknowledgementsConnection']: Omit<GraphQLTypes["UserUserAcknowledgementsConnection"], "...on UserUserAcknowledgementsConnection">
};
	["UserUserAcknowledgementsConnectionEdge"]: {
	__typename: "UserUserAcknowledgementsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["UserAcknowledgement"] | undefined | null,
	['...on UserUserAcknowledgementsConnectionEdge']: Omit<GraphQLTypes["UserUserAcknowledgementsConnectionEdge"], "...on UserUserAcknowledgementsConnectionEdge">
};
	["UserUserGroupConnection"]: {
	__typename: "UserUserGroupConnection",
	edges?: Array<GraphQLTypes["UserUserGroupConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserUserGroupConnection']: Omit<GraphQLTypes["UserUserGroupConnection"], "...on UserUserGroupConnection">
};
	["UserUserGroupConnectionEdge"]: {
	__typename: "UserUserGroupConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["UserGroup"] | undefined | null,
	['...on UserUserGroupConnectionEdge']: Omit<GraphQLTypes["UserUserGroupConnectionEdge"], "...on UserUserGroupConnectionEdge">
};
	["UserUserLogsConnection"]: {
	__typename: "UserUserLogsConnection",
	edges?: Array<GraphQLTypes["UserUserLogsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on UserUserLogsConnection']: Omit<GraphQLTypes["UserUserLogsConnection"], "...on UserUserLogsConnection">
};
	["UserUserLogsConnectionEdge"]: {
	__typename: "UserUserLogsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["UserLog"] | undefined | null,
	['...on UserUserLogsConnectionEdge']: Omit<GraphQLTypes["UserUserLogsConnectionEdge"], "...on UserUserLogsConnectionEdge">
};
	["Vehicle"]: {
	__typename: "Vehicle",
	bodyType?: GraphQLTypes["VehicleBodyType"] | undefined | null,
	color?: string | undefined | null,
	condition?: GraphQLTypes["VehicleCondition"] | undefined | null,
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	lifeCycleStage?: GraphQLTypes["VehicleLifeCycleStage"] | undefined | null,
	make?: string | undefined | null,
	mileage?: number | undefined | null,
	model?: string | undefined | null,
	msrp?: number | undefined | null,
	pictureBack?: GraphQLTypes["File"] | undefined | null,
	pictureFront?: GraphQLTypes["File"] | undefined | null,
	pictureInterior?: GraphQLTypes["File"] | undefined | null,
	pictureLeftSide?: GraphQLTypes["File"] | undefined | null,
	pictureOdometer?: GraphQLTypes["File"] | undefined | null,
	pictureRightSide?: GraphQLTypes["File"] | undefined | null,
	pictureVinNumber?: GraphQLTypes["File"] | undefined | null,
	principalPriorUse?: GraphQLTypes["VehiclePrincipalPriorUse"] | undefined | null,
	recallMastersRecallReports?: GraphQLTypes["VehicleRecallMastersRecallReportsConnection"] | undefined | null,
	registrationName?: string | undefined | null,
	registrationState?: string | undefined | null,
	stockNumber?: string | undefined | null,
	transactionPurchaseVehicle?: Array<GraphQLTypes["Transaction"]> | undefined | null,
	transactionTradeVehicle?: Array<GraphQLTypes["Transaction"]> | undefined | null,
	/** Pre-packaged groups of features (e.g., base model, performance, etc.) */
	trim?: string | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	updatedByDealership?: boolean | undefined | null,
	vehicleRecallChecks?: GraphQLTypes["VehicleVehicleRecallChecksConnection"] | undefined | null,
	vin?: string | undefined | null,
	vinAuditReports?: GraphQLTypes["VehicleVinAuditReportsConnection"] | undefined | null,
	year?: string | undefined | null,
	['...on Vehicle']: Omit<GraphQLTypes["Vehicle"], "...on Vehicle">
};
	["VehicleBodyType"]: VehicleBodyType;
	["VehicleCondition"]: VehicleCondition;
	["VehicleLifeCycleStage"]: VehicleLifeCycleStage;
	["VehicleLifeCycleStageFilter"]: {
		equals?: GraphQLTypes["VehicleLifeCycleStage"] | undefined | null,
	in?: Array<GraphQLTypes["VehicleLifeCycleStage"]> | undefined | null,
	not?: GraphQLTypes["VehicleLifeCycleStageFilter"] | undefined | null
};
	["VehicleNhtsaRecallReport"]: {
	__typename: "VehicleNhtsaRecallReport",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	response?: GraphQLTypes["JSON"] | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on VehicleNhtsaRecallReport']: Omit<GraphQLTypes["VehicleNhtsaRecallReport"], "...on VehicleNhtsaRecallReport">
};
	["VehicleNhtsaRecallReportFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["VehicleNhtsaRecallReportOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["VehiclePrincipalPriorUse"]: VehiclePrincipalPriorUse;
	["VehicleRecallMastersRecallReportsConnection"]: {
	__typename: "VehicleRecallMastersRecallReportsConnection",
	edges?: Array<GraphQLTypes["VehicleRecallMastersRecallReportsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on VehicleRecallMastersRecallReportsConnection']: Omit<GraphQLTypes["VehicleRecallMastersRecallReportsConnection"], "...on VehicleRecallMastersRecallReportsConnection">
};
	["VehicleRecallMastersRecallReportsConnectionEdge"]: {
	__typename: "VehicleRecallMastersRecallReportsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["RecallMastersRecallReport"] | undefined | null,
	['...on VehicleRecallMastersRecallReportsConnectionEdge']: Omit<GraphQLTypes["VehicleRecallMastersRecallReportsConnectionEdge"], "...on VehicleRecallMastersRecallReportsConnectionEdge">
};
	["VehicleRegistrationExtraction"]: {
	__typename: "VehicleRegistrationExtraction",
	bodyType?: string | undefined | null,
	color?: string | undefined | null,
	condition?: string | undefined | null,
	createdAt: GraphQLTypes["DateTime"],
	errorMessage?: string | undefined | null,
	id: string,
	licensePlate?: string | undefined | null,
	make?: string | undefined | null,
	mileage?: string | undefined | null,
	model?: string | undefined | null,
	registrationName?: string | undefined | null,
	registrationState?: string | undefined | null,
	requestedById: string,
	status: GraphQLTypes["VehicleRegistrationExtractionStatus"],
	vin?: string | undefined | null,
	year?: string | undefined | null,
	['...on VehicleRegistrationExtraction']: Omit<GraphQLTypes["VehicleRegistrationExtraction"], "...on VehicleRegistrationExtraction">
};
	["VehicleRegistrationExtractionFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["VehicleRegistrationExtractionStatus"]: VehicleRegistrationExtractionStatus;
	["VehicleVehicleRecallChecksConnection"]: {
	__typename: "VehicleVehicleRecallChecksConnection",
	edges?: Array<GraphQLTypes["VehicleVehicleRecallChecksConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on VehicleVehicleRecallChecksConnection']: Omit<GraphQLTypes["VehicleVehicleRecallChecksConnection"], "...on VehicleVehicleRecallChecksConnection">
};
	["VehicleVehicleRecallChecksConnectionEdge"]: {
	__typename: "VehicleVehicleRecallChecksConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["VehicleNhtsaRecallReport"] | undefined | null,
	['...on VehicleVehicleRecallChecksConnectionEdge']: Omit<GraphQLTypes["VehicleVehicleRecallChecksConnectionEdge"], "...on VehicleVehicleRecallChecksConnectionEdge">
};
	["VehicleVinAuditReportsConnection"]: {
	__typename: "VehicleVinAuditReportsConnection",
	edges?: Array<GraphQLTypes["VehicleVinAuditReportsConnectionEdge"] | undefined | null> | undefined | null,
	pageInfo: GraphQLTypes["PageInfo"],
	['...on VehicleVinAuditReportsConnection']: Omit<GraphQLTypes["VehicleVinAuditReportsConnection"], "...on VehicleVinAuditReportsConnection">
};
	["VehicleVinAuditReportsConnectionEdge"]: {
	__typename: "VehicleVinAuditReportsConnectionEdge",
	cursor: string,
	node?: GraphQLTypes["VinAuditReport"] | undefined | null,
	['...on VehicleVinAuditReportsConnectionEdge']: Omit<GraphQLTypes["VehicleVinAuditReportsConnectionEdge"], "...on VehicleVinAuditReportsConnectionEdge">
};
	["VinAuditReport"]: {
	__typename: "VinAuditReport",
	createdAt?: GraphQLTypes["DateTime"] | undefined | null,
	id?: string | undefined | null,
	response?: GraphQLTypes["JSON"] | undefined | null,
	updatedAt?: GraphQLTypes["DateTime"] | undefined | null,
	['...on VinAuditReport']: Omit<GraphQLTypes["VinAuditReport"], "...on VinAuditReport">
};
	["VinAuditReportFilter"]: {
		id?: GraphQLTypes["IDFilter"] | undefined | null
};
	["VinAuditReportOrderBy"]: {
		createdAt?: GraphQLTypes["OrderBy"] | undefined | null
};
	["ID"]: "scalar" & { name: "ID" }
    }
export enum Acknowledgement {
	COM_DEALER_PRIVACY = "COM_DEALER_PRIVACY",
	E_SIGN = "E_SIGN",
	HCA_MODIFICATION = "HCA_MODIFICATION",
	HCA_REPORT = "HCA_REPORT",
	LENDING_PORTAL_EDIT_CONFIRMATION = "LENDING_PORTAL_EDIT_CONFIRMATION",
	PREQUAL_REPORT = "PREQUAL_REPORT",
	SELFIE = "SELFIE",
	STAFF_INFORMATION_SAFEGUARDING = "STAFF_INFORMATION_SAFEGUARDING",
	TDC_CONSENTS = "TDC_CONSENTS",
	TEST_DRIVE = "TEST_DRIVE"
}
export enum AgilityCreditAccountKind {
	AUTO_SUMMARY = "AUTO_SUMMARY",
	COLLECTION = "COLLECTION",
	TRADELINE = "TRADELINE"
}
export enum AgilityCreditPullType {
	HARD = "HARD",
	PREQUAL = "PREQUAL"
}
export enum CdkDealJacketStatus {
	FAILED = "FAILED",
	PUSHED = "PUSHED",
	STAGED_FOR_PUSHING = "STAGED_FOR_PUSHING"
}
export enum CheckBoxGroupRules {
	EXACTLY_N = "EXACTLY_N"
}
export enum ComplianceStatus {
	ERROR = "ERROR",
	INFO = "INFO",
	OK = "OK",
	WARN = "WARN"
}
export enum CustomerTransactionRole {
	BUYER = "BUYER",
	CO_BUYER = "CO_BUYER"
}
export enum EmploymentStatus {
	EMPLOYED = "EMPLOYED",
	RETIRED = "RETIRED",
	SELF_EMPLOYED = "SELF_EMPLOYED",
	STUDENT = "STUDENT",
	UNEMPLOYED = "UNEMPLOYED"
}
export enum FieldOrdering {
	asc = "asc",
	desc = "desc"
}
export enum FinanceType {
	CASH = "CASH",
	FINANCE = "FINANCE",
	LEASE = "LEASE",
	OUTSIDE_FINANCING = "OUTSIDE_FINANCING",
	UNDECIDED = "UNDECIDED"
}
export enum FormCollectionStatus {
	CANCELLED = "CANCELLED",
	FINAL = "FINAL",
	PARTIAL = "PARTIAL"
}
export enum FormCollectionType {
	ADDITIONAL = "ADDITIONAL",
	POST_PURCHASE = "POST_PURCHASE",
	PRE_PURCHASE = "PRE_PURCHASE",
	VEHICLE_RECALL = "VEHICLE_RECALL"
}
export enum FormFieldType {
	CHARACTER_LIST = "CHARACTER_LIST",
	CHECKBOX = "CHECKBOX",
	IMAGE = "IMAGE",
	SIGNATURE = "SIGNATURE",
	TEXT = "TEXT",
	TEXT_LIST = "TEXT_LIST"
}
export enum FormRequestErrorCode {
	HCA_MODIFICATION_REQUIRED = "HCA_MODIFICATION_REQUIRED",
	ID_QUIZ_NOT_COMPLETE = "ID_QUIZ_NOT_COMPLETE",
	ID_VERIFICATION_NOT_COMPLETE = "ID_VERIFICATION_NOT_COMPLETE",
	INSURANCE_BINDER_NOT_UPLOADED = "INSURANCE_BINDER_NOT_UPLOADED",
	INSURANCE_CARD_NOT_UPLOADED = "INSURANCE_CARD_NOT_UPLOADED",
	LIVENESS_NOT_COMPLETE = "LIVENESS_NOT_COMPLETE",
	MISSING_BUYER_HCA = "MISSING_BUYER_HCA",
	MISSING_CO_BUYER_HCA = "MISSING_CO_BUYER_HCA",
	MISSING_FINANCE_TYPE = "MISSING_FINANCE_TYPE",
	NO_BUYER_ON_TRANSACTION = "NO_BUYER_ON_TRANSACTION",
	PRE_PURCHASE_NEEDS_TO_BE_REQUESTED = "PRE_PURCHASE_NEEDS_TO_BE_REQUESTED",
	PRE_PURCHASE_NOT_COMPLETE = "PRE_PURCHASE_NOT_COMPLETE",
	PROOF_OF_ID_NOT_UPLOADED = "PROOF_OF_ID_NOT_UPLOADED",
	RBPN_NOT_COMPLETE = "RBPN_NOT_COMPLETE",
	RED_FLAGS_NOT_COMPLETE = "RED_FLAGS_NOT_COMPLETE",
	REFERRAL_COMMISSION_NOT_PAID = "REFERRAL_COMMISSION_NOT_PAID",
	STAFF_NOT_ASSIGN = "STAFF_NOT_ASSIGN",
	TRADE_REGISTRATION_NOT_UPLOADED = "TRADE_REGISTRATION_NOT_UPLOADED",
	VEHICLE_NOT_ASSIGN = "VEHICLE_NOT_ASSIGN"
}
export enum FormSubmissionAccessEmum {
	BOTH = "BOTH",
	CUSTOMER = "CUSTOMER",
	DEALERSHIP = "DEALERSHIP"
}
export enum FormSubmissionStatus {
	CANCELLED = "CANCELLED",
	FINAL = "FINAL",
	PARTIAL = "PARTIAL",
	PENDING = "PENDING",
	SIGNED = "SIGNED"
}
export enum FormSubmissionType {
	CONTACT_ACKNOWLEDGEMENT = "CONTACT_ACKNOWLEDGEMENT",
	CUSTOM = "CUSTOM",
	DMV_DOCUMENTS = "DMV_DOCUMENTS",
	HARD_CREDIT_APPLICATION = "HARD_CREDIT_APPLICATION",
	HARD_CREDIT_APPLICATION_MODIFICATION = "HARD_CREDIT_APPLICATION_MODIFICATION",
	IDENTITY_THEFT_PREVENTION = "IDENTITY_THEFT_PREVENTION",
	IDENTITY_VERIFICATION = "IDENTITY_VERIFICATION",
	POST_PURCHASE = "POST_PURCHASE",
	PREQUAL = "PREQUAL",
	PRE_PURCHASE = "PRE_PURCHASE",
	PRIVACY_POLICY = "PRIVACY_POLICY",
	TEST_DRIVE_DISCLOSURE = "TEST_DRIVE_DISCLOSURE"
}
export enum HousingStatus {
	LIVING_WITH_RELATIVES = "LIVING_WITH_RELATIVES",
	OTHER = "OTHER",
	OWNING = "OWNING",
	RENTING = "RENTING"
}
export enum IdCardType {
	DRIVERS_LICENSE = "DRIVERS_LICENSE",
	OTHER = "OTHER",
	PASSPORT = "PASSPORT",
	STATE_ID = "STATE_ID"
}
export enum ImageRotation {
	CW_90 = "CW_90",
	CW_180 = "CW_180",
	CW_270 = "CW_270",
	NONE = "NONE"
}
export enum IncomeInterval {
	BI_WEEKLY = "BI_WEEKLY",
	MONTHLY = "MONTHLY",
	WEEKLY = "WEEKLY",
	YEARLY = "YEARLY"
}
export enum LoginOptionType {
	BUYER = "BUYER",
	CO_BUYER = "CO_BUYER",
	NEW_TRANSACTION = "NEW_TRANSACTION"
}
export enum OnboardingStep {
	ONBOARDING_COMPLETE = "ONBOARDING_COMPLETE",
	STEP1 = "STEP1",
	STEP2 = "STEP2"
}
export enum OrderBy {
	Asc = "Asc",
	Desc = "Desc"
}
export enum Permission {
	OVERRIDE_ID_CHECKS = "OVERRIDE_ID_CHECKS",
	OVERRIDE_TASKS = "OVERRIDE_TASKS"
}
export enum PolicyLayerType {
	ENF_IDV = "ENF_IDV",
	ENF_LIVENESS = "ENF_LIVENESS",
	ENF_PROOF_ID_INS_BINDER_INS_CARD = "ENF_PROOF_ID_INS_BINDER_INS_CARD",
	ENF_RF_IDQ_PROOF_ID = "ENF_RF_IDQ_PROOF_ID",
	ENF_TRADE_REG = "ENF_TRADE_REG"
}
export enum PrequalBureau {
	EQUI_FAX = "EQUI_FAX",
	EXPERIAN = "EXPERIAN",
	TRANS_UNION = "TRANS_UNION"
}
export enum ReferralStatus {
	ELIGIBLE = "ELIGIBLE",
	PAID = "PAID",
	PENDING = "PENDING"
}
export enum Role {
	ADMIN = "ADMIN",
	BDC = "BDC",
	CUSTOMER = "CUSTOMER",
	FNI_MANAGER = "FNI_MANAGER",
	SALES_MANAGER = "SALES_MANAGER",
	SALES_PERSON = "SALES_PERSON"
}
export enum StringFilterMode {
	Default = "Default",
	Insensitive = "Insensitive"
}
export enum SubmitTo {
	DEALER_TRACK = "DEALER_TRACK",
	ROUTE_ONE = "ROUTE_ONE"
}
export enum TextAlignment {
	CENTER = "CENTER",
	LEFT = "LEFT",
	RIGHT = "RIGHT"
}
export enum TodoStatus {
	DONE = "DONE",
	PENDING = "PENDING"
}
export enum TodoTypes {
	ASSIGN_FNI = "ASSIGN_FNI",
	ASSIGN_PURCHASE_VEHICLE = "ASSIGN_PURCHASE_VEHICLE",
	ASSIGN_SALES_MANAGER = "ASSIGN_SALES_MANAGER",
	ASSIGN_SALES_PERSON = "ASSIGN_SALES_PERSON",
	COMPLETE_ID_QUIZ = "COMPLETE_ID_QUIZ",
	COMPLETE_ID_VERIFICATION = "COMPLETE_ID_VERIFICATION",
	COMPLETE_LIVENESS_DETECTION = "COMPLETE_LIVENESS_DETECTION",
	COMPLETE_RBPN_FOR_PREQUAL = "COMPLETE_RBPN_FOR_PREQUAL",
	COMPLETE_RED_FLAGS = "COMPLETE_RED_FLAGS",
	HCA_MODIFICATION_REQUIRED = "HCA_MODIFICATION_REQUIRED",
	PAY_CUSTOMER_REFERRAL_COMMISSION = "PAY_CUSTOMER_REFERRAL_COMMISSION",
	REQUEST_POST_PURCHASE_FORM = "REQUEST_POST_PURCHASE_FORM",
	REQUEST_PRE_PURCHASE_FORM = "REQUEST_PRE_PURCHASE_FORM",
	SET_FINANCE_TYPE = "SET_FINANCE_TYPE",
	UPLOAD_INSURANCE_BINDER = "UPLOAD_INSURANCE_BINDER",
	UPLOAD_INSURANCE_CARD = "UPLOAD_INSURANCE_CARD",
	UPLOAD_PROOF_OF_ID = "UPLOAD_PROOF_OF_ID",
	UPLOAD_TRADE_REGISTRATION = "UPLOAD_TRADE_REGISTRATION"
}
export enum TransactionLifecycle {
	POST_PURCHASE = "POST_PURCHASE",
	PRE_PURCHASE = "PRE_PURCHASE"
}
export enum TransactionLockReason {
	DELIVERED_LOCK = "DELIVERED_LOCK"
}
export enum TransactionRole {
	BDC = "BDC",
	BUYER = "BUYER",
	CO_BUYER = "CO_BUYER",
	FNI_MANAGER = "FNI_MANAGER",
	SALES_MANAGER = "SALES_MANAGER",
	SALES_PERSON = "SALES_PERSON"
}
export enum TransactionSource {
	ADMIN_DASHBOARD = "ADMIN_DASHBOARD",
	CUSTOMER_REFERRAL = "CUSTOMER_REFERRAL",
	KIOSK = "KIOSK",
	WEB_APPLICATION = "WEB_APPLICATION",
	WEB_PREQUAL = "WEB_PREQUAL"
}
export enum TransactionStatus {
	COMPLETED = "COMPLETED",
	CREDIT_APP_SUBMITTED = "CREDIT_APP_SUBMITTED",
	DEAD = "DEAD",
	DELIVERED = "DELIVERED",
	DISASSOCIATED = "DISASSOCIATED",
	FILE_COMPLETE = "FILE_COMPLETE",
	IN_PROGRESS = "IN_PROGRESS",
	NOT_STARTED = "NOT_STARTED",
	PREQUAL_SUBMITTED = "PREQUAL_SUBMITTED",
	READY_FOR_FNI = "READY_FOR_FNI",
	REGISTERED = "REGISTERED",
	RULE_90_DAYS = "RULE_90_DAYS",
	SIGNED_UP = "SIGNED_UP",
	WEB_APPLICATION = "WEB_APPLICATION",
	WEB_LEAD = "WEB_LEAD"
}
export enum UserEventOperation {
	COMPLETED_ONBOARDING_STEP1 = "COMPLETED_ONBOARDING_STEP1",
	COMPLETED_ONBOARDING_STEP2 = "COMPLETED_ONBOARDING_STEP2",
	STARTED_ONBOARDING = "STARTED_ONBOARDING",
	VIEWED_TRANSACTION = "VIEWED_TRANSACTION"
}
export enum VehicleBodyType {
	COUPE = "COUPE",
	MINIVAN = "MINIVAN",
	OTHER = "OTHER",
	SEDAN = "SEDAN",
	SUV = "SUV"
}
export enum VehicleCondition {
	EXCELLENT = "EXCELLENT",
	GOOD = "GOOD",
	SATISFACTORY = "SATISFACTORY",
	UNSATISFACTORY = "UNSATISFACTORY"
}
export enum VehicleLifeCycleStage {
	IS_NEW = "IS_NEW",
	IS_USED = "IS_USED"
}
export enum VehiclePrincipalPriorUse {
	COMMERCIAL = "COMMERCIAL",
	DEMO = "DEMO",
	FLEET = "FLEET",
	LIVERY_VEHICLE = "LIVERY_VEHICLE",
	OTHER = "OTHER",
	PRIVATE_PASSENGER_VEHICLE = "PRIVATE_PASSENGER_VEHICLE",
	RENTAL_VEHICLE = "RENTAL_VEHICLE",
	TAXI = "TAXI"
}
export enum VehicleRegistrationExtractionStatus {
	COMPLETED = "COMPLETED",
	FAILED = "FAILED",
	PENDING = "PENDING",
	PROCESSING = "PROCESSING"
}

type ZEUS_VARIABLES = {
	["Acknowledgement"]: ValueTypes["Acknowledgement"];
	["AcknowledgementFilter"]: ValueTypes["AcknowledgementFilter"];
	["AcknowledgementTemplateFilter"]: ValueTypes["AcknowledgementTemplateFilter"];
	["AcknowledgementTemplateOrderBy"]: ValueTypes["AcknowledgementTemplateOrderBy"];
	["AddressInput"]: ValueTypes["AddressInput"];
	["AgilityCreditAccountKind"]: ValueTypes["AgilityCreditAccountKind"];
	["AgilityCreditIdVerificationFilter"]: ValueTypes["AgilityCreditIdVerificationFilter"];
	["AgilityCreditPrequalReportFilter"]: ValueTypes["AgilityCreditPrequalReportFilter"];
	["AgilityCreditPullType"]: ValueTypes["AgilityCreditPullType"];
	["AnnouncementOrderBy"]: ValueTypes["AnnouncementOrderBy"];
	["AssignedStaffOrFilter"]: ValueTypes["AssignedStaffOrFilter"];
	["BigInt"]: ValueTypes["BigInt"];
	["BooleanFilter"]: ValueTypes["BooleanFilter"];
	["CdkDealJacketStatus"]: ValueTypes["CdkDealJacketStatus"];
	["CheckBoxGroupRules"]: ValueTypes["CheckBoxGroupRules"];
	["ComplianceStatus"]: ValueTypes["ComplianceStatus"];
	["ContactV2Filter"]: ValueTypes["ContactV2Filter"];
	["CreateCustomerInput"]: ValueTypes["CreateCustomerInput"];
	["CreateEmploymentInput"]: ValueTypes["CreateEmploymentInput"];
	["CreateStaffScheduleEventsInput"]: ValueTypes["CreateStaffScheduleEventsInput"];
	["CreateUserInput"]: ValueTypes["CreateUserInput"];
	["CreditApplicationAddressInformationInput"]: ValueTypes["CreditApplicationAddressInformationInput"];
	["CreditApplicationEmploymentInformationInput"]: ValueTypes["CreditApplicationEmploymentInformationInput"];
	["CreditApplicationFormSubmissionDataInput"]: ValueTypes["CreditApplicationFormSubmissionDataInput"];
	["CreditApplicationFormSubmissionInput"]: ValueTypes["CreditApplicationFormSubmissionInput"];
	["CreditApplicationInput"]: ValueTypes["CreditApplicationInput"];
	["CustomerFilter"]: ValueTypes["CustomerFilter"];
	["CustomerPurchaseVehicleInput"]: ValueTypes["CustomerPurchaseVehicleInput"];
	["CustomerSignupInput"]: ValueTypes["CustomerSignupInput"];
	["CustomerTradeVehicleInput"]: ValueTypes["CustomerTradeVehicleInput"];
	["CustomerTransactionRole"]: ValueTypes["CustomerTransactionRole"];
	["Date"]: ValueTypes["Date"];
	["DateTime"]: ValueTypes["DateTime"];
	["DateTimeFilter"]: ValueTypes["DateTimeFilter"];
	["DealershipFilter"]: ValueTypes["DealershipFilter"];
	["DealershipPurchaseVehicleInput"]: ValueTypes["DealershipPurchaseVehicleInput"];
	["DealershipTradeVehicleInput"]: ValueTypes["DealershipTradeVehicleInput"];
	["DocumentLabelOrderBy"]: ValueTypes["DocumentLabelOrderBy"];
	["DocumentOr"]: ValueTypes["DocumentOr"];
	["DocumentOrderBy"]: ValueTypes["DocumentOrderBy"];
	["EmploymentStatus"]: ValueTypes["EmploymentStatus"];
	["FieldOrdering"]: ValueTypes["FieldOrdering"];
	["FinanceType"]: ValueTypes["FinanceType"];
	["FinanceTypeFilter"]: ValueTypes["FinanceTypeFilter"];
	["FormCollectionStatus"]: ValueTypes["FormCollectionStatus"];
	["FormCollectionStatusFilter"]: ValueTypes["FormCollectionStatusFilter"];
	["FormCollectionType"]: ValueTypes["FormCollectionType"];
	["FormCollectionTypeFilter"]: ValueTypes["FormCollectionTypeFilter"];
	["FormFieldFilter"]: ValueTypes["FormFieldFilter"];
	["FormFieldSubmissionAllowedUserFilter"]: ValueTypes["FormFieldSubmissionAllowedUserFilter"];
	["FormFieldSubmissionAllowedUserListFilter"]: ValueTypes["FormFieldSubmissionAllowedUserListFilter"];
	["FormFieldSubmissionFilter"]: ValueTypes["FormFieldSubmissionFilter"];
	["FormFieldSubmissionOrFilter"]: ValueTypes["FormFieldSubmissionOrFilter"];
	["FormFieldSubmissionOrderBy"]: ValueTypes["FormFieldSubmissionOrderBy"];
	["FormFieldType"]: ValueTypes["FormFieldType"];
	["FormFieldValue"]: ValueTypes["FormFieldValue"];
	["FormRequestErrorCode"]: ValueTypes["FormRequestErrorCode"];
	["FormSubmissionAccessEmum"]: ValueTypes["FormSubmissionAccessEmum"];
	["FormSubmissionAccessEmumFilter"]: ValueTypes["FormSubmissionAccessEmumFilter"];
	["FormSubmissionCollectionFilter"]: ValueTypes["FormSubmissionCollectionFilter"];
	["FormSubmissionCollectionOrderBy"]: ValueTypes["FormSubmissionCollectionOrderBy"];
	["FormSubmissionFilter"]: ValueTypes["FormSubmissionFilter"];
	["FormSubmissionStatus"]: ValueTypes["FormSubmissionStatus"];
	["FormSubmissionStatusFilter"]: ValueTypes["FormSubmissionStatusFilter"];
	["FormSubmissionType"]: ValueTypes["FormSubmissionType"];
	["FormSubmissionTypeFilter"]: ValueTypes["FormSubmissionTypeFilter"];
	["HardCreditApplicationFilter"]: ValueTypes["HardCreditApplicationFilter"];
	["HardCreditApplicationOrderBy"]: ValueTypes["HardCreditApplicationOrderBy"];
	["HomenetVehicleDataFilter"]: ValueTypes["HomenetVehicleDataFilter"];
	["HousingStatus"]: ValueTypes["HousingStatus"];
	["IDFilter"]: ValueTypes["IDFilter"];
	["IdCardType"]: ValueTypes["IdCardType"];
	["ImageRotation"]: ValueTypes["ImageRotation"];
	["IncomeInterval"]: ValueTypes["IncomeInterval"];
	["JSON"]: ValueTypes["JSON"];
	["LenderHardCreditApplicationOrderBy"]: ValueTypes["LenderHardCreditApplicationOrderBy"];
	["LendingPortalAddressEntryInput"]: ValueTypes["LendingPortalAddressEntryInput"];
	["LendingPortalCustomerDataInput"]: ValueTypes["LendingPortalCustomerDataInput"];
	["LendingPortalEmploymentEntryInput"]: ValueTypes["LendingPortalEmploymentEntryInput"];
	["LendingPortalPurchaseVehicleDataInput"]: ValueTypes["LendingPortalPurchaseVehicleDataInput"];
	["LendingPortalTradeVehicleDataInput"]: ValueTypes["LendingPortalTradeVehicleDataInput"];
	["LivelinessSessionFilter"]: ValueTypes["LivelinessSessionFilter"];
	["LoginOptionType"]: ValueTypes["LoginOptionType"];
	["NotificationFilter"]: ValueTypes["NotificationFilter"];
	["NotificationOrderBy"]: ValueTypes["NotificationOrderBy"];
	["OnboardingStep"]: ValueTypes["OnboardingStep"];
	["OrderBy"]: ValueTypes["OrderBy"];
	["Permission"]: ValueTypes["Permission"];
	["PolicyLayerType"]: ValueTypes["PolicyLayerType"];
	["PrequalBureau"]: ValueTypes["PrequalBureau"];
	["PrequalBureauFilter"]: ValueTypes["PrequalBureauFilter"];
	["PrequalInput"]: ValueTypes["PrequalInput"];
	["RecallMastersRecallReportFilter"]: ValueTypes["RecallMastersRecallReportFilter"];
	["RecallMastersRecallReportOrderBy"]: ValueTypes["RecallMastersRecallReportOrderBy"];
	["ReferralStatus"]: ValueTypes["ReferralStatus"];
	["Role"]: ValueTypes["Role"];
	["RoleFilter"]: ValueTypes["RoleFilter"];
	["RoleListFilter"]: ValueTypes["RoleListFilter"];
	["SetStaffInformationInput"]: ValueTypes["SetStaffInformationInput"];
	["SevenHundredCreditPrequalReportsFilter"]: ValueTypes["SevenHundredCreditPrequalReportsFilter"];
	["StaffAttributes"]: ValueTypes["StaffAttributes"];
	["StaffFilter"]: ValueTypes["StaffFilter"];
	["StaffInformationFilter"]: ValueTypes["StaffInformationFilter"];
	["StageFormInput"]: ValueTypes["StageFormInput"];
	["StringFilter"]: ValueTypes["StringFilter"];
	["StringFilterMode"]: ValueTypes["StringFilterMode"];
	["SubmitStep1Input"]: ValueTypes["SubmitStep1Input"];
	["SubmitStep2Input"]: ValueTypes["SubmitStep2Input"];
	["SubmitTo"]: ValueTypes["SubmitTo"];
	["TextAlignment"]: ValueTypes["TextAlignment"];
	["TodoFilter"]: ValueTypes["TodoFilter"];
	["TodoOrderBy"]: ValueTypes["TodoOrderBy"];
	["TodoStatus"]: ValueTypes["TodoStatus"];
	["TodoStatusFilter"]: ValueTypes["TodoStatusFilter"];
	["TodoTypes"]: ValueTypes["TodoTypes"];
	["TodoTypesFilter"]: ValueTypes["TodoTypesFilter"];
	["TransactionAndFilter"]: ValueTypes["TransactionAndFilter"];
	["TransactionDealershipAnalyticsSpotFilter"]: ValueTypes["TransactionDealershipAnalyticsSpotFilter"];
	["TransactionFilter"]: ValueTypes["TransactionFilter"];
	["TransactionLifecycle"]: ValueTypes["TransactionLifecycle"];
	["TransactionLockReason"]: ValueTypes["TransactionLockReason"];
	["TransactionLogFilter"]: ValueTypes["TransactionLogFilter"];
	["TransactionLogOrderBy"]: ValueTypes["TransactionLogOrderBy"];
	["TransactionOrderBy"]: ValueTypes["TransactionOrderBy"];
	["TransactionRole"]: ValueTypes["TransactionRole"];
	["TransactionSalesRankingAnalyticsWhereInput"]: ValueTypes["TransactionSalesRankingAnalyticsWhereInput"];
	["TransactionSource"]: ValueTypes["TransactionSource"];
	["TransactionSourceFilter"]: ValueTypes["TransactionSourceFilter"];
	["TransactionStatus"]: ValueTypes["TransactionStatus"];
	["TransactionStatusFilter"]: ValueTypes["TransactionStatusFilter"];
	["TransactionStatusUpdateDealershipAnalyticsFilter"]: ValueTypes["TransactionStatusUpdateDealershipAnalyticsFilter"];
	["UpdateCustomerAddress"]: ValueTypes["UpdateCustomerAddress"];
	["UpdateCustomerInput"]: ValueTypes["UpdateCustomerInput"];
	["UpdateEmploymentInput"]: ValueTypes["UpdateEmploymentInput"];
	["UpdateStaffScheduleEventInput"]: ValueTypes["UpdateStaffScheduleEventInput"];
	["UpdateTransactionInput"]: ValueTypes["UpdateTransactionInput"];
	["UpdateTransactionStaffInput"]: ValueTypes["UpdateTransactionStaffInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
	["UserAcknowledgementFilter"]: ValueTypes["UserAcknowledgementFilter"];
	["UserAcknowledgementOrderBy"]: ValueTypes["UserAcknowledgementOrderBy"];
	["UserDealershipFilter"]: ValueTypes["UserDealershipFilter"];
	["UserEventOperation"]: ValueTypes["UserEventOperation"];
	["UserFilter"]: ValueTypes["UserFilter"];
	["UserGroupFilter"]: ValueTypes["UserGroupFilter"];
	["UserOrFilter"]: ValueTypes["UserOrFilter"];
	["VehicleBodyType"]: ValueTypes["VehicleBodyType"];
	["VehicleCondition"]: ValueTypes["VehicleCondition"];
	["VehicleLifeCycleStage"]: ValueTypes["VehicleLifeCycleStage"];
	["VehicleLifeCycleStageFilter"]: ValueTypes["VehicleLifeCycleStageFilter"];
	["VehicleNhtsaRecallReportFilter"]: ValueTypes["VehicleNhtsaRecallReportFilter"];
	["VehicleNhtsaRecallReportOrderBy"]: ValueTypes["VehicleNhtsaRecallReportOrderBy"];
	["VehiclePrincipalPriorUse"]: ValueTypes["VehiclePrincipalPriorUse"];
	["VehicleRegistrationExtractionFilter"]: ValueTypes["VehicleRegistrationExtractionFilter"];
	["VehicleRegistrationExtractionStatus"]: ValueTypes["VehicleRegistrationExtractionStatus"];
	["VinAuditReportFilter"]: ValueTypes["VinAuditReportFilter"];
	["VinAuditReportOrderBy"]: ValueTypes["VinAuditReportOrderBy"];
	["ID"]: ValueTypes["ID"];
}